/* tslint:disable */
/* eslint-disable */
/**
 * Client Tax System API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AcceptInvitationDto {
    'token'?: string | null;
    'password'?: string | null;
}
export interface AccessRequestPageDefaultsDto {
    'pageSize'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'status'?: string | null;
    'officeId'?: string | null;
}

export enum AccessRequestStatus {
    Na = 'na',
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected'
}


export interface ActionPreferenceDto {
    'actionType'?: NotificationActionType;
    'displayName'?: string | null;
    'description'?: string | null;
    'category'?: string | null;
    'channels'?: NotificationDeliveryChannel;
    'batchStrategy'?: NotificationBatchStrategy;
    'isUsingDefaults'?: boolean;
    'effectiveChannels'?: NotificationDeliveryChannel;
    'effectiveBatchStrategy'?: NotificationBatchStrategy;
    'supportsBatching'?: boolean;
    'actionDefaultChannel'?: NotificationDeliveryChannel;
    'actionDefaultBatchStrategy'?: NotificationBatchStrategy;
}


export interface ActionPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: ActionPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ActionPreferencesResponseDto {
    'defaultChannels'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
    'actionsByCategory'?: { [key: string]: Array<ActionPreferenceDto> | null; } | null;
}


export interface ActionPreferencesResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ActionPreferencesResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ActionTypeDto {
    'actionType'?: NotificationActionType;
    'actionTypeValue'?: number;
    'displayName'?: string | null;
    'description'?: string | null;
    'category'?: string | null;
    'supportsBatching'?: boolean;
    'defaultChannel'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
}


export interface ActionTypeDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ActionTypeDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface AddSignerRequestDto {
    'name': string;
    'email': string;
    'phone'?: string | null;
    'role': string;
}
export interface AddSignerResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'strategy'?: string | null;
    'newSubmissionId'?: string | null;
    'originalSubmissionId'?: string | null;
    'fieldsDetected'?: number;
    'signers'?: Array<AddSignerSignerDto> | null;
}
export interface AddSignerResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: AddSignerResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface AddSignerSignerDto {
    'signerId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
}
export interface AdminDashboardDto {
    'summary'?: AdminDashboardSummaryDto;
    'preparerBreakdown'?: Array<PreparerActivityDto> | null;
    'officeBreakdown'?: Array<OfficeActivityDto> | null;
    'stageDistribution'?: Array<StageDistributionDto> | null;
    'averageDaysToCompletion'?: number | null;
    'overdueBinders'?: number;
    'totalActiveBinders'?: number;
    'workflowTiming'?: WorkflowTimingDto;
    'preparerTimingBreakdown'?: Array<PreparerWorkflowTimingDto> | null;
    'partnerBreakdown'?: Array<PartnerActivityDto> | null;
    'officeTimingBreakdown'?: Array<OfficeWorkflowTimingDto> | null;
    'partnerTimingBreakdown'?: Array<PartnerWorkflowTimingDto> | null;
}
export interface AdminDashboardDtoApiResponse {
    'success'?: boolean;
    'data'?: AdminDashboardDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface AdminDashboardPageDefaultsDto {
    'breakdownView'?: string | null;
}
export interface AdminDashboardSummaryDto {
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
    'bindersCreatedPriorYear'?: TimePeriodCountsDto;
    'sentForPreparationPriorYear'?: TimePeriodCountsDto;
    'completedPriorYear'?: TimePeriodCountsDto;
}

export enum AiProcessingStatus {
    NotRequired = 'notRequired',
    Pending = 'pending',
    InProgress = 'inProgress',
    Completed = 'completed',
    Failed = 'failed'
}



export enum AnchorPoint {
    TopLeft = 'topLeft',
    TopRight = 'topRight',
    BottomLeft = 'bottomLeft',
    BottomRight = 'bottomRight',
    Center = 'center',
    TopCenter = 'topCenter',
    BottomCenter = 'bottomCenter',
    LeftCenter = 'leftCenter',
    RightCenter = 'rightCenter'
}


export interface ApiError {
    'code'?: string | null;
    'message'?: string | null;
    'details'?: { [key: string]: any | null; } | null;
}
export interface ApiMeta {
    'requestId'?: string | null;
    'timestamp'?: string;
}
export interface ArchiveTaxBinderRequest {
    'isArchived': boolean;
}
export interface AssignUserToClientDto {
    'userId'?: string;
    'clientId'?: string;
    'role'?: ClientUserRole;
    'isMainContact'?: boolean | null;
}


export interface AttachEngagementLetterResponseDto {
    'documentId'?: string;
    'submissionId'?: string | null;
    'signingUrl'?: string | null;
    'status'?: string | null;
    'notificationQueued'?: boolean;
    'createdAt'?: string;
    'replacedDocumentId'?: string | null;
    'replacedSubmissionId'?: string | null;
}
export interface AttachEngagementLetterResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: AttachEngagementLetterResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum AuditBinderActivityEvent {
    BinderCreated = 'binderCreated',
    StageChanged = 'stageChanged',
    ItemRequested = 'itemRequested',
    ItemApproved = 'itemApproved',
    ItemClientResponded = 'itemClientResponded',
    DocumentUploaded = 'documentUploaded',
    DocumentApproved = 'documentApproved',
    DocumentRejected = 'documentRejected',
    CommentPosted = 'commentPosted',
    FinalDocumentUploaded = 'finalDocumentUploaded',
    BinderCompleted = 'binderCompleted',
    DocumentDeleted = 'documentDeleted',
    ItemEdited = 'itemEdited',
    DocumentsExported = 'documentsExported',
    SignatureRequested = 'signatureRequested',
    SignatureCompleted = 'signatureCompleted',
    ItemUnapproved = 'itemUnapproved',
    DocumentDownloaded = 'documentDownloaded',
    BinderSoftDeleted = 'binderSoftDeleted',
    ItemReleased = 'itemReleased'
}


export interface AuditBinderDetailActivityDto {
    'id'?: string;
    'type'?: AuditBinderActivityEvent;
    'actorName'?: string | null;
    'actorRole'?: string | null;
    'createdAt'?: string;
    'payloadJson'?: string | null;
}


export interface AuditBinderDetailCommentDto {
    'id'?: string;
    'content'?: string | null;
    'authorName'?: string | null;
    'authorRole'?: string | null;
    'isInternal'?: boolean;
    'createdAt'?: string;
}
export interface AuditBinderDetailDocumentDto {
    'id'?: string;
    'name'?: string | null;
    'fileSize'?: number;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
    'uploadedByRole'?: string | null;
    'isNonClientUpload'?: boolean;
    'isFirmUpload'?: boolean;
    'status'?: string | null;
    'rejectionReason'?: string | null;
    'reviewedAt'?: string | null;
    'reviewedByName'?: string | null;
    'exportedAt'?: string | null;
    'exportedByName'?: string | null;
}
export interface AuditBinderDetailDto {
    'binder'?: AuditBinderDetailHeaderDto;
    'items'?: Array<AuditBinderDetailItemDto> | null;
    'otherDocuments'?: Array<AuditBinderDetailDocumentDto> | null;
    'finalDocument'?: AuditBinderDetailDocumentDto;
    'finalDocumentUploadedAt'?: string | null;
    'binderActivity'?: Array<AuditBinderDetailActivityDto> | null;
    'binderComments'?: Array<AuditBinderDetailCommentDto> | null;
    'signatureDocuments'?: Array<AuditBinderSignatureDocumentDto> | null;
    'summary'?: AuditBinderDetailSummaryDto;
}
export interface AuditBinderDetailDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderDetailDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface AuditBinderDetailHeaderDto {
    'id'?: string;
    'name'?: string | null;
    'clientId'?: string;
    'clientName'?: string | null;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'dueDate'?: string | null;
    'stage'?: AuditBinderStage;
    'description'?: string | null;
    'createdAt'?: string;
    'completedAt'?: string | null;
    'deletionScheduledAt'?: string | null;
}


export interface AuditBinderDetailItemDto {
    'id'?: string;
    'title'?: string | null;
    'description'?: string | null;
    'priority'?: DocumentRequestPriority;
    'dueDate'?: string | null;
    'status'?: DocumentRequestStatus;
    'derivedStatus'?: AuditBinderItemDerivedStatus;
    'clientResponse'?: ClientResponseType;
    'clientResponseNote'?: string | null;
    'requestType'?: AuditDocumentRequestType;
    'requestTypeDisplayName'?: string | null;
    'isConfidential'?: boolean;
    'confidentialClientUserId'?: string | null;
    'confidentialClientUserName'?: string | null;
    'requiresApproval'?: boolean;
    'releasedToClientAt'?: string | null;
    'rejectionReason'?: string | null;
    'requestedByName'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'documents'?: Array<AuditBinderDetailDocumentDto> | null;
    'comments'?: Array<AuditBinderDetailCommentDto> | null;
    'activity'?: Array<AuditBinderDetailActivityDto> | null;
    'commentCount'?: number;
    'unreadCommentCount'?: number;
}


export interface AuditBinderDetailSummaryDto {
    'totalItems'?: number;
    'approvedItems'?: number;
    'pendingReviewItems'?: number;
    'awaitingClientItems'?: number;
    'needsAttentionItems'?: number;
    'naItems'?: number;
    'pendingReleaseItems'?: number;
}
export interface AuditBinderDto {
    'id'?: string;
    'name'?: string | null;
    'clientId'?: string;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'dueDate'?: string | null;
    'description'?: string | null;
    'stage'?: AuditBinderStage;
    'isArchived'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
    'preReleaseReviewAt'?: string | null;
    'preReleaseReviewById'?: string | null;
    'openAt'?: string | null;
    'openById'?: string | null;
    'inReviewStartedAt'?: string | null;
    'inReviewById'?: string | null;
    'inReviewCompletedAt'?: string | null;
    'completedAt'?: string | null;
    'completedById'?: string | null;
}


export interface AuditBinderDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum AuditBinderItemDerivedStatus {
    Awaiting = 'awaiting',
    PendingReview = 'pendingReview',
    NeedsAttention = 'needsAttention',
    Approved = 'approved',
    Na = 'na',
    PendingRelease = 'pendingRelease'
}


export interface AuditBinderSignatureDocumentDto {
    'documentId'?: string;
    'name'?: string | null;
    'fileSize'?: number;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
    'docuSealSubmissionId'?: number;
    'submissionStatus'?: string | null;
    'completedAt'?: string | null;
    'fieldTemplateId'?: string | null;
    'canEditFields'?: boolean;
    'signers'?: Array<AuditBinderSignerStatusDto> | null;
}
export interface AuditBinderSignerStatusDto {
    'clientUserId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
    'signingOrder'?: number;
    'completedAt'?: string | null;
    'signerId'?: number;
    'sentAt'?: string | null;
    'lastReminderSentAt'?: string | null;
    'reminderCount'?: number;
}

export enum AuditBinderStage {
    New = 'new',
    PreReleaseReview = 'preReleaseReview',
    Open = 'open',
    InReview = 'inReview',
    Complete = 'complete'
}


export interface AuditDashboardItemDto {
    'id'?: string;
    'name'?: string | null;
    'stage'?: AuditBinderStage;
    'dueDate'?: string | null;
    'daysOverdue'?: number;
    'periodStart'?: string;
    'periodEnd'?: string;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'createdAt'?: string;
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'clientEmail'?: string | null;
    'officeId'?: string | null;
    'officeName'?: string | null;
    'documentsTotal'?: number;
    'documentsApproved'?: number;
    'documentCompletionPercentage'?: number;
    'requestsTotal'?: number;
    'requestsCompleted'?: number;
    'completionPercentage'?: number;
    'lastActivityAt'?: string | null;
    'isWatched'?: boolean;
}


export interface AuditDashboardItemDtoPaginatedResponse {
    'items'?: Array<AuditDashboardItemDto> | null;
    'pagination'?: PaginationInfo;
}
export interface AuditDashboardItemDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: AuditDashboardItemDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum AuditDocumentRequestType {
    Cash = 'cash',
    Expenses = 'expenses',
    Payroll = 'payroll',
    Revenue = 'revenue',
    AccountsReceivable = 'accountsReceivable',
    AccountsPayable = 'accountsPayable',
    Inventory = 'inventory',
    FixedAssets = 'fixedAssets',
    DebtAndFinancing = 'debtAndFinancing',
    Equity = 'equity',
    Tax = 'tax',
    General = 'general',
    Grants = 'grants',
    Investments = 'investments',
    Other = 'other'
}



export enum BankAccountType {
    Checking = 'checking',
    Savings = 'savings'
}


export interface BatchExtractionRequest {
    'binderId': string;
    'documentIds'?: Array<string> | null;
}
export interface BatchExtractionResponse {
    'totalDocuments'?: number;
    'successfulExtractions'?: number;
    'failedExtractions'?: number;
    'skippedDocuments'?: number;
    'results'?: Array<ExtractionResult> | null;
    'duration'?: string;
}
export interface BatchExtractionResponseApiResponse {
    'success'?: boolean;
    'data'?: BatchExtractionResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BatchProcessedDocumentDto {
    'documentId'?: string;
    'pageNumbers'?: Array<number> | null;
    'detectedFormType'?: string | null;
    'confidence'?: number | null;
    'assignedToRequest'?: boolean;
    'requiredDocumentId'?: string | null;
    'dataExtracted'?: boolean;
}
export interface BatchUploadJobResponse {
    'jobId'?: string;
    'binderId'?: string;
    'status'?: string | null;
    'estimatedDuration'?: string;
    'fileName'?: string | null;
    'fileSize'?: number;
    'queuedAt'?: string;
    'autoSplitEnabled'?: boolean;
    'autoSplitApplied'?: boolean;
    'autoSplitConfidence'?: number | null;
    'detectedGroups'?: number | null;
}
export interface BatchUploadJobResponseApiResponse {
    'success'?: boolean;
    'data'?: BatchUploadJobResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BatchUploadProgress {
    'currentPage'?: number;
    'totalPages'?: number;
    'stage'?: string | null;
    'message'?: string | null;
    'percentComplete'?: number;
}
export interface BatchUploadResult {
    'jobId'?: string;
    'binderId'?: string;
    'totalPages'?: number;
    'processedDocuments'?: Array<BatchProcessedDocumentDto> | null;
    'summary'?: BatchUploadSummary;
    'duration'?: string;
}
export interface BatchUploadResultApiResponse {
    'success'?: boolean;
    'data'?: BatchUploadResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BatchUploadStatusResponse {
    'jobId'?: string;
    'status'?: string | null;
    'progress'?: BatchUploadProgress;
    'startedAt'?: string | null;
    'completedAt'?: string | null;
    'estimatedCompletion'?: string | null;
    'errorMessage'?: string | null;
}
export interface BatchUploadStatusResponseApiResponse {
    'success'?: boolean;
    'data'?: BatchUploadStatusResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BatchUploadSummary {
    'documentsCreated'?: number;
    'documentsAutoAssigned'?: number;
    'formsDetected'?: number;
    'detectionFailures'?: number;
    'dataExtractionCount'?: number;
    'warnings'?: Array<string> | null;
}
export interface BinderActionPreferenceDto {
    'actionType'?: NotificationActionType;
    'actionTypeValue'?: number;
    'displayName'?: string | null;
    'description'?: string | null;
    'category'?: string | null;
    'overrideChannel'?: NotificationDeliveryChannel;
    'isUsingDefault'?: boolean;
    'globalEffectiveChannel'?: NotificationDeliveryChannel;
    'effectiveChannel'?: NotificationDeliveryChannel;
}



export enum BinderActivityType {
    None = 'none',
    ClientComment = 'clientComment',
    ClientDocumentUpload = 'clientDocumentUpload',
    ClientSubmitted = 'clientSubmitted',
    PreparerInReview = 'preparerInReview',
    PreparerCompleted = 'preparerCompleted'
}


export interface BinderEstimatedPaymentsDto {
    'binderId'?: string;
    'taxYear'?: number;
    'sourceBinderId'?: string | null;
    'sourceTaxYear'?: number | null;
    'sourceReturnBundleId'?: string | null;
    'jurisdictions'?: Array<EstimatedPaymentJurisdictionDto> | null;
}
export interface BinderEstimatedPaymentsDtoApiResponse {
    'success'?: boolean;
    'data'?: BinderEstimatedPaymentsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BinderListItemDto {
    'id'?: string;
    'name'?: string | null;
    'clientId'?: string;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'binderType'?: BinderType;
    'dueDate'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'isArchived'?: boolean;
    'taxYear'?: number | null;
    'taxStage'?: BinderStage;
    'auditStage'?: AuditBinderStage;
    'periodStart'?: string | null;
    'periodEnd'?: string | null;
}


export interface BinderListItemDtoPaginatedResponse {
    'items'?: Array<BinderListItemDto> | null;
    'pagination'?: PaginationInfo;
}
export interface BinderListItemDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: BinderListItemDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BinderNotificationPreferenceDto {
    'binderId'?: string;
    'actions'?: Array<BinderActionPreferenceDto> | null;
}
export interface BinderNotificationPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: BinderNotificationPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BinderPageDefaultsDto {
    'rowsPerPage'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'status'?: string | null;
    'taxYear'?: string | null;
    'stage'?: string | null;
    'hasLateDocuments'?: string | null;
}

export enum BinderStage {
    New = 'new',
    Open = 'open',
    ClientSubmitted = 'clientSubmitted',
    InReview = 'inReview',
    ReadyForScan = 'readyForScan',
    SentForPreparation = 'sentForPreparation',
    FinalClientReview = 'finalClientReview',
    ClientRequestsChanges = 'clientRequestsChanges',
    EfileReady = 'efileReady',
    Complete = 'complete'
}



export enum BinderStatusFilter {
    Na = 'na',
    HasOpen = 'hasOpen',
    AllCompleted = 'allCompleted',
    NoBinders = 'noBinders'
}



export enum BinderType {
    Tax = 'tax',
    Audit = 'audit'
}


export interface BooleanApiResponse {
    'success'?: boolean;
    'data'?: boolean;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BulkApproveDocumentRequestsDto {
    'documentRequestIds': Array<string>;
    'reviewNotes'?: string | null;
}
export interface BulkApproveDocumentRequestsResultDto {
    'approvedRequestIds'?: Array<string> | null;
    'skipped'?: Array<BulkApproveSkippedItemDto> | null;
    'approvedCount'?: number;
    'skippedCount'?: number;
}
export interface BulkApproveDocumentRequestsResultDtoApiResponse {
    'success'?: boolean;
    'data'?: BulkApproveDocumentRequestsResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BulkApproveSkippedItemDto {
    'documentRequestId'?: string;
    'reason'?: string | null;
}
export interface BulkCsvImportResult {
    'success'?: boolean;
    'totalProcessed'?: number;
    'found'?: number;
    'notFound'?: number;
    'alreadyImported'?: number;
    'newlyImported'?: number;
    'failed'?: number;
    'contactInfoUpdated'?: number;
    'isDryRun'?: boolean;
    'results'?: Array<BulkCsvImportResultItem> | null;
}
export interface BulkCsvImportResultItem {
    'clientId'?: string | null;
    'found'?: boolean;
    'imported'?: boolean;
    'importedClientId'?: string | null;
    'clientName'?: string | null;
    'wasAlreadyImported'?: boolean;
    'nameUpdated'?: boolean;
    'taxIdUpdated'?: boolean;
    'emailUpdated'?: boolean;
    'phoneUpdated'?: boolean;
    'primaryUserUpdated'?: boolean;
    'spouseCreated'?: boolean;
    'spouseUpdated'?: boolean;
    'spouseUserCreated'?: boolean;
    'status'?: string | null;
    'error'?: string | null;
    'validationErrors'?: Array<string> | null;
}
export interface BulkImportJobStartedDto {
    'jobId'?: string | null;
    'hangfireJobId'?: string | null;
    'message'?: string | null;
    'statusUrl'?: string | null;
    'totalClients'?: number;
}
export interface BulkImportJobStartedDtoApiResponse {
    'success'?: boolean;
    'data'?: BulkImportJobStartedDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BulkImportJobState {
    'jobId'?: string | null;
    'status'?: string | null;
    'totalClients'?: number;
    'processedCount'?: number;
    'foundCount'?: number;
    'importedCount'?: number;
    'alreadyImportedCount'?: number;
    'notFoundCount'?: number;
    'failedCount'?: number;
    'isDryRun'?: boolean;
    'sourceSystem'?: string | null;
    'errorMessage'?: string | null;
    'startedAt'?: string;
    'completedAt'?: string | null;
    'progressPercent'?: number;
    'result'?: BulkCsvImportResult;
}
export interface BulkImportJobStateApiResponse {
    'success'?: boolean;
    'data'?: BulkImportJobState;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BulkReviewDocumentsDto {
    'documents': Array<DocumentReviewItemDto>;
}

export enum BundleDocumentCategory {
    EFileAuthorization = 'eFileAuthorization',
    EngagementLetter = 'engagementLetter',
    DirectDepositReport = 'directDepositReport',
    FilingInstructions = 'filingInstructions',
    PaymentVoucher = 'paymentVoucher',
    TaxReturn = 'taxReturn',
    AdditionalDocument = 'additionalDocument',
    AuthorizationForm = 'authorizationForm',
    CoverLetter = 'coverLetter',
    SCorpElection = 'sCorpElection'
}


export interface BundleDocumentDto {
    'id'?: string;
    'taxReturnBundleId'?: string;
    'taxReturnBundleJurisdictionId'?: string | null;
    'documentId'?: string | null;
    'documentCategory'?: BundleDocumentCategory;
    'displayName'?: string | null;
    'sortOrder'?: number;
    'isExtracted'?: boolean;
    'sourceCopyType'?: ReturnCopyType;
    'sourceStartPage'?: number | null;
    'sourceEndPage'?: number | null;
    'formType'?: string | null;
    'requiresSignature'?: boolean;
    'signatureStatus'?: BundleDocumentSignatureStatus;
    'signedAt'?: string | null;
    'docuSealSubmissionId'?: string | null;
    'isPreparerAdded'?: boolean;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
}


export interface BundleDocumentDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleDocumentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BundleDocumentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<BundleDocumentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BundleDocumentSignatureInfoDto {
    'bundleDocumentId'?: string;
    'displayName'?: string | null;
    'documentCategory'?: BundleDocumentCategory;
    'jurisdictionCode'?: string | null;
    'signatureFieldCount'?: number;
}


export interface BundleDocumentSignatureResponseDto {
    'binderId'?: string;
    'submissionId'?: string | null;
    'signingUrl'?: string | null;
    'totalSignatureFields'?: number;
    'documents'?: Array<BundleDocumentSignatureInfoDto> | null;
    'submitters'?: Array<BundleSignatureSubmitterDto> | null;
    'sentAt'?: string | null;
    'engagementLetterSubmissionId'?: string | null;
    'engagementLetterSigningUrl'?: string | null;
}
export interface BundleDocumentSignatureResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleDocumentSignatureResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum BundleDocumentSignatureStatus {
    None = 'none',
    Pending = 'pending',
    AwaitingSignature = 'awaitingSignature',
    Signed = 'signed',
    ManualRequired = 'manualRequired',
    Skipped = 'skipped'
}


export interface BundleDocumentSignatureStatusDto {
    'bundleDocumentId'?: string;
    'displayName'?: string | null;
    'documentCategory'?: BundleDocumentCategory;
    'jurisdictionCode'?: string | null;
    'signatureStatus'?: BundleDocumentSignatureStatus;
    'signedAt'?: string | null;
}


export interface BundlePageReferenceDto {
    'id'?: string;
    'referenceType'?: BundleReferenceType;
    'copyType'?: ReturnCopyType;
    'startPage'?: number;
    'endPage'?: number;
    'bookmarkTitle'?: string | null;
    'formType'?: string | null;
    'sortOrder'?: number;
}


export interface BundleProcessingResultDto {
    'success'?: boolean;
    'binderId'?: string;
    'returnsCreated'?: number;
    'documentsExtracted'?: number;
    'filingInstructionsExtracted'?: number;
    'vouchersExtracted'?: number;
    'k1PartnersExtracted'?: number;
    'warnings'?: Array<string> | null;
    'errorMessage'?: string | null;
    'processedAt'?: string;
    'returns'?: Array<TaxReturnBundleJurisdictionSummaryDto> | null;
    'clientMismatchWarning'?: ClientMismatchWarningDto;
}
export interface BundleProcessingResultDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleProcessingResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BundleProcessingStatusDto {
    'binderId'?: string;
    'isProcessed'?: boolean;
    'processedAt'?: string | null;
    'status'?: ProcessingStatus;
    'errorMessage'?: string | null;
    'returnCount'?: number;
    'returns'?: Array<TaxReturnBundleJurisdictionSummaryDto> | null;
}


export interface BundleProcessingStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleProcessingStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum BundleReferenceType {
    JurisdictionReturn = 'jurisdictionReturn',
    Form8879 = 'form8879',
    FilingInstructions = 'filingInstructions',
    PaymentVoucher = 'paymentVoucher',
    MainForm = 'mainForm',
    Schedule = 'schedule',
    StateForm = 'stateForm',
    DirectDepositReport = 'directDepositReport'
}


export interface BundleSignatureRequirementDto {
    'id'?: string;
    'taxReturnBundleJurisdictionId'?: string;
    'signerRole'?: SignerRole;
    'detectedName'?: string | null;
    'isDeceased'?: boolean;
    'deceasedDate'?: string | null;
    'userId'?: string | null;
    'userName'?: string | null;
    'userEmail'?: string | null;
    'signingOrder'?: number;
    'requiresManualSign'?: boolean;
    'manualSignReason'?: string | null;
    'status'?: SignatureRequirementStatus;
    'signedAt'?: string | null;
    'hasAssignedUser'?: boolean;
    'canESign'?: boolean;
}


export interface BundleSignatureRequirementDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleSignatureRequirementDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BundleSignatureStatusDto {
    'binderId'?: string;
    'hasBundleSignature'?: boolean;
    'submissionId'?: string | null;
    'status'?: string | null;
    'jurisdictions'?: Array<JurisdictionSignatureStatusDto> | null;
    'signers'?: Array<BundleSignerStatusDto> | null;
    'documents'?: Array<BundleDocumentSignatureStatusDto> | null;
    'signingUrl'?: string | null;
    'sentAt'?: string | null;
    'completedAt'?: string | null;
    'preparerMessage'?: string | null;
    'engagementLetterSubmissionId'?: string | null;
    'engagementLetterSigningUrl'?: string | null;
}
export interface BundleSignatureStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleSignatureStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BundleSignatureSubmitterDto {
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'slug'?: string | null;
}
export interface BundleSignerStatusDto {
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
    'slug'?: string | null;
    'completedAt'?: string | null;
    'viewedAt'?: string | null;
}
export interface CchDocumentDto {
    'documentGuid'?: string | null;
    'fileName'?: string | null;
    'year'?: string | null;
    'className'?: string | null;
    'subClassName'?: string | null;
    'entityName'?: string | null;
    'status'?: string | null;
    'alreadyImported'?: boolean;
    'mappedDocumentType'?: string | null;
}
export interface CchDocumentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<CchDocumentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CchDocumentImportItemDto {
    'cchDocumentGuid'?: string | null;
    'fileName'?: string | null;
    'status'?: string | null;
    'documentId'?: string;
    'error'?: string | null;
}
export interface CchDocumentImportRequest {
    'documentGuids'?: Array<string> | null;
    'processAsReturns'?: boolean;
}
export interface CchDocumentImportResultDto {
    'importedCount'?: number;
    'skippedCount'?: number;
    'failedCount'?: number;
    'items'?: Array<CchDocumentImportItemDto> | null;
    'bundleProcessingResult'?: BundleProcessingResultDto;
    'bundleProcessingError'?: string | null;
}
export interface CchDocumentImportResultDtoApiResponse {
    'success'?: boolean;
    'data'?: CchDocumentImportResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ChangePasswordDto {
    'currentPassword'?: string | null;
    'newPassword'?: string | null;
    'confirmPassword'?: string | null;
}
export interface ClientAccessPermissionDto {
    'id'?: string;
    'clientId'?: string;
    'userId'?: string;
    'userFirstName'?: string | null;
    'userLastName'?: string | null;
    'userEmail'?: string | null;
    'userRole'?: UserRole;
    'grantedBy'?: string;
    'grantedByFirstName'?: string | null;
    'grantedByLastName'?: string | null;
    'grantedAt'?: string;
}


export interface ClientAccessPermissionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientAccessPermissionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientAccessSummaryDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'directAccess'?: Array<DirectClientAccessDto> | null;
    'indirectAccess'?: Array<IndirectClientAccessDto> | null;
    'totalUsersWithAccess'?: number;
}
export interface ClientAccessSummaryDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientAccessSummaryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientAuditEntryDto {
    'id'?: number;
    'timestampUtc'?: string;
    'action'?: string | null;
    'description'?: string | null;
    'userName'?: string | null;
    'userId'?: string | null;
    'fieldChanges'?: Array<FieldChangeDto> | null;
    'ipAddress'?: string | null;
}
export interface ClientAuditHistoryDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'auditEntries'?: Array<ClientAuditEntryDto> | null;
    'totalEntries'?: number;
}
export interface ClientAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientBankAccountDto {
    'id'?: string;
    'accountType'?: BankAccountType;
    'accountTypeDisplay'?: string | null;
    'bankName'?: string | null;
    'accountNumber'?: string | null;
    'accountNumberLast4'?: string | null;
    'routingNumber'?: string | null;
    'isPreferredForRefund'?: boolean;
    'isPreferredForPayment'?: boolean;
    'notes'?: string | null;
}


export interface ClientBankAccountDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientBankAccountDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDependentDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'ssn'?: string | null;
    'dateOfBirth'?: string | null;
    'age'?: number | null;
    'relationship'?: DependentRelationship;
    'relationshipDisplay'?: string | null;
    'monthsLivedInHome'?: number | null;
    'isStudent'?: boolean;
    'isDisabled'?: boolean;
    'notes'?: string | null;
}


export interface ClientDependentDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientDependentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDetailsDto {
    'id'?: string;
    'clientNumber'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'taxId'?: string | null;
    'maskedTaxId'?: string | null;
    'spouseTaxId'?: string | null;
    'maskedSpouseTaxId'?: string | null;
    'fullAddress'?: string | null;
    'type'?: ClientType;
    'typeDisplay'?: string | null;
    'notes'?: string | null;
    'serviceLines'?: Array<ServiceLine> | null;
    'tags'?: Array<string> | null;
    'documentCount'?: number;
    'organizerCount'?: number;
    'auditBinderCount'?: number;
    'dependentsCount'?: number;
    'maritalStatus'?: MaritalStatus;
    'maritalStatusDisplay'?: string | null;
    'office'?: OfficeDto;
    'lastActivityAt'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'practiceManagementId'?: string | null;
    'practiceManagementSource'?: string | null;
    'isConfidential'?: boolean;
    'confidentialMarkedAt'?: string | null;
    'confidentialMarkedBy'?: string | null;
    'confidentialMarkedByName'?: string | null;
    'authorizedUserIds'?: Array<string> | null;
    'allowPhysicalSignature'?: boolean;
    'engagementLetterRequired'?: boolean;
    'partnerId'?: string | null;
    'partnerName'?: string | null;
    'partnerEmail'?: string | null;
    'defaultClientUsers'?: Array<ImportClientUserDto> | null;
    'validationWarnings'?: Array<string> | null;
    'users'?: Array<ClientUserDto> | null;
    'recentDocuments'?: Array<DocumentDto> | null;
    'recentBinders'?: Array<TaxBinderDto> | null;
    'statistics'?: ClientStatisticsDto;
}


export interface ClientDetailsDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientDetailsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDto {
    'id'?: string;
    'clientNumber'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'taxId'?: string | null;
    'maskedTaxId'?: string | null;
    'spouseTaxId'?: string | null;
    'maskedSpouseTaxId'?: string | null;
    'fullAddress'?: string | null;
    'type'?: ClientType;
    'typeDisplay'?: string | null;
    'notes'?: string | null;
    'serviceLines'?: Array<ServiceLine> | null;
    'tags'?: Array<string> | null;
    'documentCount'?: number;
    'organizerCount'?: number;
    'auditBinderCount'?: number;
    'dependentsCount'?: number;
    'maritalStatus'?: MaritalStatus;
    'maritalStatusDisplay'?: string | null;
    'office'?: OfficeDto;
    'lastActivityAt'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'practiceManagementId'?: string | null;
    'practiceManagementSource'?: string | null;
    'isConfidential'?: boolean;
    'confidentialMarkedAt'?: string | null;
    'confidentialMarkedBy'?: string | null;
    'confidentialMarkedByName'?: string | null;
    'authorizedUserIds'?: Array<string> | null;
    'allowPhysicalSignature'?: boolean;
    'engagementLetterRequired'?: boolean;
    'partnerId'?: string | null;
    'partnerName'?: string | null;
    'partnerEmail'?: string | null;
    'defaultClientUsers'?: Array<ImportClientUserDto> | null;
    'validationWarnings'?: Array<string> | null;
}


export interface ClientDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDtoPaginatedResponse {
    'items'?: Array<ClientDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientLoginDto {
    'emailOrPhone': string;
    'taxIdLast4': string;
}
export interface ClientMismatchWarningDto {
    'detectedClientNumber'?: string | null;
    'detectedClientName'?: string | null;
    'expectedClientNumber'?: string | null;
    'expectedClientName'?: string | null;
}
export interface ClientNoteDto {
    'id'?: string;
    'clientId'?: string;
    'serviceLine'?: ServiceLine;
    'content'?: string | null;
    'createdById'?: string;
    'createdByName'?: string | null;
    'createdAt'?: string;
    'updatedById'?: string | null;
    'updatedByName'?: string | null;
    'updatedAt'?: string;
}


export interface ClientNoteDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientNoteDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientNoteDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientNoteDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientNotificationPreferenceDto {
    'id'?: string;
    'clientId'?: string;
    'preferredChannel'?: NotificationChannel;
    'isEnabled'?: boolean;
    'batchIntervalMinutes'?: number;
    'enableDocumentRequests'?: boolean;
    'enableDocumentApprovals'?: boolean;
    'enableDocumentRejections'?: boolean;
    'enableDocumentComments'?: boolean;
    'enableBinderStageChanges'?: boolean;
    'enableBinderCreated'?: boolean;
    'enableSignatureRequests'?: boolean;
    'enableAuditBinderStageChanges'?: boolean;
    'enableAuditBinderComments'?: boolean;
    'enableAuditBinderDocumentApprovals'?: boolean;
    'enableAuditBinderDocumentRejections'?: boolean;
    'enableAuditBinderDocumentRequests'?: boolean;
    'enableAuditBinderDocumentRequestOutcomes'?: boolean;
    'notifyPrimaryUser'?: boolean;
    'notifySpouse'?: boolean;
    'notifyDependents'?: boolean;
    'notifyAuthorized'?: boolean;
    'notifyAccountant'?: boolean;
}


export interface ClientNotificationPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientNotificationPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientPageDefaultsDto {
    'rowsPerPage'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'myClientsOnly'?: string | null;
    'binderStatus'?: string | null;
    'type'?: string | null;
    'state'?: string | null;
    'officeIds'?: Array<string> | null;
    'partnerId'?: string | null;
    'confidentialFilter'?: string | null;
    'tags'?: Array<string> | null;
    'dateRangeStart'?: string | null;
    'dateRangeEnd'?: string | null;
}
export interface ClientPortalAccessRequestDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'zipCode'?: string | null;
    'last4TaxId'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'connectedTaxEntities'?: string | null;
    'comments'?: string | null;
    'status'?: AccessRequestStatus;
    'createdAt'?: string;
    'updatedAt'?: string;
    'reviewedAt'?: string | null;
    'reviewedByUserId'?: string | null;
    'reviewedByUserName'?: string | null;
    'reviewerNotes'?: string | null;
    'matchedClientId'?: string | null;
    'matchedClientName'?: string | null;
    'officeId'?: string | null;
    'officeName'?: string | null;
}


export interface ClientPortalAccessRequestDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientPortalAccessRequestDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientPortalAccessRequestDtoPaginatedResponse {
    'items'?: Array<ClientPortalAccessRequestDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientPortalAccessRequestDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientPortalAccessRequestDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientResponseDto {
    'responseType': ClientResponseType;
    'note'?: string | null;
}



export enum ClientResponseType {
    CannotProvide = 'cannotProvide',
    NotApplicable = 'notApplicable',
    WillProvideDocument = 'willProvideDocument',
    FirmHasThisItem = 'firmHasThisItem',
    IncludedInOtherRequest = 'includedInOtherRequest'
}


export interface ClientSearchQueryDto {
    'searchTerm'?: string | null;
    'type'?: ClientType;
    'officeId'?: string | null;
    'officeIds'?: Array<string> | null;
    'state'?: string | null;
    'enableSemanticSearch'?: boolean | null;
    'watchedClientsOnly'?: boolean | null;
    'binderStatus'?: BinderStatusFilter;
    'dateRange'?: DateRangeDto;
    'confidentialFilter'?: ConfidentialFilter;
    'partnerId'?: string | null;
    'page'?: number;
    'pageSize'?: number;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
}


export interface ClientSearchResultDto {
    'client'?: ClientDto;
    'score'?: number;
    'exactScore'?: number;
    'fuzzyScore'?: number;
    'semanticScore'?: number;
    'matchType'?: string | null;
    'highlightedName'?: string | null;
}
export interface ClientSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientSearchResultDtoPaginatedResponse {
    'items'?: Array<ClientSearchResultDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientSearchResultDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientSearchResultDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientSearchSuggestionDto {
    'id'?: string;
    'name'?: string | null;
    'clientNumber'?: string | null;
    'email'?: string | null;
    'clientType'?: ClientType;
    'clientTypeDisplay'?: string | null;
    'statusDisplay'?: string | null;
    'score'?: number;
}


export interface ClientSearchSuggestionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientSearchSuggestionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientSpouseDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'ssn'?: string | null;
    'dateOfBirth'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
}
export interface ClientSpouseDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientSpouseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientStatisticsDto {
    'totalDocuments'?: number;
    'totalBinders'?: number;
    'totalComments'?: number;
    'documentsByYear'?: { [key: string]: number; } | null;
    'documentsByType'?: ClientStatisticsDtoDocumentsByType | null;
    'lastDocumentUpload'?: string | null;
    'lastOrganizerUpdate'?: string | null;
}
export interface ClientStatisticsDtoDocumentsByType {
    'incomeDocument'?: number;
    'deductionDocument'?: number;
    'supportingDocument'?: number;
    'identificationDocument'?: number;
    'otherClientDocument'?: number;
    'taxReturn'?: number;
    'eFileAuthorization'?: number;
    'taxBinder'?: number;
    'engagementLetter'?: number;
    'estimatedPaymentVoucher'?: number;
    'directDepositReport'?: number;
    'otherPreparerDocument'?: number;
    'powerOfAttorney'?: number;
    'taxInformationAuthorization'?: number;
    'paymentAuthorization'?: number;
    'extensionRequest'?: number;
    'otherAuthorization'?: number;
}

export enum ClientType {
    Corporation = 'corporation',
    EmployeePlan = 'employeePlan',
    Fiduciary = 'fiduciary',
    Individual = 'individual',
    NonProfit = 'nonProfit',
    Partnership = 'partnership',
    SoleProprietorship = 'soleProprietorship',
    Other = 'other',
    Staff = 'staff',
    Project = 'project',
    Audit = 'audit'
}


export interface ClientUserDto {
    'id'?: string;
    'userId'?: string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'role'?: ClientUserRole;
    'roleDisplay'?: string | null;
    'isMainContact'?: boolean;
    'createdAt'?: string;
    'otherConnectedClientsCount'?: number;
    'otherConnectedClients'?: Array<ConnectedClientInfo> | null;
}


export interface ClientUserDtoPaginatedResponse {
    'items'?: Array<ClientUserDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientUserDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientUserDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum ClientUserRole {
    Primary = 'primary',
    Spouse = 'spouse',
    Dependent = 'dependent',
    Authorized = 'authorized',
    Accountant = 'accountant',
    K1Recipient = 'k1Recipient'
}


export interface ClientWatcherInfo {
    'userId'?: string;
    'userName'?: string | null;
    'userEmail'?: string | null;
    'watchedAt'?: string;
    'isAutoAdded'?: boolean;
}
export interface ClientWatcherInfoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientWatcherInfo> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CommentDto {
    'id'?: string;
    'content'?: string | null;
    'documentId'?: string | null;
    'binderId'?: string | null;
    'documentRequestId'?: string | null;
    'isInternal'?: boolean;
    'parentCommentId'?: string | null;
    'priority'?: string | null;
    'status'?: string | null;
    'replies'?: Array<CommentDto> | null;
    'createdById'?: string;
    'createdByName'?: string | null;
    'createdByRole'?: string | null;
    'createdAt'?: string;
    'updatedById'?: string | null;
    'updatedByName'?: string | null;
    'updatedAt'?: string;
    'isRead'?: boolean;
    'readAt'?: string | null;
    'readById'?: string | null;
    'readByName'?: string | null;
}
export interface CommentDtoApiResponse {
    'success'?: boolean;
    'data'?: CommentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CommentDtoPaginatedResponse {
    'items'?: Array<CommentDto> | null;
    'pagination'?: PaginationInfo;
}
export interface CommentDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: CommentDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CommonFormTypeDto {
    'code'?: string | null;
    'displayName'?: string | null;
    'category'?: string | null;
}
export interface CompleteQuestionnaireRequest {
    'answers': any;
}

export enum ConfidentialFilter {
    All = 'all',
    PublicOnly = 'publicOnly',
    MyViewableClients = 'myViewableClients',
    Restricted = 'restricted',
    AllConfidential = 'allConfidential'
}


export interface ConnectedClientInfo {
    'clientId'?: string;
    'clientName'?: string | null;
}
export interface ConvertToPaperDto {
    'reason'?: string | null;
}

export enum CoordinateSystem {
    PdfPoints = 'pdfPoints',
    Percentage = 'percentage',
    Pixels = 'pixels',
    Millimeters = 'millimeters'
}


export interface CreateAuditBinderDto {
    'clientId': string;
    'name': string;
    'periodStart': string;
    'periodEnd': string;
    'dueDate': string;
    'description'?: string | null;
}
export interface CreateBinderWithBundleResultDto {
    'binder'?: TaxBinderDto;
    'returnsCreated'?: number;
    'documentsExtracted'?: number;
    'filingInstructionsExtracted'?: number;
    'vouchersExtracted'?: number;
    'k1PartnersExtracted'?: number;
    'warnings'?: Array<string> | null;
    'clientMismatchWarning'?: ClientMismatchWarningDto;
    'processedAt'?: string;
}
export interface CreateBinderWithBundleResultDtoApiResponse {
    'success'?: boolean;
    'data'?: CreateBinderWithBundleResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CreateClientNoteDto {
    'clientId': string;
    'serviceLine': ServiceLine;
    'content': string;
}


export interface CreateClientPortalAccessRequestDto {
    'firstName': string;
    'lastName': string;
    'zipCode': string;
    'last4TaxId': string;
    'email': string;
    'phoneNumber': string;
    'connectedTaxEntities'?: string | null;
    'comments'?: string | null;
    'officeId'?: string | null;
}
export interface CreateCommentDto {
    'content': string;
    'documentId'?: string | null;
    'binderId'?: string | null;
    'documentRequestId'?: string | null;
    'isInternal'?: boolean;
    'parentCommentId'?: string | null;
    'priority'?: string | null;
    'status'?: string | null;
}
export interface CreateDocumentRequestDto {
    'title': string;
    'description'?: string | null;
    'clientId': string;
    'binderId'?: string | null;
    'priority'?: DocumentRequestPriority;
    'dueDate'?: string | null;
    'notes'?: string | null;
    'taxYear': number;
    'sortOrder'?: number;
    'requestType'?: AuditDocumentRequestType;
    'isConfidential'?: boolean | null;
    'confidentialClientUserId'?: string | null;
    'requiresApproval'?: boolean | null;
}


export interface CreateK1RecipientAssignmentDto {
    'k1DocumentId': string;
    'partnerName': string;
    'bookmarkName': string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
}
export interface CreatePaymentVoucherDto {
    'quarter': VoucherQuarter;
    'taxYear': number;
    'formNumber': string;
    'dueDate': string;
    'amount': number;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
}


export interface CreatePrimaryUserDto {
    'firstName': string;
    'lastName': string;
    'email': string;
    'phoneNumber': string;
}
export interface CreateQuestionnaireDto {
    'title': string;
    'description'?: string | null;
    'taxYear': number;
    'isActive'?: boolean;
    'isRequired'?: boolean;
    'questions'?: Array<CreateQuestionnaireQuestionDto> | null;
}
export interface CreateQuestionnaireQuestionDto {
    'question': string;
    'description'?: string | null;
    'questionType': QuestionType;
    'options'?: Array<string> | null;
    'isRequired'?: boolean;
    'validationRules'?: { [key: string]: any | null; } | null;
}


export interface CreateQuestionnaireResponseDto {
    'binderId': string;
    'responseData': string;
}
export interface CreateSignatureRequestDto {
    'documentId': string;
    'name'?: string | null;
    'signers': Array<SignerAssignmentDto>;
    'fields': Array<SignatureFieldPlacementDto>;
    'fieldTemplateId'?: string | null;
}
export interface CreateSignatureTemplateDto {
    'documentType': DocumentType;
    'specificFormType'?: string | null;
    'templateName': string;
    'requiresSignature'?: boolean;
    'isOneTimeUse'?: boolean;
    'fields': Array<TemplateSignatureFieldDto>;
}


export interface CreateSigningFormRequestDto {
    'templateId': string;
    'submitters': Array<SigningFormSubmitterDto>;
    'isPreviewMode'?: boolean;
    'completedRedirectUrl'?: string | null;
    'expiresAt'?: string | null;
    'message'?: SigningFormMessageDto;
}
export interface CreateSubmissionFromPdfDto {
    'name'?: string | null;
    'send_email'?: boolean;
    'send_sms'?: boolean;
    'order'?: string | null;
    'completed_redirect_url'?: string | null;
    'bcc_completed'?: string | null;
    'reply_to'?: string | null;
    'expire_at'?: string | null;
    'flatten'?: boolean;
    'merge_documents'?: boolean;
    'remove_tags'?: boolean;
    'embedded'?: boolean;
    'documents': Array<DocuSealDocumentDto>;
    'submitters': Array<SubmitterDto>;
}
export interface CreateTemplateFromDocumentDto {
    'documentId': string;
    'templateName'?: string | null;
    'documentType'?: DocumentType;
    'requiresSignature'?: boolean;
    'isOneTimeUse'?: boolean;
    'autoGenerateName'?: boolean | null;
}


export interface CreateUploadLinkDto {
    'label': string;
    'message'?: string | null;
    'recipientEmails'?: Array<string> | null;
    'expiresAt'?: string | null;
}
export interface CreateUserDto {
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'password'?: string | null;
}


export interface CreateUserWithClientDto {
    'email': string;
    'firstName': string;
    'lastName': string;
    'phoneNumber'?: string | null;
    'clientId': string;
    'clientUserRole': ClientUserRole;
    'isMainContact'?: boolean | null;
}


export interface DashboardDto {
    'stats'?: DashboardStatsDto;
    'metrics'?: DashboardMetricsDto;
    'recentActivities'?: Array<RecentActivityDto> | null;
    'recentClients'?: Array<RecentClientDto> | null;
}
export interface DashboardDtoApiResponse {
    'success'?: boolean;
    'data'?: DashboardDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DashboardMetricsDto {
    'documentsAwaitingReview'?: number;
    'pendingSignatures'?: number;
    'questionnairesInProgress'?: number;
    'clientResponseRate'?: number;
}
export interface DashboardMetricsDtoApiResponse {
    'success'?: boolean;
    'data'?: DashboardMetricsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DashboardPageDefaultsDto {
    'myClientsOnly'?: string | null;
    'assignedToMe'?: string | null;
    'officeId'?: string | null;
    'partnerId'?: string | null;
    'activeCardFilter'?: string | null;
    'sortField'?: string | null;
    'sortOrder'?: string | null;
    'taxYear'?: string | null;
    'taxType'?: string | null;
    'stage'?: string | null;
    'isClientSubmitted'?: string | null;
}
export interface DashboardStatsDto {
    'documentsToReviewCount'?: number;
    'clientSubmissionsCount'?: number;
    'returnsInProcessCount'?: number;
    'commentsToReviewCount'?: number;
    'lateDocumentsCount'?: number;
}
export interface DashboardStatsDtoApiResponse {
    'success'?: boolean;
    'data'?: DashboardStatsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DateRangeDto {
    'startDate'?: string | null;
    'endDate'?: string | null;
}
export interface DeleteReturnDto {
    'reason'?: string | null;
}

export enum DependentRelationship {
    Child = 'child',
    Stepchild = 'stepchild',
    FosterChild = 'fosterChild',
    AdoptedChild = 'adoptedChild',
    Grandchild = 'grandchild',
    Parent = 'parent',
    Sibling = 'sibling',
    OtherRelative = 'otherRelative'
}


export interface DevClientLoginDto {
    'clientId': string;
    'emailOrPhone': string;
}
export interface DevSsoLoginDto {
    'email': string;
}
export interface DirectClientAccessDto {
    'userId'?: string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'clientRole'?: ClientUserRole;
    'clientRoleDisplay'?: string | null;
    'systemRole'?: UserRole;
    'systemRoleDisplay'?: string | null;
    'associatedAt'?: string;
}


export interface DocuSealDocumentDto {
    'name': string;
    'file': string;
    'fields'?: Array<DocuSealDocumentFieldDto> | null;
}
export interface DocuSealDocumentFieldDto {
    'name': string;
    'title'?: string | null;
    'type'?: string | null;
    'role'?: string | null;
    'required'?: boolean;
    'format'?: string | null;
    'areas'?: Array<DocuSealFieldAreaDto> | null;
}
export interface DocuSealFieldAreaDto {
    'x'?: number;
    'y'?: number;
    'w'?: number;
    'h'?: number;
    'page'?: number;
}
export interface DocuSealWebhookData {
    'status'?: string | null;
    'email'?: string | null;
    'name'?: string | null;
    'declineReason'?: string | null;
    'documents'?: Array<DocuSealWebhookDocument> | null;
}
export interface DocuSealWebhookDocument {
    'documentId'?: string | null;
    'fileName'?: string | null;
    'downloadUrl'?: string | null;
    'signedAt'?: string | null;
}
export interface DocuSealWebhookDto {
    'eventType'?: string | null;
    'submissionId'?: string | null;
    'timestamp'?: string;
    'data'?: DocuSealWebhookData;
    'signature'?: string | null;
}
export interface DocumentClassificationResult {
    'suggestedDocumentType'?: DocumentType;
    'confidence'?: number;
    'suggestedTags'?: Array<string> | null;
    'suggestedRequiredDocumentSlotId'?: string | null;
    'reasoning'?: string | null;
    'autoApplied'?: boolean;
    'detectedFormType'?: string | null;
}


export interface DocumentClassificationResultApiResponse {
    'success'?: boolean;
    'data'?: DocumentClassificationResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentCompletionStatus {
    'totalDocuments'?: number;
    'uploadedDocuments'?: number;
    'pendingDocuments'?: number;
    'completionPercentage'?: number;
    'documentStatuses'?: DocumentCompletionStatusDocumentStatuses | null;
}
export interface DocumentCompletionStatusDocumentStatuses {
    'incomeDocument'?: DocumentStatus;
    'deductionDocument'?: DocumentStatus;
    'supportingDocument'?: DocumentStatus;
    'identificationDocument'?: DocumentStatus;
    'otherClientDocument'?: DocumentStatus;
    'taxReturn'?: DocumentStatus;
    'eFileAuthorization'?: DocumentStatus;
    'taxBinder'?: DocumentStatus;
    'engagementLetter'?: DocumentStatus;
    'estimatedPaymentVoucher'?: DocumentStatus;
    'directDepositReport'?: DocumentStatus;
    'otherPreparerDocument'?: DocumentStatus;
    'powerOfAttorney'?: DocumentStatus;
    'taxInformationAuthorization'?: DocumentStatus;
    'paymentAuthorization'?: DocumentStatus;
    'extensionRequest'?: DocumentStatus;
    'otherAuthorization'?: DocumentStatus;
}



export enum DocumentDirection {
    ReceivedFromClient = 'receivedFromClient',
    SentToClient = 'sentToClient'
}


export interface DocumentDownloadUrlDto {
    'downloadUrl'?: string | null;
    'expiresAt'?: string;
    'fileName'?: string | null;
    'contentType'?: string | null;
    'fileSize'?: number | null;
}
export interface DocumentDownloadUrlDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentDownloadUrlDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentDto {
    'id'?: string;
    'type'?: DocumentType;
    'status'?: DocumentStatus;
    'direction'?: DocumentDirection;
    'binderId'?: string;
    'createdAt'?: string;
    'updatedAt'?: string;
    'updatedById'?: string | null;
    'detectedFormType'?: string | null;
    'detectionConfidence'?: number | null;
    'userOverrideFormType'?: string | null;
    'effectiveFormType'?: string | null;
    'suggestedDocumentType'?: DocumentType;
    'classificationConfidence'?: number | null;
    'classificationTimestamp'?: string | null;
    'dataExtractedAt'?: string | null;
    'dataExtractionConfidence'?: number | null;
    'dataExtractionSource'?: string | null;
    'extractedDataJson'?: string | null;
    'aiProcessingStatus'?: AiProcessingStatus;
    'aiProcessingQueuedAt'?: string | null;
    'aiProcessingCompletedAt'?: string | null;
    'aiProcessingError'?: string | null;
    'isAiProcessing'?: boolean;
    'createdById'?: string | null;
    'uploadedByName'?: string | null;
    'uploadedByRole'?: UserRole;
    'exportedAt'?: string | null;
    'exportedById'?: string | null;
    'exportedByName'?: string | null;
    'signatureStatus'?: SignatureStatus;
    'signatureSubmissionId'?: string | null;
    'signatureTemplateId'?: string | null;
    'requiresSignature'?: boolean;
    'signatureSentAt'?: string | null;
    'signatureCompletedAt'?: string | null;
    'signedPdfStoredAt'?: string | null;
    'requiresESignature'?: boolean;
    'reviewedAt'?: string | null;
    'reviewedById'?: string | null;
    'reviewedByName'?: string | null;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
    'documentRequestId'?: string | null;
    'documentRequestName'?: string | null;
    'category'?: string | null;
    'description'?: string | null;
    'comment'?: string | null;
    'reviewComment'?: string | null;
    'virusScanPassed'?: boolean | null;
    'virusScanAt'?: string | null;
    'virusScanProvider'?: string | null;
    'isLate'?: boolean;
    'thumbnailUrl'?: string | null;
    'documentFiles'?: Array<DocumentFileDto> | null;
}


export interface DocumentDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<DocumentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentDtoPaginatedResponse {
    'items'?: Array<DocumentDto> | null;
    'pagination'?: PaginationInfo;
}
export interface DocumentDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: DocumentDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentFileDto {
    'id'?: string;
    'documentId'?: string;
    'fileName'?: string | null;
    'fileSize'?: number;
    'mimeType'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'createdById'?: string | null;
    'updatedById'?: string | null;
    'shA256Hash'?: string | null;
    'hashComputedAt'?: string | null;
}

export enum DocumentFilter {
    ApprovedOnly = 'approvedOnly',
    All = 'all',
    Selected = 'selected'
}


export interface DocumentGroupDto {
    'groupId'?: string | null;
    'name'?: string | null;
    'startPage'?: number;
    'endPage'?: number;
    'pageCount'?: number;
    'pages'?: Array<DocumentPageDto> | null;
    'bookmarkName'?: string | null;
    'hasBookmark'?: boolean;
    'documentType'?: DocumentType;
}


export interface DocumentGroupSelectionDto {
    'groupId': string;
    'documentType': DocumentType;
    'selectedPageIds': Array<string>;
    'signatureTemplateId'?: string | null;
}


export interface DocumentPageDto {
    'pageId'?: string | null;
    'pageNumber'?: number;
    'previewImageBase64'?: string | null;
    'previewImageUrl'?: string | null;
    'originalWidth'?: number;
    'originalHeight'?: number;
    'thumbnailWidth'?: number;
    'thumbnailHeight'?: number;
    'isSelected'?: boolean;
}
export interface DocumentPreprocessingDto {
    'id'?: string;
    'binderId'?: string;
    'originalFileName'?: string | null;
    'status'?: ProcessingStatus;
    'errorMessage'?: string | null;
    'totalPages'?: number;
    'createdAt'?: string;
    'completedAt'?: string | null;
    'documents'?: Array<PreprocessedDocumentDto> | null;
}


export interface DocumentPreprocessingDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentPreprocessingDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentPreviewResponseDto {
    'previewId'?: string | null;
    'fileName'?: string | null;
    'totalPages'?: number;
    'groups'?: Array<DocumentGroupDto> | null;
    'createdAt'?: string;
    'fileSizeBytes'?: number;
}
export interface DocumentPreviewResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentPreviewResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestAuditEntryDto {
    'id'?: number;
    'timestampUtc'?: string;
    'action'?: string | null;
    'description'?: string | null;
    'userName'?: string | null;
    'userId'?: string | null;
    'fieldChanges'?: Array<FieldChangeDto> | null;
    'ipAddress'?: string | null;
}
export interface DocumentRequestAuditHistoryDto {
    'documentRequestId'?: string;
    'documentRequestTitle'?: string | null;
    'currentStatus'?: DocumentRequestStatus;
    'auditEntries'?: Array<DocumentRequestAuditEntryDto> | null;
    'totalEntries'?: number;
}


export interface DocumentRequestAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestDocumentDto {
    'id'?: string;
    'documentId'?: string;
    'name'?: string | null;
    'type'?: DocumentType;
    'status'?: DocumentStatus;
    'fileSize'?: number | null;
    'contentType'?: string | null;
    'createdAt'?: string;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
}


export interface DocumentRequestDto {
    'id'?: string;
    'title'?: string | null;
    'description'?: string | null;
    'clientId'?: string;
    'clientName'?: string | null;
    'binderId'?: string | null;
    'binderName'?: string | null;
    'requestedById'?: string;
    'requestedByName'?: string | null;
    'status'?: DocumentRequestStatus;
    'statusDisplayName'?: string | null;
    'priority'?: DocumentRequestPriority;
    'priorityDisplayName'?: string | null;
    'dueDate'?: string | null;
    'completedDate'?: string | null;
    'completedById'?: string | null;
    'completedByName'?: string | null;
    'notes'?: string | null;
    'sortOrder'?: number;
    'taxYear'?: number;
    'createdAt'?: string;
    'updatedAt'?: string;
    'documents'?: Array<DocumentRequestDocumentDto> | null;
    'commentCount'?: number;
    'unreadCommentCount'?: number;
    'isOverdue'?: boolean;
    'submittedAt'?: string | null;
    'submittedById'?: string | null;
    'submittedByName'?: string | null;
    'reviewedAt'?: string | null;
    'reviewedById'?: string | null;
    'reviewedByName'?: string | null;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
    'requiresResubmission'?: boolean;
    'requestType'?: AuditDocumentRequestType;
    'requestTypeDisplayName'?: string | null;
    'isConfidential'?: boolean;
    'confidentialClientUserId'?: string | null;
    'confidentialClientUserName'?: string | null;
    'requiresApproval'?: boolean;
    'releasedToClientAt'?: string | null;
    'releasedToClientById'?: string | null;
    'clientResponse'?: ClientResponseType;
    'clientResponseNote'?: string | null;
    'clientRespondedAt'?: string | null;
    'clientResponseDisplayName'?: string | null;
    'totalDocuments'?: number;
    'uploadedDocuments'?: number;
    'approvedDocuments'?: number;
    'rejectedDocuments'?: number;
    'pendingDocuments'?: number;
    'requiresChangesDocuments'?: number;
    'canBeReviewed'?: boolean;
    'canResubmit'?: boolean;
    'hasPartialReview'?: boolean;
    'completionPercentage'?: number;
}


export interface DocumentRequestDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<DocumentRequestDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestDtoPaginatedResponse {
    'items'?: Array<DocumentRequestDto> | null;
    'pagination'?: PaginationInfo;
}
export interface DocumentRequestDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum DocumentRequestPriority {
    Low = 'low',
    Medium = 'medium',
    High = 'high',
    Critical = 'critical'
}



export enum DocumentRequestReviewAction {
    Approve = 'approve',
    Reject = 'reject',
    RequestChanges = 'requestChanges',
    Unapprove = 'unapprove'
}



export enum DocumentRequestStatus {
    Pending = 'pending',
    Submitted = 'submitted',
    Completed = 'completed',
    Rejected = 'rejected',
    Cancelled = 'cancelled'
}



export enum DocumentReviewAction {
    Approve = 'approve',
    Reject = 'reject',
    RequireChanges = 'requireChanges'
}


export interface DocumentReviewItemDto {
    'documentId': string;
    'action': DocumentReviewAction;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
}


export interface DocumentReviewResultDto {
    'id'?: string;
    'status'?: DocumentStatus;
    'reviewedAt'?: string | null;
    'reviewedBy'?: string | null;
    'reviewComment'?: string | null;
}


export interface DocumentReviewResultDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentReviewResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentSignatureResultDto {
    'documentId'?: string;
    'documentName'?: string | null;
    'success'?: boolean;
    'submissionId'?: string | null;
    'signingUrl'?: string | null;
    'error'?: string | null;
    'existingSubmissionId'?: string | null;
}

export enum DocumentSplitOption {
    KeepTogether = 'keepTogether',
    SplitByGroups = 'splitByGroups'
}


export interface DocumentStagingDto {
    'binderId'?: string;
    'stage'?: BinderStage;
    'preprocessing'?: DocumentPreprocessingDto;
    'documents'?: Array<PreprocessedDocumentDto> | null;
    'canFinalize'?: boolean;
    'totalDocuments'?: number;
    'documentsRequiringSignature'?: number;
}


export interface DocumentStagingDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentStagingDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum DocumentStatus {
    Na = 'na',
    NotUploaded = 'notUploaded',
    RequiresChanges = 'requiresChanges',
    Staged = 'staged',
    ReadyForReview = 'readyForReview',
    UnderReview = 'underReview',
    PendingApproval = 'pendingApproval',
    Processing = 'processing',
    Validating = 'validating',
    Uploading = 'uploading',
    Uploaded = 'uploaded',
    UploadFailed = 'uploadFailed',
    Accepted = 'accepted',
    Approved = 'approved',
    Rejected = 'rejected',
    Completed = 'completed',
    Archived = 'archived',
    Deleted = 'deleted'
}



export enum DocumentType {
    IncomeDocument = 'incomeDocument',
    DeductionDocument = 'deductionDocument',
    SupportingDocument = 'supportingDocument',
    IdentificationDocument = 'identificationDocument',
    OtherClientDocument = 'otherClientDocument',
    TaxReturn = 'taxReturn',
    EFileAuthorization = 'eFileAuthorization',
    TaxBinder = 'taxBinder',
    EngagementLetter = 'engagementLetter',
    EstimatedPaymentVoucher = 'estimatedPaymentVoucher',
    DirectDepositReport = 'directDepositReport',
    OtherPreparerDocument = 'otherPreparerDocument',
    PowerOfAttorney = 'powerOfAttorney',
    TaxInformationAuthorization = 'taxInformationAuthorization',
    PaymentAuthorization = 'paymentAuthorization',
    ExtensionRequest = 'extensionRequest',
    OtherAuthorization = 'otherAuthorization'
}


export interface DocumentTypeCategoryDto {
    'value'?: DocumentType;
    'name'?: string | null;
    'displayName'?: string | null;
    'requiresSignature'?: boolean;
    'group'?: string | null;
}


export interface DocumentTypeDto {
    'value'?: string | null;
    'label'?: string | null;
    'description'?: string | null;
    'category'?: string | null;
}
export interface DocumentTypeDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<DocumentTypeDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentTypeOptionsDto {
    'categories'?: Array<DocumentTypeCategoryDto> | null;
    'commonFormTypes'?: Array<CommonFormTypeDto> | null;
}
export interface DocumentTypeOptionsDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentTypeOptionsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentUploadResponseDto {
    'documentId'?: string;
    'fileIds'?: Array<string> | null;
    'documentIds'?: Array<string> | null;
}
export interface DocumentUploadResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentUploadResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentUploadResult {
    'documentId'?: string;
    'documentName'?: string | null;
    'documentType'?: DocumentType;
    'fileIds'?: Array<string> | null;
    'includedPageNumbers'?: Array<number> | null;
    'groupName'?: string | null;
    'uploaderRole'?: UploaderRole;
    'signatureTemplateId'?: string | null;
    'eSignatureStatus'?: ESignatureStatus;
    'eSignatureSubmissionId'?: string | null;
}


export interface DocumentUploadWithPagesDto {
    'previewId': string;
    'selectedGroups': Array<DocumentGroupSelectionDto>;
    'binderId': string;
    'folderName'?: string | null;
    'splitOption': DocumentSplitOption;
    'sendESignatureOnUpload'?: boolean;
    'direction'?: DocumentDirection;
    'generateAiDescription'?: boolean;
}


export interface DocumentUploadWithPagesResponseDto {
    'createdDocuments'?: Array<DocumentUploadResult> | null;
    'previewId'?: string | null;
    'totalPagesProcessed'?: number;
    'splitOption'?: DocumentSplitOption;
}


export interface DocumentUploadWithPagesResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentUploadWithPagesResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DuplicateClientAssociationDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'clientType'?: ClientType;
    'clientTypeDisplay'?: string | null;
    'role'?: ClientUserRole;
    'roleDisplay'?: string | null;
}


export interface DuplicateDetectionResult {
    'isPotentialDuplicate'?: boolean;
    'matches'?: Array<DuplicateMatch> | null;
    'highestSimilarityScore'?: number;
}
export interface DuplicateDetectionResultApiResponse {
    'success'?: boolean;
    'data'?: DuplicateDetectionResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DuplicateMatch {
    'existingDocumentId'?: string;
    'existingDocumentName'?: string | null;
    'similarityScore'?: number;
    'matchReason'?: string | null;
    'uploadedAt'?: string;
}

export enum EFileSigningMethod {
    NotSigned = 'notSigned',
    ESignature = 'eSignature',
    PaperCopy = 'paperCopy'
}



export enum ESignatureAuditAction {
    DocumentUploaded = 'documentUploaded',
    SignatureRequested = 'signatureRequested',
    DocumentViewed = 'documentViewed',
    SigningStarted = 'signingStarted',
    DocumentSigned = 'documentSigned',
    DocumentDeclined = 'documentDeclined',
    SubmissionCompleted = 'submissionCompleted',
    SubmissionExpired = 'submissionExpired',
    SubmissionCancelled = 'submissionCancelled',
    ReminderSent = 'reminderSent',
    SignerReplaced = 'signerReplaced',
    DocumentReplaced = 'documentReplaced',
    IdentityVerified = 'identityVerified',
    IdentityVerificationFailed = 'identityVerificationFailed',
    SignerAdded = 'signerAdded',
    SubmissionVoided = 'submissionVoided',
    AddonCreated = 'addonCreated'
}


export interface ESignatureAuditEntryDto {
    'id'?: number;
    'action'?: ESignatureAuditAction;
    'description'?: string | null;
    'documentType'?: DocumentType;
    'documentName'?: string | null;
    'actorType'?: string | null;
    'actorName'?: string | null;
    'actorEmail'?: string | null;
    'signerName'?: string | null;
    'signerEmail'?: string | null;
    'signerRole'?: SignerRole;
    'timestampUtc'?: string;
    'ipAddress'?: string | null;
    'signatureMethod'?: string | null;
    'identityVerificationMethod'?: string | null;
    'declineReason'?: string | null;
    'metadata'?: { [key: string]: any | null; } | null;
}


export interface ESignatureAuditHistoryDto {
    'entries'?: Array<ESignatureAuditEntryDto> | null;
    'totalCount'?: number;
}
export interface ESignatureAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: ESignatureAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ESignatureDocumentDto {
    'id'?: string;
    'documentType'?: DocumentType;
    'fileName'?: string | null;
    'uploadedAt'?: string;
    'uploadedByUserId'?: string;
    'uploadedByUserName'?: string | null;
    'submission'?: ESignatureSubmissionDto;
}


export interface ESignatureDocumentListDto {
    'documents'?: Array<ESignatureDocumentDto> | null;
    'summary'?: ESignatureSummaryDto;
}
export interface ESignatureDocumentListDtoApiResponse {
    'success'?: boolean;
    'data'?: ESignatureDocumentListDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum ESignatureStatus {
    NotRequested = 'notRequested',
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed'
}


export interface ESignatureStatusDto {
    'documentId'?: string | null;
    'hasDocument'?: boolean;
    'signedAt'?: string | null;
    'isSigned'?: boolean;
    'submissionId'?: string | null;
    'signingUrl'?: string | null;
    'submissionStatus'?: string | null;
    'hasSubmission'?: boolean;
    'sequentialStatus'?: string | null;
    'currentUserCanSign'?: boolean;
    'currentUserSigningUrl'?: string | null;
    'currentUserWaitingForPreviousSigner'?: boolean;
    'currentUserSigned'?: boolean;
    'waitingForSignerName'?: string | null;
    'signatureMethod'?: EngagementLetterSignatureMethod;
    'physicalSignatureAllowed'?: boolean;
    'engagementLetterRequired'?: boolean;
}


export interface ESignatureSubmissionDto {
    'submissionId'?: string | null;
    'status'?: SignatureStatus;
    'createdAt'?: string;
    'completedAt'?: string | null;
    'expiresAt'?: string | null;
    'signers'?: Array<SignerStatusDto> | null;
    'signersCompleted'?: number;
    'signersTotal'?: number;
    'sequentialStatus'?: string | null;
    'nextSigner'?: SignerStatusDto;
}


export interface ESignatureSummaryDto {
    'total'?: number;
    'completed'?: number;
    'pending'?: number;
    'notStarted'?: number;
}
export interface EligibleSignerDto {
    'userId'?: string;
    'name'?: string | null;
    'email'?: string | null;
    'relationship'?: string | null;
}
export interface EligibleSignersDto {
    'users'?: Array<EligibleSignerDto> | null;
}
export interface EligibleSignersDtoApiResponse {
    'success'?: boolean;
    'data'?: EligibleSignersDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface EmailVerificationResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'email'?: string | null;
    'emailVerified'?: boolean;
}
export interface EmailVerificationResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: EmailVerificationResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum EngagementLetterSignatureMethod {
    NotSigned = 'notSigned',
    ESignature = 'eSignature',
    PhysicalUpload = 'physicalUpload'
}


export interface EntityAuditTrailDto {
    'entityType'?: string | null;
    'entityId'?: string | null;
    'auditEntries'?: Array<StructuredAuditDto> | null;
    'totalEntries'?: number;
}
export interface EntityAuditTrailDtoApiResponse {
    'success'?: boolean;
    'data'?: EntityAuditTrailDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface EntityCommentGroupDto {
    'entityId'?: string;
    'entityType'?: string | null;
    'entityName'?: string | null;
    'entityDescription'?: string | null;
    'comments'?: Array<CommentDto> | null;
    'totalCount'?: number;
    'unreadCount'?: number;
    'latestCommentAt'?: string | null;
}
export interface EnumOptionDto {
    'value'?: string | null;
    'numericValue'?: number;
    'displayName'?: string | null;
    'order'?: number | null;
}
export interface EnumOptionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<EnumOptionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface EstimatedPaymentJurisdictionDto {
    'returnId'?: string;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'vouchers'?: Array<TaxReturnBundlePaymentVoucherDto> | null;
}
export interface EstimatedPaymentPreFillDto {
    'voucherId'?: string;
    'quarter'?: VoucherQuarter;
    'taxYear'?: number;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'formNumber'?: string | null;
    'amount'?: number;
    'dueDate'?: string;
    'isPaid'?: boolean;
    'paidAt'?: string | null;
}


export interface ExportAuditBinderDocumentsDto {
    'documentIds': Array<string>;
}

export enum ExportFormat {
    Auto = 'auto',
    SinglePdf = 'singlePdf',
    Zip = 'zip',
    Direct = 'direct'
}



export enum ExportType {
    SinglePdf = 'singlePdf',
    ZipArchive = 'zipArchive'
}


export interface ExternalClientDto {
    'id'?: string;
    'sourceSystem'?: string | null;
    'externalId'?: string | null;
    'externalGuid'?: string | null;
    'clientNumber'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'officeId'?: string | null;
    'officeName'?: string | null;
    'clientType'?: string | null;
    'clientTypeDisplay'?: string | null;
    'status'?: string | null;
    'isActive'?: boolean;
    'lastActivityAt'?: string | null;
    'lastSyncedAt'?: string;
    'hasEmbedding'?: boolean;
    'embeddingGeneratedAt'?: string | null;
    'importedClientId'?: string | null;
    'isImported'?: boolean;
    'primaryPartnerStaffGuid'?: string | null;
    'primaryPartnerName'?: string | null;
    'primaryPartnerEmail'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface ExternalClientDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalClientDtoPaginatedResponse {
    'items'?: Array<ExternalClientDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ExternalClientDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalClientSearchResultDto {
    'client'?: ExternalClientDto;
    'score'?: number;
    'exactScore'?: number;
    'fuzzyScore'?: number;
    'semanticScore'?: number;
    'matchType'?: string | null;
    'highlightedName'?: string | null;
}
export interface ExternalClientSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ExternalClientSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalClientSearchResultDtoPaginatedResponse {
    'items'?: Array<ExternalClientSearchResultDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ExternalClientSearchResultDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientSearchResultDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalClientSearchSuggestionDto {
    'id'?: string;
    'name'?: string | null;
    'clientNumber'?: string | null;
    'sourceSystem'?: string | null;
    'score'?: number;
}
export interface ExternalClientSearchSuggestionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ExternalClientSearchSuggestionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalClientSyncRequestDto {
    'sourceSystem'?: string | null;
    'modifiedSince'?: string | null;
    'regenerateEmbeddings'?: boolean;
}
export interface ExternalClientSyncResultDto {
    'sourceSystem'?: string | null;
    'syncStartedAt'?: string;
    'syncCompletedAt'?: string | null;
    'duration'?: string | null;
    'success'?: boolean;
    'errorMessage'?: string | null;
    'totalFetched'?: number;
    'inserted'?: number;
    'updated'?: number;
    'markedInactive'?: number;
    'errors'?: number;
    'embeddingsGenerated'?: number;
}
export interface ExternalClientSyncStatusDto {
    'isRunning'?: boolean;
    'lastSyncAt'?: string | null;
    'nextScheduledSync'?: string | null;
    'syncCronSchedule'?: string | null;
    'totalClients'?: number;
    'activeClients'?: number;
    'clientsWithEmbeddings'?: number;
    'importedClients'?: number;
    'sourceSystems'?: Array<SourceSystemStatsDto> | null;
    'lastSyncResults'?: Array<ExternalClientSyncResultDto> | null;
}
export interface ExternalClientSyncStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientSyncStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalDocumentShareDto {
    'id'?: string;
    'fileName'?: string | null;
    'mimeType'?: string | null;
    'fileSize'?: number;
    'fileCount'?: number;
    'recipientEmails'?: Array<string> | null;
    'recipients'?: Array<ExternalDocumentShareRecipientDto> | null;
    'message'?: string | null;
    'shareUrl'?: string | null;
    'status'?: ExternalDocumentShareStatus;
    'createdAt'?: string;
    'expiresAt'?: string;
    'downloadedAt'?: string | null;
    'downloadCount'?: number;
    'expireOnDownload'?: boolean;
}


export interface ExternalDocumentShareDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalDocumentShareDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalDocumentShareDtoPaginatedResponse {
    'items'?: Array<ExternalDocumentShareDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ExternalDocumentShareDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ExternalDocumentShareDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalDocumentShareRecipientDto {
    'email'?: string | null;
    'downloadedAt'?: string | null;
    'downloadCount'?: number;
}

export enum ExternalDocumentShareStatus {
    Sent = 'sent',
    Downloaded = 'downloaded',
    Expired = 'expired'
}


export interface ExternalUploadViewDto {
    'label'?: string | null;
    'uploads'?: Array<UploadedFileDto> | null;
}
export interface ExternalUploadViewDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalUploadViewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExtractedDataResult {
    'formType'?: string | null;
    'jsonData'?: string | null;
    'confidence'?: number;
    'source'?: string | null;
    'fieldCount'?: number;
    'extractedAt'?: string;
    'rawFields'?: { [key: string]: any | null; } | null;
    'errorMessage'?: string | null;
    'success'?: boolean;
    'detectedFormType'?: string | null;
    'detectionConfidence'?: number;
    'isRecognizedTaxForm'?: boolean;
}
export interface ExtractedDataResultApiResponse {
    'success'?: boolean;
    'data'?: ExtractedDataResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExtractionResult {
    'documentId'?: string;
    'success'?: boolean;
    'formType'?: string | null;
    'confidence'?: number | null;
    'fieldCount'?: number | null;
    'errorMessage'?: string | null;
    'skipped'?: boolean;
}
export interface FieldChangeDto {
    'fieldName'?: string | null;
    'displayName'?: string | null;
    'oldValue'?: string | null;
    'newValue'?: string | null;
}
export interface FieldDetail {
    'name'?: string | null;
    'type'?: string | null;
    'role'?: string | null;
    'page'?: number;
    'x'?: number;
    'y'?: number;
    'width'?: number;
    'height'?: number;
    'confidence'?: number;
}
export interface FieldDimensionsDto {
    'width': number;
    'height': number;
    'maintainAspectRatio'?: boolean;
}
export interface FieldPositionDto {
    'x': number;
    'y': number;
    'system'?: CoordinateSystem;
    'anchor'?: AnchorPoint;
}


export interface FieldPreferencesDto {
    'fontSize'?: number | null;
    'fontType'?: string | null;
    'font'?: string | null;
    'color'?: string | null;
    'align'?: string | null;
    'vAlign'?: string | null;
    'format'?: string | null;
    'price'?: number | null;
    'currency'?: string | null;
    'mask'?: boolean | null;
}
export interface FilePreviewDto {
    'fileId'?: string;
    'documentId'?: string;
    'fileName'?: string | null;
    'mimeType'?: string | null;
    'fileSize'?: number;
    'documentType'?: DocumentType;
}



export enum FilingInstructionType {
    TaxReturn = 'taxReturn',
    EstimatedTax = 'estimatedTax'
}



export enum FilingMethod {
    EFile = 'eFile',
    Mail = 'mail'
}


export interface FinalizeStagingDto {
    'sendNotification'?: boolean;
    'createSignatureSubmissions'?: boolean;
}
export interface FinalizeStagingResultDto {
    'binderId'?: string;
    'success'?: boolean;
    'totalDocumentsProcessed'?: number;
    'documentsFinalized'?: number;
    'signatureSubmissionsCreated'?: number;
    'notificationSent'?: boolean;
    'processedDocuments'?: Array<ProcessedDocumentDto> | null;
    'warnings'?: Array<string> | null;
    'errors'?: Array<string> | null;
    'processedAt'?: string;
}
export interface FinalizeStagingResultDtoApiResponse {
    'success'?: boolean;
    'data'?: FinalizeStagingResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface Form8879DiagnosticReport {
    'totalForms'?: number;
    'formsWithFields'?: number;
    'formsWithoutFields'?: number;
    'formsWithErrors'?: number;
    'formsWithVariantDetected'?: number;
    'formsDirectory'?: string | null;
    'results'?: Array<FormDetectionResult> | null;
}
export interface Form8879DiagnosticReportApiResponse {
    'success'?: boolean;
    'data'?: Form8879DiagnosticReport;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface FormBuilderAreaDto {
    'x'?: number;
    'y'?: number;
    'w'?: number;
    'h'?: number;
    'attachment_uuid'?: string | null;
    'page'?: number;
}
export interface FormBuilderConfigDto {
    'jwtToken': string;
    'builderOptions'?: { [key: string]: any | null; } | null;
    'callbackUrl'?: string | null;
    'testMode'?: boolean;
}
export interface FormBuilderConfigDtoApiResponse {
    'success'?: boolean;
    'data'?: FormBuilderConfigDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface FormBuilderDocumentDto {
    'id'?: number | null;
    'name'?: string | null;
    'uuid'?: string | null;
    'record_type'?: string | null;
    'record_id'?: number | null;
    'blob_id'?: number | null;
    'created_at'?: string | null;
    'signed_uuid'?: string | null;
    'filename'?: string | null;
    'metadata'?: { [key: string]: any | null; } | null;
    'preview_images'?: Array<FormBuilderPreviewImageDto> | null;
}
export interface FormBuilderFieldDto {
    'uuid'?: string | null;
    'submitter_uuid'?: string | null;
    'name'?: string | null;
    'type'?: string | null;
    'required'?: boolean;
    'preferences'?: FormBuilderFieldPreferencesDto;
    'areas'?: Array<FormBuilderAreaDto> | null;
}
export interface FormBuilderFieldPreferencesDto {
    'fontSize'?: number | null;
    'fontType'?: string | null;
    'font'?: string | null;
    'color'?: string | null;
    'align'?: string | null;
    'vAlign'?: string | null;
    'format'?: string | null;
    'price'?: number | null;
    'currency'?: string | null;
    'mask'?: boolean | null;
}
export interface FormBuilderPreviewImageDto {
    'id'?: number | null;
    'name'?: string | null;
    'uuid'?: string | null;
    'record_type'?: string | null;
    'record_id'?: number | null;
    'blob_id'?: number | null;
    'created_at'?: string | null;
    'url'?: string | null;
    'filename'?: string | null;
    'metadata'?: { [key: string]: any | null; } | null;
}
export interface FormBuilderSaveDto {
    'id': number;
    'slug'?: string | null;
    'name': string;
    'external_id'?: string | null;
    'folder_id'?: number | null;
    'shared_link'?: boolean;
    'created_at'?: string;
    'updated_at'?: string;
    'author_id'?: number | null;
    'account_id'?: number | null;
    'archived_at'?: string | null;
    'source'?: string | null;
    'application_key'?: string | null;
    'preferences'?: { [key: string]: any | null; } | null;
    'variables_schema'?: { [key: string]: any | null; } | null;
    'schema'?: Array<FormBuilderSchemaDto> | null;
    'documents'?: Array<FormBuilderDocumentDto> | null;
    'submitters'?: Array<FormBuilderSubmitterDto> | null;
    'fields'?: Array<FormBuilderFieldDto> | null;
}
export interface FormBuilderSchemaDto {
    'attachment_uuid'?: string | null;
    'name'?: string | null;
}
export interface FormBuilderSubmitterDto {
    'uuid'?: string | null;
    'name'?: string | null;
}
export interface FormBuilderTokenRequestDto {
    'integrationEmail'?: string | null;
    'externalId'?: string | null;
    'name'?: string | null;
    'templateId'?: string | null;
    'documentUrls'?: Array<string> | null;
}
export interface FormDetectionResult {
    'fileName'?: string | null;
    'success'?: boolean;
    'error'?: string | null;
    'catalogStateFed'?: string | null;
    'catalogFormName'?: string | null;
    'catalogFullTitle'?: string | null;
    'detectedVariant'?: string | null;
    'hasSignatureFields'?: boolean;
    'signatureFieldCount'?: number;
    'fields'?: Array<FieldDetail> | null;
    'signerInfoCount'?: number;
    'signers'?: Array<SignerDetail> | null;
}
export interface GrantAccessRequest {
    'userId'?: string;
}
export interface GrantSmsConsentDto {
    'consentMethod': string;
    'acknowledgeSmsTerms': boolean;
}
export interface GroupedCommentsDto {
    'binderComments'?: Array<CommentDto> | null;
    'documentGroups'?: Array<EntityCommentGroupDto> | null;
    'documentRequestGroups'?: Array<EntityCommentGroupDto> | null;
    'totalComments'?: number;
    'unreadComments'?: number;
}
export interface GroupedCommentsDtoApiResponse {
    'success'?: boolean;
    'data'?: GroupedCommentsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface GuidListApiResponse {
    'success'?: boolean;
    'data'?: Array<string> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ImpersonateClientDto {
    'clientId': string;
    'userId': string;
}
export interface ImpersonateClientResponseDto {
    'accessToken'?: string | null;
    'expiresIn'?: number;
    'isImpersonated'?: boolean;
    'originalUserId'?: string;
    'originalUserEmail'?: string | null;
    'impersonatedClientId'?: string;
    'impersonatedUserId'?: string;
    'originalUserRole'?: UserRole;
}


export interface ImpersonateClientResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ImpersonateClientResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum ImportAction {
    Created = 'created',
    Updated = 'updated',
    Skipped = 'skipped',
    Failed = 'failed'
}


export interface ImportClientDto {
    'clientId': string;
    'updateExisting'?: boolean;
    'taxId'?: string | null;
    'spouseTaxId'?: string | null;
    'clientUsers'?: Array<ImportClientUserDto> | null;
    'serviceLines'?: Array<ServiceLine> | null;
}
export interface ImportClientResultDto {
    'id'?: string | null;
    'cchClientId'?: string | null;
    'clientNumber'?: string | null;
    'clientName'?: string | null;
    'success'?: boolean;
    'error'?: string | null;
    'action'?: ImportAction;
    'validationWarnings'?: Array<string> | null;
}


export interface ImportClientResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportClientResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ImportClientUserDto {
    'userId'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'role': ClientUserRole;
    'name'?: string | null;
    'spouseData'?: SpouseData;
    'isMainContact'?: boolean | null;
}


export interface ImportDocumentRequestRowError {
    'rowNumber'?: number;
    'descriptionPreview'?: string | null;
    'reason'?: string | null;
}
export interface ImportDocumentRequestsResultDto {
    'importedCount'?: number;
    'skippedCount'?: number;
    'errors'?: Array<ImportDocumentRequestRowError> | null;
}
export interface ImportDocumentRequestsResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportDocumentRequestsResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ImportMultipleClientsDto {
    'clientIds': Array<string>;
    'updateExisting'?: boolean;
    'continueOnError'?: boolean;
}
export interface ImportResultDto {
    'totalClients'?: number;
    'importedCount'?: number;
    'updatedCount'?: number;
    'failedCount'?: number;
    'skippedCount'?: number;
    'results'?: Array<ImportClientResultDto> | null;
    'processingTime'?: string;
}
export interface ImportResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ImportZipQueuedDto {
    'operationId'?: string | null;
}
export interface ImportZipQueuedDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportZipQueuedDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface IndirectClientAccessDto {
    'userId'?: string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'systemRole'?: UserRole;
    'systemRoleDisplay'?: string | null;
    'accessReason'?: string | null;
    'matchedWithUserId'?: string;
    'matchedWithUserName'?: string | null;
    'matchType'?: string | null;
    'matchedValue'?: string | null;
}


export interface Int32ApiResponse {
    'success'?: boolean;
    'data'?: number;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface InviteUserDto {
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'clientId'?: string;
    'inviteMessage'?: string | null;
}


export interface JobHistoryDto {
    'id'?: string;
    'jobName'?: string | null;
    'lastStartedAt'?: string | null;
    'lastCompletedAt'?: string | null;
    'lastStatus'?: string | null;
    'lastError'?: string | null;
    'lastDurationMs'?: number | null;
    'lastDurationFormatted'?: string | null;
    'metadata'?: any | null;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface JobStatusSummaryDto {
    'totalJobs'?: number;
    'runningJobs'?: number;
    'successfulJobs'?: number;
    'failedJobs'?: number;
    'jobs'?: Array<JobHistoryDto> | null;
}
export interface JobStatusSummaryDtoApiResponse {
    'success'?: boolean;
    'data'?: JobStatusSummaryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface JurisdictionSignatureStatusDto {
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'isComplete'?: boolean;
    'status'?: ReturnStatus;
}



export enum JurisdictionType {
    Federal = 'federal',
    State = 'state',
    City = 'city',
    County = 'county',
    Miscellaneous = 'miscellaneous'
}


export interface K1ExtractedPartnerDto {
    'bookmarkName'?: string | null;
    'partnerName'?: string | null;
    'documentId'?: string;
    'startPage'?: number;
    'endPage'?: number;
}
export interface K1ExtractedPartnerDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<K1ExtractedPartnerDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface K1RecipientAssignmentDto {
    'id'?: string;
    'binderId'?: string;
    'k1DocumentId'?: string;
    'userId'?: string;
    'partnerName'?: string | null;
    'bookmarkName'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'createdAt'?: string;
    'suggestedFileName'?: string | null;
}
export interface K1RecipientAssignmentDtoApiResponse {
    'success'?: boolean;
    'data'?: K1RecipientAssignmentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface K1RecipientAssignmentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<K1RecipientAssignmentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface K1StatusDto {
    'isComplete'?: boolean;
    'documentId'?: string | null;
    'hasK1Documents'?: boolean;
    'suggestedFileName'?: string | null;
}
export interface K1StatusDtoApiResponse {
    'success'?: boolean;
    'data'?: K1StatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface LinkExternalClientDto {
    'importedClientId': string;
}
export interface ListSubmissionsResponseDto {
    'data'?: Array<SubmissionSummaryDto> | null;
    'pagination'?: PaginationDto;
}
export interface ListSubmissionsResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ListSubmissionsResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface LoginDto {
    'email': string;
    'password': string;
    'rememberMe'?: boolean;
}
export interface LoginResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'errorCode'?: string | null;
    'user'?: UserDto;
    'token'?: string | null;
    'refreshToken'?: string | null;
    'expiresAt'?: string;
    'requiresVerification'?: boolean;
    'verificationMethod'?: string | null;
    'clientId'?: string | null;
    'isFirstLogin'?: boolean;
}
export interface LoginResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: LoginResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum MaritalStatus {
    Single = 'single',
    MarriedFilingJointly = 'marriedFilingJointly',
    MarriedFilingSeparately = 'marriedFilingSeparately',
    HeadOfHousehold = 'headOfHousehold',
    QualifyingWidow = 'qualifyingWidow'
}


export interface MarkNotificationsReadDto {
    'notificationIds': Array<string>;
}
export interface MarkPaymentVoucherPaidDto {
    'isPaid'?: boolean;
    'paidAt'?: string | null;
    'paymentNotes'?: string | null;
}
export interface MarkSubmittedDto {
    'submissionNotes'?: string | null;
}
export interface MarkTaxReturnFiledDto {
    'filedAt'?: string | null;
    'eFileConfirmationNumber'?: string | null;
}
export interface MarkTaxReturnRejectedDto {
    'rejectionReason'?: string | null;
}
export interface MergeConflictDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'survivingUserRole'?: ClientUserRole;
    'survivingUserRoleDisplay'?: string | null;
    'mergedUserRole'?: ClientUserRole;
    'mergedUserRoleDisplay'?: string | null;
    'resolvedRole'?: ClientUserRole;
    'resolvedRoleDisplay'?: string | null;
}


export interface MergePreviewDto {
    'survivingUser'?: UserDto;
    'mergedUser'?: UserDto;
    'clientConflicts'?: Array<MergeConflictDto> | null;
    'statistics'?: MergeStatisticsDto;
}
export interface MergePreviewDtoApiResponse {
    'success'?: boolean;
    'data'?: MergePreviewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface MergeResultDto {
    'success'?: boolean;
    'survivingUserId'?: string;
    'mergedUserId'?: string;
    'statistics'?: MergeStatisticsDto;
    'auditLogId'?: number;
    'errorMessage'?: string | null;
}
export interface MergeResultDtoApiResponse {
    'success'?: boolean;
    'data'?: MergeResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface MergeStatisticsDto {
    'clientAssociationsToMerge'?: number;
    'clientConflicts'?: number;
    'refreshTokensToDelete'?: number;
}
export interface MergeUsersDto {
    'survivingUserId': string;
    'mergedUserId': string;
}
export interface NewSignerInfoDto {
    'signerId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'signingUrl'?: string | null;
}

export enum NotificationActionType {
    DocumentUploaded = 'documentUploaded',
    DocumentApproved = 'documentApproved',
    DocumentRejected = 'documentRejected',
    DocumentRequested = 'documentRequested',
    LateDocumentUploaded = 'lateDocumentUploaded',
    DocumentAiProcessingCompleted = 'documentAiProcessingCompleted',
    CommentCreated = 'commentCreated',
    BinderCreated = 'binderCreated',
    BinderStageChanged = 'binderStageChanged',
    AuditBinderDeletionWarning = 'auditBinderDeletionWarning',
    BinderArchived = 'binderArchived',
    AuditBinderReleasedToClient = 'auditBinderReleasedToClient',
    AuditBinderStageChanged = 'auditBinderStageChanged',
    AuditBinderCommentReceived = 'auditBinderCommentReceived',
    AuditBinderDocumentApproved = 'auditBinderDocumentApproved',
    AuditBinderDocumentRejected = 'auditBinderDocumentRejected',
    AuditBinderDocumentRequested = 'auditBinderDocumentRequested',
    AuditBinderDocumentRequestOutcome = 'auditBinderDocumentRequestOutcome',
    AuditBinderFirmDocumentUploaded = 'auditBinderFirmDocumentUploaded',
    AuditBinderClientCommented = 'auditBinderClientCommented',
    AuditBinderClientDocumentUploaded = 'auditBinderClientDocumentUploaded',
    AuditBinderRequestAwaitingRelease = 'auditBinderRequestAwaitingRelease',
    ClientSubmitted = 'clientSubmitted',
    ClientRequestedChanges = 'clientRequestedChanges',
    QuestionnaireCompleted = 'questionnaireCompleted',
    SignatureRequested = 'signatureRequested',
    SignatureCompleted = 'signatureCompleted',
    SignatureDeclined = 'signatureDeclined',
    SignatureReminder = 'signatureReminder',
    SignatureExpired = 'signatureExpired',
    CoSignerTurnToSign = 'coSignerTurnToSign',
    AllSignaturesCompleted = 'allSignaturesCompleted',
    TaxReturnReleased = 'taxReturnReleased',
    TaxReturnRecalled = 'taxReturnRecalled',
    EstimatedPaymentReminder = 'estimatedPaymentReminder',
    K1Ready = 'k1Ready',
    WelcomeEmail = 'welcomeEmail',
    PasswordReset = 'passwordReset',
    SecurityAlert = 'securityAlert',
    BinderLinkSent = 'binderLinkSent'
}



export enum NotificationAudience {
    Client = 'client',
    Preparer = 'preparer',
    System = 'system',
    Admin = 'admin'
}



export enum NotificationBatchStrategy {
    Immediate = 'immediate',
    Batched = 'batched',
    Scheduled = 'scheduled'
}



export enum NotificationChannel {
    Email = 'email',
    Sms = 'sms',
    Both = 'both'
}


export interface NotificationCountSummaryDto {
    'totalUnread'?: number;
    'highPriority'?: number;
    'byActionType'?: { [key: string]: number; } | null;
}
export interface NotificationCountSummaryDtoApiResponse {
    'success'?: boolean;
    'data'?: NotificationCountSummaryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum NotificationDeliveryChannel {
    None = 'none',
    Email = 'email',
    Sms = 'sms',
    EmailAndSms = 'emailAndSms',
    Realtime = 'realtime',
    EmailAndRealtime = 'emailAndRealtime',
    SmsAndRealtime = 'smsAndRealtime',
    All = 'all'
}



export enum NotificationEntityType {
    None = 'none',
    Document = 'document',
    DocumentRequest = 'documentRequest',
    Comment = 'comment',
    Binder = 'binder',
    Questionnaire = 'questionnaire',
    QuestionnaireResponse = 'questionnaireResponse',
    Signature = 'signature',
    ESignatureSubmission = 'eSignatureSubmission',
    User = 'user',
    Client = 'client'
}



export enum NotificationPriority {
    Low = 'low',
    Normal = 'normal',
    High = 'high',
    Critical = 'critical'
}


export interface ObjectApiResponse {
    'success'?: boolean;
    'data'?: any | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface OfficeActivityDto {
    'officeId'?: string;
    'officeName'?: string | null;
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
}
export interface OfficeDto {
    'id'?: string;
    'name'?: string | null;
    'clientCount'?: number;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface OfficeWorkflowTimingDto {
    'officeId'?: string;
    'officeName'?: string | null;
    'bindersCompleted'?: number;
    'timing'?: WorkflowTimingDto;
}
export interface OptionDto {
    'id'?: string;
    'name'?: string | null;
    'displayOrder'?: number | null;
    'isActive'?: boolean;
}
export interface OptionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<OptionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface OrganizerAnalysisResultDto {
    'documentRequestsCreated'?: number;
    'documentRequestsSkippedDuplicate'?: number;
    'documentRequestsFailed'?: number;
    'engagementLetterExtracted'?: boolean;
    'engagementLetterAlreadyPresent'?: boolean;
    'engagementLetterDocumentId'?: string | null;
    'operationId'?: string | null;
}
export interface OrganizerAnalysisResultDtoApiResponse {
    'success'?: boolean;
    'data'?: OrganizerAnalysisResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface OrganizerStorageDto {
    'binderId'?: string;
    'documentCount'?: number;
    'fileCount'?: number;
    'totalSizeBytes'?: number;
}
export interface OrphanFileCleanupResult {
    'startedAt'?: string;
    'completedAt'?: string;
    'duration'?: string;
    'isDryRun'?: boolean;
    'filesScanned'?: number;
    'orphansDetected'?: number;
    'filesDeleted'?: number;
    'deletionFailures'?: number;
    'metadataFilesDeleted'?: number;
    'bytesFreed'?: number;
    'orphanedFiles'?: Array<string> | null;
    'errors'?: Array<string> | null;
    'success'?: boolean;
}
export interface OrphanFileCleanupResultApiResponse {
    'success'?: boolean;
    'data'?: OrphanFileCleanupResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface OrphanedFileInfo {
    'storageKey'?: string | null;
    'filePath'?: string | null;
    'sizeBytes'?: number;
    'createdAt'?: string;
    'lastModifiedAt'?: string;
    'ageInDays'?: number;
    'isMetadataFile'?: boolean;
    'orphanReason'?: string | null;
}
export interface OrphanedFileInfoListApiResponse {
    'success'?: boolean;
    'data'?: Array<OrphanedFileInfo> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PageBoundaryDto {
    'pageNumber'?: number;
    'previousFormType'?: string | null;
    'newFormType'?: string | null;
    'confidence'?: number;
    'reason'?: string | null;
    'recommendSplit'?: boolean;
}
export interface PageDefaultsDto {
    'dashboard'?: DashboardPageDefaultsDto;
    'clients'?: ClientPageDefaultsDto;
    'binders'?: BinderPageDefaultsDto;
    'adminDashboard'?: AdminDashboardPageDefaultsDto;
    'users'?: UserPageDefaultsDto;
    'accessRequests'?: AccessRequestPageDefaultsDto;
}
export interface PageGroupSuggestionDto {
    'startPage'?: number;
    'endPage'?: number;
    'pageCount'?: number;
    'formType'?: string | null;
    'confidence'?: number;
    'suggestedDocumentName'?: string | null;
    'suggestedDocumentType'?: DocumentType;
    'isKnownMultiPageForm'?: boolean;
    'expectedPageCount'?: number | null;
    'pageCountMatchesExpected'?: boolean;
    'metadata'?: { [key: string]: string | null; } | null;
}


export interface PageSplittingResultDto {
    'totalPages'?: number;
    'suggestedGroups'?: Array<PageGroupSuggestionDto> | null;
    'pageFormTypes'?: { [key: string]: string | null; } | null;
    'detectedBoundaries'?: Array<PageBoundaryDto> | null;
    'overallConfidence'?: number;
    'recommendAutoSplit'?: boolean;
    'analysisTimeMs'?: number;
    'warnings'?: Array<string> | null;
}
export interface PageSplittingResultDtoApiResponse {
    'success'?: boolean;
    'data'?: PageSplittingResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PaginationDto {
    'count'?: number;
    'next'?: number | null;
    'prev'?: number | null;
}
export interface PaginationInfo {
    'page'?: number;
    'pageSize'?: number;
    'totalCount'?: number;
    'totalPages'?: number;
    'hasNextPage'?: boolean;
    'hasPreviousPage'?: boolean;
}
export interface PartnerActivityDto {
    'partnerId'?: string;
    'partnerName'?: string | null;
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
}
export interface PartnerWorkflowTimingDto {
    'partnerId'?: string;
    'partnerName'?: string | null;
    'bindersCompleted'?: number;
    'timing'?: WorkflowTimingDto;
}
export interface PaymentVoucherReminderOptInDto {
    'reminderEnabled'?: boolean;
    'reminderDaysPrior'?: number;
}
export interface PdfConversionConfigDto {
    'environment'?: string | null;
    'useImageOptimization'?: boolean;
    'imageDpi'?: number;
    'imageQuality'?: number;
    'maxPdfSizeBytes'?: number;
    'maxPages'?: number;
    'maxConcurrentConversions'?: number;
    'pageConversionTimeoutSeconds'?: number;
}
export interface PdfConversionConfigDtoApiResponse {
    'success'?: boolean;
    'data'?: PdfConversionConfigDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PhoneLookupResult {
    'success'?: boolean;
    'phoneNumber'?: string | null;
    'lineType'?: string | null;
    'carrierName'?: string | null;
    'errorMessage'?: string | null;
    'isMobile'?: boolean;
}
export interface PhoneLookupResultApiResponse {
    'success'?: boolean;
    'data'?: PhoneLookupResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PhoneVerificationResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'phoneNumber'?: string | null;
    'phoneNumberVerified'?: boolean;
}
export interface PhoneVerificationResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: PhoneVerificationResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PossibleDuplicateDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'createdAt'?: string;
    'lastLoginAt'?: string | null;
    'matchReason'?: string | null;
    'clientCount'?: number;
    'clientAssociations'?: Array<DuplicateClientAssociationDto> | null;
}


export interface PossibleDuplicateDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<PossibleDuplicateDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PrepareForSignatureDto {
    'documentIds': Array<string>;
    'clientName': string;
    'clientEmail': string;
    'signerName': string;
    'signerEmail': string;
    'overrideExisting'?: boolean;
    'spouseName'?: string | null;
    'spouseEmail'?: string | null;
    'sendEmail'?: boolean;
    'sendSms'?: boolean;
    'clientPhone'?: string | null;
}
export interface PrepareForSignatureResultDto {
    'totalRequested'?: number;
    'successful'?: number;
    'failed'?: number;
    'results'?: Array<DocumentSignatureResultDto> | null;
}
export interface PrepareForSignatureResultDtoApiResponse {
    'success'?: boolean;
    'data'?: PrepareForSignatureResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PreparerActivityDto {
    'preparerId'?: string;
    'preparerName'?: string | null;
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
}
export interface PreparerWorkflowTimingDto {
    'preparerId'?: string;
    'preparerName'?: string | null;
    'bindersCompleted'?: number;
    'timing'?: WorkflowTimingDto;
}
export interface PreprocessedDocumentDto {
    'id'?: string;
    'documentName'?: string | null;
    'startPage'?: number;
    'endPage'?: number;
    'pageCount'?: number;
    'requiresSignature'?: boolean;
    'type'?: DocumentType;
    'isIncluded'?: boolean;
    'bookmarkName'?: string | null;
    'thumbnailUrl'?: string | null;
    'signatureTemplateId'?: string | null;
    'suggestedFields'?: Array<SuggestedSignatureFieldDto> | null;
}


export interface PreprocessedDocumentDtoApiResponse {
    'success'?: boolean;
    'data'?: PreprocessedDocumentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PreviewRequestDto {
    'pdfBase64': string;
}
export interface ProblemDetails {
    [key: string]: any;

    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
}
export interface ProcessedDocumentDto {
    'documentId'?: string;
    'documentName'?: string | null;
    'wasFinalized'?: boolean;
    'signatureSubmissionCreated'?: boolean;
    'signatureSubmissionId'?: string | null;
    'signingUrl'?: string | null;
    'error'?: string | null;
}

export enum ProcessingStatus {
    InProgress = 'inProgress',
    Completed = 'completed',
    Failed = 'failed',
    Cancelled = 'cancelled'
}


export interface PublicExternalDocumentShareDto {
    'fileName'?: string | null;
    'fileSize'?: number;
    'fileCount'?: number;
    'senderName'?: string | null;
    'message'?: string | null;
    'expiresAt'?: string;
    'status'?: ExternalDocumentShareStatus;
    'isExpired'?: boolean;
}


export interface PublicExternalDocumentShareDtoApiResponse {
    'success'?: boolean;
    'data'?: PublicExternalDocumentShareDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum QuestionType {
    Text = 'text',
    LongText = 'longText',
    Number = 'number',
    Date = 'date',
    Boolean = 'boolean',
    SingleChoice = 'singleChoice',
    MultipleChoice = 'multipleChoice',
    Dropdown = 'dropdown',
    Email = 'email',
    Phone = 'phone',
    Currency = 'currency'
}


export interface QuestionnaireDto {
    'id'?: string;
    'title'?: string | null;
    'description'?: string | null;
    'taxYear'?: number;
    'isActive'?: boolean;
    'isRequired'?: boolean;
    'sortOrder'?: number;
    'createdById'?: string;
    'createdByName'?: string | null;
    'publishedDate'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'questions'?: Array<QuestionnaireQuestionDto> | null;
    'responseCount'?: number;
    'completedResponseCount'?: number;
}
export interface QuestionnaireDtoApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<QuestionnaireDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireDtoPaginatedResponse {
    'items'?: Array<QuestionnaireDto> | null;
    'pagination'?: PaginationInfo;
}
export interface QuestionnaireDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnairePreFillDataDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'maritalStatus'?: MaritalStatus;
    'maritalStatusDisplay'?: string | null;
    'dateOfBirth'?: string | null;
    'ssn'?: string | null;
    'spouse'?: ClientSpouseDto;
    'dependents'?: Array<ClientDependentDto> | null;
    'preferredRefundAccount'?: ClientBankAccountDto;
    'preferredPaymentAccount'?: ClientBankAccountDto;
    'priorYearEstimatedPayments'?: Array<EstimatedPaymentPreFillDto> | null;
    'taxYear'?: number | null;
    'lastUpdated'?: string | null;
}


export interface QuestionnairePreFillDataDtoApiResponse {
    'success'?: boolean;
    'data'?: QuestionnairePreFillDataDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireQuestionDto {
    'id'?: string;
    'questionnaireId'?: string;
    'question'?: string | null;
    'description'?: string | null;
    'questionType'?: QuestionType;
    'questionTypeDisplayName'?: string | null;
    'options'?: Array<string> | null;
    'isRequired'?: boolean;
    'sortOrder'?: number;
    'validationRules'?: { [key: string]: any | null; } | null;
}


export interface QuestionnaireResponseDto {
    'id'?: string;
    'binderId'?: string;
    'binderName'?: string | null;
    'responseData'?: string | null;
    'status'?: QuestionnaireStatus;
    'statusDisplayName'?: string | null;
    'submittedAt'?: string | null;
    'reviewedByUserId'?: string | null;
    'reviewedByName'?: string | null;
    'reviewedAt'?: string | null;
    'reviewComment'?: string | null;
    'version'?: number;
    'createdAt'?: string;
    'createdById'?: string;
    'createdByName'?: string | null;
}


export interface QuestionnaireResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireResponseDtoPaginatedResponse {
    'items'?: Array<QuestionnaireResponseDto> | null;
    'pagination'?: PaginationInfo;
}
export interface QuestionnaireResponseDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireResponseDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum QuestionnaireStatus {
    Draft = 'draft',
    Submitted = 'submitted'
}


export interface RecallReturnDto {
    'reason': string;
}
export interface RecallReturnResultDto {
    'binderId'?: string;
    'recalledAt'?: string;
    'newStage'?: string | null;
    'documentsDeleted'?: number;
    'submissionArchived'?: boolean;
    'jurisdictionsAffected'?: Array<string> | null;
    'hadSignatures'?: boolean;
    'warningMessage'?: string | null;
}
export interface RecallReturnResultDtoApiResponse {
    'success'?: boolean;
    'data'?: RecallReturnResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface RecentActivityDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'activityType'?: string | null;
    'activityDescription'?: string | null;
    'activityIcon'?: string | null;
    'activityDate'?: string;
    'timeAgo'?: string | null;
}
export interface RecentActivityDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<RecentActivityDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface RecentClientDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'companyName'?: string | null;
    'initials'?: string | null;
    'lastInteraction'?: string;
    'timeAgo'?: string | null;
    'status'?: string | null;
    'statusColor'?: string | null;
}
export interface RecentClientDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<RecentClientDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface RefreshTokenDto {
    'refreshToken': string;
}
export interface ReleaseDocumentRequestsDto {
    'documentRequestIds': Array<string>;
}
export interface ReleaseDocumentRequestsResultDto {
    'releasedRequestIds'?: Array<string> | null;
    'skipped'?: Array<ReleaseSkippedItemDto> | null;
    'releasedCount'?: number;
    'skippedCount'?: number;
}
export interface ReleaseDocumentRequestsResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ReleaseDocumentRequestsResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ReleaseSkippedItemDto {
    'documentRequestId'?: string;
    'reason'?: string | null;
}
export interface ReleaseStatusDto {
    'binderId'?: string;
    'isReleased'?: boolean;
    'releasedAt'?: string | null;
    'releasedBy'?: string | null;
    'signingStatus'?: string | null;
    'signaturesCompleted'?: number;
    'signaturesRequired'?: number;
}
export interface ReleaseStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: ReleaseStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ReleaseToClientDto {
    'customMessage'?: string | null;
}
export interface ReleaseToClientResultDto {
    'binderId'?: string;
    'releasedAt'?: string;
    'bundleSignatureSubmissionId'?: string | null;
    'directDepositSignatureSubmissionId'?: string | null;
    'jurisdictionsIncluded'?: Array<string> | null;
    'signingUrl'?: string | null;
    'engagementLetterSignatureSubmissionId'?: string | null;
    'engagementLetterSigningUrl'?: string | null;
    'notificationsSent'?: number;
    'newStage'?: string | null;
}
export interface ReleaseToClientResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ReleaseToClientResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ReplaceDocumentResponseDto {
    'success'?: boolean;
    'newDocumentId'?: string;
    'newSubmissionId'?: string | null;
    'replacedDocumentId'?: string;
    'notificationsSent'?: boolean;
    'signersNotified'?: number;
}
export interface ReplaceDocumentResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ReplaceDocumentResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ReplaceSignerDto {
    'newSignerUserId'?: string;
    'reason'?: string | null;
    'sendNotification'?: boolean;
}
export interface ReplaceSignerResponseDto {
    'success'?: boolean;
    'previousSigner'?: SignerInfoDto;
    'newSigner'?: NewSignerInfoDto;
    'notificationSent'?: boolean;
}
export interface ReplaceSignerResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ReplaceSignerResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface RequestBundleSignatureDto {
    'sendImmediately'?: boolean;
    'customMessage'?: string | null;
    'jurisdictionCodes'?: Array<string> | null;
}
export interface RequestChangesDto {
    'reason': string;
}
export interface RequestPasswordResetDto {
    'email': string;
}
export interface ResetPasswordDto {
    'email'?: string | null;
    'token'?: string | null;
    'newPassword'?: string | null;
    'confirmPassword'?: string | null;
}
export interface ResetUserSettingDto {
    'pageKey'?: string | null;
}

export enum ReturnCopyType {
    ClientCopy = 'clientCopy',
    GovernmentCopy = 'governmentCopy',
    K1 = 'k1'
}



export enum ReturnStatus {
    Pending = 'pending',
    ReadyForReview = 'readyForReview',
    AwaitingSignature = 'awaitingSignature',
    Signed = 'signed',
    Filed = 'filed',
    Accepted = 'accepted',
    Rejected = 'rejected'
}


export interface ReviewAccessRequestDto {
    'status': AccessRequestStatus;
    'reviewerNotes'?: string | null;
}


export interface ReviewDocumentDto {
    'action': DocumentReviewAction;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
}


export interface ReviewDocumentRequest {
    'status': string;
    'comment'?: string | null;
}
export interface ReviewDocumentRequestDto {
    'action': DocumentRequestReviewAction;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
    'requiresResubmission'?: boolean;
}


export interface RevokeSmsConsentDto {
    'reason'?: string | null;
}
export interface SendBackToClientDto {
    'reason': string;
}
export interface SendBulkReminderDto {
    'message'?: string | null;
    'skipRecentlyReminded'?: boolean;
}
export interface SendBulkReminderResponseDto {
    'success'?: boolean;
    'remindersAttempted'?: number;
    'remindersSent'?: number;
    'remindersSkipped'?: number;
    'results'?: Array<SignerReminderResultDto> | null;
}
export interface SendBulkReminderResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SendBulkReminderResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SendEmailVerificationDto {
    'email'?: string | null;
}
export interface SendPhoneVerificationDto {
    'phoneNumber'?: string | null;
}
export interface SendReminderResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'reminderSentAt'?: string;
    'channelsUsed'?: Array<string> | null;
    'nextReminderAvailableAt'?: string;
}
export interface SendReminderResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SendReminderResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SendSignerReminderDto {
    'message'?: string | null;
}
export interface SendVerificationCodeDto {
    'email'?: string | null;
    'method'?: string | null;
}

export enum ServiceLine {
    Tax = 'tax',
    Audit = 'audit',
    Cas = 'cas'
}


export interface SetAuditBinderFinalDocumentDto {
    'documentId': string;
}
export interface SetConfidentialDto {
    'isConfidential': boolean;
    'confidentialClientUserId'?: string | null;
}
export interface SignatureDocumentDto {
    'documentId'?: string | null;
    'fileName'?: string | null;
    'status'?: string | null;
    'signedAt'?: string | null;
    'downloadUrl'?: string | null;
}
export interface SignatureDocumentItemDto {
    'documentId'?: string;
    'name'?: string | null;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
    'docuSealSubmissionId'?: number;
    'submissionStatus'?: string | null;
    'completedAt'?: string | null;
    'signers'?: Array<SignatureDocumentSignerDto> | null;
}
export interface SignatureDocumentListDto {
    'documents'?: Array<SignatureDocumentItemDto> | null;
}
export interface SignatureDocumentListDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureDocumentListDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureDocumentSignerDto {
    'clientUserId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
    'signingOrder'?: number;
    'completedAt'?: string | null;
    'signerId'?: number;
    'sentAt'?: string | null;
    'lastReminderSentAt'?: string | null;
    'reminderCount'?: number;
}
export interface SignatureFieldDto {
    'name': string;
    'type': string;
    'role': string;
    'required'?: boolean;
    'page'?: number | null;
    'x'?: number | null;
    'y'?: number | null;
    'width'?: number | null;
    'height'?: number | null;
    'label'?: string | null;
    'placeholder'?: string | null;
}
export interface SignatureFieldPlacementDto {
    'role': string;
    'type': string;
    'page'?: number;
    'x'?: number;
    'y'?: number;
    'w'?: number;
    'h'?: number;
    'required'?: boolean;
    'title'?: string | null;
}

export enum SignatureFieldType {
    Signature = 'signature',
    Date = 'date',
    InitialsOnly = 'initialsOnly',
    FullName = 'fullName',
    Pin = 'pin',
    Checkbox = 'checkbox',
    SsnLastFour = 'ssnLastFour',
    PhoneNumber = 'phoneNumber',
    Email = 'email',
    Text = 'text'
}


export interface SignatureRequestResultDto {
    'documentId'?: string;
    'docuSealSubmissionId'?: number;
    'submissionStatus'?: string | null;
    'signers'?: Array<SignerStatusItemDto> | null;
}
export interface SignatureRequestResultDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureRequestResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum SignatureRequirementStatus {
    Pending = 'pending',
    AwaitingSignature = 'awaitingSignature',
    Signed = 'signed',
    Skipped = 'skipped',
    ManualSignRequired = 'manualSignRequired'
}


export interface SignatureSigningSessionDto {
    'documentId'?: string;
    'docuSealSubmissionId'?: number;
    'slug'?: string | null;
    'email'?: string | null;
    'status'?: string | null;
}
export interface SignatureSigningSessionDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureSigningSessionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum SignatureStatus {
    NotRequired = 'notRequired',
    Pending = 'pending',
    Sent = 'sent',
    Viewed = 'viewed',
    Signed = 'signed',
    Declined = 'declined',
    Expired = 'expired',
    Completed = 'completed',
    Cancelled = 'cancelled'
}


export interface SignatureStatusDto {
    'submissionId'?: string | null;
    'status'?: SignatureStatus;
    'viewedAt'?: string | null;
    'signedAt'?: string | null;
    'declinedAt'?: string | null;
    'expiredAt'?: string | null;
    'declineReason'?: string | null;
    'documentsSigned'?: number;
    'totalDocuments'?: number;
}


export interface SignatureStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureSubmissionDto {
    'submissionId'?: string | null;
    'status'?: string | null;
    'signingUrl'?: string | null;
    'createdAt'?: string;
    'completedAt'?: string | null;
    'documents'?: Array<SignatureDocumentDto> | null;
    'submitters'?: Array<SubmissionSubmitterDto> | null;
}
export interface SignatureSubmissionDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureSubmissionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureTemplateDto {
    'id'?: string;
    'documentType'?: DocumentType;
    'documentTypeDescription'?: string | null;
    'specificFormType'?: string | null;
    'templateName'?: string | null;
    'requiresSignature'?: boolean;
    'fields'?: Array<TemplateSignatureFieldDto> | null;
    'isActive'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
    'createdByName'?: string | null;
    'docuSealTemplateId'?: string | null;
    'docuSealSlug'?: string | null;
    'isOneTimeUse'?: boolean;
    'usedAt'?: string | null;
    'docuSealSubmissionId'?: string | null;
}


export interface SignatureTemplateDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureTemplateDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureTemplateDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<SignatureTemplateDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureTemplateDtoPaginatedResponse {
    'items'?: Array<SignatureTemplateDto> | null;
    'pagination'?: PaginationInfo;
}
export interface SignatureTemplateDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: SignatureTemplateDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignerAssignmentDto {
    'role': string;
    'clientUserId': string;
    'signingOrder'?: number;
}
export interface SignerDetail {
    'name'?: string | null;
    'role'?: string | null;
    'isDeceased'?: boolean;
}
export interface SignerInfoDto {
    'signerId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
}
export interface SignerReminderResultDto {
    'signerId'?: string | null;
    'signerName'?: string | null;
    'sent'?: boolean;
    'reason'?: string | null;
}

export enum SignerRole {
    PrimaryTaxpayer = 'primaryTaxpayer',
    Spouse = 'spouse',
    Partner = 'partner',
    Preparer = 'preparer',
    Other = 'other'
}


export interface SignerStatusDto {
    'signerId'?: string | null;
    'role'?: SignerRole;
    'name'?: string | null;
    'email'?: string | null;
    'status'?: SignatureStatus;
    'sentAt'?: string | null;
    'viewedAt'?: string | null;
    'signedAt'?: string | null;
    'declinedAt'?: string | null;
    'declineReason'?: string | null;
    'lastReminderSentAt'?: string | null;
    'reminderCount'?: number;
    'canSendReminder'?: boolean;
    'signingOrder'?: number;
    'canSign'?: boolean;
    'isWaitingForPreviousSigner'?: boolean;
}


export interface SignerStatusItemDto {
    'clientUserId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
    'signingOrder'?: number;
}
export interface SigningFormConfigDto {
    'baseUrl'?: string | null;
    'scriptUrl'?: string | null;
    'isPreviewMode'?: boolean;
    'customCss'?: string | null;
    'sendCopyEmail'?: boolean;
}
export interface SigningFormConfigDtoApiResponse {
    'success'?: boolean;
    'data'?: SigningFormConfigDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SigningFormMessageDto {
    'subject'?: string | null;
    'body'?: string | null;
}
export interface SigningFormResponseDto {
    'success'?: boolean;
    'submissionId'?: string | null;
    'submitters'?: Array<SigningFormSubmissionDto> | null;
    'isPreviewMode'?: boolean;
    'errorMessage'?: string | null;
}
export interface SigningFormResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SigningFormResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SigningFormSubmissionDto {
    'id'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'slug'?: string | null;
    'embedSrc'?: string | null;
    'status'?: string | null;
    'externalId'?: string | null;
    'order'?: number;
}
export interface SigningFormSubmitterDto {
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'phone'?: string | null;
    'values'?: { [key: string]: any | null; } | null;
    'externalId'?: string | null;
    'metadata'?: { [key: string]: any | null; } | null;
    'order'?: number;
}
export interface SingleDocumentSignatureDto {
    'clientName': string;
    'clientEmail': string;
    'spouseName'?: string | null;
    'spouseEmail'?: string | null;
    'sendEmail'?: boolean;
    'sendSms'?: boolean;
    'clientPhone'?: string | null;
    'fields'?: Array<SignatureFieldDto> | null;
}
export interface SmsConsentStatusDto {
    'smsConsentGiven'?: boolean;
    'smsConsentTimestamp'?: string | null;
    'smsConsentMethod'?: string | null;
    'smsOptOutTimestamp'?: string | null;
    'phoneNumber'?: string | null;
    'phoneNumberVerified'?: boolean;
    'hasActiveSmsConsent'?: boolean;
    'canReceiveSms'?: boolean;
}
export interface SmsConsentStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: SmsConsentStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SourceSystemStatsDto {
    'sourceSystem'?: string | null;
    'totalClients'?: number;
    'activeClients'?: number;
    'clientsWithEmbeddings'?: number;
    'lastSyncedAt'?: string | null;
}
export interface SpouseData {
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'taxId'?: string | null;
    'dateOfBirth'?: string | null;
    'occupation'?: string | null;
    'isDeceased'?: boolean;
}
export interface SsoLoginInitiateDto {
    'redirectUrl'?: string | null;
    'state'?: string | null;
}
export interface SsoLoginInitiateDtoApiResponse {
    'success'?: boolean;
    'data'?: SsoLoginInitiateDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SsoLoginResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'user'?: UserDto;
    'token'?: string | null;
    'refreshToken'?: string | null;
    'expiresAt'?: string;
    'isNewUser'?: boolean;
    'wasLinked'?: boolean;
}
export interface SsoLoginResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SsoLoginResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SsoStatusDto {
    'enabled'?: boolean;
    'providerName'?: string | null;
    'tenantIdMasked'?: string | null;
    'loginUrl'?: string | null;
    'statusMessage'?: string | null;
}
export interface SsoStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: SsoStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StageDistributionDto {
    'stage'?: BinderStage;
    'stageName'?: string | null;
    'count'?: number;
}


export interface StorageMetricsDto {
    'totalFileSizeBytes'?: number;
    'totalFileCount'?: number;
    'organizerCount'?: number;
    'documentCount'?: number;
    'avgFileSizeBytes'?: number;
    'scannedAt'?: string;
    'topBindersBySize'?: Array<OrganizerStorageDto> | null;
}
export interface StorageMetricsDtoApiResponse {
    'success'?: boolean;
    'data'?: StorageMetricsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringApiResponse {
    'success'?: boolean;
    'data'?: string | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringInt32DictionaryApiResponse {
    'success'?: boolean;
    'data'?: { [key: string]: number; } | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringListApiResponse {
    'success'?: boolean;
    'data'?: Array<string> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringObjectDictionaryApiResponse {
    'success'?: boolean;
    'data'?: { [key: string]: any | null; } | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StructuredAuditDto {
    'id'?: number;
    'timestampUtc'?: string;
    'entityType'?: string | null;
    'tableName'?: string | null;
    'action'?: string | null;
    'entityId'?: string | null;
    'parentEntityType'?: string | null;
    'parentEntityId'?: string | null;
    'userId'?: string | null;
    'userName'?: string | null;
    'ipAddress'?: string | null;
    'userAgent'?: string | null;
    'correlationId'?: string | null;
    'changes'?: { [key: string]: any | null; } | null;
}
export interface StructuredAuditDtoApiResponse {
    'success'?: boolean;
    'data'?: StructuredAuditDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StructuredAuditDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<StructuredAuditDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StructuredAuditDtoPaginatedResponse {
    'items'?: Array<StructuredAuditDto> | null;
    'pagination'?: PaginationInfo;
}
export interface StructuredAuditDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: StructuredAuditDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SubmissionDocumentDetailsDto {
    'name'?: string | null;
    'attachment_uuid'?: string | null;
    'url'?: string | null;
    'size'?: number | null;
    'content_type'?: string | null;
    'pages'?: number | null;
    'metadata'?: { [key: string]: any | null; } | null;
    'created_at'?: string | null;
    'updated_at'?: string | null;
}
export interface SubmissionDocumentDto {
    'attachment_uuid'?: string | null;
    'name'?: string | null;
}
export interface SubmissionDocumentsResponseDto {
    'id'?: number;
    'documents'?: Array<SubmissionDocumentDetailsDto> | null;
}
export interface SubmissionDocumentsResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SubmissionDocumentsResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SubmissionResponseDto {
    'id'?: number;
    'name'?: string | null;
    'source'?: string | null;
    'submitters_order'?: string | null;
    'status'?: string | null;
    'documents'?: Array<SubmissionDocumentDto> | null;
    'submitters'?: Array<SubmissionSubmitterDto> | null;
    'expire_at'?: string | null;
    'created_at'?: string | null;
    'completed_at'?: string | null;
    'audit_log_url'?: string | null;
    'combined_document_url'?: string | null;
}
export interface SubmissionResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SubmissionResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum SubmissionStatus {
    Pending = 'pending',
    Completed = 'completed',
    Declined = 'declined',
    Expired = 'expired'
}


export interface SubmissionSubmitterDto {
    'id'?: number;
    'submission_id'?: number;
    'uuid'?: string | null;
    'email'?: string | null;
    'slug'?: string | null;
    'sent_at'?: string | null;
    'opened_at'?: string | null;
    'completed_at'?: string | null;
    'declined_at'?: string | null;
    'created_at'?: string | null;
    'updated_at'?: string | null;
    'name'?: string | null;
    'phone'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
    'external_id'?: string | null;
}
export interface SubmissionSubmitterSummaryDto {
    'id'?: number;
    'name'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
    'external_id'?: string | null;
}
export interface SubmissionSummaryDto {
    'id'?: number;
    'name'?: string | null;
    'source'?: string | null;
    'status'?: string | null;
    'slug'?: string | null;
    'external_id'?: string | null;
    'template'?: SubmissionTemplateDto;
    'submitters'?: Array<SubmissionSubmitterSummaryDto> | null;
    'created_at'?: string | null;
    'updated_at'?: string | null;
    'completed_at'?: string | null;
    'expire_at'?: string | null;
    'archived_at'?: string | null;
}
export interface SubmissionTemplateDto {
    'id'?: number;
    'name'?: string | null;
    'external_id'?: string | null;
    'folder'?: string | null;
}
export interface SubmitTaxBinderRequest {
    'note'?: string | null;
}
export interface SubmitterDto {
    'name': string;
    'email'?: string | null;
    'phone'?: string | null;
    'role'?: string | null;
    'order'?: number;
    'send_email'?: boolean | null;
    'external_id'?: string | null;
    'values'?: { [key: string]: any | null; } | null;
    'fields'?: Array<SubmitterFieldDto> | null;
    'message'?: SubmitterMessageDto;
    'preferences'?: { [key: string]: any | null; } | null;
}
export interface SubmitterFieldDto {
    'name'?: string | null;
    'default_value'?: string | null;
    'readonly'?: boolean | null;
}
export interface SubmitterMessageDto {
    'subject'?: string | null;
    'body'?: string | null;
}
export interface SuggestedSignatureFieldDto {
    'id'?: string;
    'name'?: string | null;
    'type'?: SignatureFieldType;
    'role'?: string | null;
    'page'?: number;
    'x'?: number;
    'y'?: number;
    'width'?: number;
    'height'?: number;
    'isRequired'?: boolean;
    'description'?: string | null;
    'defaultValue'?: string | null;
}


export interface SyncAllClientsDto {
    'lastSyncedAfter'?: string | null;
    'updateExisting'?: boolean;
    'batchSize'?: number | null;
}
export interface TaxBinderAuditEntryDto {
    'id'?: number;
    'timestampUtc'?: string;
    'action'?: string | null;
    'description'?: string | null;
    'userName'?: string | null;
    'userId'?: string | null;
    'fieldChanges'?: Array<FieldChangeDto> | null;
    'ipAddress'?: string | null;
}
export interface TaxBinderAuditHistoryDto {
    'binderId'?: string;
    'taxYear'?: number;
    'clientName'?: string | null;
    'currentStage'?: BinderStage;
    'auditEntries'?: Array<TaxBinderAuditEntryDto> | null;
    'totalEntries'?: number;
}


export interface TaxBinderAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderDto {
    'id'?: string;
    'name'?: string | null;
    'taxYear'?: number;
    'taxType'?: string | null;
    'clientType'?: ClientType;
    'stage'?: BinderStage;
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'clientEmail'?: string | null;
    'clientPhone'?: string | null;
    'officeId'?: string | null;
    'officeName'?: string | null;
    'partnerId'?: string | null;
    'partnerName'?: string | null;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'assignedPreparer'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'dueDate'?: string | null;
    'notificationDaysPrior'?: number;
    'isExtended'?: boolean;
    'engagementLetter'?: ESignatureStatusDto;
    'directDepositReport'?: ESignatureStatusDto;
    'organizerDocumentId'?: string | null;
    'hasOrganizer'?: boolean;
    'taxReturnBundleId'?: string | null;
    'hasTaxReturnBundle'?: boolean;
    'bundleSignature'?: ESignatureStatusDto;
    'completionStatus'?: DocumentCompletionStatus;
    'documentsTotal'?: number;
    'documentsApproved'?: number;
    'documentsRejected'?: number;
    'documentCompletionPercentage'?: number;
    'questionnaireRequired'?: number;
    'questionnaireCompleted'?: number;
    'questionnaireCompletionPercentage'?: number;
    'questionnaireCompletedAt'?: string | null;
    'isQuestionnaireComplete'?: boolean;
    'questionnaireAnswers'?: string | null;
    'priority'?: string | null;
    'daysOverdue'?: number | null;
    'completionPercentage'?: number;
    'invoiceLink'?: string | null;
    'isArchived'?: boolean;
    'filingDeadline'?: string | null;
    'description'?: string | null;
    'clientSubmittedAt'?: string | null;
    'clientSubmittedBy'?: string | null;
    'isClientSubmitted'?: boolean;
    'inReviewStartedAt'?: string | null;
    'inReviewBy'?: string | null;
    'isInReview'?: boolean;
    'inReviewCompletedAt'?: string | null;
    'readyForScanAt'?: string | null;
    'readyForScanBy'?: string | null;
    'sentForPreparationAt'?: string | null;
    'sentForPreparationBy'?: string | null;
    'finalClientReviewAt'?: string | null;
    'finalClientReviewBy'?: string | null;
    'completedAt'?: string | null;
    'completedBy'?: string | null;
    'clientRequestsChangesAt'?: string | null;
    'clientRequestsChangesBy'?: string | null;
    'efileReadyAt'?: string | null;
    'efileReadyBy'?: string | null;
    'releasedToClientAt'?: string | null;
    'releasedToClientBy'?: string | null;
    'isReleasedToClient'?: boolean;
    'recalledAt'?: string | null;
    'recalledBy'?: string | null;
    'recallReason'?: string | null;
    'allowedTransitions'?: Array<BinderStage> | null;
    'hasUnreviewedDocuments'?: boolean;
    'unreviewedDocumentsCount'?: number;
    'hasUnreviewedComments'?: boolean;
    'unreviewedCommentsCount'?: number;
    'lastActivityType'?: BinderActivityType;
    'lastActivityAt'?: string | null;
    'lateDocumentsUploadedAt'?: string | null;
    'lateDocumentsCount'?: number;
}


export interface TaxBinderDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderDtoPaginatedResponse {
    'items'?: Array<TaxBinderDto> | null;
    'pagination'?: PaginationInfo;
}
export interface TaxBinderDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderExportPreviewDto {
    'totalFiles'?: number;
    'pdfFiles'?: number;
    'imageFiles'?: number;
    'otherFiles'?: number;
    'recommendedFormat'?: ExportType;
    'estimatedSize'?: number;
    'files'?: Array<FilePreviewDto> | null;
}


export interface TaxBinderExportPreviewDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderExportPreviewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderExportSelectionDto {
    'documentIds': Array<string>;
    'specificFileIds'?: Array<string> | null;
    'preferredFormat': ExportFormat;
}


export interface TaxBinderPackageExportDto {
    'includeClientInfo'?: boolean;
    'includeSpouseInfo'?: boolean;
    'includeDependents'?: boolean;
    'includeBankAccounts'?: boolean;
    'includeQuestionnaire'?: boolean;
    'includeComments'?: boolean;
    'includeExtractedText'?: boolean;
    'includeSeparatorPages'?: boolean;
    'documentFilter': DocumentFilter;
    'selectedDocumentIds'?: Array<string> | null;
}


export interface TaxBinderVerificationStatusDto {
    'userRole'?: ClientUserRole;
    'isSpouseInfoVerified'?: boolean;
    'spouseInfoVerifiedAt'?: string | null;
    'canModifyMaritalStatus'?: boolean;
    'maritalStatus'?: MaritalStatus;
    'spouseInfo'?: ClientSpouseDto;
    'hasSpouseSsnOnly'?: boolean;
    'hasPrimaryUser'?: boolean;
    'primaryUserName'?: string | null;
    'primaryUserEmail'?: string | null;
    'primaryUserPhone'?: string | null;
}


export interface TaxBinderVerificationStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderVerificationStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxReturnBundleFilingInstructionDto {
    'id'?: string;
    'taxReturnBundleJurisdictionId'?: string;
    'documentId'?: string | null;
    'taxYear'?: number;
    'instructionType'?: FilingInstructionType;
    'dueDate'?: string | null;
    'taxLiability'?: number | null;
    'amountPaid'?: number | null;
    'balanceDue'?: number | null;
    'refundAmount'?: number | null;
    'isDirectDeposit'?: boolean;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
    'specialInstructions'?: string | null;
    'extractionSource'?: string | null;
    'extractionConfidence'?: number | null;
    'extractedAt'?: string | null;
    'hasBalanceDue'?: boolean;
    'hasRefund'?: boolean;
    'formattedMailingAddress'?: string | null;
}


export interface TaxReturnBundleFilingInstructionDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxReturnBundleFilingInstructionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxReturnBundleJurisdictionDto {
    'id'?: string;
    'taxReturnBundleId'?: string;
    'jurisdictionType'?: JurisdictionType;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'status'?: ReturnStatus;
    'filingMethod'?: FilingMethod;
    'sortOrder'?: number;
    'eFileAuthorizationDocumentId'?: string | null;
    'eFileAuthorizationFormType'?: string | null;
    'eFileAuthorizationSignedAt'?: string | null;
    'eFileAuthorizationSentById'?: string | null;
    'eFileAuthorizationSentByName'?: string | null;
    'eFileAuthorizationSentAt'?: string | null;
    'eFileSigningMethod'?: EFileSigningMethod;
    'paperConvertedAt'?: string | null;
    'filedAt'?: string | null;
    'filedById'?: string | null;
    'filedByName'?: string | null;
    'eFileConfirmationNumber'?: string | null;
    'acceptedAt'?: string | null;
    'rejectedAt'?: string | null;
    'rejectionReason'?: string | null;
    'isAmended'?: boolean;
    'originalReturnId'?: string | null;
    'notes'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'hasEFileAuthorization'?: boolean;
    'isSigned'?: boolean;
    'isFiled'?: boolean;
    'isAccepted'?: boolean;
    'isRejected'?: boolean;
    'filingInstruction'?: TaxReturnBundleFilingInstructionDto;
    'estimatedTaxFilingInstruction'?: TaxReturnBundleFilingInstructionDto;
    'filingInstructions'?: Array<TaxReturnBundleFilingInstructionDto> | null;
    'paymentVouchers'?: Array<TaxReturnBundlePaymentVoucherDto> | null;
    'pageReferences'?: Array<BundlePageReferenceDto> | null;
    'signatureRequirements'?: Array<BundleSignatureRequirementDto> | null;
    'bundleDocuments'?: Array<BundleDocumentDto> | null;
    'documentCount'?: number;
}


export interface TaxReturnBundleJurisdictionDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxReturnBundleJurisdictionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxReturnBundleJurisdictionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<TaxReturnBundleJurisdictionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxReturnBundleJurisdictionSummaryDto {
    'id'?: string;
    'jurisdictionType'?: JurisdictionType;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'status'?: ReturnStatus;
    'filingMethod'?: FilingMethod;
    'sortOrder'?: number;
    'isSigned'?: boolean;
    'isFiled'?: boolean;
    'dueDate'?: string | null;
    'balanceDue'?: number | null;
    'refundAmount'?: number | null;
}


export interface TaxReturnBundlePaymentVoucherDto {
    'id'?: string;
    'taxReturnBundleJurisdictionId'?: string;
    'documentId'?: string | null;
    'quarter'?: VoucherQuarter;
    'taxYear'?: number;
    'formNumber'?: string | null;
    'dueDate'?: string;
    'amount'?: number;
    'reminderEnabled'?: boolean;
    'reminderDaysPrior'?: number;
    'reminderSentAt'?: string | null;
    'paidAt'?: string | null;
    'paymentNotes'?: string | null;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
    'isPaid'?: boolean;
    'isOverdue'?: boolean;
    'daysUntilDue'?: number;
    'quarterDisplay'?: string | null;
    'formattedMailingAddress'?: string | null;
}


export interface TaxReturnBundlePaymentVoucherDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxReturnBundlePaymentVoucherDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxReturnBundlePaymentVoucherDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<TaxReturnBundlePaymentVoucherDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxTypeOption {
    'value'?: number;
    'name'?: string | null;
    'displayName'?: string | null;
}
export interface TaxTypeOptionListApiResponse {
    'success'?: boolean;
    'data'?: Array<TaxTypeOption> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TemplateSignatureFieldDto {
    'fieldId': string;
    'label': string;
    'role'?: string | null;
    'type': SignatureFieldType;
    'page'?: number;
    'position': FieldPositionDto;
    'dimensions': FieldDimensionsDto;
    'isRequired'?: boolean;
    'tabOrder'?: number;
    'fieldUuid'?: string | null;
    'submitterUuid'?: string | null;
    'attachmentUuid'?: string | null;
    'preferences'?: FieldPreferencesDto;
}


export interface TimePeriodCountsDto {
    'pastDay'?: number;
    'pastWeek'?: number;
    'pastMonth'?: number;
    'past90Days'?: number;
    'past120Days'?: number;
    'thisYear'?: number;
}
export interface TransitionAuditBinderDto {
    'toStage': AuditBinderStage;
}


export interface UnifiedNotificationDto {
    'id'?: string;
    'actionType'?: NotificationActionType;
    'actionTypeDisplay'?: string | null;
    'targetAudience'?: NotificationAudience;
    'title'?: string | null;
    'message'?: string | null;
    'priority'?: NotificationPriority;
    'clientId'?: string | null;
    'clientName'?: string | null;
    'binderId'?: string | null;
    'binderName'?: string | null;
    'documentId'?: string | null;
    'documentName'?: string | null;
    'documentRequestId'?: string | null;
    'entityType'?: NotificationEntityType;
    'entityId'?: string | null;
    'entityName'?: string | null;
    'triggeredByUserId'?: string | null;
    'triggeredByUserName'?: string | null;
    'triggeredByUserRole'?: UserRole;
    'isRead'?: boolean;
    'readAt'?: string | null;
    'isDismissed'?: boolean;
    'dismissedAt'?: string | null;
    'recipientUserId'?: string | null;
    'recipientUserName'?: string | null;
    'deliveryChannels'?: NotificationDeliveryChannel;
    'isSent'?: boolean | null;
    'sentAt'?: string | null;
    'deliveryError'?: string | null;
    'createdAt'?: string;
    'metadata'?: { [key: string]: any | null; } | null;
}


export interface UnifiedNotificationDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UnifiedNotificationDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UnifiedNotificationDtoPaginatedResponse {
    'items'?: Array<UnifiedNotificationDto> | null;
    'pagination'?: PaginationInfo;
}
export interface UnifiedNotificationDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: UnifiedNotificationDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UpdateActionPreferenceDto {
    'channels'?: NotificationDeliveryChannel;
    'batchStrategy'?: NotificationBatchStrategy;
}


export interface UpdateAuditBinderDto {
    'name'?: string | null;
    'periodStart'?: string | null;
    'periodEnd'?: string | null;
    'dueDate'?: string | null;
    'description'?: string | null;
}
export interface UpdateBinderActionPreferenceDto {
    'channel'?: NotificationDeliveryChannel;
}


export interface UpdateBundleSignatureRequirementDto {
    'userId'?: string | null;
    'requiresManualSign'?: boolean | null;
    'manualSignReason'?: string | null;
}
export interface UpdateClientDto {
    'name'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'type'?: ClientType;
    'maritalStatus'?: MaritalStatus;
    'taxId'?: string | null;
    'spouseTaxId'?: string | null;
    'notes'?: string | null;
    'tags'?: Array<string> | null;
    'allowPhysicalSignature'?: boolean | null;
    'engagementLetterRequired'?: boolean | null;
    'isConfidential'?: boolean | null;
    'serviceLines'?: Array<ServiceLine> | null;
}


export interface UpdateClientNoteDto {
    'content': string;
}
export interface UpdateClientNotificationPreferenceDto {
    'preferredChannel'?: NotificationChannel;
    'isEnabled'?: boolean | null;
    'batchIntervalMinutes'?: number | null;
    'enableDocumentRequests'?: boolean | null;
    'enableDocumentApprovals'?: boolean | null;
    'enableDocumentRejections'?: boolean | null;
    'enableDocumentComments'?: boolean | null;
    'enableBinderStageChanges'?: boolean | null;
    'enableBinderCreated'?: boolean | null;
    'enableSignatureRequests'?: boolean | null;
    'enableAuditBinderStageChanges'?: boolean | null;
    'enableAuditBinderComments'?: boolean | null;
    'enableAuditBinderDocumentApprovals'?: boolean | null;
    'enableAuditBinderDocumentRejections'?: boolean | null;
    'enableAuditBinderDocumentRequests'?: boolean | null;
    'enableAuditBinderDocumentRequestOutcomes'?: boolean | null;
    'notifyPrimaryUser'?: boolean | null;
    'notifySpouse'?: boolean | null;
    'notifyDependents'?: boolean | null;
    'notifyAuthorized'?: boolean | null;
    'notifyAccountant'?: boolean | null;
}


export interface UpdateClientUserRoleDto {
    'userId': string;
    'clientId': string;
    'role': ClientUserRole;
    'isMainContact'?: boolean | null;
}


export interface UpdateCommentDto {
    'content': string;
    'priority'?: string | null;
    'status'?: string | null;
}
export interface UpdateContactInfoDto {
    'email'?: string | null;
    'phoneNumber'?: string | null;
}
export interface UpdateDocumentDto {
    'type'?: DocumentType;
    'status'?: DocumentStatus;
    'userOverrideFormType'?: string | null;
}


export interface UpdateDocumentRequestDto {
    'title'?: string | null;
    'description'?: string | null;
    'binderId'?: string | null;
    'status'?: DocumentRequestStatus;
    'priority'?: DocumentRequestPriority;
    'dueDate'?: string | null;
    'notes'?: string | null;
    'requestType'?: AuditDocumentRequestType;
    'isConfidential'?: boolean | null;
    'confidentialClientUserId'?: string | null;
}


export interface UpdateFilingInstructionDto {
    'dueDate'?: string | null;
    'taxLiability'?: number | null;
    'amountPaid'?: number | null;
    'balanceDue'?: number | null;
    'refundAmount'?: number | null;
    'isDirectDeposit'?: boolean | null;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
    'specialInstructions'?: string | null;
}
export interface UpdateJurisdictionDto {
    'status'?: ReturnStatus;
    'notes'?: string | null;
    'eFileConfirmationNumber'?: string | null;
    'rejectionReason'?: string | null;
}


export interface UpdateK1RecipientAssignmentDto {
    'email': string;
    'firstName'?: string | null;
    'lastName'?: string | null;
}
export interface UpdatePaymentVoucherDto {
    'quarter'?: VoucherQuarter;
    'taxYear'?: number | null;
    'formNumber'?: string | null;
    'dueDate'?: string | null;
    'amount'?: number | null;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
}


export interface UpdatePreparerDocumentDto {
    'displayName'?: string | null;
    'category'?: BundleDocumentCategory;
    'jurisdictionId'?: string | null;
    'requiresSignature'?: boolean | null;
    'signatureFieldPlacementsJson'?: string | null;
}


export interface UpdatePreprocessedDocumentDto {
    'documentName'?: string | null;
    'isIncluded'?: boolean | null;
    'requiresSignature'?: boolean | null;
    'documentType'?: DocumentType;
}


export interface UpdateQuestionnaireDto {
    'title'?: string | null;
    'description'?: string | null;
    'isActive'?: boolean | null;
    'isRequired'?: boolean | null;
}
export interface UpdateQuestionnaireResponseDto {
    'responseData': string;
}
export interface UpdateSignatureTemplateDto {
    'specificFormType'?: string | null;
    'templateName'?: string | null;
    'requiresSignature'?: boolean;
    'fields'?: Array<TemplateSignatureFieldDto> | null;
    'isActive'?: boolean;
}
export interface UpdateTaxBinderDto {
    'name'?: string | null;
    'preparerId'?: string | null;
    'dueDate'?: string | null;
    'notificationDaysPrior'?: number | null;
    'isExtended'?: boolean | null;
    'invoiceLink'?: string | null;
    'engagementLetterDocumentId'?: string | null;
}
export interface UpdateTaxBinderStageDto {
    'stage': BinderStage;
}


export interface UpdateUserDto {
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
}
export interface UpdateUserNotificationPreferenceDto {
    'isEnabled'?: boolean | null;
    'defaultChannels'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
    'batchIntervalMinutes'?: number | null;
    'actionChannelPreferences'?: { [key: string]: number; } | null;
    'actionBatchPreferences'?: { [key: string]: number; } | null;
    'notifyPrimaryUser'?: boolean | null;
    'notifySpouse'?: boolean | null;
    'notifyDependents'?: boolean | null;
    'notifyAuthorized'?: boolean | null;
    'notifyAccountant'?: boolean | null;
}


export interface UpdateUserSettingDto {
    'pageDefaults'?: PageDefaultsDto;
}
export interface UploadLinkDetailDto {
    'id'?: string;
    'label'?: string | null;
    'expiresAt'?: string | null;
    'isActive'?: boolean;
    'revokedAt'?: string | null;
    'uploadCount'?: number;
    'recipientCount'?: number;
    'createdAt'?: string;
    'uploadUrl'?: string | null;
    'message'?: string | null;
    'recipientEmails'?: Array<string> | null;
    'documents'?: Array<UploadLinkDocumentDto> | null;
}
export interface UploadLinkDetailDtoApiResponse {
    'success'?: boolean;
    'data'?: UploadLinkDetailDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UploadLinkDocumentDto {
    'id'?: string;
    'name'?: string | null;
    'fileSize'?: number;
    'uploadedAt'?: string;
}
export interface UploadLinkDto {
    'id'?: string;
    'label'?: string | null;
    'expiresAt'?: string | null;
    'isActive'?: boolean;
    'revokedAt'?: string | null;
    'uploadCount'?: number;
    'recipientCount'?: number;
    'createdAt'?: string;
}
export interface UploadLinkDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UploadLinkDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UploadSignedEngagementLetterResponseDto {
    'binderId'?: string;
    'documentId'?: string;
    'signedAt'?: string;
    'signatureMethod'?: EngagementLetterSignatureMethod;
    'archivedDocumentId'?: string | null;
}


export interface UploadSignedEngagementLetterResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: UploadSignedEngagementLetterResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UploadedFileDto {
    'fileName'?: string | null;
    'uploadedAt'?: string;
}
export interface UploadedFileDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UploadedFileDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum UploaderRole {
    Client = 'client',
    Preparer = 'preparer'
}


export interface UserAdminSearchQueryDto {
    'search'?: string | null;
    'role'?: UserRole;
    'isActive'?: boolean | null;
    'createdAfter'?: string | null;
    'createdBefore'?: string | null;
    'lastLoginAfter'?: string | null;
    'lastLoginBefore'?: string | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'page'?: number;
    'pageSize'?: number;
}


export interface UserAdminSearchResultDto {
    'id'?: string;
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'lastLoginAt'?: string | null;
    'createdAt'?: string;
    'clientCount'?: number;
    'possibleDuplicateCount'?: number;
    'clientAssignments'?: Array<UserClientAssignmentDto> | null;
}


export interface UserAdminSearchResultDtoPaginatedResponse {
    'items'?: Array<UserAdminSearchResultDto> | null;
    'pagination'?: PaginationInfo;
}
export interface UserAdminSearchResultDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: UserAdminSearchResultDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserClientAssignmentDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'clientType'?: ClientType;
    'clientTypeDisplay'?: string | null;
    'clientUserRole'?: ClientUserRole;
    'clientUserRoleDisplay'?: string | null;
    'isConfidential'?: boolean;
    'authorizedUserIds'?: Array<string> | null;
    'confidentialMarkedByName'?: string | null;
}


export interface UserDto {
    'id'?: string;
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'isPartner'?: boolean;
    'emailConfirmed'?: boolean;
    'twoFactorEnabled'?: boolean;
    'lastLoginAt'?: string;
    'createdAt'?: string;
    'updatedAt'?: string;
    'smsConsentGiven'?: boolean;
    'smsConsentTimestamp'?: string | null;
    'smsConsentMethod'?: string | null;
    'smsOptOutTimestamp'?: string | null;
    'hasActiveSmsConsent'?: boolean;
    'clientCount'?: number;
    'clientAssignments'?: Array<UserClientAssignmentDto> | null;
}


export interface UserDtoApiResponse {
    'success'?: boolean;
    'data'?: UserDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserListDto {
    'id'?: string;
    'email'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'isPartner'?: boolean;
    'lastLoginAt'?: string;
}


export interface UserListDtoPaginatedResponse {
    'items'?: Array<UserListDto> | null;
    'pagination'?: PaginationInfo;
}
export interface UserListDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: UserListDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserNotificationPreferenceDto {
    'id'?: string;
    'userId'?: string;
    'isEnabled'?: boolean;
    'defaultChannels'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
    'batchIntervalMinutes'?: number;
    'actionChannelPreferences'?: { [key: string]: number; } | null;
    'actionBatchPreferences'?: { [key: string]: number; } | null;
    'notifyPrimaryUser'?: boolean;
    'notifySpouse'?: boolean;
    'notifyDependents'?: boolean;
    'notifyAuthorized'?: boolean;
    'notifyAccountant'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
}


export interface UserNotificationPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: UserNotificationPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserPageDefaultsDto {
    'rowsPerPage'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'role'?: string | null;
    'isActive'?: string | null;
    'createdAfter'?: string | null;
    'createdBefore'?: string | null;
    'lastLoginAfter'?: string | null;
    'lastLoginBefore'?: string | null;
}

export enum UserRole {
    Client = 'client',
    Preparer = 'preparer',
    Admin = 'admin'
}


export interface UserSearchResultDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'email'?: string | null;
    'role'?: UserRole;
}


export interface UserSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UserSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserSettingDto {
    'id'?: string;
    'userId'?: string;
    'pageDefaults'?: PageDefaultsDto;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface UserSettingDtoApiResponse {
    'success'?: boolean;
    'data'?: UserSettingDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserWithClientsSearchResultDto {
    'id'?: string;
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'clientAssignments'?: Array<UserClientAssignmentDto> | null;
}


export interface UserWithClientsSearchResultDtoApiResponse {
    'success'?: boolean;
    'data'?: UserWithClientsSearchResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserWithClientsSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UserWithClientsSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface VerifyCodeDto {
    'emailOrPhone': string;
    'clientId': string;
    'code': string;
    'rememberMe'?: boolean;
}
export interface VerifyEmailDto {
    'code': string;
}
export interface VerifyPhoneDto {
    'code': string;
}
export interface VerifySpouseInfoDto {
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'maritalStatus'?: MaritalStatus;
    'spouseEmail'?: string | null;
    'spousePhone'?: string | null;
    'spouseFirstName'?: string | null;
    'spouseLastName'?: string | null;
    'spouseSsn'?: string | null;
    'spouseDateOfBirth'?: string | null;
    'marriageDate'?: string | null;
    'isNewSpouse'?: boolean;
    'removeSpouse'?: boolean;
}



export enum VoucherQuarter {
    Q1 = 'q1',
    Q2 = 'q2',
    Q3 = 'q3',
    Q4 = 'q4'
}


export interface WorkflowTimingDto {
    'avgDaysOpenToSentForPrep'?: number | null;
    'avgDaysClientSubmittedToInReview'?: number | null;
    'avgDaysEfileReadyToCompleted'?: number | null;
    'avgDaysOpenToCompleted'?: number | null;
}

/**
 * AdminApi - axios parameter creator
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminJobsReclassifyFilingInstructionsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/jobs/reclassify-filing-instructions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {number} [maxFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesCleanupPost: async (dryRun?: boolean, maxFiles?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/orphan-files/cleanup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }

            if (maxFiles !== undefined) {
                localVarQueryParameter['maxFiles'] = maxFiles;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [minimumAgeInDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesDetectGet: async (minimumAgeInDays?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/orphan-files/detect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minimumAgeInDays !== undefined) {
                localVarQueryParameter['minimumAgeInDays'] = minimumAgeInDays;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} storageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesStorageKeyDelete: async (storageKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storageKey' is not null or undefined
            assertParamExists('apiAdminOrphanFilesStorageKeyDelete', 'storageKey', storageKey)
            const localVarPath = `/api/Admin/orphan-files/{storageKey}`
                .replace(`{${"storageKey"}}`, encodeURIComponent(String(storageKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminPdfConversionConfigGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/pdf-conversion-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminStorageMetricsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/storage/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminJobsReclassifyFilingInstructionsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminJobsReclassifyFilingInstructionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {number} [maxFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOrphanFilesCleanupPost(dryRun?: boolean, maxFiles?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrphanFileCleanupResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOrphanFilesCleanupPost(dryRun, maxFiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminOrphanFilesCleanupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [minimumAgeInDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOrphanFilesDetectGet(minimumAgeInDays?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrphanedFileInfoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOrphanFilesDetectGet(minimumAgeInDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminOrphanFilesDetectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} storageKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOrphanFilesStorageKeyDelete(storageKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOrphanFilesStorageKeyDelete(storageKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminOrphanFilesStorageKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfConversionConfigDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminPdfConversionConfigGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminPdfConversionConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageMetricsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminStorageMetricsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminStorageMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAdminJobsReclassifyFilingInstructionsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiApiAdminOrphanFilesCleanupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesCleanupPost(requestParameters: AdminApiApiAdminOrphanFilesCleanupPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrphanFileCleanupResultApiResponse> {
            return localVarFp.apiAdminOrphanFilesCleanupPost(requestParameters.dryRun, requestParameters.maxFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiApiAdminOrphanFilesDetectGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesDetectGet(requestParameters: AdminApiApiAdminOrphanFilesDetectGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrphanedFileInfoListApiResponse> {
            return localVarFp.apiAdminOrphanFilesDetectGet(requestParameters.minimumAgeInDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesStorageKeyDelete(requestParameters: AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAdminOrphanFilesStorageKeyDelete(requestParameters.storageKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<PdfConversionConfigDtoApiResponse> {
            return localVarFp.apiAdminPdfConversionConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<StorageMetricsDtoApiResponse> {
            return localVarFp.apiAdminStorageMetricsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - interface
 */
export interface AdminApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {AdminApiApiAdminOrphanFilesCleanupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminOrphanFilesCleanupPost(requestParameters?: AdminApiApiAdminOrphanFilesCleanupPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrphanFileCleanupResultApiResponse>;

    /**
     * 
     * @param {AdminApiApiAdminOrphanFilesDetectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminOrphanFilesDetectGet(requestParameters?: AdminApiApiAdminOrphanFilesDetectGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrphanedFileInfoListApiResponse>;

    /**
     * 
     * @param {AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminOrphanFilesStorageKeyDelete(requestParameters: AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<PdfConversionConfigDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<StorageMetricsDtoApiResponse>;

}

/**
 * Request parameters for apiAdminOrphanFilesCleanupPost operation in AdminApi.
 */
export interface AdminApiApiAdminOrphanFilesCleanupPostRequest {
    readonly dryRun?: boolean

    readonly maxFiles?: number
}

/**
 * Request parameters for apiAdminOrphanFilesDetectGet operation in AdminApi.
 */
export interface AdminApiApiAdminOrphanFilesDetectGetRequest {
    readonly minimumAgeInDays?: number
}

/**
 * Request parameters for apiAdminOrphanFilesStorageKeyDelete operation in AdminApi.
 */
export interface AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest {
    readonly storageKey: string
}

/**
 * AdminApi - object-oriented interface
 */
export class AdminApi extends BaseAPI implements AdminApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminJobsReclassifyFilingInstructionsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiApiAdminOrphanFilesCleanupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminOrphanFilesCleanupPost(requestParameters: AdminApiApiAdminOrphanFilesCleanupPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminOrphanFilesCleanupPost(requestParameters.dryRun, requestParameters.maxFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiApiAdminOrphanFilesDetectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminOrphanFilesDetectGet(requestParameters: AdminApiApiAdminOrphanFilesDetectGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminOrphanFilesDetectGet(requestParameters.minimumAgeInDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminOrphanFilesStorageKeyDelete(requestParameters: AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminOrphanFilesStorageKeyDelete(requestParameters.storageKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminPdfConversionConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminStorageMetricsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDashboardApi - axios parameter creator
 */
export const AdminDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDashboardGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDashboardApi - functional programming interface
 */
export const AdminDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDashboardGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDashboardDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDashboardGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDashboardApi.apiAdminDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDashboardApi - factory interface
 */
export const AdminDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardDtoApiResponse> {
            return localVarFp.apiAdminDashboardGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDashboardApi - interface
 */
export interface AdminDashboardApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardDtoApiResponse>;

}

/**
 * AdminDashboardApi - object-oriented interface
 */
export class AdminDashboardApi extends BaseAPI implements AdminDashboardApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminDashboardGet(options?: RawAxiosRequestConfig) {
        return AdminDashboardApiFp(this.configuration).apiAdminDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditBindersApi - axios parameter creator
 */
export const AuditBindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksGet', 'binderId', binderId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdGet: async (binderId: string, linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdGet', 'binderId', binderId)
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdGet', 'linkId', linkId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links/{linkId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdRevokePost: async (binderId: string, linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdRevokePost', 'binderId', binderId)
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdRevokePost', 'linkId', linkId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links/{linkId}/revoke`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {CreateUploadLinkDto} [createUploadLinkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksPost: async (binderId: string, createUploadLinkDto?: CreateUploadLinkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksPost', 'binderId', binderId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUploadLinkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] 
         * @param {string} [dueDateStart] 
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] 
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [assignedToMe] 
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersGet: async (clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (stages) {
                localVarQueryParameter['Stages'] = stages;
            }

            if (dueDateStart !== undefined) {
                localVarQueryParameter['DueDateStart'] = (dueDateStart as any instanceof Date) ?
                    (dueDateStart as any).toISOString() :
                    dueDateStart;
            }

            if (dueDateEnd !== undefined) {
                localVarQueryParameter['DueDateEnd'] = (dueDateEnd as any instanceof Date) ?
                    (dueDateEnd as any).toISOString() :
                    dueDateEnd;
            }

            if (periodStart !== undefined) {
                localVarQueryParameter['PeriodStart'] = (periodStart as any instanceof Date) ?
                    (periodStart as any).toISOString() :
                    periodStart;
            }

            if (periodEnd !== undefined) {
                localVarQueryParameter['PeriodEnd'] = (periodEnd as any instanceof Date) ?
                    (periodEnd as any).toISOString() :
                    periodEnd;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDelete', 'id', id)
            const localVarPath = `/api/audit-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDetailGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDetailGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<File>} files 
         * @param {string} [documentRequestId] 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsPost: async (id: string, files: Array<File>, documentRequestId?: string, comment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDocumentsPost', 'id', id)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiAuditBindersIdDocumentsPost', 'files', files)
            const localVarPath = `/api/audit-binders/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }


            if (documentRequestId !== undefined) { 
                localVarFormParams.append('DocumentRequestId', documentRequestId as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ExportAuditBinderDocumentsDto} [exportAuditBinderDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsZipPost: async (id: string, exportAuditBinderDocumentsDto?: ExportAuditBinderDocumentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDocumentsZipPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/documents/zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportAuditBinderDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SetAuditBinderFinalDocumentDto} [setAuditBinderFinalDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDocumentPost: async (id: string, setAuditBinderFinalDocumentDto?: SetAuditBinderFinalDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDocumentPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/final-document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAuditBinderFinalDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentRequestsPost: async (id: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdImportDocumentRequestsPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/import-document-requests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentsFromZipPost: async (id: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdImportDocumentsFromZipPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/import-documents-from-zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAuditBinderDto} [updateAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdPut: async (id: string, updateAuditBinderDto?: UpdateAuditBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdPut', 'id', id)
            const localVarPath = `/api/audit-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAuditBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdPut: async (id: string, documentId: string, createSignatureRequestDto?: CreateSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdPut', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdPut', 'documentId', documentId)
            const localVarPath = `/api/audit-binders/{id}/signature-documents/{documentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet: async (id: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'documentId', documentId)
            const localVarPath = `/api/audit-binders/{id}/signature-documents/{documentId}/signing-session`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsEligibleSignersGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsEligibleSignersGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/signature-documents/eligible-signers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsPost: async (id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/signature-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TransitionAuditBinderDto} [transitionAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdTransitionPost: async (id: string, transitionAuditBinderDto?: TransitionAuditBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdTransitionPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/transition`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transitionAuditBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAuditBinderDto} [createAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersPost: async (createAuditBinderDto?: CreateAuditBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAuditBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditBindersApi - functional programming interface
 */
export const AuditBindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditBindersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksLinkIdGet(binderId: string, linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDetailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksLinkIdGet(binderId, linkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksLinkIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(binderId: string, linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(binderId, linkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksLinkIdRevokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {CreateUploadLinkDto} [createUploadLinkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksPost(binderId: string, createUploadLinkDto?: CreateUploadLinkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDetailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksPost(binderId, createUploadLinkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] 
         * @param {string} [dueDateStart] 
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] 
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [assignedToMe] 
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersGet(clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersGet(clientId, preparerId, officeId, stages, dueDateStart, dueDateEnd, periodStart, periodEnd, watchedClientsOnly, assignedToMe, isArchived, search, page, limit, sortBy, sortOrder, requestType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDetailGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDetailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDetailGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<File>} files 
         * @param {string} [documentRequestId] 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDocumentsPost(id: string, files: Array<File>, documentRequestId?: string, comment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDocumentsPost(id, files, documentRequestId, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ExportAuditBinderDocumentsDto} [exportAuditBinderDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDocumentsZipPost(id: string, exportAuditBinderDocumentsDto?: ExportAuditBinderDocumentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDocumentsZipPost(id, exportAuditBinderDocumentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDocumentsZipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SetAuditBinderFinalDocumentDto} [setAuditBinderFinalDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdFinalDocumentPost(id: string, setAuditBinderFinalDocumentDto?: SetAuditBinderFinalDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdFinalDocumentPost(id, setAuditBinderFinalDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdFinalDocumentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdImportDocumentRequestsPost(id: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDocumentRequestsResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdImportDocumentRequestsPost(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdImportDocumentRequestsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdImportDocumentsFromZipPost(id: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportZipQueuedDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdImportDocumentsFromZipPost(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdImportDocumentsFromZipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAuditBinderDto} [updateAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdPut(id: string, updateAuditBinderDto?: UpdateAuditBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdPut(id, updateAuditBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsDocumentIdPut(id: string, documentId: string, createSignatureRequestDto?: CreateSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureRequestResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsDocumentIdPut(id, documentId, createSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsDocumentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSigningSessionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsEligibleSignersGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibleSignersDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsEligibleSignersGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsEligibleSignersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsPost(id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureRequestResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsPost(id, createSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TransitionAuditBinderDto} [transitionAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdTransitionPost(id: string, transitionAuditBinderDto?: TransitionAuditBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdTransitionPost(id, transitionAuditBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdTransitionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAuditBinderDto} [createAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersPost(createAuditBinderDto?: CreateAuditBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersPost(createAuditBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditBindersApi - factory interface
 */
export const AuditBindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditBindersApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDtoListApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksPost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksPost(requestParameters.binderId, requestParameters.createUploadLinkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersGet(requestParameters: AuditBindersApiApiAuditBindersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse> {
            return localVarFp.apiAuditBindersGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAuditBindersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdDetailGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDetailGet(requestParameters: AuditBindersApiApiAuditBindersIdDetailGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDetailDtoApiResponse> {
            return localVarFp.apiAuditBindersIdDetailGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiAuditBindersIdDocumentsPost(requestParameters.id, requestParameters.files, requestParameters.documentRequestId, requestParameters.comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsZipPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiAuditBindersIdDocumentsZipPost(requestParameters.id, requestParameters.exportAuditBinderDocumentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdFinalDocumentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDocumentPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDocumentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersIdFinalDocumentPost(requestParameters.id, requestParameters.setAuditBinderFinalDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdGet(requestParameters: AuditBindersApiApiAuditBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentRequestsPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDocumentRequestsResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdImportDocumentRequestsPost(requestParameters.id, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentsFromZipPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportZipQueuedDtoApiResponse> {
            return localVarFp.apiAuditBindersIdImportDocumentsFromZipPost(requestParameters.id, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdPut(requestParameters: AuditBindersApiApiAuditBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersIdPut(requestParameters.id, requestParameters.updateAuditBinderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters.id, requestParameters.documentId, requestParameters.createSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdTransitionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdTransitionPost(requestParameters: AuditBindersApiApiAuditBindersIdTransitionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersIdTransitionPost(requestParameters.id, requestParameters.transitionAuditBinderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersPost(requestParameters: AuditBindersApiApiAuditBindersPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersPost(requestParameters.createAuditBinderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditBindersApi - interface
 */
export interface AuditBindersApiInterface {
    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDtoListApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksPost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersGet(requestParameters?: AuditBindersApiApiAuditBindersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDetailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDetailGet(requestParameters: AuditBindersApiApiAuditBindersIdDetailGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDetailDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDocumentsZipPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdFinalDocumentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdFinalDocumentPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDocumentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdGet(requestParameters: AuditBindersApiApiAuditBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdImportDocumentRequestsPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDocumentRequestsResultDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdImportDocumentsFromZipPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportZipQueuedDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdPut(requestParameters: AuditBindersApiApiAuditBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdTransitionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdTransitionPost(requestParameters: AuditBindersApiApiAuditBindersIdTransitionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersPost(requestParameters?: AuditBindersApiApiAuditBindersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksLinkIdGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest {
    readonly binderId: string

    readonly linkId: string
}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksLinkIdRevokePost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest {
    readonly binderId: string

    readonly linkId: string
}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest {
    readonly binderId: string

    readonly createUploadLinkDto?: CreateUploadLinkDto
}

/**
 * Request parameters for apiAuditBindersGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersGetRequest {
    readonly clientId?: string

    readonly preparerId?: string

    readonly officeId?: string

    readonly stages?: Array<AuditBinderStage>

    readonly dueDateStart?: string

    readonly dueDateEnd?: string

    readonly periodStart?: string

    readonly periodEnd?: string

    readonly watchedClientsOnly?: boolean

    readonly assignedToMe?: boolean

    readonly isArchived?: boolean

    readonly search?: string

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly requestType?: AuditDocumentRequestType
}

/**
 * Request parameters for apiAuditBindersIdDelete operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdDetailGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDetailGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdDocumentsPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDocumentsPostRequest {
    readonly id: string

    readonly files: Array<File>

    readonly documentRequestId?: string

    readonly comment?: string
}

/**
 * Request parameters for apiAuditBindersIdDocumentsZipPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest {
    readonly id: string

    readonly exportAuditBinderDocumentsDto?: ExportAuditBinderDocumentsDto
}

/**
 * Request parameters for apiAuditBindersIdFinalDocumentPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdFinalDocumentPostRequest {
    readonly id: string

    readonly setAuditBinderFinalDocumentDto?: SetAuditBinderFinalDocumentDto
}

/**
 * Request parameters for apiAuditBindersIdGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdImportDocumentRequestsPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest {
    readonly id: string

    readonly file?: File
}

/**
 * Request parameters for apiAuditBindersIdImportDocumentsFromZipPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest {
    readonly id: string

    readonly file?: File
}

/**
 * Request parameters for apiAuditBindersIdPut operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdPutRequest {
    readonly id: string

    readonly updateAuditBinderDto?: UpdateAuditBinderDto
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsDocumentIdPut operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest {
    readonly id: string

    readonly documentId: string

    readonly createSignatureRequestDto?: CreateSignatureRequestDto
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest {
    readonly id: string

    readonly documentId: string
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsEligibleSignersGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest {
    readonly id: string

    readonly createSignatureRequestDto?: CreateSignatureRequestDto
}

/**
 * Request parameters for apiAuditBindersIdTransitionPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdTransitionPostRequest {
    readonly id: string

    readonly transitionAuditBinderDto?: TransitionAuditBinderDto
}

/**
 * Request parameters for apiAuditBindersPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersPostRequest {
    readonly createAuditBinderDto?: CreateAuditBinderDto
}

/**
 * AuditBindersApi - object-oriented interface
 */
export class AuditBindersApi extends BaseAPI implements AuditBindersApiInterface {
    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksPost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksPost(requestParameters.binderId, requestParameters.createUploadLinkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersGet(requestParameters: AuditBindersApiApiAuditBindersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDetailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDetailGet(requestParameters: AuditBindersApiApiAuditBindersIdDetailGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDetailGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDocumentsPost(requestParameters.id, requestParameters.files, requestParameters.documentRequestId, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDocumentsZipPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDocumentsZipPost(requestParameters.id, requestParameters.exportAuditBinderDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdFinalDocumentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdFinalDocumentPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDocumentPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdFinalDocumentPost(requestParameters.id, requestParameters.setAuditBinderFinalDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdGet(requestParameters: AuditBindersApiApiAuditBindersIdGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdImportDocumentRequestsPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdImportDocumentRequestsPost(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdImportDocumentsFromZipPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdImportDocumentsFromZipPost(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdPut(requestParameters: AuditBindersApiApiAuditBindersIdPutRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdPut(requestParameters.id, requestParameters.updateAuditBinderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters.id, requestParameters.documentId, requestParameters.createSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdTransitionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdTransitionPost(requestParameters: AuditBindersApiApiAuditBindersIdTransitionPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdTransitionPost(requestParameters.id, requestParameters.transitionAuditBinderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersPost(requestParameters: AuditBindersApiApiAuditBindersPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersPost(requestParameters.createAuditBinderDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditDashboardApi - axios parameter creator
 */
export const AuditDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] 
         * @param {string} [dueDateStart] 
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] 
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [assignedToMe] 
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditDashboardGet: async (clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (stages) {
                localVarQueryParameter['Stages'] = stages;
            }

            if (dueDateStart !== undefined) {
                localVarQueryParameter['DueDateStart'] = (dueDateStart as any instanceof Date) ?
                    (dueDateStart as any).toISOString() :
                    dueDateStart;
            }

            if (dueDateEnd !== undefined) {
                localVarQueryParameter['DueDateEnd'] = (dueDateEnd as any instanceof Date) ?
                    (dueDateEnd as any).toISOString() :
                    dueDateEnd;
            }

            if (periodStart !== undefined) {
                localVarQueryParameter['PeriodStart'] = (periodStart as any instanceof Date) ?
                    (periodStart as any).toISOString() :
                    periodStart;
            }

            if (periodEnd !== undefined) {
                localVarQueryParameter['PeriodEnd'] = (periodEnd as any instanceof Date) ?
                    (periodEnd as any).toISOString() :
                    periodEnd;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditDashboardApi - functional programming interface
 */
export const AuditDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] 
         * @param {string} [dueDateStart] 
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] 
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [assignedToMe] 
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditDashboardGet(clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditDashboardGet(clientId, preparerId, officeId, stages, dueDateStart, dueDateEnd, periodStart, periodEnd, watchedClientsOnly, assignedToMe, isArchived, search, page, limit, sortBy, sortOrder, requestType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditDashboardApi.apiAuditDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditDashboardApi - factory interface
 */
export const AuditDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditDashboardApiApiAuditDashboardGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditDashboardGet(requestParameters: AuditDashboardApiApiAuditDashboardGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse> {
            return localVarFp.apiAuditDashboardGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditDashboardApi - interface
 */
export interface AuditDashboardApiInterface {
    /**
     * 
     * @param {AuditDashboardApiApiAuditDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditDashboardGet(requestParameters?: AuditDashboardApiApiAuditDashboardGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>;

}

/**
 * Request parameters for apiAuditDashboardGet operation in AuditDashboardApi.
 */
export interface AuditDashboardApiApiAuditDashboardGetRequest {
    readonly clientId?: string

    readonly preparerId?: string

    readonly officeId?: string

    readonly stages?: Array<AuditBinderStage>

    readonly dueDateStart?: string

    readonly dueDateEnd?: string

    readonly periodStart?: string

    readonly periodEnd?: string

    readonly watchedClientsOnly?: boolean

    readonly assignedToMe?: boolean

    readonly isArchived?: boolean

    readonly search?: string

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly requestType?: AuditDocumentRequestType
}

/**
 * AuditDashboardApi - object-oriented interface
 */
export class AuditDashboardApi extends BaseAPI implements AuditDashboardApiInterface {
    /**
     * 
     * @param {AuditDashboardApiApiAuditDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditDashboardGet(requestParameters: AuditDashboardApiApiAuditDashboardGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditDashboardApiFp(this.configuration).apiAuditDashboardGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AcceptInvitationDto} [acceptInvitationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAcceptInvitationPost: async (acceptInvitationDto?: AcceptInvitationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/accept-invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateClientPortalAccessRequestDto} [createClientPortalAccessRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestPost: async (createClientPortalAccessRequestDto?: CreateClientPortalAccessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/access-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientPortalAccessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [status] 
         * @param {string} [officeId] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsGet: async (page?: number, pageSize?: number, status?: string, officeId?: string, search?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/access-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthAccessRequestsIdGet', 'id', id)
            const localVarPath = `/api/Auth/access-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ReviewAccessRequestDto} [reviewAccessRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdReviewPut: async (id: string, reviewAccessRequestDto?: ReviewAccessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthAccessRequestsIdReviewPut', 'id', id)
            const localVarPath = `/api/Auth/access-requests/{id}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewAccessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangePasswordDto} [changePasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthChangePasswordPost: async (changePasswordDto?: ChangePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientLoginDto} [clientLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthClientLoginPost: async (clientLoginDto?: ClientLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/client-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DevClientLoginDto} [devClientLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevClientLoginPost: async (devClientLoginDto?: DevClientLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/dev-client-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(devClientLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DevSsoLoginDto} [devSsoLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevSsoLoginPost: async (devSsoLoginDto?: DevSsoLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/dev-sso-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(devSsoLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDisable2faPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/disable-2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthEnable2faPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/enable-2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImpersonateClientDto} [impersonateClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthImpersonateClientPost: async (impersonateClientDto?: ImpersonateClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/impersonate-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(impersonateClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLoginPost: async (loginDto?: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshTokenPost: async (refreshTokenDto?: RefreshTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestPasswordResetDto} [requestPasswordResetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRequestPasswordResetPost: async (requestPasswordResetDto?: RequestPasswordResetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordResetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordDto} [resetPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthResetPasswordPost: async (resetPasswordDto?: ResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendVerificationCodeDto} [sendVerificationCodeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSendVerificationCodePost: async (sendVerificationCodeDto?: SendVerificationCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/send-verification-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendVerificationCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoCallbackGet: async (code?: string, state?: string, error?: string, errorDescription?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (errorDescription !== undefined) {
                localVarQueryParameter['error_description'] = errorDescription;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLoginGet: async (returnUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLogoutGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyCodeDto} [verifyCodeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthVerifyCodePost: async (verifyCodeDto?: VerifyCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/verify-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AcceptInvitationDto} [acceptInvitationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAcceptInvitationPost(acceptInvitationDto?: AcceptInvitationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAcceptInvitationPost(acceptInvitationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAcceptInvitationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateClientPortalAccessRequestDto} [createClientPortalAccessRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestPost(createClientPortalAccessRequestDto?: CreateClientPortalAccessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestPost(createClientPortalAccessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [status] 
         * @param {string} [officeId] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestsGet(page?: number, pageSize?: number, status?: string, officeId?: string, search?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestsGet(page, pageSize, status, officeId, search, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ReviewAccessRequestDto} [reviewAccessRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestsIdReviewPut(id: string, reviewAccessRequestDto?: ReviewAccessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestsIdReviewPut(id, reviewAccessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestsIdReviewPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangePasswordDto} [changePasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthChangePasswordPost(changePasswordDto?: ChangePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthChangePasswordPost(changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthChangePasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClientLoginDto} [clientLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthClientLoginPost(clientLoginDto?: ClientLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthClientLoginPost(clientLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthClientLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DevClientLoginDto} [devClientLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthDevClientLoginPost(devClientLoginDto?: DevClientLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthDevClientLoginPost(devClientLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthDevClientLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DevSsoLoginDto} [devSsoLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthDevSsoLoginPost(devSsoLoginDto?: DevSsoLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoLoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthDevSsoLoginPost(devSsoLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthDevSsoLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthDisable2faPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthDisable2faPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthDisable2faPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthEnable2faPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthEnable2faPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthEnable2faPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImpersonateClientDto} [impersonateClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthImpersonateClientPost(impersonateClientDto?: ImpersonateClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonateClientResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthImpersonateClientPost(impersonateClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthImpersonateClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthLoginPost(loginDto?: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthLoginPost(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RefreshTokenDto} [refreshTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthRefreshTokenPost(refreshTokenDto?: RefreshTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthRefreshTokenPost(refreshTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthRefreshTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RequestPasswordResetDto} [requestPasswordResetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthRequestPasswordResetPost(requestPasswordResetDto?: RequestPasswordResetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthRequestPasswordResetPost(requestPasswordResetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthRequestPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetPasswordDto} [resetPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthResetPasswordPost(resetPasswordDto?: ResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthResetPasswordPost(resetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendVerificationCodeDto} [sendVerificationCodeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSendVerificationCodePost(sendVerificationCodeDto?: SendVerificationCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSendVerificationCodePost(sendVerificationCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSendVerificationCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoCallbackGet(code?: string, state?: string, error?: string, errorDescription?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoCallbackGet(code, state, error, errorDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoLoginGet(returnUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoLoginGet(returnUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoLoginGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoLogoutGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoLogoutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyCodeDto} [verifyCodeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthVerifyCodePost(verifyCodeDto?: VerifyCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthVerifyCodePost(verifyCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthVerifyCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {AuthApiApiAuthAcceptInvitationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAcceptInvitationPost(requestParameters: AuthApiApiAuthAcceptInvitationPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthAcceptInvitationPost(requestParameters.acceptInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthAccessRequestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestPost(requestParameters: AuthApiApiAuthAccessRequestPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse> {
            return localVarFp.apiAuthAccessRequestPost(requestParameters.createClientPortalAccessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthAccessRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsGet(requestParameters: AuthApiApiAuthAccessRequestsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoPaginatedResponseApiResponse> {
            return localVarFp.apiAuthAccessRequestsGet(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.officeId, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthAccessRequestsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdGet(requestParameters: AuthApiApiAuthAccessRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse> {
            return localVarFp.apiAuthAccessRequestsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthAccessRequestsIdReviewPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdReviewPut(requestParameters: AuthApiApiAuthAccessRequestsIdReviewPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse> {
            return localVarFp.apiAuthAccessRequestsIdReviewPut(requestParameters.id, requestParameters.reviewAccessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthChangePasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthChangePasswordPost(requestParameters: AuthApiApiAuthChangePasswordPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthChangePasswordPost(requestParameters.changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthClientLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthClientLoginPost(requestParameters: AuthApiApiAuthClientLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthClientLoginPost(requestParameters.clientLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthDevClientLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevClientLoginPost(requestParameters: AuthApiApiAuthDevClientLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthDevClientLoginPost(requestParameters.devClientLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthDevSsoLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevSsoLoginPost(requestParameters: AuthApiApiAuthDevSsoLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SsoLoginResponseDtoApiResponse> {
            return localVarFp.apiAuthDevSsoLoginPost(requestParameters.devSsoLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDisable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthDisable2faPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthEnable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthEnable2faPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthImpersonateClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthImpersonateClientPost(requestParameters: AuthApiApiAuthImpersonateClientPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonateClientResponseDtoApiResponse> {
            return localVarFp.apiAuthImpersonateClientPost(requestParameters.impersonateClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLoginPost(requestParameters: AuthApiApiAuthLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthLoginPost(requestParameters.loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthRefreshTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshTokenPost(requestParameters: AuthApiApiAuthRefreshTokenPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthRefreshTokenPost(requestParameters.refreshTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthRequestPasswordResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRequestPasswordResetPost(requestParameters: AuthApiApiAuthRequestPasswordResetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthRequestPasswordResetPost(requestParameters.requestPasswordResetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthResetPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthResetPasswordPost(requestParameters: AuthApiApiAuthResetPasswordPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthResetPasswordPost(requestParameters.resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSendVerificationCodePost(requestParameters: AuthApiApiAuthSendVerificationCodePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthSendVerificationCodePost(requestParameters.sendVerificationCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthSsoCallbackGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoCallbackGet(requestParameters: AuthApiApiAuthSsoCallbackGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthSsoCallbackGet(requestParameters.code, requestParameters.state, requestParameters.error, requestParameters.errorDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthSsoLoginGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLoginGet(requestParameters: AuthApiApiAuthSsoLoginGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthSsoLoginGet(requestParameters.returnUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiAuthSsoLogoutGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<SsoStatusDtoApiResponse> {
            return localVarFp.apiAuthSsoStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthApiApiAuthVerifyCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthVerifyCodePost(requestParameters: AuthApiApiAuthVerifyCodePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthVerifyCodePost(requestParameters.verifyCodeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - interface
 */
export interface AuthApiInterface {
    /**
     * 
     * @param {AuthApiApiAuthAcceptInvitationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAcceptInvitationPost(requestParameters?: AuthApiApiAuthAcceptInvitationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestPost(requestParameters?: AuthApiApiAuthAccessRequestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestsGet(requestParameters?: AuthApiApiAuthAccessRequestsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestsIdGet(requestParameters: AuthApiApiAuthAccessRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestsIdReviewPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestsIdReviewPut(requestParameters: AuthApiApiAuthAccessRequestsIdReviewPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthChangePasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthChangePasswordPost(requestParameters?: AuthApiApiAuthChangePasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthClientLoginPost(requestParameters?: AuthApiApiAuthClientLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthDevClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthDevClientLoginPost(requestParameters?: AuthApiApiAuthDevClientLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthDevSsoLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthDevSsoLoginPost(requestParameters?: AuthApiApiAuthDevSsoLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SsoLoginResponseDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthDisable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthEnable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthImpersonateClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthImpersonateClientPost(requestParameters?: AuthApiApiAuthImpersonateClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonateClientResponseDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthLoginPost(requestParameters?: AuthApiApiAuthLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthRefreshTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthRefreshTokenPost(requestParameters?: AuthApiApiAuthRefreshTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthRequestPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthRequestPasswordResetPost(requestParameters?: AuthApiApiAuthRequestPasswordResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthResetPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthResetPasswordPost(requestParameters?: AuthApiApiAuthResetPasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSendVerificationCodePost(requestParameters?: AuthApiApiAuthSendVerificationCodePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthSsoCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoCallbackGet(requestParameters?: AuthApiApiAuthSsoCallbackGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AuthApiApiAuthSsoLoginGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoLoginGet(requestParameters?: AuthApiApiAuthSsoLoginGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<SsoStatusDtoApiResponse>;

    /**
     * 
     * @param {AuthApiApiAuthVerifyCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthVerifyCodePost(requestParameters?: AuthApiApiAuthVerifyCodePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

}

/**
 * Request parameters for apiAuthAcceptInvitationPost operation in AuthApi.
 */
export interface AuthApiApiAuthAcceptInvitationPostRequest {
    readonly acceptInvitationDto?: AcceptInvitationDto
}

/**
 * Request parameters for apiAuthAccessRequestPost operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestPostRequest {
    readonly createClientPortalAccessRequestDto?: CreateClientPortalAccessRequestDto
}

/**
 * Request parameters for apiAuthAccessRequestsGet operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestsGetRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly status?: string

    readonly officeId?: string

    readonly search?: string

    readonly sortBy?: string

    readonly sortOrder?: string
}

/**
 * Request parameters for apiAuthAccessRequestsIdGet operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuthAccessRequestsIdReviewPut operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestsIdReviewPutRequest {
    readonly id: string

    readonly reviewAccessRequestDto?: ReviewAccessRequestDto
}

/**
 * Request parameters for apiAuthChangePasswordPost operation in AuthApi.
 */
export interface AuthApiApiAuthChangePasswordPostRequest {
    readonly changePasswordDto?: ChangePasswordDto
}

/**
 * Request parameters for apiAuthClientLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthClientLoginPostRequest {
    readonly clientLoginDto?: ClientLoginDto
}

/**
 * Request parameters for apiAuthDevClientLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthDevClientLoginPostRequest {
    readonly devClientLoginDto?: DevClientLoginDto
}

/**
 * Request parameters for apiAuthDevSsoLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthDevSsoLoginPostRequest {
    readonly devSsoLoginDto?: DevSsoLoginDto
}

/**
 * Request parameters for apiAuthImpersonateClientPost operation in AuthApi.
 */
export interface AuthApiApiAuthImpersonateClientPostRequest {
    readonly impersonateClientDto?: ImpersonateClientDto
}

/**
 * Request parameters for apiAuthLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthLoginPostRequest {
    readonly loginDto?: LoginDto
}

/**
 * Request parameters for apiAuthRefreshTokenPost operation in AuthApi.
 */
export interface AuthApiApiAuthRefreshTokenPostRequest {
    readonly refreshTokenDto?: RefreshTokenDto
}

/**
 * Request parameters for apiAuthRequestPasswordResetPost operation in AuthApi.
 */
export interface AuthApiApiAuthRequestPasswordResetPostRequest {
    readonly requestPasswordResetDto?: RequestPasswordResetDto
}

/**
 * Request parameters for apiAuthResetPasswordPost operation in AuthApi.
 */
export interface AuthApiApiAuthResetPasswordPostRequest {
    readonly resetPasswordDto?: ResetPasswordDto
}

/**
 * Request parameters for apiAuthSendVerificationCodePost operation in AuthApi.
 */
export interface AuthApiApiAuthSendVerificationCodePostRequest {
    readonly sendVerificationCodeDto?: SendVerificationCodeDto
}

/**
 * Request parameters for apiAuthSsoCallbackGet operation in AuthApi.
 */
export interface AuthApiApiAuthSsoCallbackGetRequest {
    readonly code?: string

    readonly state?: string

    readonly error?: string

    readonly errorDescription?: string
}

/**
 * Request parameters for apiAuthSsoLoginGet operation in AuthApi.
 */
export interface AuthApiApiAuthSsoLoginGetRequest {
    readonly returnUrl?: string
}

/**
 * Request parameters for apiAuthVerifyCodePost operation in AuthApi.
 */
export interface AuthApiApiAuthVerifyCodePostRequest {
    readonly verifyCodeDto?: VerifyCodeDto
}

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * 
     * @param {AuthApiApiAuthAcceptInvitationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAcceptInvitationPost(requestParameters: AuthApiApiAuthAcceptInvitationPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAcceptInvitationPost(requestParameters.acceptInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestPost(requestParameters: AuthApiApiAuthAccessRequestPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestPost(requestParameters.createClientPortalAccessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestsGet(requestParameters: AuthApiApiAuthAccessRequestsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestsGet(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.officeId, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestsIdGet(requestParameters: AuthApiApiAuthAccessRequestsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthAccessRequestsIdReviewPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestsIdReviewPut(requestParameters: AuthApiApiAuthAccessRequestsIdReviewPutRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestsIdReviewPut(requestParameters.id, requestParameters.reviewAccessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthChangePasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthChangePasswordPost(requestParameters: AuthApiApiAuthChangePasswordPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthChangePasswordPost(requestParameters.changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthClientLoginPost(requestParameters: AuthApiApiAuthClientLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthClientLoginPost(requestParameters.clientLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthDevClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthDevClientLoginPost(requestParameters: AuthApiApiAuthDevClientLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthDevClientLoginPost(requestParameters.devClientLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthDevSsoLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthDevSsoLoginPost(requestParameters: AuthApiApiAuthDevSsoLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthDevSsoLoginPost(requestParameters.devSsoLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthDisable2faPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthDisable2faPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthEnable2faPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthEnable2faPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthImpersonateClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthImpersonateClientPost(requestParameters: AuthApiApiAuthImpersonateClientPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthImpersonateClientPost(requestParameters.impersonateClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthLoginPost(requestParameters: AuthApiApiAuthLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthLoginPost(requestParameters.loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthLogoutPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthRefreshTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthRefreshTokenPost(requestParameters: AuthApiApiAuthRefreshTokenPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthRefreshTokenPost(requestParameters.refreshTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthRequestPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthRequestPasswordResetPost(requestParameters: AuthApiApiAuthRequestPasswordResetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthRequestPasswordResetPost(requestParameters.requestPasswordResetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthResetPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthResetPasswordPost(requestParameters: AuthApiApiAuthResetPasswordPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthResetPasswordPost(requestParameters.resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSendVerificationCodePost(requestParameters: AuthApiApiAuthSendVerificationCodePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSendVerificationCodePost(requestParameters.sendVerificationCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthSsoCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoCallbackGet(requestParameters: AuthApiApiAuthSsoCallbackGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoCallbackGet(requestParameters.code, requestParameters.state, requestParameters.error, requestParameters.errorDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthSsoLoginGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoLoginGet(requestParameters: AuthApiApiAuthSsoLoginGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoLoginGet(requestParameters.returnUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoLogoutGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoStatusGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiApiAuthVerifyCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthVerifyCodePost(requestParameters: AuthApiApiAuthVerifyCodePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthVerifyCodePost(requestParameters.verifyCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BinderNotificationPreferencesApi - axios parameter creator
 */
export const BinderNotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {NotificationActionType} actionType 
         * @param {UpdateBinderActionPreferenceDto} [updateBinderActionPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesActionTypePut: async (binderId: string, actionType: NotificationActionType, updateBinderActionPreferenceDto?: UpdateBinderActionPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdNotificationPreferencesActionTypePut', 'binderId', binderId)
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdNotificationPreferencesActionTypePut', 'actionType', actionType)
            const localVarPath = `/api/audit-binders/{binderId}/notification-preferences/{actionType}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBinderActionPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdNotificationPreferencesGet', 'binderId', binderId)
            const localVarPath = `/api/audit-binders/{binderId}/notification-preferences`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BinderNotificationPreferencesApi - functional programming interface
 */
export const BinderNotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BinderNotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {NotificationActionType} actionType 
         * @param {UpdateBinderActionPreferenceDto} [updateBinderActionPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdNotificationPreferencesActionTypePut(binderId: string, actionType: NotificationActionType, updateBinderActionPreferenceDto?: UpdateBinderActionPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdNotificationPreferencesActionTypePut(binderId, actionType, updateBinderActionPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderNotificationPreferencesApi.apiAuditBindersBinderIdNotificationPreferencesActionTypePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdNotificationPreferencesGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdNotificationPreferencesGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderNotificationPreferencesApi.apiAuditBindersBinderIdNotificationPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BinderNotificationPreferencesApi - factory interface
 */
export const BinderNotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BinderNotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters.binderId, requestParameters.actionType, requestParameters.updateBinderActionPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BinderNotificationPreferencesApi - interface
 */
export interface BinderNotificationPreferencesApiInterface {
    /**
     * 
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse>;

}

/**
 * Request parameters for apiAuditBindersBinderIdNotificationPreferencesActionTypePut operation in BinderNotificationPreferencesApi.
 */
export interface BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest {
    readonly binderId: string

    readonly actionType: NotificationActionType

    readonly updateBinderActionPreferenceDto?: UpdateBinderActionPreferenceDto
}

/**
 * Request parameters for apiAuditBindersBinderIdNotificationPreferencesGet operation in BinderNotificationPreferencesApi.
 */
export interface BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest {
    readonly binderId: string
}

/**
 * BinderNotificationPreferencesApi - object-oriented interface
 */
export class BinderNotificationPreferencesApi extends BaseAPI implements BinderNotificationPreferencesApiInterface {
    /**
     * 
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest, options?: RawAxiosRequestConfig) {
        return BinderNotificationPreferencesApiFp(this.configuration).apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters.binderId, requestParameters.actionType, requestParameters.updateBinderActionPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig) {
        return BinderNotificationPreferencesApiFp(this.configuration).apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BinderWatcherApi - axios parameter creator
 */
export const BinderWatcherApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersDelete: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiBindersBinderIdWatchersDelete', 'binderId', binderId)
            const localVarPath = `/api/binders/{binderId}/watchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersMeGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiBindersBinderIdWatchersMeGet', 'binderId', binderId)
            const localVarPath = `/api/binders/{binderId}/watchers/me`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersPost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiBindersBinderIdWatchersPost', 'binderId', binderId)
            const localVarPath = `/api/binders/{binderId}/watchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersWatchedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/binders/watched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BinderWatcherApi - functional programming interface
 */
export const BinderWatcherApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BinderWatcherApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersBinderIdWatchersDelete(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersBinderIdWatchersDelete(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersBinderIdWatchersDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersBinderIdWatchersMeGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersBinderIdWatchersMeGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersBinderIdWatchersMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersBinderIdWatchersPost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersBinderIdWatchersPost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersBinderIdWatchersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersWatchedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersWatchedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersWatchedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BinderWatcherApi - factory interface
 */
export const BinderWatcherApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BinderWatcherApiFp(configuration)
    return {
        /**
         * 
         * @param {BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersDelete(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiBindersBinderIdWatchersDelete(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersMeGet(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiBindersBinderIdWatchersMeGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BinderWatcherApiApiBindersBinderIdWatchersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersPost(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiBindersBinderIdWatchersPost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse> {
            return localVarFp.apiBindersWatchedGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BinderWatcherApi - interface
 */
export interface BinderWatcherApiInterface {
    /**
     * 
     * @param {BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersBinderIdWatchersDelete(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersBinderIdWatchersMeGet(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {BinderWatcherApiApiBindersBinderIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersBinderIdWatchersPost(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse>;

}

/**
 * Request parameters for apiBindersBinderIdWatchersDelete operation in BinderWatcherApi.
 */
export interface BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiBindersBinderIdWatchersMeGet operation in BinderWatcherApi.
 */
export interface BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiBindersBinderIdWatchersPost operation in BinderWatcherApi.
 */
export interface BinderWatcherApiApiBindersBinderIdWatchersPostRequest {
    readonly binderId: string
}

/**
 * BinderWatcherApi - object-oriented interface
 */
export class BinderWatcherApi extends BaseAPI implements BinderWatcherApiInterface {
    /**
     * 
     * @param {BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersBinderIdWatchersDelete(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest, options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersBinderIdWatchersDelete(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersBinderIdWatchersMeGet(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest, options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersBinderIdWatchersMeGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BinderWatcherApiApiBindersBinderIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersBinderIdWatchersPost(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersPostRequest, options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersBinderIdWatchersPost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersWatchedGet(options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersWatchedGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BindersApi - axios parameter creator
 */
export const BindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersGet: async (clientId?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BindersApi - functional programming interface
 */
export const BindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BindersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersGet(clientId?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderListItemDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersGet(clientId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BindersApi.apiBindersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BindersApi - factory interface
 */
export const BindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BindersApiFp(configuration)
    return {
        /**
         * 
         * @param {BindersApiApiBindersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersGet(requestParameters: BindersApiApiBindersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BinderListItemDtoPaginatedResponseApiResponse> {
            return localVarFp.apiBindersGet(requestParameters.clientId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BindersApi - interface
 */
export interface BindersApiInterface {
    /**
     * 
     * @param {BindersApiApiBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersGet(requestParameters?: BindersApiApiBindersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderListItemDtoPaginatedResponseApiResponse>;

}

/**
 * Request parameters for apiBindersGet operation in BindersApi.
 */
export interface BindersApiApiBindersGetRequest {
    readonly clientId?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * BindersApi - object-oriented interface
 */
export class BindersApi extends BaseAPI implements BindersApiInterface {
    /**
     * 
     * @param {BindersApiApiBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersGet(requestParameters: BindersApiApiBindersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return BindersApiFp(this.configuration).apiBindersGet(requestParameters.clientId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CCHOAuthApi - axios parameter creator
 */
export const CCHOAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthAuthorizeUrlGet: async (state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/authorize-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthCallbackGet: async (code?: string, state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthConnectGet: async (state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthManageGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/manage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRefreshPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRevokePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CCHOAuthApi - functional programming interface
 */
export const CCHOAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CCHOAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthAuthorizeUrlGet(state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthAuthorizeUrlGet(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthAuthorizeUrlGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthCallbackGet(code?: string, state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthCallbackGet(code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthConnectGet(state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthConnectGet(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthConnectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthManageGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthManageGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthManageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthRefreshPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthRevokePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthRevokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CCHOAuthApi - factory interface
 */
export const CCHOAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CCHOAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthAuthorizeUrlGet(requestParameters: CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthAuthorizeUrlGet(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CCHOAuthApiApiCCHOAuthCallbackGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthCallbackGet(requestParameters: CCHOAuthApiApiCCHOAuthCallbackGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthCallbackGet(requestParameters.code, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CCHOAuthApiApiCCHOAuthConnectGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthConnectGet(requestParameters: CCHOAuthApiApiCCHOAuthConnectGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthConnectGet(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthManageGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthManageGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthRefreshPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthRevokePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CCHOAuthApi - interface
 */
export interface CCHOAuthApiInterface {
    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthAuthorizeUrlGet(requestParameters?: CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthCallbackGet(requestParameters?: CCHOAuthApiApiCCHOAuthCallbackGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthConnectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthConnectGet(requestParameters?: CCHOAuthApiApiCCHOAuthConnectGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthManageGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for apiCCHOAuthAuthorizeUrlGet operation in CCHOAuthApi.
 */
export interface CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest {
    readonly state?: string
}

/**
 * Request parameters for apiCCHOAuthCallbackGet operation in CCHOAuthApi.
 */
export interface CCHOAuthApiApiCCHOAuthCallbackGetRequest {
    readonly code?: string

    readonly state?: string
}

/**
 * Request parameters for apiCCHOAuthConnectGet operation in CCHOAuthApi.
 */
export interface CCHOAuthApiApiCCHOAuthConnectGetRequest {
    readonly state?: string
}

/**
 * CCHOAuthApi - object-oriented interface
 */
export class CCHOAuthApi extends BaseAPI implements CCHOAuthApiInterface {
    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthAuthorizeUrlGet(requestParameters: CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthAuthorizeUrlGet(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthCallbackGet(requestParameters: CCHOAuthApiApiCCHOAuthCallbackGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthCallbackGet(requestParameters.code, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthConnectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthConnectGet(requestParameters: CCHOAuthApiApiCCHOAuthConnectGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthConnectGet(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthGet(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthManageGet(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthManageGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthRevokePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAccessApi - axios parameter creator
 */
export const ClientAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedUsers: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAuthorizedUsers', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/access/authorized-users`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {GrantAccessRequest} [grantAccessRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccess: async (clientId: string, grantAccessRequest?: GrantAccessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('grantAccess', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/access/grant`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantAccessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConfidential: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('markConfidential', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/confidential`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess: async (clientId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('revokeAccess', 'clientId', clientId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('revokeAccess', 'userId', userId)
            const localVarPath = `/api/ClientAccess/{clientId}/access/revoke/{userId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPreparers: async (query?: string, clientId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientAccess/search-preparers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmarkConfidential: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('unmarkConfidential', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/confidential`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAccessApi - functional programming interface
 */
export const ClientAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAccessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizedUsers(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAccessPermissionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizedUsers(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.getAuthorizedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {GrantAccessRequest} [grantAccessRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantAccess(clientId: string, grantAccessRequest?: GrantAccessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantAccess(clientId, grantAccessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.grantAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markConfidential(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markConfidential(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.markConfidential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAccess(clientId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAccess(clientId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.revokeAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPreparers(query?: string, clientId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPreparers(query, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.searchPreparers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmarkConfidential(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmarkConfidential(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.unmarkConfidential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAccessApi - factory interface
 */
export const ClientAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAccessApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientAccessApiGetAuthorizedUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedUsers(requestParameters: ClientAccessApiGetAuthorizedUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessPermissionDtoListApiResponse> {
            return localVarFp.getAuthorizedUsers(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAccessApiGrantAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccess(requestParameters: ClientAccessApiGrantAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.grantAccess(requestParameters.clientId, requestParameters.grantAccessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAccessApiMarkConfidentialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConfidential(requestParameters: ClientAccessApiMarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.markConfidential(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAccessApiRevokeAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess(requestParameters: ClientAccessApiRevokeAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.revokeAccess(requestParameters.clientId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAccessApiSearchPreparersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPreparers(requestParameters: ClientAccessApiSearchPreparersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResultDtoListApiResponse> {
            return localVarFp.searchPreparers(requestParameters.query, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAccessApiUnmarkConfidentialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmarkConfidential(requestParameters: ClientAccessApiUnmarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.unmarkConfidential(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAccessApi - interface
 */
export interface ClientAccessApiInterface {
    /**
     * 
     * @param {ClientAccessApiGetAuthorizedUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthorizedUsers(requestParameters: ClientAccessApiGetAuthorizedUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessPermissionDtoListApiResponse>;

    /**
     * 
     * @param {ClientAccessApiGrantAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    grantAccess(requestParameters: ClientAccessApiGrantAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientAccessApiMarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markConfidential(requestParameters: ClientAccessApiMarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientAccessApiRevokeAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeAccess(requestParameters: ClientAccessApiRevokeAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientAccessApiSearchPreparersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchPreparers(requestParameters?: ClientAccessApiSearchPreparersRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResultDtoListApiResponse>;

    /**
     * 
     * @param {ClientAccessApiUnmarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unmarkConfidential(requestParameters: ClientAccessApiUnmarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

}

/**
 * Request parameters for getAuthorizedUsers operation in ClientAccessApi.
 */
export interface ClientAccessApiGetAuthorizedUsersRequest {
    readonly clientId: string
}

/**
 * Request parameters for grantAccess operation in ClientAccessApi.
 */
export interface ClientAccessApiGrantAccessRequest {
    readonly clientId: string

    readonly grantAccessRequest?: GrantAccessRequest
}

/**
 * Request parameters for markConfidential operation in ClientAccessApi.
 */
export interface ClientAccessApiMarkConfidentialRequest {
    readonly clientId: string
}

/**
 * Request parameters for revokeAccess operation in ClientAccessApi.
 */
export interface ClientAccessApiRevokeAccessRequest {
    readonly clientId: string

    readonly userId: string
}

/**
 * Request parameters for searchPreparers operation in ClientAccessApi.
 */
export interface ClientAccessApiSearchPreparersRequest {
    readonly query?: string

    readonly clientId?: string
}

/**
 * Request parameters for unmarkConfidential operation in ClientAccessApi.
 */
export interface ClientAccessApiUnmarkConfidentialRequest {
    readonly clientId: string
}

/**
 * ClientAccessApi - object-oriented interface
 */
export class ClientAccessApi extends BaseAPI implements ClientAccessApiInterface {
    /**
     * 
     * @param {ClientAccessApiGetAuthorizedUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuthorizedUsers(requestParameters: ClientAccessApiGetAuthorizedUsersRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).getAuthorizedUsers(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAccessApiGrantAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public grantAccess(requestParameters: ClientAccessApiGrantAccessRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).grantAccess(requestParameters.clientId, requestParameters.grantAccessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAccessApiMarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markConfidential(requestParameters: ClientAccessApiMarkConfidentialRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).markConfidential(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAccessApiRevokeAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeAccess(requestParameters: ClientAccessApiRevokeAccessRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).revokeAccess(requestParameters.clientId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAccessApiSearchPreparersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchPreparers(requestParameters: ClientAccessApiSearchPreparersRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).searchPreparers(requestParameters.query, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAccessApiUnmarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unmarkConfidential(requestParameters: ClientAccessApiUnmarkConfidentialRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).unmarkConfidential(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientNotesApi - axios parameter creator
 */
export const ClientNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {ServiceLine} [serviceLine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesGet: async (clientId?: string, serviceLine?: ServiceLine, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (serviceLine !== undefined) {
                localVarQueryParameter['serviceLine'] = serviceLine;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientNotesIdDelete', 'id', id)
            const localVarPath = `/api/ClientNotes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientNotesIdGet', 'id', id)
            const localVarPath = `/api/ClientNotes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateClientNoteDto} [updateClientNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdPut: async (id: string, updateClientNoteDto?: UpdateClientNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientNotesIdPut', 'id', id)
            const localVarPath = `/api/ClientNotes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateClientNoteDto} [createClientNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesPost: async (createClientNoteDto?: CreateClientNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientNotesApi - functional programming interface
 */
export const ClientNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {ServiceLine} [serviceLine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesGet(clientId?: string, serviceLine?: ServiceLine, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesGet(clientId, serviceLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateClientNoteDto} [updateClientNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesIdPut(id: string, updateClientNoteDto?: UpdateClientNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesIdPut(id, updateClientNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateClientNoteDto} [createClientNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesPost(createClientNoteDto?: CreateClientNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesPost(createClientNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientNotesApi - factory interface
 */
export const ClientNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientNotesApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientNotesApiApiClientNotesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesGet(requestParameters: ClientNotesApiApiClientNotesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoListApiResponse> {
            return localVarFp.apiClientNotesGet(requestParameters.clientId, requestParameters.serviceLine, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientNotesApiApiClientNotesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdDelete(requestParameters: ClientNotesApiApiClientNotesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientNotesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientNotesApiApiClientNotesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdGet(requestParameters: ClientNotesApiApiClientNotesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse> {
            return localVarFp.apiClientNotesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientNotesApiApiClientNotesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdPut(requestParameters: ClientNotesApiApiClientNotesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse> {
            return localVarFp.apiClientNotesIdPut(requestParameters.id, requestParameters.updateClientNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientNotesApiApiClientNotesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesPost(requestParameters: ClientNotesApiApiClientNotesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse> {
            return localVarFp.apiClientNotesPost(requestParameters.createClientNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientNotesApi - interface
 */
export interface ClientNotesApiInterface {
    /**
     * 
     * @param {ClientNotesApiApiClientNotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesGet(requestParameters?: ClientNotesApiApiClientNotesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoListApiResponse>;

    /**
     * 
     * @param {ClientNotesApiApiClientNotesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesIdDelete(requestParameters: ClientNotesApiApiClientNotesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientNotesApiApiClientNotesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesIdGet(requestParameters: ClientNotesApiApiClientNotesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse>;

    /**
     * 
     * @param {ClientNotesApiApiClientNotesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesIdPut(requestParameters: ClientNotesApiApiClientNotesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse>;

    /**
     * 
     * @param {ClientNotesApiApiClientNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesPost(requestParameters?: ClientNotesApiApiClientNotesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse>;

}

/**
 * Request parameters for apiClientNotesGet operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesGetRequest {
    readonly clientId?: string

    readonly serviceLine?: ServiceLine
}

/**
 * Request parameters for apiClientNotesIdDelete operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientNotesIdGet operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientNotesIdPut operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesIdPutRequest {
    readonly id: string

    readonly updateClientNoteDto?: UpdateClientNoteDto
}

/**
 * Request parameters for apiClientNotesPost operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesPostRequest {
    readonly createClientNoteDto?: CreateClientNoteDto
}

/**
 * ClientNotesApi - object-oriented interface
 */
export class ClientNotesApi extends BaseAPI implements ClientNotesApiInterface {
    /**
     * 
     * @param {ClientNotesApiApiClientNotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesGet(requestParameters: ClientNotesApiApiClientNotesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesGet(requestParameters.clientId, requestParameters.serviceLine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientNotesApiApiClientNotesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesIdDelete(requestParameters: ClientNotesApiApiClientNotesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientNotesApiApiClientNotesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesIdGet(requestParameters: ClientNotesApiApiClientNotesIdGetRequest, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientNotesApiApiClientNotesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesIdPut(requestParameters: ClientNotesApiApiClientNotesIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesIdPut(requestParameters.id, requestParameters.updateClientNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientNotesApiApiClientNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesPost(requestParameters: ClientNotesApiApiClientNotesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesPost(requestParameters.createClientNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientNotificationPreferencesApi - axios parameter creator
 */
export const ClientNotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdNotificationPreferencesGet', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/notification-preferences`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {UpdateClientNotificationPreferenceDto} [updateClientNotificationPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesPut: async (clientId: string, updateClientNotificationPreferenceDto?: UpdateClientNotificationPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdNotificationPreferencesPut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/notification-preferences`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientNotificationPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientNotificationPreferencesApi - functional programming interface
 */
export const ClientNotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientNotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdNotificationPreferencesGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdNotificationPreferencesGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotificationPreferencesApi.apiClientsClientIdNotificationPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {UpdateClientNotificationPreferenceDto} [updateClientNotificationPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdNotificationPreferencesPut(clientId: string, updateClientNotificationPreferenceDto?: UpdateClientNotificationPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdNotificationPreferencesPut(clientId, updateClientNotificationPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotificationPreferencesApi.apiClientsClientIdNotificationPreferencesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientNotificationPreferencesApi - factory interface
 */
export const ClientNotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientNotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesGet(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiClientsClientIdNotificationPreferencesGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesPut(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiClientsClientIdNotificationPreferencesPut(requestParameters.clientId, requestParameters.updateClientNotificationPreferenceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientNotificationPreferencesApi - interface
 */
export interface ClientNotificationPreferencesApiInterface {
    /**
     * 
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdNotificationPreferencesGet(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdNotificationPreferencesPut(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse>;

}

/**
 * Request parameters for apiClientsClientIdNotificationPreferencesGet operation in ClientNotificationPreferencesApi.
 */
export interface ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest {
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdNotificationPreferencesPut operation in ClientNotificationPreferencesApi.
 */
export interface ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest {
    readonly clientId: string

    readonly updateClientNotificationPreferenceDto?: UpdateClientNotificationPreferenceDto
}

/**
 * ClientNotificationPreferencesApi - object-oriented interface
 */
export class ClientNotificationPreferencesApi extends BaseAPI implements ClientNotificationPreferencesApiInterface {
    /**
     * 
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdNotificationPreferencesGet(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig) {
        return ClientNotificationPreferencesApiFp(this.configuration).apiClientsClientIdNotificationPreferencesGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdNotificationPreferencesPut(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig) {
        return ClientNotificationPreferencesApiFp(this.configuration).apiClientsClientIdNotificationPreferencesPut(requestParameters.clientId, requestParameters.updateClientNotificationPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientWatcherApi - axios parameter creator
 */
export const ClientWatcherApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersDelete: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersDelete', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersGet', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersMeGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersMeGet', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers/me`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersPost: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersPost', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/watched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkDelete: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/watchers/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/watchers/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientWatcherApi - functional programming interface
 */
export const ClientWatcherApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientWatcherApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersDelete(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersDelete(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientWatcherInfoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersMeGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersMeGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersPost(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersPost(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsWatchedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsWatchedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsWatchedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsWatchersBulkDelete(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsWatchersBulkDelete(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsWatchersBulkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsWatchersBulkPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsWatchersBulkPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsWatchersBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientWatcherApi - factory interface
 */
export const ClientWatcherApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientWatcherApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientWatcherApiApiClientsClientIdWatchersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersDelete(requestParameters: ClientWatcherApiApiClientsClientIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdWatchersDelete(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientWatcherApiApiClientsClientIdWatchersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientWatcherInfoListApiResponse> {
            return localVarFp.apiClientsClientIdWatchersGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientWatcherApiApiClientsClientIdWatchersMeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersMeGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdWatchersMeGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientWatcherApiApiClientsClientIdWatchersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersPost(requestParameters: ClientWatcherApiApiClientsClientIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdWatchersPost(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse> {
            return localVarFp.apiClientsWatchedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientWatcherApiApiClientsWatchersBulkDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkDelete(requestParameters: ClientWatcherApiApiClientsWatchersBulkDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsWatchersBulkDelete(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientWatcherApiApiClientsWatchersBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkPost(requestParameters: ClientWatcherApiApiClientsWatchersBulkPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsWatchersBulkPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientWatcherApi - interface
 */
export interface ClientWatcherApiInterface {
    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersDelete(requestParameters: ClientWatcherApiApiClientsClientIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientWatcherInfoListApiResponse>;

    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersMeGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersPost(requestParameters: ClientWatcherApiApiClientsClientIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse>;

    /**
     * 
     * @param {ClientWatcherApiApiClientsWatchersBulkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsWatchersBulkDelete(requestParameters?: ClientWatcherApiApiClientsWatchersBulkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

    /**
     * 
     * @param {ClientWatcherApiApiClientsWatchersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsWatchersBulkPost(requestParameters?: ClientWatcherApiApiClientsWatchersBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

}

/**
 * Request parameters for apiClientsClientIdWatchersDelete operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersDeleteRequest {
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdWatchersGet operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersGetRequest {
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdWatchersMeGet operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersMeGetRequest {
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdWatchersPost operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersPostRequest {
    readonly clientId: string
}

/**
 * Request parameters for apiClientsWatchersBulkDelete operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsWatchersBulkDeleteRequest {
    readonly requestBody?: Array<string>
}

/**
 * Request parameters for apiClientsWatchersBulkPost operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsWatchersBulkPostRequest {
    readonly requestBody?: Array<string>
}

/**
 * ClientWatcherApi - object-oriented interface
 */
export class ClientWatcherApi extends BaseAPI implements ClientWatcherApiInterface {
    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersDelete(requestParameters: ClientWatcherApiApiClientsClientIdWatchersDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersDelete(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersGetRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersMeGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersMeGetRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersMeGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientWatcherApiApiClientsClientIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersPost(requestParameters: ClientWatcherApiApiClientsClientIdWatchersPostRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersPost(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsWatchedGet(options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsWatchedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientWatcherApiApiClientsWatchersBulkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsWatchersBulkDelete(requestParameters: ClientWatcherApiApiClientsWatchersBulkDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsWatchersBulkDelete(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientWatcherApiApiClientsWatchersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsWatchersBulkPost(requestParameters: ClientWatcherApiApiClientsWatchersBulkPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsWatchersBulkPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientsApi - axios parameter creator
 */
export const ClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdDelete: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('apiClientsBankAccountsAccountIdDelete', 'accountId', accountId)
            const localVarPath = `/api/Clients/bank-accounts/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountId 
         * @param {ClientBankAccountDto} [clientBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdPut: async (accountId: string, clientBankAccountDto?: ClientBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('apiClientsBankAccountsAccountIdPut', 'accountId', accountId)
            const localVarPath = `/api/Clients/bank-accounts/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsByNumberClientNumberGet: async (clientNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientNumber' is not null or undefined
            assertParamExists('apiClientsByNumberClientNumberGet', 'clientNumber', clientNumber)
            const localVarPath = `/api/Clients/by-number/{clientNumber}`
                .replace(`{${"clientNumber"}}`, encodeURIComponent(String(clientNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientBankAccountDto} [clientBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdBankAccountsPost: async (clientId: string, clientBankAccountDto?: ClientBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdBankAccountsPost', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/bank-accounts`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientDependentDto} [clientDependentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDependentsPost: async (clientId: string, clientDependentDto?: ClientDependentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdDependentsPost', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/dependents`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientDependentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {string} [binderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdQuestionnairePreFillDataGet: async (clientId: string, binderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdQuestionnairePreFillDataGet', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/questionnaire-pre-fill-data`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['binderId'] = binderId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpouseDelete: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdSpouseDelete', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/spouse`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientSpouseDto} [clientSpouseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpousePut: async (clientId: string, clientSpouseDto?: ClientSpouseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdSpousePut', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/spouse`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientSpouseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dependentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdDelete: async (dependentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dependentId' is not null or undefined
            assertParamExists('apiClientsDependentsDependentIdDelete', 'dependentId', dependentId)
            const localVarPath = `/api/Clients/dependents/{dependentId}`
                .replace(`{${"dependentId"}}`, encodeURIComponent(String(dependentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dependentId 
         * @param {ClientDependentDto} [clientDependentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdPut: async (dependentId: string, clientDependentDto?: ClientDependentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dependentId' is not null or undefined
            assertParamExists('apiClientsDependentsDependentIdPut', 'dependentId', dependentId)
            const localVarPath = `/api/Clients/dependents/{dependentId}`
                .replace(`{${"dependentId"}}`, encodeURIComponent(String(dependentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientDependentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {ClientType} [type] 
         * @param {string} [state] 
         * @param {Array<string>} [tags] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {boolean} [watchedByMe] 
         * @param {ConfidentialFilter} [confidentialFilter] 
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsGet: async (page?: number, limit?: number, sortBy?: string, sortOrder?: string, search?: string, type?: ClientType, state?: string, tags?: Array<string>, createdAfter?: string, createdBefore?: string, watchedByMe?: boolean, confidentialFilter?: ConfidentialFilter, partnerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (state !== undefined) {
                localVarQueryParameter['State'] = state;
            }

            if (tags) {
                localVarQueryParameter['Tags'] = tags;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['CreatedAfter'] = (createdAfter as any instanceof Date) ?
                    (createdAfter as any).toISOString() :
                    createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['CreatedBefore'] = (createdBefore as any instanceof Date) ?
                    (createdBefore as any).toISOString() :
                    createdBefore;
            }

            if (watchedByMe !== undefined) {
                localVarQueryParameter['WatchedByMe'] = watchedByMe;
            }

            if (confidentialFilter !== undefined) {
                localVarQueryParameter['ConfidentialFilter'] = confidentialFilter;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['PartnerId'] = partnerId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdArchivePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdArchivePost', 'id', id)
            const localVarPath = `/api/Clients/{id}/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdAuditHistoryGet: async (id: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdAuditHistoryGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/audit-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCchDocumentsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdCchDocumentsGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/cch-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreatePrimaryUserDto} [createPrimaryUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCreatePrimaryUserPost: async (id: string, createPrimaryUserDto?: CreatePrimaryUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdCreatePrimaryUserPost', 'id', id)
            const localVarPath = `/api/Clients/{id}/create-primary-user`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPrimaryUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdDelete', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdEligibleSignersGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdEligibleSignersGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/eligible-signers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdGet', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateClientDto} [updateClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdPut: async (id: string, updateClientDto?: UpdateClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdPut', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdRestorePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdRestorePost', 'id', id)
            const localVarPath = `/api/Clients/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdSimilarGet: async (id: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdSimilarGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/similar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdUserAccessGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdUserAccessGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/user-access`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchClientIdPreviewGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsImportCchClientIdPreviewGet', 'clientId', clientId)
            const localVarPath = `/api/Clients/import/cch/{clientId}/preview`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportMultipleClientsDto} [importMultipleClientsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchMultiplePost: async (importMultipleClientsDto?: ImportMultipleClientsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importMultipleClientsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportClientDto} [importClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchPost: async (importClientDto?: ImportClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SyncAllClientsDto} [syncAllClientsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchSyncPost: async (syncAllClientsDto?: SyncAllClientsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncAllClientsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchValidateConnectionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch/validate-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsMyClientsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/my-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchBulkUpdateFieldsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/bulk-update-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchGet: async (q?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientSearchQueryDto} [clientSearchQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchHybridPost: async (clientSearchQueryDto?: ClientSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/hybrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [maxCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchRefreshEmbeddingsPost: async (maxCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/refresh-embeddings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxCount !== undefined) {
                localVarQueryParameter['maxCount'] = maxCount;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchSuggestionsGet: async (q?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientsApi - functional programming interface
 */
export const ClientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsBankAccountsAccountIdDelete(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsBankAccountsAccountIdDelete(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsBankAccountsAccountIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} accountId 
         * @param {ClientBankAccountDto} [clientBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsBankAccountsAccountIdPut(accountId: string, clientBankAccountDto?: ClientBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBankAccountDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsBankAccountsAccountIdPut(accountId, clientBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsBankAccountsAccountIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsByNumberClientNumberGet(clientNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsByNumberClientNumberGet(clientNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsByNumberClientNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientBankAccountDto} [clientBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdBankAccountsPost(clientId: string, clientBankAccountDto?: ClientBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBankAccountDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdBankAccountsPost(clientId, clientBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdBankAccountsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientDependentDto} [clientDependentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdDependentsPost(clientId: string, clientDependentDto?: ClientDependentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDependentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdDependentsPost(clientId, clientDependentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdDependentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {string} [binderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdQuestionnairePreFillDataGet(clientId: string, binderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnairePreFillDataDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdQuestionnairePreFillDataGet(clientId, binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdQuestionnairePreFillDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdSpouseDelete(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdSpouseDelete(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdSpouseDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientSpouseDto} [clientSpouseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdSpousePut(clientId: string, clientSpouseDto?: ClientSpouseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSpouseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdSpousePut(clientId, clientSpouseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdSpousePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dependentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsDependentsDependentIdDelete(dependentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsDependentsDependentIdDelete(dependentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsDependentsDependentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dependentId 
         * @param {ClientDependentDto} [clientDependentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsDependentsDependentIdPut(dependentId: string, clientDependentDto?: ClientDependentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDependentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsDependentsDependentIdPut(dependentId, clientDependentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsDependentsDependentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {ClientType} [type] 
         * @param {string} [state] 
         * @param {Array<string>} [tags] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {boolean} [watchedByMe] 
         * @param {ConfidentialFilter} [confidentialFilter] 
         * @param {string} [partnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsGet(page?: number, limit?: number, sortBy?: string, sortOrder?: string, search?: string, type?: ClientType, state?: string, tags?: Array<string>, createdAfter?: string, createdBefore?: string, watchedByMe?: boolean, confidentialFilter?: ConfidentialFilter, partnerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsGet(page, limit, sortBy, sortOrder, search, type, state, tags, createdAfter, createdBefore, watchedByMe, confidentialFilter, partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdArchivePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdArchivePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdArchivePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdAuditHistoryGet(id: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdAuditHistoryGet(id, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdAuditHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdCchDocumentsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdCchDocumentsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdCchDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreatePrimaryUserDto} [createPrimaryUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdCreatePrimaryUserPost(id: string, createPrimaryUserDto?: CreatePrimaryUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithClientsSearchResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdCreatePrimaryUserPost(id, createPrimaryUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdCreatePrimaryUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdEligibleSignersGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibleSignersDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdEligibleSignersGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdEligibleSignersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDetailsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateClientDto} [updateClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdPut(id: string, updateClientDto?: UpdateClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdPut(id, updateClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdRestorePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdRestorePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdRestorePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdSimilarGet(id: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdSimilarGet(id, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdSimilarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdUserAccessGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAccessSummaryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdUserAccessGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdUserAccessGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchClientIdPreviewGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchClientIdPreviewGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchClientIdPreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportMultipleClientsDto} [importMultipleClientsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchMultiplePost(importMultipleClientsDto?: ImportMultipleClientsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchMultiplePost(importMultipleClientsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchMultiplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportClientDto} [importClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchPost(importClientDto?: ImportClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportClientResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchPost(importClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SyncAllClientsDto} [syncAllClientsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchSyncPost(syncAllClientsDto?: SyncAllClientsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchSyncPost(syncAllClientsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchValidateConnectionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchValidateConnectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsMyClientsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsMyClientsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsMyClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchBulkUpdateFieldsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchBulkUpdateFieldsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchGet(q?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchGet(q, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClientSearchQueryDto} [clientSearchQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchHybridPost(clientSearchQueryDto?: ClientSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSearchResultDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchHybridPost(clientSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchHybridPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [maxCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchRefreshEmbeddingsPost(maxCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchRefreshEmbeddingsPost(maxCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchRefreshEmbeddingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchSuggestionsGet(q?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSearchSuggestionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchSuggestionsGet(q, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientsApi - factory interface
 */
export const ClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientsApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientsApiApiClientsBankAccountsAccountIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdDelete(requestParameters: ClientsApiApiClientsBankAccountsAccountIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsBankAccountsAccountIdDelete(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsBankAccountsAccountIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdPut(requestParameters: ClientsApiApiClientsBankAccountsAccountIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse> {
            return localVarFp.apiClientsBankAccountsAccountIdPut(requestParameters.accountId, requestParameters.clientBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsByNumberClientNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsByNumberClientNumberGet(requestParameters: ClientsApiApiClientsByNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse> {
            return localVarFp.apiClientsByNumberClientNumberGet(requestParameters.clientNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsClientIdBankAccountsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdBankAccountsPost(requestParameters: ClientsApiApiClientsClientIdBankAccountsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse> {
            return localVarFp.apiClientsClientIdBankAccountsPost(requestParameters.clientId, requestParameters.clientBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsClientIdDependentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDependentsPost(requestParameters: ClientsApiApiClientsClientIdDependentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse> {
            return localVarFp.apiClientsClientIdDependentsPost(requestParameters.clientId, requestParameters.clientDependentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdQuestionnairePreFillDataGet(requestParameters: ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnairePreFillDataDtoApiResponse> {
            return localVarFp.apiClientsClientIdQuestionnairePreFillDataGet(requestParameters.clientId, requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsClientIdSpouseDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpouseDelete(requestParameters: ClientsApiApiClientsClientIdSpouseDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdSpouseDelete(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsClientIdSpousePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpousePut(requestParameters: ClientsApiApiClientsClientIdSpousePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSpouseDtoApiResponse> {
            return localVarFp.apiClientsClientIdSpousePut(requestParameters.clientId, requestParameters.clientSpouseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsDependentsDependentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdDelete(requestParameters: ClientsApiApiClientsDependentsDependentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsDependentsDependentIdDelete(requestParameters.dependentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsDependentsDependentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdPut(requestParameters: ClientsApiApiClientsDependentsDependentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse> {
            return localVarFp.apiClientsDependentsDependentIdPut(requestParameters.dependentId, requestParameters.clientDependentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsGet(requestParameters: ClientsApiApiClientsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.type, requestParameters.state, requestParameters.tags, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.watchedByMe, requestParameters.confidentialFilter, requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdArchivePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdArchivePost(requestParameters: ClientsApiApiClientsIdArchivePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsIdArchivePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdAuditHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdAuditHistoryGet(requestParameters: ClientsApiApiClientsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuditHistoryDtoApiResponse> {
            return localVarFp.apiClientsIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdCchDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCchDocumentsGet(requestParameters: ClientsApiApiClientsIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiClientsIdCchDocumentsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdCreatePrimaryUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCreatePrimaryUserPost(requestParameters: ClientsApiApiClientsIdCreatePrimaryUserPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse> {
            return localVarFp.apiClientsIdCreatePrimaryUserPost(requestParameters.id, requestParameters.createPrimaryUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdDelete(requestParameters: ClientsApiApiClientsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdEligibleSignersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdEligibleSignersGet(requestParameters: ClientsApiApiClientsIdEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse> {
            return localVarFp.apiClientsIdEligibleSignersGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdGet(requestParameters: ClientsApiApiClientsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetailsDtoApiResponse> {
            return localVarFp.apiClientsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdPut(requestParameters: ClientsApiApiClientsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse> {
            return localVarFp.apiClientsIdPut(requestParameters.id, requestParameters.updateClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdRestorePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdRestorePost(requestParameters: ClientsApiApiClientsIdRestorePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsIdRestorePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdSimilarGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdSimilarGet(requestParameters: ClientsApiApiClientsIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoListApiResponse> {
            return localVarFp.apiClientsIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsIdUserAccessGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdUserAccessGet(requestParameters: ClientsApiApiClientsIdUserAccessGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessSummaryDtoApiResponse> {
            return localVarFp.apiClientsIdUserAccessGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsImportCchClientIdPreviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchClientIdPreviewGet(requestParameters: ClientsApiApiClientsImportCchClientIdPreviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse> {
            return localVarFp.apiClientsImportCchClientIdPreviewGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsImportCchMultiplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchMultiplePost(requestParameters: ClientsApiApiClientsImportCchMultiplePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse> {
            return localVarFp.apiClientsImportCchMultiplePost(requestParameters.importMultipleClientsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsImportCchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchPost(requestParameters: ClientsApiApiClientsImportCchPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImportClientResultDtoApiResponse> {
            return localVarFp.apiClientsImportCchPost(requestParameters.importClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsImportCchSyncPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchSyncPost(requestParameters: ClientsApiApiClientsImportCchSyncPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse> {
            return localVarFp.apiClientsImportCchSyncPost(requestParameters.syncAllClientsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsImportCchValidateConnectionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsMyClientsGet(options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoListApiResponse> {
            return localVarFp.apiClientsMyClientsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsSearchBulkUpdateFieldsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchGet(requestParameters: ClientsApiApiClientsSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsSearchGet(requestParameters.q, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsSearchHybridPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchHybridPost(requestParameters: ClientsApiApiClientsSearchHybridPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsSearchHybridPost(requestParameters.clientSearchQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchRefreshEmbeddingsPost(requestParameters: ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsSearchRefreshEmbeddingsPost(requestParameters.maxCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientsApiApiClientsSearchSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchSuggestionsGet(requestParameters: ClientsApiApiClientsSearchSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchSuggestionDtoListApiResponse> {
            return localVarFp.apiClientsSearchSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientsApi - interface
 */
export interface ClientsApiInterface {
    /**
     * 
     * @param {ClientsApiApiClientsBankAccountsAccountIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsBankAccountsAccountIdDelete(requestParameters: ClientsApiApiClientsBankAccountsAccountIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsBankAccountsAccountIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsBankAccountsAccountIdPut(requestParameters: ClientsApiApiClientsBankAccountsAccountIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsByNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsByNumberClientNumberGet(requestParameters: ClientsApiApiClientsByNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsClientIdBankAccountsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdBankAccountsPost(requestParameters: ClientsApiApiClientsClientIdBankAccountsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsClientIdDependentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdDependentsPost(requestParameters: ClientsApiApiClientsClientIdDependentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdQuestionnairePreFillDataGet(requestParameters: ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnairePreFillDataDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsClientIdSpouseDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdSpouseDelete(requestParameters: ClientsApiApiClientsClientIdSpouseDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsClientIdSpousePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdSpousePut(requestParameters: ClientsApiApiClientsClientIdSpousePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSpouseDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsDependentsDependentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsDependentsDependentIdDelete(requestParameters: ClientsApiApiClientsDependentsDependentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsDependentsDependentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsDependentsDependentIdPut(requestParameters: ClientsApiApiClientsDependentsDependentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsGet(requestParameters?: ClientsApiApiClientsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdArchivePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdArchivePost(requestParameters: ClientsApiApiClientsIdArchivePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdAuditHistoryGet(requestParameters: ClientsApiApiClientsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuditHistoryDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdCchDocumentsGet(requestParameters: ClientsApiApiClientsIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdCreatePrimaryUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdCreatePrimaryUserPost(requestParameters: ClientsApiApiClientsIdCreatePrimaryUserPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdDelete(requestParameters: ClientsApiApiClientsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdEligibleSignersGet(requestParameters: ClientsApiApiClientsIdEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdGet(requestParameters: ClientsApiApiClientsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetailsDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdPut(requestParameters: ClientsApiApiClientsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdRestorePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdRestorePost(requestParameters: ClientsApiApiClientsIdRestorePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdSimilarGet(requestParameters: ClientsApiApiClientsIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoListApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsIdUserAccessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdUserAccessGet(requestParameters: ClientsApiApiClientsIdUserAccessGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessSummaryDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsImportCchClientIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchClientIdPreviewGet(requestParameters: ClientsApiApiClientsImportCchClientIdPreviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsImportCchMultiplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchMultiplePost(requestParameters?: ClientsApiApiClientsImportCchMultiplePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsImportCchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchPost(requestParameters?: ClientsApiApiClientsImportCchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportClientResultDtoApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsImportCchSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchSyncPost(requestParameters?: ClientsApiApiClientsImportCchSyncPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsMyClientsGet(options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchGet(requestParameters?: ClientsApiApiClientsSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsSearchHybridPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchHybridPost(requestParameters?: ClientsApiApiClientsSearchHybridPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchRefreshEmbeddingsPost(requestParameters?: ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

    /**
     * 
     * @param {ClientsApiApiClientsSearchSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchSuggestionsGet(requestParameters?: ClientsApiApiClientsSearchSuggestionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchSuggestionDtoListApiResponse>;

}

/**
 * Request parameters for apiClientsBankAccountsAccountIdDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsBankAccountsAccountIdDeleteRequest {
    readonly accountId: string
}

/**
 * Request parameters for apiClientsBankAccountsAccountIdPut operation in ClientsApi.
 */
export interface ClientsApiApiClientsBankAccountsAccountIdPutRequest {
    readonly accountId: string

    readonly clientBankAccountDto?: ClientBankAccountDto
}

/**
 * Request parameters for apiClientsByNumberClientNumberGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsByNumberClientNumberGetRequest {
    readonly clientNumber: string
}

/**
 * Request parameters for apiClientsClientIdBankAccountsPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdBankAccountsPostRequest {
    readonly clientId: string

    readonly clientBankAccountDto?: ClientBankAccountDto
}

/**
 * Request parameters for apiClientsClientIdDependentsPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdDependentsPostRequest {
    readonly clientId: string

    readonly clientDependentDto?: ClientDependentDto
}

/**
 * Request parameters for apiClientsClientIdQuestionnairePreFillDataGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest {
    readonly clientId: string

    readonly binderId?: string
}

/**
 * Request parameters for apiClientsClientIdSpouseDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdSpouseDeleteRequest {
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdSpousePut operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdSpousePutRequest {
    readonly clientId: string

    readonly clientSpouseDto?: ClientSpouseDto
}

/**
 * Request parameters for apiClientsDependentsDependentIdDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsDependentsDependentIdDeleteRequest {
    readonly dependentId: string
}

/**
 * Request parameters for apiClientsDependentsDependentIdPut operation in ClientsApi.
 */
export interface ClientsApiApiClientsDependentsDependentIdPutRequest {
    readonly dependentId: string

    readonly clientDependentDto?: ClientDependentDto
}

/**
 * Request parameters for apiClientsGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly search?: string

    readonly type?: ClientType

    readonly state?: string

    readonly tags?: Array<string>

    readonly createdAfter?: string

    readonly createdBefore?: string

    readonly watchedByMe?: boolean

    readonly confidentialFilter?: ConfidentialFilter

    readonly partnerId?: string
}

/**
 * Request parameters for apiClientsIdArchivePost operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdArchivePostRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsIdAuditHistoryGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdAuditHistoryGetRequest {
    readonly id: string

    readonly startDate?: string

    readonly endDate?: string
}

/**
 * Request parameters for apiClientsIdCchDocumentsGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdCchDocumentsGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsIdCreatePrimaryUserPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdCreatePrimaryUserPostRequest {
    readonly id: string

    readonly createPrimaryUserDto?: CreatePrimaryUserDto
}

/**
 * Request parameters for apiClientsIdDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsIdEligibleSignersGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdEligibleSignersGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsIdGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsIdPut operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdPutRequest {
    readonly id: string

    readonly updateClientDto?: UpdateClientDto
}

/**
 * Request parameters for apiClientsIdRestorePost operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdRestorePostRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsIdSimilarGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdSimilarGetRequest {
    readonly id: string

    readonly limit?: number
}

/**
 * Request parameters for apiClientsIdUserAccessGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdUserAccessGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsImportCchClientIdPreviewGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchClientIdPreviewGetRequest {
    readonly clientId: string
}

/**
 * Request parameters for apiClientsImportCchMultiplePost operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchMultiplePostRequest {
    readonly importMultipleClientsDto?: ImportMultipleClientsDto
}

/**
 * Request parameters for apiClientsImportCchPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchPostRequest {
    readonly importClientDto?: ImportClientDto
}

/**
 * Request parameters for apiClientsImportCchSyncPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchSyncPostRequest {
    readonly syncAllClientsDto?: SyncAllClientsDto
}

/**
 * Request parameters for apiClientsSearchGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchGetRequest {
    readonly q?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiClientsSearchHybridPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchHybridPostRequest {
    readonly clientSearchQueryDto?: ClientSearchQueryDto
}

/**
 * Request parameters for apiClientsSearchRefreshEmbeddingsPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest {
    readonly maxCount?: number
}

/**
 * Request parameters for apiClientsSearchSuggestionsGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchSuggestionsGetRequest {
    readonly q?: string

    readonly limit?: number
}

/**
 * ClientsApi - object-oriented interface
 */
export class ClientsApi extends BaseAPI implements ClientsApiInterface {
    /**
     * 
     * @param {ClientsApiApiClientsBankAccountsAccountIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsBankAccountsAccountIdDelete(requestParameters: ClientsApiApiClientsBankAccountsAccountIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsBankAccountsAccountIdDelete(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsBankAccountsAccountIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsBankAccountsAccountIdPut(requestParameters: ClientsApiApiClientsBankAccountsAccountIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsBankAccountsAccountIdPut(requestParameters.accountId, requestParameters.clientBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsByNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsByNumberClientNumberGet(requestParameters: ClientsApiApiClientsByNumberClientNumberGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsByNumberClientNumberGet(requestParameters.clientNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsClientIdBankAccountsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdBankAccountsPost(requestParameters: ClientsApiApiClientsClientIdBankAccountsPostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdBankAccountsPost(requestParameters.clientId, requestParameters.clientBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsClientIdDependentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdDependentsPost(requestParameters: ClientsApiApiClientsClientIdDependentsPostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdDependentsPost(requestParameters.clientId, requestParameters.clientDependentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdQuestionnairePreFillDataGet(requestParameters: ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdQuestionnairePreFillDataGet(requestParameters.clientId, requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsClientIdSpouseDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdSpouseDelete(requestParameters: ClientsApiApiClientsClientIdSpouseDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdSpouseDelete(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsClientIdSpousePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdSpousePut(requestParameters: ClientsApiApiClientsClientIdSpousePutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdSpousePut(requestParameters.clientId, requestParameters.clientSpouseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsDependentsDependentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsDependentsDependentIdDelete(requestParameters: ClientsApiApiClientsDependentsDependentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsDependentsDependentIdDelete(requestParameters.dependentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsDependentsDependentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsDependentsDependentIdPut(requestParameters: ClientsApiApiClientsDependentsDependentIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsDependentsDependentIdPut(requestParameters.dependentId, requestParameters.clientDependentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsGet(requestParameters: ClientsApiApiClientsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.type, requestParameters.state, requestParameters.tags, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.watchedByMe, requestParameters.confidentialFilter, requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdArchivePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdArchivePost(requestParameters: ClientsApiApiClientsIdArchivePostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdArchivePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdAuditHistoryGet(requestParameters: ClientsApiApiClientsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdCchDocumentsGet(requestParameters: ClientsApiApiClientsIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdCchDocumentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdCreatePrimaryUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdCreatePrimaryUserPost(requestParameters: ClientsApiApiClientsIdCreatePrimaryUserPostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdCreatePrimaryUserPost(requestParameters.id, requestParameters.createPrimaryUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdDelete(requestParameters: ClientsApiApiClientsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdEligibleSignersGet(requestParameters: ClientsApiApiClientsIdEligibleSignersGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdEligibleSignersGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdGet(requestParameters: ClientsApiApiClientsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdPut(requestParameters: ClientsApiApiClientsIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdPut(requestParameters.id, requestParameters.updateClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdRestorePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdRestorePost(requestParameters: ClientsApiApiClientsIdRestorePostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdRestorePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdSimilarGet(requestParameters: ClientsApiApiClientsIdSimilarGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdUserAccessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdUserAccessGet(requestParameters: ClientsApiApiClientsIdUserAccessGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdUserAccessGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsImportCchClientIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchClientIdPreviewGet(requestParameters: ClientsApiApiClientsImportCchClientIdPreviewGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchClientIdPreviewGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsImportCchMultiplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchMultiplePost(requestParameters: ClientsApiApiClientsImportCchMultiplePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchMultiplePost(requestParameters.importMultipleClientsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsImportCchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchPost(requestParameters: ClientsApiApiClientsImportCchPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchPost(requestParameters.importClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsImportCchSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchSyncPost(requestParameters: ClientsApiApiClientsImportCchSyncPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchSyncPost(requestParameters.syncAllClientsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchValidateConnectionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsMyClientsGet(options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsMyClientsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchBulkUpdateFieldsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchGet(requestParameters: ClientsApiApiClientsSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchGet(requestParameters.q, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsSearchHybridPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchHybridPost(requestParameters: ClientsApiApiClientsSearchHybridPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchHybridPost(requestParameters.clientSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchRefreshEmbeddingsPost(requestParameters: ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchRefreshEmbeddingsPost(requestParameters.maxCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsSearchSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchSuggestionsGet(requestParameters: ClientsApiApiClientsSearchSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommentsApi - axios parameter creator
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [documentId] 
         * @param {string} [binderId] 
         * @param {string} [documentRequestId] 
         * @param {string} [createdById] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGet: async (page?: number, limit?: number, sortBy?: string, sortOrder?: string, documentId?: string, binderId?: string, documentRequestId?: string, createdById?: string, createdAfter?: string, createdBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (documentId !== undefined) {
                localVarQueryParameter['DocumentId'] = documentId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (documentRequestId !== undefined) {
                localVarQueryParameter['DocumentRequestId'] = documentRequestId;
            }

            if (createdById !== undefined) {
                localVarQueryParameter['CreatedById'] = createdById;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['CreatedAfter'] = (createdAfter as any instanceof Date) ?
                    (createdAfter as any).toISOString() :
                    createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['CreatedBefore'] = (createdBefore as any instanceof Date) ?
                    (createdBefore as any).toISOString() :
                    createdBefore;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {boolean} [includeResolved] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGroupedGet: async (binderId: string, includeResolved?: boolean, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiCommentsGroupedGet', 'binderId', binderId)
            const localVarPath = `/api/Comments/grouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (includeResolved !== undefined) {
                localVarQueryParameter['IncludeResolved'] = includeResolved;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdDelete', 'id', id)
            const localVarPath = `/api/Comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdGet', 'id', id)
            const localVarPath = `/api/Comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCommentDto} [updateCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdPut: async (id: string, updateCommentDto?: UpdateCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdPut', 'id', id)
            const localVarPath = `/api/Comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdReadPut: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdReadPut', 'id', id)
            const localVarPath = `/api/Comments/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdUnreadPut: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdUnreadPut', 'id', id)
            const localVarPath = `/api/Comments/{id}/unread`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCommentDto} [createCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsPost: async (createCommentDto?: CreateCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [documentId] 
         * @param {string} [binderId] 
         * @param {string} [documentRequestId] 
         * @param {string} [createdById] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsGet(page?: number, limit?: number, sortBy?: string, sortOrder?: string, documentId?: string, binderId?: string, documentRequestId?: string, createdById?: string, createdAfter?: string, createdBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsGet(page, limit, sortBy, sortOrder, documentId, binderId, documentRequestId, createdById, createdAfter, createdBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {boolean} [includeResolved] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsGroupedGet(binderId: string, includeResolved?: boolean, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupedCommentsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsGroupedGet(binderId, includeResolved, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsGroupedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCommentDto} [updateCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdPut(id: string, updateCommentDto?: UpdateCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdPut(id, updateCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdReadPut(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdReadPut(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdUnreadPut(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdUnreadPut(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdUnreadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCommentDto} [createCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsPost(createCommentDto?: CreateCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsPost(createCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommentsApi - factory interface
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * 
         * @param {CommentsApiApiCommentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGet(requestParameters: CommentsApiApiCommentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoPaginatedResponseApiResponse> {
            return localVarFp.apiCommentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.documentId, requestParameters.binderId, requestParameters.documentRequestId, requestParameters.createdById, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommentsApiApiCommentsGroupedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGroupedGet(requestParameters: CommentsApiApiCommentsGroupedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupedCommentsDtoApiResponse> {
            return localVarFp.apiCommentsGroupedGet(requestParameters.binderId, requestParameters.includeResolved, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommentsApiApiCommentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdDelete(requestParameters: CommentsApiApiCommentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiCommentsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommentsApiApiCommentsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdGet(requestParameters: CommentsApiApiCommentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommentsApiApiCommentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdPut(requestParameters: CommentsApiApiCommentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdPut(requestParameters.id, requestParameters.updateCommentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommentsApiApiCommentsIdReadPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdReadPut(requestParameters: CommentsApiApiCommentsIdReadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdReadPut(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommentsApiApiCommentsIdUnreadPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdUnreadPut(requestParameters: CommentsApiApiCommentsIdUnreadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdUnreadPut(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommentsApiApiCommentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsPost(requestParameters: CommentsApiApiCommentsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsPost(requestParameters.createCommentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - interface
 */
export interface CommentsApiInterface {
    /**
     * 
     * @param {CommentsApiApiCommentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsGet(requestParameters?: CommentsApiApiCommentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {CommentsApiApiCommentsGroupedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsGroupedGet(requestParameters: CommentsApiApiCommentsGroupedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupedCommentsDtoApiResponse>;

    /**
     * 
     * @param {CommentsApiApiCommentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdDelete(requestParameters: CommentsApiApiCommentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {CommentsApiApiCommentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdGet(requestParameters: CommentsApiApiCommentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @param {CommentsApiApiCommentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdPut(requestParameters: CommentsApiApiCommentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @param {CommentsApiApiCommentsIdReadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdReadPut(requestParameters: CommentsApiApiCommentsIdReadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @param {CommentsApiApiCommentsIdUnreadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdUnreadPut(requestParameters: CommentsApiApiCommentsIdUnreadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @param {CommentsApiApiCommentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsPost(requestParameters?: CommentsApiApiCommentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

}

/**
 * Request parameters for apiCommentsGet operation in CommentsApi.
 */
export interface CommentsApiApiCommentsGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly documentId?: string

    readonly binderId?: string

    readonly documentRequestId?: string

    readonly createdById?: string

    readonly createdAfter?: string

    readonly createdBefore?: string
}

/**
 * Request parameters for apiCommentsGroupedGet operation in CommentsApi.
 */
export interface CommentsApiApiCommentsGroupedGetRequest {
    readonly binderId: string

    readonly includeResolved?: boolean

    readonly sortBy?: string
}

/**
 * Request parameters for apiCommentsIdDelete operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiCommentsIdGet operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiCommentsIdPut operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdPutRequest {
    readonly id: string

    readonly updateCommentDto?: UpdateCommentDto
}

/**
 * Request parameters for apiCommentsIdReadPut operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdReadPutRequest {
    readonly id: string
}

/**
 * Request parameters for apiCommentsIdUnreadPut operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdUnreadPutRequest {
    readonly id: string
}

/**
 * Request parameters for apiCommentsPost operation in CommentsApi.
 */
export interface CommentsApiApiCommentsPostRequest {
    readonly createCommentDto?: CreateCommentDto
}

/**
 * CommentsApi - object-oriented interface
 */
export class CommentsApi extends BaseAPI implements CommentsApiInterface {
    /**
     * 
     * @param {CommentsApiApiCommentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsGet(requestParameters: CommentsApiApiCommentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.documentId, requestParameters.binderId, requestParameters.documentRequestId, requestParameters.createdById, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommentsApiApiCommentsGroupedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsGroupedGet(requestParameters: CommentsApiApiCommentsGroupedGetRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsGroupedGet(requestParameters.binderId, requestParameters.includeResolved, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommentsApiApiCommentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdDelete(requestParameters: CommentsApiApiCommentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommentsApiApiCommentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdGet(requestParameters: CommentsApiApiCommentsIdGetRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommentsApiApiCommentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdPut(requestParameters: CommentsApiApiCommentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdPut(requestParameters.id, requestParameters.updateCommentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommentsApiApiCommentsIdReadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdReadPut(requestParameters: CommentsApiApiCommentsIdReadPutRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdReadPut(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommentsApiApiCommentsIdUnreadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdUnreadPut(requestParameters: CommentsApiApiCommentsIdUnreadPutRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdUnreadPut(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommentsApiApiCommentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsPost(requestParameters: CommentsApiApiCommentsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsPost(requestParameters.createCommentDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocuSealApi - axios parameter creator
 */
export const DocuSealApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocuSeal/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [templateId] 
         * @param {SubmissionStatus} [status] 
         * @param {string} [q] 
         * @param {string} [slug] 
         * @param {string} [templateFolder] 
         * @param {boolean} [archived] 
         * @param {number} [limit] 
         * @param {number} [after] 
         * @param {number} [before] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsGet: async (templateId?: number, status?: SubmissionStatus, q?: string, slug?: string, templateFolder?: string, archived?: boolean, limit?: number, after?: number, before?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocuSeal/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (templateFolder !== undefined) {
                localVarQueryParameter['templateFolder'] = templateFolder;
            }

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = before;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdDocumentsGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocuSealSubmissionsIdDocumentsGet', 'id', id)
            const localVarPath = `/api/DocuSeal/submissions/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocuSealSubmissionsIdGet', 'id', id)
            const localVarPath = `/api/DocuSeal/submissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSubmissionFromPdfDto} [createSubmissionFromPdfDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsPdfPost: async (createSubmissionFromPdfDto?: CreateSubmissionFromPdfDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocuSeal/submissions/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubmissionFromPdfDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocuSealApi - functional programming interface
 */
export const DocuSealApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocuSealApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [templateId] 
         * @param {SubmissionStatus} [status] 
         * @param {string} [q] 
         * @param {string} [slug] 
         * @param {string} [templateFolder] 
         * @param {boolean} [archived] 
         * @param {number} [limit] 
         * @param {number} [after] 
         * @param {number} [before] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsGet(templateId?: number, status?: SubmissionStatus, q?: string, slug?: string, templateFolder?: string, archived?: boolean, limit?: number, after?: number, before?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSubmissionsResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsGet(templateId, status, q, slug, templateFolder, archived, limit, after, before, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsIdDocumentsGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDocumentsResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsIdDocumentsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSubmissionFromPdfDto} [createSubmissionFromPdfDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsPdfPost(createSubmissionFromPdfDto?: CreateSubmissionFromPdfDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsPdfPost(createSubmissionFromPdfDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocuSealApi - factory interface
 */
export const DocuSealApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocuSealApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocuSealHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocuSealApiApiDocuSealSubmissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSubmissionsResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsGet(requestParameters.templateId, requestParameters.status, requestParameters.q, requestParameters.slug, requestParameters.templateFolder, requestParameters.archived, requestParameters.limit, requestParameters.after, requestParameters.before, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdDocumentsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDocumentsResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsIdDocumentsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocuSealApiApiDocuSealSubmissionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocuSealApiApiDocuSealSubmissionsPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsPdfPost(requestParameters: DocuSealApiApiDocuSealSubmissionsPdfPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsPdfPost(requestParameters.createSubmissionFromPdfDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocuSealApi - interface
 */
export interface DocuSealApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsGet(requestParameters?: DocuSealApiApiDocuSealSubmissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSubmissionsResponseDtoApiResponse>;

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsIdDocumentsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDocumentsResponseDtoApiResponse>;

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsIdGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse>;

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsPdfPost(requestParameters?: DocuSealApiApiDocuSealSubmissionsPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse>;

}

/**
 * Request parameters for apiDocuSealSubmissionsGet operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsGetRequest {
    readonly templateId?: number

    readonly status?: SubmissionStatus

    readonly q?: string

    readonly slug?: string

    readonly templateFolder?: string

    readonly archived?: boolean

    readonly limit?: number

    readonly after?: number

    readonly before?: number
}

/**
 * Request parameters for apiDocuSealSubmissionsIdDocumentsGet operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest {
    readonly id: number
}

/**
 * Request parameters for apiDocuSealSubmissionsIdGet operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsIdGetRequest {
    readonly id: number
}

/**
 * Request parameters for apiDocuSealSubmissionsPdfPost operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsPdfPostRequest {
    readonly createSubmissionFromPdfDto?: CreateSubmissionFromPdfDto
}

/**
 * DocuSealApi - object-oriented interface
 */
export class DocuSealApi extends BaseAPI implements DocuSealApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealHealthGet(options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsGet(requestParameters.templateId, requestParameters.status, requestParameters.q, requestParameters.slug, requestParameters.templateFolder, requestParameters.archived, requestParameters.limit, requestParameters.after, requestParameters.before, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsIdDocumentsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsIdDocumentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsIdGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocuSealApiApiDocuSealSubmissionsPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsPdfPost(requestParameters: DocuSealApiApiDocuSealSubmissionsPdfPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsPdfPost(requestParameters.createSubmissionFromPdfDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentRequestsApi - axios parameter creator
 */
export const DocumentRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [binderId] 
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsAwaitingReviewGet: async (clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/awaiting-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (priority !== undefined) {
                localVarQueryParameter['Priority'] = priority;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (isOverdue !== undefined) {
                localVarQueryParameter['IsOverdue'] = isOverdue;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkApproveDocumentRequestsDto} [bulkApproveDocumentRequestsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsBulkApprovePost: async (bulkApproveDocumentRequestsDto?: BulkApproveDocumentRequestsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/bulk-approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkApproveDocumentRequestsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [binderId] 
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsGet: async (clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (priority !== undefined) {
                localVarQueryParameter['Priority'] = priority;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (isOverdue !== undefined) {
                localVarQueryParameter['IsOverdue'] = isOverdue;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdAuditHistoryGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdAuditHistoryGet', 'id', id)
            const localVarPath = `/api/document-requests/{id}/audit-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ClientResponseDto} [clientResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdClientResponsePost: async (id: string, clientResponseDto?: ClientResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdClientResponsePost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/client-response`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SetConfidentialDto} [setConfidentialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdConfidentialPatch: async (id: string, setConfidentialDto?: SetConfidentialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdConfidentialPatch', 'id', id)
            const localVarPath = `/api/document-requests/{id}/confidential`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setConfidentialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdDelete', 'id', id)
            const localVarPath = `/api/document-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdGet', 'id', id)
            const localVarPath = `/api/document-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkSubmittedDto} [markSubmittedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdMarkSubmittedPost: async (id: string, markSubmittedDto?: MarkSubmittedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdMarkSubmittedPost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/mark-submitted`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markSubmittedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDocumentRequestDto} [updateDocumentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdPut: async (id: string, updateDocumentRequestDto?: UpdateDocumentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdPut', 'id', id)
            const localVarPath = `/api/document-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ReviewDocumentRequestDto} [reviewDocumentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReviewPost: async (id: string, reviewDocumentRequestDto?: ReviewDocumentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdReviewPost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdStatusPatch: async (id: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdStatusPatch', 'id', id)
            const localVarPath = `/api/document-requests/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<File>} [files] 
         * @param {boolean} [replaceExisting] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdUploadPost: async (id: string, files?: Array<File>, replaceExisting?: boolean, runAiDetection?: boolean, generateAiDescription?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdUploadPost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }


            if (replaceExisting !== undefined) { 
                localVarFormParams.append('replaceExisting', String(replaceExisting) as any);
            }

            if (runAiDetection !== undefined) { 
                localVarFormParams.append('runAiDetection', String(runAiDetection) as any);
            }

            if (generateAiDescription !== undefined) { 
                localVarFormParams.append('generateAiDescription', String(generateAiDescription) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsOverdueGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/overdue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDocumentRequestDto} [createDocumentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsPost: async (createDocumentRequestDto?: CreateDocumentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDocumentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReleaseDocumentRequestsDto} [releaseDocumentRequestsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsReleasePost: async (releaseDocumentRequestsDto?: ReleaseDocumentRequestsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseDocumentRequestsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {number} [taxYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsStatisticsGet: async (clientId?: string, taxYear?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['taxYear'] = taxYear;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentRequestsApi - functional programming interface
 */
export const DocumentRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [binderId] 
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsAwaitingReviewGet(clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsAwaitingReviewGet(clientId, binderId, status, priority, requestType, taxYear, isOverdue, search, sortBy, sortDirection, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsAwaitingReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkApproveDocumentRequestsDto} [bulkApproveDocumentRequestsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsBulkApprovePost(bulkApproveDocumentRequestsDto?: BulkApproveDocumentRequestsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkApproveDocumentRequestsResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsBulkApprovePost(bulkApproveDocumentRequestsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsBulkApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [binderId] 
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsGet(clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsGet(clientId, binderId, status, priority, requestType, taxYear, isOverdue, search, sortBy, sortDirection, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdAuditHistoryGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdAuditHistoryGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdAuditHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ClientResponseDto} [clientResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdClientResponsePost(id: string, clientResponseDto?: ClientResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdClientResponsePost(id, clientResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdClientResponsePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SetConfidentialDto} [setConfidentialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdConfidentialPatch(id: string, setConfidentialDto?: SetConfidentialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdConfidentialPatch(id, setConfidentialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdConfidentialPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {MarkSubmittedDto} [markSubmittedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdMarkSubmittedPost(id: string, markSubmittedDto?: MarkSubmittedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdMarkSubmittedPost(id, markSubmittedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdMarkSubmittedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDocumentRequestDto} [updateDocumentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdPut(id: string, updateDocumentRequestDto?: UpdateDocumentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdPut(id, updateDocumentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ReviewDocumentRequestDto} [reviewDocumentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdReviewPost(id: string, reviewDocumentRequestDto?: ReviewDocumentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdReviewPost(id, reviewDocumentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdStatusPatch(id: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdStatusPatch(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<File>} [files] 
         * @param {boolean} [replaceExisting] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdUploadPost(id: string, files?: Array<File>, replaceExisting?: boolean, runAiDetection?: boolean, generateAiDescription?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdUploadPost(id, files, replaceExisting, runAiDetection, generateAiDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsOverdueGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsOverdueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateDocumentRequestDto} [createDocumentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsPost(createDocumentRequestDto?: CreateDocumentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsPost(createDocumentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReleaseDocumentRequestsDto} [releaseDocumentRequestsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsReleasePost(releaseDocumentRequestsDto?: ReleaseDocumentRequestsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseDocumentRequestsResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsReleasePost(releaseDocumentRequestsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsReleasePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {number} [taxYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsStatisticsGet(clientId?: string, taxYear?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringInt32DictionaryApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsStatisticsGet(clientId, taxYear, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsStatisticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentRequestsApi - factory interface
 */
export const DocumentRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsAwaitingReviewGet(requestParameters: DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse> {
            return localVarFp.apiDocumentRequestsAwaitingReviewGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsBulkApprovePost(requestParameters: DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BulkApproveDocumentRequestsResultDtoApiResponse> {
            return localVarFp.apiDocumentRequestsBulkApprovePost(requestParameters.bulkApproveDocumentRequestsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse> {
            return localVarFp.apiDocumentRequestsGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdAuditHistoryGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestAuditHistoryDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdAuditHistoryGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdClientResponsePost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdClientResponsePost(requestParameters.id, requestParameters.clientResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdConfidentialPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdConfidentialPatch(requestParameters.id, requestParameters.setConfidentialDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdDelete(requestParameters: DocumentRequestsApiApiDocumentRequestsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentRequestsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdMarkSubmittedPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdMarkSubmittedPost(requestParameters.id, requestParameters.markSubmittedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdPut(requestParameters: DocumentRequestsApiApiDocumentRequestsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdPut(requestParameters.id, requestParameters.updateDocumentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReviewPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdReviewPost(requestParameters.id, requestParameters.reviewDocumentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdStatusPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdStatusPatch(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdUploadPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdUploadPost(requestParameters.id, requestParameters.files, requestParameters.replaceExisting, requestParameters.runAiDetection, requestParameters.generateAiDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoListApiResponse> {
            return localVarFp.apiDocumentRequestsOverdueGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsPost(requestParameters: DocumentRequestsApiApiDocumentRequestsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsPost(requestParameters.createDocumentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsReleasePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsReleasePost(requestParameters: DocumentRequestsApiApiDocumentRequestsReleasePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseDocumentRequestsResultDtoApiResponse> {
            return localVarFp.apiDocumentRequestsReleasePost(requestParameters.releaseDocumentRequestsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsStatisticsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringInt32DictionaryApiResponse> {
            return localVarFp.apiDocumentRequestsStatisticsGet(requestParameters.clientId, requestParameters.taxYear, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentRequestsApi - interface
 */
export interface DocumentRequestsApiInterface {
    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsAwaitingReviewGet(requestParameters?: DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsBulkApprovePost(requestParameters?: DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkApproveDocumentRequestsResultDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsGet(requestParameters?: DocumentRequestsApiApiDocumentRequestsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdAuditHistoryGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestAuditHistoryDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdClientResponsePost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdConfidentialPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdDelete(requestParameters: DocumentRequestsApiApiDocumentRequestsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdMarkSubmittedPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdPut(requestParameters: DocumentRequestsApiApiDocumentRequestsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdReviewPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdStatusPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdUploadPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoListApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsPost(requestParameters?: DocumentRequestsApiApiDocumentRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsReleasePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsReleasePost(requestParameters?: DocumentRequestsApiApiDocumentRequestsReleasePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseDocumentRequestsResultDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsStatisticsGet(requestParameters?: DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringInt32DictionaryApiResponse>;

}

/**
 * Request parameters for apiDocumentRequestsAwaitingReviewGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest {
    readonly clientId?: string

    readonly binderId?: string

    readonly status?: DocumentRequestStatus

    readonly priority?: DocumentRequestPriority

    readonly requestType?: AuditDocumentRequestType

    readonly taxYear?: number

    readonly isOverdue?: boolean

    readonly search?: string

    readonly sortBy?: string

    readonly sortDirection?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiDocumentRequestsBulkApprovePost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest {
    readonly bulkApproveDocumentRequestsDto?: BulkApproveDocumentRequestsDto
}

/**
 * Request parameters for apiDocumentRequestsGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsGetRequest {
    readonly clientId?: string

    readonly binderId?: string

    readonly status?: DocumentRequestStatus

    readonly priority?: DocumentRequestPriority

    readonly requestType?: AuditDocumentRequestType

    readonly taxYear?: number

    readonly isOverdue?: boolean

    readonly search?: string

    readonly sortBy?: string

    readonly sortDirection?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiDocumentRequestsIdAuditHistoryGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiDocumentRequestsIdClientResponsePost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest {
    readonly id: string

    readonly clientResponseDto?: ClientResponseDto
}

/**
 * Request parameters for apiDocumentRequestsIdConfidentialPatch operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest {
    readonly id: string

    readonly setConfidentialDto?: SetConfidentialDto
}

/**
 * Request parameters for apiDocumentRequestsIdDelete operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiDocumentRequestsIdGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiDocumentRequestsIdMarkSubmittedPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest {
    readonly id: string

    readonly markSubmittedDto?: MarkSubmittedDto
}

/**
 * Request parameters for apiDocumentRequestsIdPut operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdPutRequest {
    readonly id: string

    readonly updateDocumentRequestDto?: UpdateDocumentRequestDto
}

/**
 * Request parameters for apiDocumentRequestsIdReviewPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest {
    readonly id: string

    readonly reviewDocumentRequestDto?: ReviewDocumentRequestDto
}

/**
 * Request parameters for apiDocumentRequestsIdStatusPatch operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest {
    readonly id: string

    readonly body?: string
}

/**
 * Request parameters for apiDocumentRequestsIdUploadPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest {
    readonly id: string

    readonly files?: Array<File>

    readonly replaceExisting?: boolean

    readonly runAiDetection?: boolean

    readonly generateAiDescription?: boolean
}

/**
 * Request parameters for apiDocumentRequestsPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsPostRequest {
    readonly createDocumentRequestDto?: CreateDocumentRequestDto
}

/**
 * Request parameters for apiDocumentRequestsReleasePost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsReleasePostRequest {
    readonly releaseDocumentRequestsDto?: ReleaseDocumentRequestsDto
}

/**
 * Request parameters for apiDocumentRequestsStatisticsGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest {
    readonly clientId?: string

    readonly taxYear?: number
}

/**
 * DocumentRequestsApi - object-oriented interface
 */
export class DocumentRequestsApi extends BaseAPI implements DocumentRequestsApiInterface {
    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsAwaitingReviewGet(requestParameters: DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsAwaitingReviewGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsBulkApprovePost(requestParameters: DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsBulkApprovePost(requestParameters.bulkApproveDocumentRequestsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdAuditHistoryGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdAuditHistoryGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdClientResponsePost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdClientResponsePost(requestParameters.id, requestParameters.clientResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdConfidentialPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdConfidentialPatch(requestParameters.id, requestParameters.setConfidentialDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdDelete(requestParameters: DocumentRequestsApiApiDocumentRequestsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdMarkSubmittedPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdMarkSubmittedPost(requestParameters.id, requestParameters.markSubmittedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdPut(requestParameters: DocumentRequestsApiApiDocumentRequestsIdPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdPut(requestParameters.id, requestParameters.updateDocumentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdReviewPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdReviewPost(requestParameters.id, requestParameters.reviewDocumentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdStatusPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdStatusPatch(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdUploadPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdUploadPost(requestParameters.id, requestParameters.files, requestParameters.replaceExisting, requestParameters.runAiDetection, requestParameters.generateAiDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsOverdueGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsPost(requestParameters: DocumentRequestsApiApiDocumentRequestsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsPost(requestParameters.createDocumentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsReleasePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsReleasePost(requestParameters: DocumentRequestsApiApiDocumentRequestsReleasePostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsReleasePost(requestParameters.releaseDocumentRequestsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsStatisticsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsStatisticsGet(requestParameters.clientId, requestParameters.taxYear, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentTypesApi - axios parameter creator
 */
export const DocumentTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesSuggestionsGet: async (query?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-types/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTypesApi - functional programming interface
 */
export const DocumentTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeOptionsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTypesApi.apiDocumentTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentTypesSuggestionsGet(query?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentTypesSuggestionsGet(query, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTypesApi.apiDocumentTypesSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentTypesApi - factory interface
 */
export const DocumentTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeOptionsDtoApiResponse> {
            return localVarFp.apiDocumentTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentTypesApiApiDocumentTypesSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesSuggestionsGet(requestParameters: DocumentTypesApiApiDocumentTypesSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringListApiResponse> {
            return localVarFp.apiDocumentTypesSuggestionsGet(requestParameters.query, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentTypesApi - interface
 */
export interface DocumentTypesApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeOptionsDtoApiResponse>;

    /**
     * 
     * @param {DocumentTypesApiApiDocumentTypesSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentTypesSuggestionsGet(requestParameters?: DocumentTypesApiApiDocumentTypesSuggestionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringListApiResponse>;

}

/**
 * Request parameters for apiDocumentTypesSuggestionsGet operation in DocumentTypesApi.
 */
export interface DocumentTypesApiApiDocumentTypesSuggestionsGetRequest {
    readonly query?: string

    readonly limit?: number
}

/**
 * DocumentTypesApi - object-oriented interface
 */
export class DocumentTypesApi extends BaseAPI implements DocumentTypesApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentTypesGet(options?: RawAxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).apiDocumentTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentTypesApiApiDocumentTypesSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentTypesSuggestionsGet(requestParameters: DocumentTypesApiApiDocumentTypesSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).apiDocumentTypesSuggestionsGet(requestParameters.query, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsAnalyzeForSplittingPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/analyze-for-splitting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsBindersBinderIdPreprocessPost: async (binderId: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiDocumentsBindersBinderIdPreprocessPost', 'binderId', binderId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiDocumentsBindersBinderIdPreprocessPost', 'file', file)
            const localVarPath = `/api/Documents/binders/{binderId}/preprocess`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (autoSplit !== undefined) { 
                localVarFormParams.append('AutoSplit', String(autoSplit) as any);
            }

            if (detectSignatures !== undefined) { 
                localVarFormParams.append('DetectSignatures', String(detectSignatures) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [binderId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsCheckDuplicatePost: async (binderId?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/check-duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['binderId'] = binderId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {boolean} [autoApply] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdClassifyPost: async (documentId: string, autoApply?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdClassifyPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/classify`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (autoApply !== undefined) {
                localVarQueryParameter['autoApply'] = autoApply;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdExtractDataPost: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdExtractDataPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/extract-data`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdFilesFileIdDelete: async (documentId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdFilesFileIdDelete', 'documentId', documentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdFilesFileIdDelete', 'fileId', fileId)
            const localVarPath = `/api/Documents/{documentId}/files/{fileId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPatch: async (documentId: string, reviewDocumentRequest?: ReviewDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdReviewPatch', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {ReviewDocumentDto} [reviewDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPost: async (documentId: string, reviewDocumentDto?: ReviewDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdReviewPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {boolean} [runFormDetection] 
         * @param {boolean} [generateDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdTriggerAiProcessingPost: async (documentId: string, runFormDetection?: boolean, generateDescription?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdTriggerAiProcessingPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/trigger-ai-processing`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runFormDetection !== undefined) {
                localVarQueryParameter['runFormDetection'] = runFormDetection;
            }

            if (generateDescription !== undefined) {
                localVarQueryParameter['generateDescription'] = generateDescription;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchExtractionRequest} [batchExtractionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsExtractDataBatchPost: async (batchExtractionRequest?: BatchExtractionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/extract-data-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchExtractionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] 
         * @param {DocumentDirection} [direction] 
         * @param {string} [category] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsGet: async (page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            if (category !== undefined) {
                localVarQueryParameter['Category'] = category;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isExported !== undefined) {
                localVarQueryParameter['IsExported'] = isExported;
            }

            if (exportedAfter !== undefined) {
                localVarQueryParameter['ExportedAfter'] = (exportedAfter as any instanceof Date) ?
                    (exportedAfter as any).toISOString() :
                    exportedAfter;
            }

            if (exportedBefore !== undefined) {
                localVarQueryParameter['ExportedBefore'] = (exportedBefore as any instanceof Date) ?
                    (exportedBefore as any).toISOString() :
                    exportedBefore;
            }

            if (exportedById !== undefined) {
                localVarQueryParameter['ExportedById'] = exportedById;
            }

            if (excludeK1Documents !== undefined) {
                localVarQueryParameter['ExcludeK1Documents'] = excludeK1Documents;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdConvertToPdfPost: async (id: string, body?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdConvertToPdfPost', 'id', id)
            const localVarPath = `/api/Documents/{id}/convert-to-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdDelete', 'id', id)
            const localVarPath = `/api/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDownloadGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdDownloadGet', 'id', id)
            const localVarPath = `/api/Documents/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,application/octet-stream,text/plain,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [generateAiDescription] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdFilesPost: async (id: string, generateAiDescription?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdFilesPost', 'id', id)
            const localVarPath = `/api/Documents/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (generateAiDescription !== undefined) {
                localVarQueryParameter['generateAiDescription'] = generateAiDescription;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdGet', 'id', id)
            const localVarPath = `/api/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPrepareForSignaturePost: async (id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdPrepareForSignaturePost', 'id', id)
            const localVarPath = `/api/Documents/{id}/prepare-for-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleDocumentSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDocumentDto} [updateDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPut: async (id: string, updateDocumentDto?: UpdateDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdPut', 'id', id)
            const localVarPath = `/api/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdDelete: async (preprocessingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiDocumentsPreprocessingPreprocessingIdDelete', 'preprocessingId', preprocessingId)
            const localVarPath = `/api/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdGet: async (preprocessingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiDocumentsPreprocessingPreprocessingIdGet', 'preprocessingId', preprocessingId)
            const localVarPath = `/api/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreviewPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiDocumentsPreviewPost', 'file', file)
            const localVarPath = `/api/Documents/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdAwaitingReviewGet: async (documentRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiDocumentsRequestDocumentRequestIdAwaitingReviewGet', 'documentRequestId', documentRequestId)
            const localVarPath = `/api/Documents/request/{documentRequestId}/awaiting-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdBulkReviewPost: async (documentRequestId: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiDocumentsRequestDocumentRequestIdBulkReviewPost', 'documentRequestId', documentRequestId)
            const localVarPath = `/api/Documents/request/{documentRequestId}/bulk-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReviewDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdDocumentsGet: async (documentRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiDocumentsRequestDocumentRequestIdDocumentsGet', 'documentRequestId', documentRequestId)
            const localVarPath = `/api/Documents/request/{documentRequestId}/documents`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] 
         * @param {DocumentType} [type] 
         * @param {string} [comment] 
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] 
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadPost: async (files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiDocumentsUploadPost', 'files', files)
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiDocumentsUploadPost', 'binderId', binderId)
            const localVarPath = `/api/Documents/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }


            if (frontendType !== undefined) { 
                localVarFormParams.append('FrontendType', frontendType as any);
            }

            if (type !== undefined) { 
                localVarFormParams.append('Type', type as any);
            }

            if (binderId !== undefined) { 
                localVarFormParams.append('BinderId', binderId as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }

            if (documentRequestId !== undefined) { 
                localVarFormParams.append('DocumentRequestId', documentRequestId as any);
            }

            if (signatureTemplateId !== undefined) { 
                localVarFormParams.append('SignatureTemplateId', signatureTemplateId as any);
            }

            if (runAiDetection !== undefined) { 
                localVarFormParams.append('RunAiDetection', String(runAiDetection) as any);
            }

            if (generateAiDescription !== undefined) { 
                localVarFormParams.append('GenerateAiDescription', String(generateAiDescription) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }

            if (skipDuplicateCheck !== undefined) { 
                localVarFormParams.append('SkipDuplicateCheck', String(skipDuplicateCheck) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadWithPagesPost: async (documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/upload-with-pages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentUploadWithPagesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsAnalyzeForSplittingPost: async (version: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsAnalyzeForSplittingPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/analyze-for-splitting`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} version 
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsBindersBinderIdPreprocessPost: async (binderId: string, version: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiVversionDocumentsBindersBinderIdPreprocessPost', 'binderId', binderId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsBindersBinderIdPreprocessPost', 'version', version)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiVversionDocumentsBindersBinderIdPreprocessPost', 'file', file)
            const localVarPath = `/api/v{version}/Documents/binders/{binderId}/preprocess`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (autoSplit !== undefined) { 
                localVarFormParams.append('AutoSplit', String(autoSplit) as any);
            }

            if (detectSignatures !== undefined) { 
                localVarFormParams.append('DetectSignatures', String(detectSignatures) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [binderId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsCheckDuplicatePost: async (version: string, binderId?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsCheckDuplicatePost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/check-duplicate`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['binderId'] = binderId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {boolean} [autoApply] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdClassifyPost: async (documentId: string, version: string, autoApply?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdClassifyPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdClassifyPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/classify`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (autoApply !== undefined) {
                localVarQueryParameter['autoApply'] = autoApply;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdExtractDataPost: async (documentId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdExtractDataPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdExtractDataPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/extract-data`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdFilesFileIdDelete: async (documentId: string, fileId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdFilesFileIdDelete', 'documentId', documentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdFilesFileIdDelete', 'fileId', fileId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdFilesFileIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/files/{fileId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPatch: async (documentId: string, version: string, reviewDocumentRequest?: ReviewDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPatch', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPatch', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {ReviewDocumentDto} [reviewDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPost: async (documentId: string, version: string, reviewDocumentDto?: ReviewDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {boolean} [runFormDetection] 
         * @param {boolean} [generateDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdTriggerAiProcessingPost: async (documentId: string, version: string, runFormDetection?: boolean, generateDescription?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdTriggerAiProcessingPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdTriggerAiProcessingPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/trigger-ai-processing`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runFormDetection !== undefined) {
                localVarQueryParameter['runFormDetection'] = runFormDetection;
            }

            if (generateDescription !== undefined) {
                localVarQueryParameter['generateDescription'] = generateDescription;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {BatchExtractionRequest} [batchExtractionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsExtractDataBatchPost: async (version: string, batchExtractionRequest?: BatchExtractionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsExtractDataBatchPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/extract-data-batch`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchExtractionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] 
         * @param {DocumentDirection} [direction] 
         * @param {string} [category] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsGet: async (version: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            if (category !== undefined) {
                localVarQueryParameter['Category'] = category;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isExported !== undefined) {
                localVarQueryParameter['IsExported'] = isExported;
            }

            if (exportedAfter !== undefined) {
                localVarQueryParameter['ExportedAfter'] = (exportedAfter as any instanceof Date) ?
                    (exportedAfter as any).toISOString() :
                    exportedAfter;
            }

            if (exportedBefore !== undefined) {
                localVarQueryParameter['ExportedBefore'] = (exportedBefore as any instanceof Date) ?
                    (exportedBefore as any).toISOString() :
                    exportedBefore;
            }

            if (exportedById !== undefined) {
                localVarQueryParameter['ExportedById'] = exportedById;
            }

            if (excludeK1Documents !== undefined) {
                localVarQueryParameter['ExcludeK1Documents'] = excludeK1Documents;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdConvertToPdfPost: async (id: string, version: string, body?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdConvertToPdfPost', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdConvertToPdfPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/convert-to-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDelete: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDownloadGet: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDownloadGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDownloadGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,application/octet-stream,text/plain,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [generateAiDescription] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdFilesPost: async (id: string, version: string, generateAiDescription?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdFilesPost', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdFilesPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (generateAiDescription !== undefined) {
                localVarQueryParameter['generateAiDescription'] = generateAiDescription;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdGet: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPrepareForSignaturePost: async (id: string, version: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPrepareForSignaturePost', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPrepareForSignaturePost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/prepare-for-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleDocumentSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UpdateDocumentDto} [updateDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPut: async (id: string, version: string, updateDocumentDto?: UpdateDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPut', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPut', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdDelete: async (preprocessingId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdDelete', 'preprocessingId', preprocessingId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdGet: async (preprocessingId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdGet', 'preprocessingId', preprocessingId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreviewPost: async (version: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsPreviewPost', 'version', version)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiVversionDocumentsPreviewPost', 'file', file)
            const localVarPath = `/api/v{version}/Documents/preview`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet: async (documentRequestId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet', 'documentRequestId', documentRequestId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/request/{documentRequestId}/awaiting-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {string} version 
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost: async (documentRequestId: string, version: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost', 'documentRequestId', documentRequestId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/request/{documentRequestId}/bulk-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReviewDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdDocumentsGet: async (documentRequestId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdDocumentsGet', 'documentRequestId', documentRequestId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdDocumentsGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/request/{documentRequestId}/documents`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsTypesGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsTypesGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/types`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] 
         * @param {DocumentType} [type] 
         * @param {string} [comment] 
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] 
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadPost: async (version: string, files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadPost', 'version', version)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadPost', 'files', files)
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadPost', 'binderId', binderId)
            const localVarPath = `/api/v{version}/Documents/upload`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }


            if (frontendType !== undefined) { 
                localVarFormParams.append('FrontendType', frontendType as any);
            }

            if (type !== undefined) { 
                localVarFormParams.append('Type', type as any);
            }

            if (binderId !== undefined) { 
                localVarFormParams.append('BinderId', binderId as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }

            if (documentRequestId !== undefined) { 
                localVarFormParams.append('DocumentRequestId', documentRequestId as any);
            }

            if (signatureTemplateId !== undefined) { 
                localVarFormParams.append('SignatureTemplateId', signatureTemplateId as any);
            }

            if (runAiDetection !== undefined) { 
                localVarFormParams.append('RunAiDetection', String(runAiDetection) as any);
            }

            if (generateAiDescription !== undefined) { 
                localVarFormParams.append('GenerateAiDescription', String(generateAiDescription) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }

            if (skipDuplicateCheck !== undefined) { 
                localVarFormParams.append('SkipDuplicateCheck', String(skipDuplicateCheck) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadWithPagesPost: async (version: string, documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadWithPagesPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/upload-with-pages`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentUploadWithPagesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsAnalyzeForSplittingPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSplittingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsAnalyzeForSplittingPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsAnalyzeForSplittingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsBindersBinderIdPreprocessPost(binderId: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsBindersBinderIdPreprocessPost(binderId, file, autoSplit, detectSignatures, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsBindersBinderIdPreprocessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [binderId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsCheckDuplicatePost(binderId?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateDetectionResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsCheckDuplicatePost(binderId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsCheckDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {boolean} [autoApply] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdClassifyPost(documentId: string, autoApply?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassificationResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdClassifyPost(documentId, autoApply, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdClassifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdExtractDataPost(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractedDataResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdExtractDataPost(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdExtractDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdFilesFileIdDelete(documentId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdFilesFileIdDelete(documentId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdFilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdReviewPatch(documentId: string, reviewDocumentRequest?: ReviewDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdReviewPatch(documentId, reviewDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdReviewPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {ReviewDocumentDto} [reviewDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdReviewPost(documentId: string, reviewDocumentDto?: ReviewDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdReviewPost(documentId, reviewDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {boolean} [runFormDetection] 
         * @param {boolean} [generateDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdTriggerAiProcessingPost(documentId: string, runFormDetection?: boolean, generateDescription?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdTriggerAiProcessingPost(documentId, runFormDetection, generateDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdTriggerAiProcessingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchExtractionRequest} [batchExtractionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsExtractDataBatchPost(batchExtractionRequest?: BatchExtractionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchExtractionResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsExtractDataBatchPost(batchExtractionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsExtractDataBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] 
         * @param {DocumentDirection} [direction] 
         * @param {string} [category] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsGet(page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsGet(page, limit, sortBy, sortOrder, type, binderId, direction, category, searchTerm, isExported, exportedAfter, exportedBefore, exportedById, excludeK1Documents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdConvertToPdfPost(id: string, body?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdConvertToPdfPost(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdConvertToPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdDownloadGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDownloadUrlDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdDownloadGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [generateAiDescription] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdFilesPost(id: string, generateAiDescription?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdFilesPost(id, generateAiDescription, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdPrepareForSignaturePost(id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSubmissionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdPrepareForSignaturePost(id, singleDocumentSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdPrepareForSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDocumentDto} [updateDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdPut(id: string, updateDocumentDto?: UpdateDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdPut(id, updateDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsPreprocessingPreprocessingIdDelete(preprocessingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsPreprocessingPreprocessingIdDelete(preprocessingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsPreprocessingPreprocessingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsPreprocessingPreprocessingIdGet(preprocessingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsPreprocessingPreprocessingIdGet(preprocessingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsPreprocessingPreprocessingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsPreviewPost(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreviewResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsPreviewPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsRequestDocumentRequestIdAwaitingReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId, bulkReviewDocumentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsRequestDocumentRequestIdBulkReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsRequestDocumentRequestIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] 
         * @param {DocumentType} [type] 
         * @param {string} [comment] 
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] 
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsUploadPost(files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsUploadPost(files, binderId, frontendType, type, comment, documentRequestId, signatureTemplateId, runAiDetection, generateAiDescription, direction, skipDuplicateCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsUploadWithPagesPost(documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsUploadWithPagesPost(documentUploadWithPagesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsUploadWithPagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsAnalyzeForSplittingPost(version: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSplittingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsAnalyzeForSplittingPost(version, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsAnalyzeForSplittingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} version 
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsBindersBinderIdPreprocessPost(binderId: string, version: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsBindersBinderIdPreprocessPost(binderId, version, file, autoSplit, detectSignatures, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsBindersBinderIdPreprocessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [binderId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsCheckDuplicatePost(version: string, binderId?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateDetectionResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsCheckDuplicatePost(version, binderId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsCheckDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {boolean} [autoApply] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdClassifyPost(documentId: string, version: string, autoApply?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassificationResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdClassifyPost(documentId, version, autoApply, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdClassifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdExtractDataPost(documentId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractedDataResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdExtractDataPost(documentId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdExtractDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdFilesFileIdDelete(documentId: string, fileId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdFilesFileIdDelete(documentId, fileId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdFilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdReviewPatch(documentId: string, version: string, reviewDocumentRequest?: ReviewDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdReviewPatch(documentId, version, reviewDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdReviewPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {ReviewDocumentDto} [reviewDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdReviewPost(documentId: string, version: string, reviewDocumentDto?: ReviewDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdReviewPost(documentId, version, reviewDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} version 
         * @param {boolean} [runFormDetection] 
         * @param {boolean} [generateDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdTriggerAiProcessingPost(documentId: string, version: string, runFormDetection?: boolean, generateDescription?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdTriggerAiProcessingPost(documentId, version, runFormDetection, generateDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdTriggerAiProcessingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {BatchExtractionRequest} [batchExtractionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsExtractDataBatchPost(version: string, batchExtractionRequest?: BatchExtractionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchExtractionResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsExtractDataBatchPost(version, batchExtractionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsExtractDataBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] 
         * @param {DocumentDirection} [direction] 
         * @param {string} [category] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsGet(version: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsGet(version, page, limit, sortBy, sortOrder, type, binderId, direction, category, searchTerm, isExported, exportedAfter, exportedBefore, exportedById, excludeK1Documents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdConvertToPdfPost(id: string, version: string, body?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdConvertToPdfPost(id, version, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdConvertToPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdDelete(id: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdDownloadGet(id: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDownloadUrlDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdDownloadGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [generateAiDescription] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdFilesPost(id: string, version: string, generateAiDescription?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdFilesPost(id, version, generateAiDescription, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdGet(id: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdPrepareForSignaturePost(id: string, version: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSubmissionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdPrepareForSignaturePost(id, version, singleDocumentSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdPrepareForSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UpdateDocumentDto} [updateDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdPut(id: string, version: string, updateDocumentDto?: UpdateDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdPut(id, version, updateDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsPreprocessingPreprocessingIdDelete(preprocessingId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsPreprocessingPreprocessingIdDelete(preprocessingId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsPreprocessingPreprocessingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} preprocessingId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsPreprocessingPreprocessingIdGet(preprocessingId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsPreprocessingPreprocessingIdGet(preprocessingId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsPreprocessingPreprocessingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsPreviewPost(version: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreviewResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsPreviewPost(version, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {string} version 
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId: string, version: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId, version, bulkReviewDocumentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentRequestId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsRequestDocumentRequestIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsTypesGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsTypesGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] 
         * @param {DocumentType} [type] 
         * @param {string} [comment] 
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] 
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsUploadPost(version: string, files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsUploadPost(version, files, binderId, frontendType, type, comment, documentRequestId, signatureTemplateId, runAiDetection, generateAiDescription, direction, skipDuplicateCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsUploadWithPagesPost(version: string, documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsUploadWithPagesPost(version, documentUploadWithPagesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsUploadWithPagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * 
         * @param {DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse> {
            return localVarFp.apiDocumentsAnalyzeForSplittingPost(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiDocumentsCheckDuplicatePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse> {
            return localVarFp.apiDocumentsCheckDuplicatePost(requestParameters.binderId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse> {
            return localVarFp.apiDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.autoApply, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse> {
            return localVarFp.apiDocumentsDocumentIdExtractDataPost(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse> {
            return localVarFp.apiDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.reviewDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.reviewDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiDocumentsExtractDataBatchPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse> {
            return localVarFp.apiDocumentsExtractDataBatchPost(requestParameters.batchExtractionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsGet(requestParameters: DocumentsApiApiDocumentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse> {
            return localVarFp.apiDocumentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDelete(requestParameters: DocumentsApiApiDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDownloadGet(requestParameters: DocumentsApiApiDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse> {
            return localVarFp.apiDocumentsIdDownloadGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsIdFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdFilesPost(requestParameters: DocumentsApiApiDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsIdFilesPost(requestParameters.id, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdGet(requestParameters: DocumentsApiApiDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse> {
            return localVarFp.apiDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPut(requestParameters: DocumentsApiApiDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsIdPut(requestParameters.id, requestParameters.updateDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreviewPost(requestParameters: DocumentsApiApiDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse> {
            return localVarFp.apiDocumentsPreviewPost(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse> {
            return localVarFp.apiDocumentsTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadPost(requestParameters: DocumentsApiApiDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiDocumentsUploadPost(requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiDocumentsUploadWithPagesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse> {
            return localVarFp.apiDocumentsUploadWithPagesPost(requestParameters.documentUploadWithPagesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse> {
            return localVarFp.apiVversionDocumentsAnalyzeForSplittingPost(requestParameters.version, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.version, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse> {
            return localVarFp.apiVversionDocumentsCheckDuplicatePost(requestParameters.version, requestParameters.binderId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.version, requestParameters.autoApply, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdExtractDataPost(requestParameters.documentId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.version, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse> {
            return localVarFp.apiVversionDocumentsExtractDataBatchPost(requestParameters.version, requestParameters.batchExtractionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse> {
            return localVarFp.apiVversionDocumentsGet(requestParameters.version, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiVversionDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.version, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDelete(requestParameters: DocumentsApiApiVversionDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiVversionDocumentsIdDelete(requestParameters.id, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDownloadGet(requestParameters: DocumentsApiApiVversionDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdDownloadGet(requestParameters.id, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsIdFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdFilesPost(requestParameters: DocumentsApiApiVversionDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdFilesPost(requestParameters.id, requestParameters.version, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdGet(requestParameters: DocumentsApiApiVversionDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdGet(requestParameters.id, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.version, requestParameters.singleDocumentSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPut(requestParameters: DocumentsApiApiVversionDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdPut(requestParameters.id, requestParameters.version, requestParameters.updateDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreviewPost(requestParameters: DocumentsApiApiVversionDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse> {
            return localVarFp.apiVversionDocumentsPreviewPost(requestParameters.version, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.version, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsTypesGet(requestParameters: DocumentsApiApiVversionDocumentsTypesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsTypesGet(requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadPost(requestParameters: DocumentsApiApiVversionDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiVversionDocumentsUploadPost(requestParameters.version, requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse> {
            return localVarFp.apiVversionDocumentsUploadWithPagesPost(requestParameters.version, requestParameters.documentUploadWithPagesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - interface
 */
export interface DocumentsApiInterface {
    /**
     * 
     * @param {DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsAnalyzeForSplittingPost(requestParameters?: DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsCheckDuplicatePost(requestParameters?: DocumentsApiApiDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsExtractDataBatchPost(requestParameters?: DocumentsApiApiDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsGet(requestParameters?: DocumentsApiApiDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdDelete(requestParameters: DocumentsApiApiDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdDownloadGet(requestParameters: DocumentsApiApiDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdFilesPost(requestParameters: DocumentsApiApiDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdGet(requestParameters: DocumentsApiApiDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdPut(requestParameters: DocumentsApiApiDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsPreviewPost(requestParameters: DocumentsApiApiDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsUploadPost(requestParameters: DocumentsApiApiDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsUploadWithPagesPost(requestParameters?: DocumentsApiApiDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdDelete(requestParameters: DocumentsApiApiVversionDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdDownloadGet(requestParameters: DocumentsApiApiVversionDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdFilesPost(requestParameters: DocumentsApiApiVversionDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdGet(requestParameters: DocumentsApiApiVversionDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdPut(requestParameters: DocumentsApiApiVversionDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsPreviewPost(requestParameters: DocumentsApiApiVversionDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsTypesGet(requestParameters: DocumentsApiApiVversionDocumentsTypesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsUploadPost(requestParameters: DocumentsApiApiVversionDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>;

}

/**
 * Request parameters for apiDocumentsAnalyzeForSplittingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest {
    readonly file?: File
}

/**
 * Request parameters for apiDocumentsBindersBinderIdPreprocessPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest {
    readonly binderId: string

    readonly file: File

    readonly autoSplit?: boolean

    readonly detectSignatures?: boolean

    readonly direction?: DocumentDirection
}

/**
 * Request parameters for apiDocumentsCheckDuplicatePost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsCheckDuplicatePostRequest {
    readonly binderId?: string

    readonly file?: File
}

/**
 * Request parameters for apiDocumentsDocumentIdClassifyPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdClassifyPostRequest {
    readonly documentId: string

    readonly autoApply?: boolean
}

/**
 * Request parameters for apiDocumentsDocumentIdExtractDataPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest {
    readonly documentId: string
}

/**
 * Request parameters for apiDocumentsDocumentIdFilesFileIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest {
    readonly documentId: string

    readonly fileId: string
}

/**
 * Request parameters for apiDocumentsDocumentIdReviewPatch operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdReviewPatchRequest {
    readonly documentId: string

    readonly reviewDocumentRequest?: ReviewDocumentRequest
}

/**
 * Request parameters for apiDocumentsDocumentIdReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdReviewPostRequest {
    readonly documentId: string

    readonly reviewDocumentDto?: ReviewDocumentDto
}

/**
 * Request parameters for apiDocumentsDocumentIdTriggerAiProcessingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest {
    readonly documentId: string

    readonly runFormDetection?: boolean

    readonly generateDescription?: boolean
}

/**
 * Request parameters for apiDocumentsExtractDataBatchPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsExtractDataBatchPostRequest {
    readonly batchExtractionRequest?: BatchExtractionRequest
}

/**
 * Request parameters for apiDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly type?: DocumentType

    readonly binderId?: string

    readonly direction?: DocumentDirection

    readonly category?: string

    readonly searchTerm?: string

    readonly isExported?: boolean

    readonly exportedAfter?: string

    readonly exportedBefore?: string

    readonly exportedById?: string

    readonly excludeK1Documents?: boolean
}

/**
 * Request parameters for apiDocumentsIdConvertToPdfPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdConvertToPdfPostRequest {
    readonly id: string

    readonly body?: any
}

/**
 * Request parameters for apiDocumentsIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiDocumentsIdDownloadGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdDownloadGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiDocumentsIdFilesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdFilesPostRequest {
    readonly id: string

    readonly generateAiDescription?: boolean

    readonly file?: File
}

/**
 * Request parameters for apiDocumentsIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiDocumentsIdPrepareForSignaturePost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest {
    readonly id: string

    readonly singleDocumentSignatureDto?: SingleDocumentSignatureDto
}

/**
 * Request parameters for apiDocumentsIdPut operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdPutRequest {
    readonly id: string

    readonly updateDocumentDto?: UpdateDocumentDto
}

/**
 * Request parameters for apiDocumentsPreprocessingPreprocessingIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest {
    readonly preprocessingId: string
}

/**
 * Request parameters for apiDocumentsPreprocessingPreprocessingIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest {
    readonly preprocessingId: string
}

/**
 * Request parameters for apiDocumentsPreviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsPreviewPostRequest {
    readonly file: File
}

/**
 * Request parameters for apiDocumentsRequestDocumentRequestIdAwaitingReviewGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest {
    readonly documentRequestId: string
}

/**
 * Request parameters for apiDocumentsRequestDocumentRequestIdBulkReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest {
    readonly documentRequestId: string

    readonly bulkReviewDocumentsDto?: BulkReviewDocumentsDto
}

/**
 * Request parameters for apiDocumentsRequestDocumentRequestIdDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest {
    readonly documentRequestId: string
}

/**
 * Request parameters for apiDocumentsUploadPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsUploadPostRequest {
    readonly files: Array<File>

    readonly binderId: string

    readonly frontendType?: string

    readonly type?: DocumentType

    readonly comment?: string

    readonly documentRequestId?: string

    readonly signatureTemplateId?: string

    readonly runAiDetection?: boolean

    readonly generateAiDescription?: boolean

    readonly direction?: DocumentDirection

    readonly skipDuplicateCheck?: boolean
}

/**
 * Request parameters for apiDocumentsUploadWithPagesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsUploadWithPagesPostRequest {
    readonly documentUploadWithPagesDto?: DocumentUploadWithPagesDto
}

/**
 * Request parameters for apiVversionDocumentsAnalyzeForSplittingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest {
    readonly version: string

    readonly file?: File
}

/**
 * Request parameters for apiVversionDocumentsBindersBinderIdPreprocessPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest {
    readonly binderId: string

    readonly version: string

    readonly file: File

    readonly autoSplit?: boolean

    readonly detectSignatures?: boolean

    readonly direction?: DocumentDirection
}

/**
 * Request parameters for apiVversionDocumentsCheckDuplicatePost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest {
    readonly version: string

    readonly binderId?: string

    readonly file?: File
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdClassifyPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest {
    readonly documentId: string

    readonly version: string

    readonly autoApply?: boolean
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdExtractDataPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest {
    readonly documentId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdFilesFileIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest {
    readonly documentId: string

    readonly fileId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdReviewPatch operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest {
    readonly documentId: string

    readonly version: string

    readonly reviewDocumentRequest?: ReviewDocumentRequest
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest {
    readonly documentId: string

    readonly version: string

    readonly reviewDocumentDto?: ReviewDocumentDto
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdTriggerAiProcessingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest {
    readonly documentId: string

    readonly version: string

    readonly runFormDetection?: boolean

    readonly generateDescription?: boolean
}

/**
 * Request parameters for apiVversionDocumentsExtractDataBatchPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest {
    readonly version: string

    readonly batchExtractionRequest?: BatchExtractionRequest
}

/**
 * Request parameters for apiVversionDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsGetRequest {
    readonly version: string

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly type?: DocumentType

    readonly binderId?: string

    readonly direction?: DocumentDirection

    readonly category?: string

    readonly searchTerm?: string

    readonly isExported?: boolean

    readonly exportedAfter?: string

    readonly exportedBefore?: string

    readonly exportedById?: string

    readonly excludeK1Documents?: boolean
}

/**
 * Request parameters for apiVversionDocumentsIdConvertToPdfPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest {
    readonly id: string

    readonly version: string

    readonly body?: any
}

/**
 * Request parameters for apiVversionDocumentsIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdDeleteRequest {
    readonly id: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsIdDownloadGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdDownloadGetRequest {
    readonly id: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsIdFilesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdFilesPostRequest {
    readonly id: string

    readonly version: string

    readonly generateAiDescription?: boolean

    readonly file?: File
}

/**
 * Request parameters for apiVversionDocumentsIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdGetRequest {
    readonly id: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsIdPrepareForSignaturePost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest {
    readonly id: string

    readonly version: string

    readonly singleDocumentSignatureDto?: SingleDocumentSignatureDto
}

/**
 * Request parameters for apiVversionDocumentsIdPut operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdPutRequest {
    readonly id: string

    readonly version: string

    readonly updateDocumentDto?: UpdateDocumentDto
}

/**
 * Request parameters for apiVversionDocumentsPreprocessingPreprocessingIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest {
    readonly preprocessingId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsPreprocessingPreprocessingIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest {
    readonly preprocessingId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsPreviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsPreviewPostRequest {
    readonly version: string

    readonly file: File
}

/**
 * Request parameters for apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest {
    readonly documentRequestId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest {
    readonly documentRequestId: string

    readonly version: string

    readonly bulkReviewDocumentsDto?: BulkReviewDocumentsDto
}

/**
 * Request parameters for apiVversionDocumentsRequestDocumentRequestIdDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest {
    readonly documentRequestId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsTypesGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsTypesGetRequest {
    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsUploadPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsUploadPostRequest {
    readonly version: string

    readonly files: Array<File>

    readonly binderId: string

    readonly frontendType?: string

    readonly type?: DocumentType

    readonly comment?: string

    readonly documentRequestId?: string

    readonly signatureTemplateId?: string

    readonly runAiDetection?: boolean

    readonly generateAiDescription?: boolean

    readonly direction?: DocumentDirection

    readonly skipDuplicateCheck?: boolean
}

/**
 * Request parameters for apiVversionDocumentsUploadWithPagesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest {
    readonly version: string

    readonly documentUploadWithPagesDto?: DocumentUploadWithPagesDto
}

/**
 * DocumentsApi - object-oriented interface
 */
export class DocumentsApi extends BaseAPI implements DocumentsApiInterface {
    /**
     * 
     * @param {DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsAnalyzeForSplittingPost(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiDocumentsCheckDuplicatePostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsCheckDuplicatePost(requestParameters.binderId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.autoApply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdExtractDataPost(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.reviewDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.reviewDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiDocumentsExtractDataBatchPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsExtractDataBatchPost(requestParameters.batchExtractionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsGet(requestParameters: DocumentsApiApiDocumentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdDelete(requestParameters: DocumentsApiApiDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdDownloadGet(requestParameters: DocumentsApiApiDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdDownloadGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdFilesPost(requestParameters: DocumentsApiApiDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdFilesPost(requestParameters.id, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdGet(requestParameters: DocumentsApiApiDocumentsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdPut(requestParameters: DocumentsApiApiDocumentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdPut(requestParameters.id, requestParameters.updateDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsPreviewPost(requestParameters: DocumentsApiApiDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsPreviewPost(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsTypesGet(options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsUploadPost(requestParameters: DocumentsApiApiDocumentsUploadPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsUploadPost(requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiDocumentsUploadWithPagesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsUploadWithPagesPost(requestParameters.documentUploadWithPagesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsAnalyzeForSplittingPost(requestParameters.version, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.version, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsCheckDuplicatePost(requestParameters.version, requestParameters.binderId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.version, requestParameters.autoApply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdExtractDataPost(requestParameters.documentId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.version, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsExtractDataBatchPost(requestParameters.version, requestParameters.batchExtractionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsGet(requestParameters.version, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.version, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdDelete(requestParameters: DocumentsApiApiVversionDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdDelete(requestParameters.id, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdDownloadGet(requestParameters: DocumentsApiApiVversionDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdDownloadGet(requestParameters.id, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdFilesPost(requestParameters: DocumentsApiApiVversionDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdFilesPost(requestParameters.id, requestParameters.version, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdGet(requestParameters: DocumentsApiApiVversionDocumentsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdGet(requestParameters.id, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.version, requestParameters.singleDocumentSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdPut(requestParameters: DocumentsApiApiVversionDocumentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdPut(requestParameters.id, requestParameters.version, requestParameters.updateDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsPreviewPost(requestParameters: DocumentsApiApiVversionDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsPreviewPost(requestParameters.version, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.version, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsTypesGet(requestParameters: DocumentsApiApiVversionDocumentsTypesGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsTypesGet(requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsUploadPost(requestParameters: DocumentsApiApiVversionDocumentsUploadPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsUploadPost(requestParameters.version, requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsUploadWithPagesPost(requestParameters.version, requestParameters.documentUploadWithPagesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalClientsApi - axios parameter creator
 */
export const ExternalClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {string} [sourceSystem] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportCsvPost: async (dryRun?: boolean, sourceSystem?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/bulk-import-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }

            if (sourceSystem !== undefined) {
                localVarQueryParameter['sourceSystem'] = sourceSystem;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdCsvGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiClientsExternalBulkImportJobsJobIdCsvGet', 'jobId', jobId)
            const localVarPath = `/api/clients/external/bulk-import-jobs/{jobId}/csv`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/csv';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiClientsExternalBulkImportJobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/clients/external/bulk-import-jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientNumber 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByClientNumberClientNumberGet: async (clientNumber: string, source?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientNumber' is not null or undefined
            assertParamExists('apiClientsExternalByClientNumberClientNumberGet', 'clientNumber', clientNumber)
            const localVarPath = `/api/clients/external/by-client-number/{clientNumber}`
                .replace(`{${"clientNumber"}}`, encodeURIComponent(String(clientNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} officeName 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByOfficeOfficeNameGet: async (officeName: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'officeName' is not null or undefined
            assertParamExists('apiClientsExternalByOfficeOfficeNameGet', 'officeName', officeName)
            const localVarPath = `/api/clients/external/by-office/{officeName}`
                .replace(`{${"officeName"}}`, encodeURIComponent(String(officeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [maxCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalEmbeddingsRefreshPost: async (maxCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/embeddings/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxCount !== undefined) {
                localVarQueryParameter['maxCount'] = maxCount;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdGet', 'id', id)
            const localVarPath = `/api/clients/external/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdLinkDelete', 'id', id)
            const localVarPath = `/api/clients/external/{id}/link`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {LinkExternalClientDto} [linkExternalClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkPost: async (id: string, linkExternalClientDto?: LinkExternalClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdLinkPost', 'id', id)
            const localVarPath = `/api/clients/external/{id}/link`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkExternalClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdSimilarGet: async (id: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdSimilarGet', 'id', id)
            const localVarPath = `/api/clients/external/{id}/similar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalJobsHistoryGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/jobs/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchTerm 
         * @param {string} [sourceSystem] 
         * @param {string} [officeName] 
         * @param {string} [clientType] 
         * @param {boolean} [isActive] 
         * @param {boolean} [isImported] 
         * @param {boolean} [enableSemanticSearch] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSearchGet: async (searchTerm: string, sourceSystem?: string, officeName?: string, clientType?: string, isActive?: boolean, isImported?: boolean, enableSemanticSearch?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchTerm' is not null or undefined
            assertParamExists('apiClientsExternalSearchGet', 'searchTerm', searchTerm)
            const localVarPath = `/api/clients/external/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (sourceSystem !== undefined) {
                localVarQueryParameter['SourceSystem'] = sourceSystem;
            }

            if (officeName !== undefined) {
                localVarQueryParameter['OfficeName'] = officeName;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['ClientType'] = clientType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (isImported !== undefined) {
                localVarQueryParameter['IsImported'] = isImported;
            }

            if (enableSemanticSearch !== undefined) {
                localVarQueryParameter['EnableSemanticSearch'] = enableSemanticSearch;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} source 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSourceExternalIdGet: async (source: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('apiClientsExternalSourceExternalIdGet', 'source', source)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('apiClientsExternalSourceExternalIdGet', 'externalId', externalId)
            const localVarPath = `/api/clients/external/{source}/{externalId}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)))
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSuggestionsGet: async (q?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} source 
         * @param {ExternalClientSyncRequestDto} [externalClientSyncRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncSourcePost: async (source: string, externalClientSyncRequestDto?: ExternalClientSyncRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('apiClientsExternalSyncSourcePost', 'source', source)
            const localVarPath = `/api/clients/external/sync/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalClientSyncRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalClientsApi - functional programming interface
 */
export const ExternalClientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalClientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {string} [sourceSystem] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalBulkImportCsvPost(dryRun?: boolean, sourceSystem?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkImportJobStartedDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalBulkImportCsvPost(dryRun, sourceSystem, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalBulkImportCsvPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalBulkImportJobsJobIdCsvGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalBulkImportJobsJobIdCsvGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalBulkImportJobsJobIdCsvGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalBulkImportJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkImportJobStateApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalBulkImportJobsJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalBulkImportJobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientNumber 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalByClientNumberClientNumberGet(clientNumber: string, source?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalByClientNumberClientNumberGet(clientNumber, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalByClientNumberClientNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} officeName 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalByOfficeOfficeNameGet(officeName: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalByOfficeOfficeNameGet(officeName, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalByOfficeOfficeNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [maxCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalEmbeddingsRefreshPost(maxCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalEmbeddingsRefreshPost(maxCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalEmbeddingsRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdLinkDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdLinkDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdLinkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {LinkExternalClientDto} [linkExternalClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdLinkPost(id: string, linkExternalClientDto?: LinkExternalClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdLinkPost(id, linkExternalClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdLinkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdSimilarGet(id: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdSimilarGet(id, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdSimilarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobStatusSummaryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalJobsHistoryGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalJobsHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchTerm 
         * @param {string} [sourceSystem] 
         * @param {string} [officeName] 
         * @param {string} [clientType] 
         * @param {boolean} [isActive] 
         * @param {boolean} [isImported] 
         * @param {boolean} [enableSemanticSearch] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSearchGet(searchTerm: string, sourceSystem?: string, officeName?: string, clientType?: string, isActive?: boolean, isImported?: boolean, enableSemanticSearch?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSearchResultDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSearchGet(searchTerm, sourceSystem, officeName, clientType, isActive, isImported, enableSemanticSearch, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} source 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSourceExternalIdGet(source: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSourceExternalIdGet(source, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSourceExternalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSuggestionsGet(q?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSearchSuggestionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSuggestionsGet(q, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSyncPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSyncPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} source 
         * @param {ExternalClientSyncRequestDto} [externalClientSyncRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSyncSourcePost(source: string, externalClientSyncRequestDto?: ExternalClientSyncRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSyncSourcePost(source, externalClientSyncRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSyncSourcePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSyncStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSyncStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSyncStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalClientsApi - factory interface
 */
export const ExternalClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalClientsApiFp(configuration)
    return {
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportCsvPost(requestParameters: ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStartedDtoApiResponse> {
            return localVarFp.apiClientsExternalBulkImportCsvPost(requestParameters.dryRun, requestParameters.sourceSystem, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStateApiResponse> {
            return localVarFp.apiClientsExternalBulkImportJobsJobIdGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByClientNumberClientNumberGet(requestParameters: ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse> {
            return localVarFp.apiClientsExternalByClientNumberClientNumberGet(requestParameters.clientNumber, requestParameters.source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByOfficeOfficeNameGet(requestParameters: ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsExternalByOfficeOfficeNameGet(requestParameters.officeName, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalEmbeddingsRefreshPost(requestParameters: ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiClientsExternalEmbeddingsRefreshPost(requestParameters.maxCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse> {
            return localVarFp.apiClientsExternalIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalIdLinkDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkDelete(requestParameters: ExternalClientsApiApiClientsExternalIdLinkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsExternalIdLinkDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalIdLinkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkPost(requestParameters: ExternalClientsApiApiClientsExternalIdLinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsExternalIdLinkPost(requestParameters.id, requestParameters.linkExternalClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalIdSimilarGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdSimilarGet(requestParameters: ExternalClientsApiApiClientsExternalIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoListApiResponse> {
            return localVarFp.apiClientsExternalIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig): AxiosPromise<JobStatusSummaryDtoApiResponse> {
            return localVarFp.apiClientsExternalJobsHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSearchGet(requestParameters: ExternalClientsApiApiClientsExternalSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsExternalSearchGet(requestParameters.searchTerm, requestParameters.sourceSystem, requestParameters.officeName, requestParameters.clientType, requestParameters.isActive, requestParameters.isImported, requestParameters.enableSemanticSearch, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSourceExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse> {
            return localVarFp.apiClientsExternalSourceExternalIdGet(requestParameters.source, requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSuggestionsGet(requestParameters: ExternalClientsApiApiClientsExternalSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchSuggestionDtoListApiResponse> {
            return localVarFp.apiClientsExternalSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncPost(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiClientsExternalSyncPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalClientsApiApiClientsExternalSyncSourcePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncSourcePost(requestParameters: ExternalClientsApiApiClientsExternalSyncSourcePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiClientsExternalSyncSourcePost(requestParameters.source, requestParameters.externalClientSyncRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSyncStatusDtoApiResponse> {
            return localVarFp.apiClientsExternalSyncStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalClientsApi - interface
 */
export interface ExternalClientsApiInterface {
    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalBulkImportCsvPost(requestParameters?: ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStartedDtoApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalBulkImportJobsJobIdGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStateApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalByClientNumberClientNumberGet(requestParameters: ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalByOfficeOfficeNameGet(requestParameters: ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalEmbeddingsRefreshPost(requestParameters?: ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdLinkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdLinkDelete(requestParameters: ExternalClientsApiApiClientsExternalIdLinkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdLinkPost(requestParameters: ExternalClientsApiApiClientsExternalIdLinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdSimilarGet(requestParameters: ExternalClientsApiApiClientsExternalIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig): AxiosPromise<JobStatusSummaryDtoApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSearchGet(requestParameters: ExternalClientsApiApiClientsExternalSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSourceExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSuggestionsGet(requestParameters?: ExternalClientsApiApiClientsExternalSuggestionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchSuggestionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSyncPost(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSyncSourcePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSyncSourcePost(requestParameters: ExternalClientsApiApiClientsExternalSyncSourcePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSyncStatusDtoApiResponse>;

}

/**
 * Request parameters for apiClientsExternalBulkImportCsvPost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest {
    readonly dryRun?: boolean

    readonly sourceSystem?: string

    readonly file?: File
}

/**
 * Request parameters for apiClientsExternalBulkImportJobsJobIdCsvGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest {
    readonly jobId: string
}

/**
 * Request parameters for apiClientsExternalBulkImportJobsJobIdGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest {
    readonly jobId: string
}

/**
 * Request parameters for apiClientsExternalByClientNumberClientNumberGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest {
    readonly clientNumber: string

    readonly source?: string
}

/**
 * Request parameters for apiClientsExternalByOfficeOfficeNameGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest {
    readonly officeName: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiClientsExternalEmbeddingsRefreshPost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest {
    readonly maxCount?: number
}

/**
 * Request parameters for apiClientsExternalIdGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsExternalIdLinkDelete operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdLinkDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiClientsExternalIdLinkPost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdLinkPostRequest {
    readonly id: string

    readonly linkExternalClientDto?: LinkExternalClientDto
}

/**
 * Request parameters for apiClientsExternalIdSimilarGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdSimilarGetRequest {
    readonly id: string

    readonly limit?: number
}

/**
 * Request parameters for apiClientsExternalSearchGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSearchGetRequest {
    readonly searchTerm: string

    readonly sourceSystem?: string

    readonly officeName?: string

    readonly clientType?: string

    readonly isActive?: boolean

    readonly isImported?: boolean

    readonly enableSemanticSearch?: boolean

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiClientsExternalSourceExternalIdGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest {
    readonly source: string

    readonly externalId: string
}

/**
 * Request parameters for apiClientsExternalSuggestionsGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSuggestionsGetRequest {
    readonly q?: string

    readonly limit?: number
}

/**
 * Request parameters for apiClientsExternalSyncSourcePost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSyncSourcePostRequest {
    readonly source: string

    readonly externalClientSyncRequestDto?: ExternalClientSyncRequestDto
}

/**
 * ExternalClientsApi - object-oriented interface
 */
export class ExternalClientsApi extends BaseAPI implements ExternalClientsApiInterface {
    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalBulkImportCsvPost(requestParameters: ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalBulkImportCsvPost(requestParameters.dryRun, requestParameters.sourceSystem, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalBulkImportJobsJobIdGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalBulkImportJobsJobIdGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalByClientNumberClientNumberGet(requestParameters: ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalByClientNumberClientNumberGet(requestParameters.clientNumber, requestParameters.source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalByOfficeOfficeNameGet(requestParameters: ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalByOfficeOfficeNameGet(requestParameters.officeName, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalEmbeddingsRefreshPost(requestParameters: ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalEmbeddingsRefreshPost(requestParameters.maxCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdLinkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdLinkDelete(requestParameters: ExternalClientsApiApiClientsExternalIdLinkDeleteRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdLinkDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdLinkPost(requestParameters: ExternalClientsApiApiClientsExternalIdLinkPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdLinkPost(requestParameters.id, requestParameters.linkExternalClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdSimilarGet(requestParameters: ExternalClientsApiApiClientsExternalIdSimilarGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalJobsHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSearchGet(requestParameters: ExternalClientsApiApiClientsExternalSearchGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSearchGet(requestParameters.searchTerm, requestParameters.sourceSystem, requestParameters.officeName, requestParameters.clientType, requestParameters.isActive, requestParameters.isImported, requestParameters.enableSemanticSearch, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSourceExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSourceExternalIdGet(requestParameters.source, requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSuggestionsGet(requestParameters: ExternalClientsApiApiClientsExternalSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSyncPost(options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSyncPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalClientsApiApiClientsExternalSyncSourcePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSyncSourcePost(requestParameters: ExternalClientsApiApiClientsExternalSyncSourcePostRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSyncSourcePost(requestParameters.source, requestParameters.externalClientSyncRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSyncStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalDocumentSharesApi - axios parameter creator
 */
export const ExternalDocumentSharesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesGet: async (page?: number, pageSize?: number, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external-document-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalDocumentSharesIdDelete', 'id', id)
            const localVarPath = `/api/external-document-shares/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDownloadGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalDocumentSharesIdDownloadGet', 'id', id)
            const localVarPath = `/api/external-document-shares/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdExpirePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalDocumentSharesIdExpirePost', 'id', id)
            const localVarPath = `/api/external-document-shares/{id}/expire`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {Array<string>} recipientEmails 
         * @param {string} [message] 
         * @param {string} [expiresAt] 
         * @param {boolean} [expireOnDownload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPost: async (files: Array<File>, recipientEmails: Array<string>, message?: string, expiresAt?: string, expireOnDownload?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPost', 'files', files)
            // verify required parameter 'recipientEmails' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPost', 'recipientEmails', recipientEmails)
            const localVarPath = `/api/external-document-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }

            if (recipientEmails) {
                recipientEmails.forEach((element) => {
                    localVarFormParams.append('RecipientEmails', element as any);
                })
            }


            if (message !== undefined) { 
                localVarFormParams.append('Message', message as any);
            }

            if (expiresAt !== undefined) { 
                localVarFormParams.append('ExpiresAt', expiresAt as any);
            }

            if (expireOnDownload !== undefined) { 
                localVarFormParams.append('ExpireOnDownload', String(expireOnDownload) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenDownloadGet: async (token: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPublicTokenDownloadGet', 'token', token)
            const localVarPath = `/api/external-document-shares/public/{token}/download`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPublicTokenGet', 'token', token)
            const localVarPath = `/api/external-document-shares/public/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalDocumentSharesApi - functional programming interface
 */
export const ExternalDocumentSharesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalDocumentSharesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesGet(page?: number, pageSize?: number, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalDocumentShareDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesGet(page, pageSize, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesIdDownloadGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesIdDownloadGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesIdExpirePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalDocumentShareDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesIdExpirePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesIdExpirePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {Array<string>} recipientEmails 
         * @param {string} [message] 
         * @param {string} [expiresAt] 
         * @param {boolean} [expireOnDownload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesPost(files: Array<File>, recipientEmails: Array<string>, message?: string, expiresAt?: string, expireOnDownload?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalDocumentShareDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesPost(files, recipientEmails, message, expiresAt, expireOnDownload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesPublicTokenDownloadGet(token: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesPublicTokenDownloadGet(token, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesPublicTokenDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesPublicTokenGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicExternalDocumentShareDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesPublicTokenGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesPublicTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalDocumentSharesApi - factory interface
 */
export const ExternalDocumentSharesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalDocumentSharesApiFp(configuration)
    return {
        /**
         * 
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoPaginatedResponseApiResponse> {
            return localVarFp.apiExternalDocumentSharesGet(requestParameters.page, requestParameters.pageSize, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDelete(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiExternalDocumentSharesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiExternalDocumentSharesIdDownloadGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdExpirePost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse> {
            return localVarFp.apiExternalDocumentSharesIdExpirePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse> {
            return localVarFp.apiExternalDocumentSharesPost(requestParameters.files, requestParameters.recipientEmails, requestParameters.message, requestParameters.expiresAt, requestParameters.expireOnDownload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters.token, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicExternalDocumentShareDtoApiResponse> {
            return localVarFp.apiExternalDocumentSharesPublicTokenGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalDocumentSharesApi - interface
 */
export interface ExternalDocumentSharesApiInterface {
    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesGet(requestParameters?: ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesIdDelete(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesIdDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesIdExpirePost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse>;

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesPost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse>;

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesPublicTokenGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicExternalDocumentShareDtoApiResponse>;

}

/**
 * Request parameters for apiExternalDocumentSharesGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly skip?: number

    readonly take?: number
}

/**
 * Request parameters for apiExternalDocumentSharesIdDelete operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiExternalDocumentSharesIdDownloadGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiExternalDocumentSharesIdExpirePost operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest {
    readonly id: string
}

/**
 * Request parameters for apiExternalDocumentSharesPost operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest {
    readonly files: Array<File>

    readonly recipientEmails: Array<string>

    readonly message?: string

    readonly expiresAt?: string

    readonly expireOnDownload?: boolean
}

/**
 * Request parameters for apiExternalDocumentSharesPublicTokenDownloadGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest {
    readonly token: string

    readonly email?: string
}

/**
 * Request parameters for apiExternalDocumentSharesPublicTokenGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest {
    readonly token: string
}

/**
 * ExternalDocumentSharesApi - object-oriented interface
 */
export class ExternalDocumentSharesApi extends BaseAPI implements ExternalDocumentSharesApiInterface {
    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesGet(requestParameters.page, requestParameters.pageSize, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesIdDelete(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesIdDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesIdDownloadGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesIdExpirePost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesIdExpirePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesPost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesPost(requestParameters.files, requestParameters.recipientEmails, requestParameters.message, requestParameters.expiresAt, requestParameters.expireOnDownload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters.token, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesPublicTokenGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesPublicTokenGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalUploadApi - axios parameter creator
 */
export const ExternalUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdFilesPost: async (id: string, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalUploadIdFilesPost', 'id', id)
            const localVarPath = `/api/external-upload/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalUploadIdGet', 'id', id)
            const localVarPath = `/api/external-upload/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalUploadApi - functional programming interface
 */
export const ExternalUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalUploadIdFilesPost(id: string, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalUploadIdFilesPost(id, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalUploadApi.apiExternalUploadIdFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalUploadIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalUploadViewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalUploadIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalUploadApi.apiExternalUploadIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalUploadApi - factory interface
 */
export const ExternalUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalUploadApiFp(configuration)
    return {
        /**
         * 
         * @param {ExternalUploadApiApiExternalUploadIdFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdFilesPost(requestParameters: ExternalUploadApiApiExternalUploadIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileDtoListApiResponse> {
            return localVarFp.apiExternalUploadIdFilesPost(requestParameters.id, requestParameters.files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalUploadApiApiExternalUploadIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdGet(requestParameters: ExternalUploadApiApiExternalUploadIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalUploadViewDtoApiResponse> {
            return localVarFp.apiExternalUploadIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalUploadApi - interface
 */
export interface ExternalUploadApiInterface {
    /**
     * 
     * @param {ExternalUploadApiApiExternalUploadIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalUploadIdFilesPost(requestParameters: ExternalUploadApiApiExternalUploadIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileDtoListApiResponse>;

    /**
     * 
     * @param {ExternalUploadApiApiExternalUploadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalUploadIdGet(requestParameters: ExternalUploadApiApiExternalUploadIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalUploadViewDtoApiResponse>;

}

/**
 * Request parameters for apiExternalUploadIdFilesPost operation in ExternalUploadApi.
 */
export interface ExternalUploadApiApiExternalUploadIdFilesPostRequest {
    readonly id: string

    readonly files?: Array<File>
}

/**
 * Request parameters for apiExternalUploadIdGet operation in ExternalUploadApi.
 */
export interface ExternalUploadApiApiExternalUploadIdGetRequest {
    readonly id: string
}

/**
 * ExternalUploadApi - object-oriented interface
 */
export class ExternalUploadApi extends BaseAPI implements ExternalUploadApiInterface {
    /**
     * 
     * @param {ExternalUploadApiApiExternalUploadIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalUploadIdFilesPost(requestParameters: ExternalUploadApiApiExternalUploadIdFilesPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalUploadApiFp(this.configuration).apiExternalUploadIdFilesPost(requestParameters.id, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalUploadApiApiExternalUploadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalUploadIdGet(requestParameters: ExternalUploadApiApiExternalUploadIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalUploadApiFp(this.configuration).apiExternalUploadIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * Form8879DiagnosticApi - axios parameter creator
 */
export const Form8879DiagnosticApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879DetectionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/diagnostic/8879-detection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879TextFileNameGet: async (fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiDiagnostic8879TextFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/diagnostic/8879-text/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Form8879DiagnosticApi - functional programming interface
 */
export const Form8879DiagnosticApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Form8879DiagnosticApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Form8879DiagnosticReportApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiagnostic8879DetectionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Form8879DiagnosticApi.apiDiagnostic8879DetectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDiagnostic8879TextFileNameGet(fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiagnostic8879TextFileNameGet(fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Form8879DiagnosticApi.apiDiagnostic8879TextFileNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Form8879DiagnosticApi - factory interface
 */
export const Form8879DiagnosticApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Form8879DiagnosticApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig): AxiosPromise<Form8879DiagnosticReportApiResponse> {
            return localVarFp.apiDiagnostic8879DetectionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879TextFileNameGet(requestParameters: Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiDiagnostic8879TextFileNameGet(requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Form8879DiagnosticApi - interface
 */
export interface Form8879DiagnosticApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig): AxiosPromise<Form8879DiagnosticReportApiResponse>;

    /**
     * 
     * @param {Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDiagnostic8879TextFileNameGet(requestParameters: Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

}

/**
 * Request parameters for apiDiagnostic8879TextFileNameGet operation in Form8879DiagnosticApi.
 */
export interface Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest {
    readonly fileName: string
}

/**
 * Form8879DiagnosticApi - object-oriented interface
 */
export class Form8879DiagnosticApi extends BaseAPI implements Form8879DiagnosticApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig) {
        return Form8879DiagnosticApiFp(this.configuration).apiDiagnostic8879DetectionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDiagnostic8879TextFileNameGet(requestParameters: Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest, options?: RawAxiosRequestConfig) {
        return Form8879DiagnosticApiFp(this.configuration).apiDiagnostic8879TextFileNameGet(requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * K1Api - axios parameter creator
 */
export const K1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1DocumentsDocumentIdDelete: async (binderId: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1DocumentsDocumentIdDelete', 'binderId', binderId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1DocumentsDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/documents/{documentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractPost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1ExtractPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/extract`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractedGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1ExtractedGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/extracted`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdDelete: async (binderId: string, assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdDelete', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdDelete', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} assignmentId 
         * @param {UpdateK1RecipientAssignmentDto} [updateK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPut: async (binderId: string, assignmentId: string, updateK1RecipientAssignmentDto?: UpdateK1RecipientAssignmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPut', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateK1RecipientAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost: async (binderId: string, assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}/resend-notification`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {CreateK1RecipientAssignmentDto} [createK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersPost: async (binderId: string, createK1RecipientAssignmentDto?: CreateK1RecipientAssignmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createK1RecipientAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {File} [k1Pdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ReuploadPost: async (binderId: string, k1Pdf?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1ReuploadPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/reupload`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (k1Pdf !== undefined) { 
                localVarFormParams.append('k1Pdf', k1Pdf as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1StatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1StatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * K1Api - functional programming interface
 */
export const K1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = K1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(binderId: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(binderId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1DocumentsDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1ExtractPost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1ExtractedPartnerDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1ExtractPost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1ExtractPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1ExtractedGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1ExtractedPartnerDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1ExtractedGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1ExtractedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(binderId: string, assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(binderId, assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersAssignmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} assignmentId 
         * @param {UpdateK1RecipientAssignmentDto} [updateK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdPut(binderId: string, assignmentId: string, updateK1RecipientAssignmentDto?: UpdateK1RecipientAssignmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1RecipientAssignmentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdPut(binderId, assignmentId, updateK1RecipientAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersAssignmentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(binderId: string, assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(binderId, assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1RecipientAssignmentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {CreateK1RecipientAssignmentDto} [createK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersPost(binderId: string, createK1RecipientAssignmentDto?: CreateK1RecipientAssignmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1RecipientAssignmentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersPost(binderId, createK1RecipientAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {File} [k1Pdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1ReuploadPost(binderId: string, k1Pdf?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1ExtractedPartnerDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1ReuploadPost(binderId, k1Pdf, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1ReuploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1StatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1StatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1StatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1StatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * K1Api - factory interface
 */
export const K1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = K1ApiFp(configuration)
    return {
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters.binderId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1ExtractPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1ExtractPost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractedGet(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1ExtractedGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters.binderId, requestParameters.assignmentId, requestParameters.updateK1RecipientAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersGet(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersPost(requestParameters.binderId, requestParameters.createK1RecipientAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ReuploadPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1ReuploadPost(requestParameters.binderId, requestParameters.k1Pdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {K1ApiApiTaxBindersBinderIdK1StatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1StatusGet(requestParameters: K1ApiApiTaxBindersBinderIdK1StatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1StatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1StatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * K1Api - interface
 */
export interface K1ApiInterface {
    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1ExtractPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1ExtractedGet(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersGet(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoListApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1ReuploadPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse>;

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1StatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1StatusGet(requestParameters: K1ApiApiTaxBindersBinderIdK1StatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1StatusDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBinderIdK1DocumentsDocumentIdDelete operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest {
    readonly binderId: string

    readonly documentId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1ExtractPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1ExtractPostRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1ExtractedGet operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdDelete operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest {
    readonly binderId: string

    readonly assignmentId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdPut operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest {
    readonly binderId: string

    readonly assignmentId: string

    readonly updateK1RecipientAssignmentDto?: UpdateK1RecipientAssignmentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest {
    readonly binderId: string

    readonly assignmentId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersGet operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersPostRequest {
    readonly binderId: string

    readonly createK1RecipientAssignmentDto?: CreateK1RecipientAssignmentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdK1ReuploadPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest {
    readonly binderId: string

    readonly k1Pdf?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdK1StatusGet operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1StatusGetRequest {
    readonly binderId: string
}

/**
 * K1Api - object-oriented interface
 */
export class K1Api extends BaseAPI implements K1ApiInterface {
    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters.binderId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1ExtractPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1ExtractPost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1ExtractedGet(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1ExtractedGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters.binderId, requestParameters.assignmentId, requestParameters.updateK1RecipientAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersGet(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersGetRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersPost(requestParameters.binderId, requestParameters.createK1RecipientAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1ReuploadPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1ReuploadPost(requestParameters.binderId, requestParameters.k1Pdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {K1ApiApiTaxBindersBinderIdK1StatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1StatusGet(requestParameters: K1ApiApiTaxBindersBinderIdK1StatusGetRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1StatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationPreferencesApi - axios parameter creator
 */
export const NotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/action-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationActionType} actionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeDelete: async (actionType: NotificationActionType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiNotificationPreferencesActionsActionTypeDelete', 'actionType', actionType)
            const localVarPath = `/api/notification-preferences/actions/{actionType}`
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationActionType} actionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeGet: async (actionType: NotificationActionType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiNotificationPreferencesActionsActionTypeGet', 'actionType', actionType)
            const localVarPath = `/api/notification-preferences/actions/{actionType}`
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationActionType} actionType 
         * @param {UpdateActionPreferenceDto} [updateActionPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypePut: async (actionType: NotificationActionType, updateActionPreferenceDto?: UpdateActionPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiNotificationPreferencesActionsActionTypePut', 'actionType', actionType)
            const localVarPath = `/api/notification-preferences/actions/{actionType}`
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateActionPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesDisablePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesEnablePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserNotificationPreferenceDto} [updateUserNotificationPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesPut: async (updateUserNotificationPreferenceDto?: UpdateUserNotificationPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserNotificationPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesResetPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationPreferencesApi - functional programming interface
 */
export const NotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionTypeDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationActionType} actionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsActionTypeDelete(actionType: NotificationActionType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsActionTypeDelete(actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsActionTypeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationActionType} actionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsActionTypeGet(actionType: NotificationActionType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsActionTypeGet(actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsActionTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationActionType} actionType 
         * @param {UpdateActionPreferenceDto} [updateActionPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsActionTypePut(actionType: NotificationActionType, updateActionPreferenceDto?: UpdateActionPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsActionTypePut(actionType, updateActionPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsActionTypePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPreferencesResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesDisablePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesDisablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesEnablePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesEnablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateUserNotificationPreferenceDto} [updateUserNotificationPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesPut(updateUserNotificationPreferenceDto?: UpdateUserNotificationPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesPut(updateUserNotificationPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesResetPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationPreferencesApi - factory interface
 */
export const NotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionTypeDtoListApiResponse> {
            return localVarFp.apiNotificationPreferencesActionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeDelete(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsActionTypeDelete(requestParameters.actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeGet(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsActionTypeGet(requestParameters.actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypePut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsActionTypePut(requestParameters.actionType, requestParameters.updateActionPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferencesResponseDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesDisablePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesEnablePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesGet(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationPreferencesApiApiNotificationPreferencesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesPut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesPut(requestParameters.updateUserNotificationPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesResetPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationPreferencesApi - interface
 */
export interface NotificationPreferencesApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionTypeDtoListApiResponse>;

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsActionTypeDelete(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsActionTypeGet(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse>;

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsActionTypePut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferencesResponseDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesGet(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesPut(requestParameters?: NotificationPreferencesApiApiNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

}

/**
 * Request parameters for apiNotificationPreferencesActionsActionTypeDelete operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest {
    readonly actionType: NotificationActionType
}

/**
 * Request parameters for apiNotificationPreferencesActionsActionTypeGet operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest {
    readonly actionType: NotificationActionType
}

/**
 * Request parameters for apiNotificationPreferencesActionsActionTypePut operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest {
    readonly actionType: NotificationActionType

    readonly updateActionPreferenceDto?: UpdateActionPreferenceDto
}

/**
 * Request parameters for apiNotificationPreferencesPut operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesPutRequest {
    readonly updateUserNotificationPreferenceDto?: UpdateUserNotificationPreferenceDto
}

/**
 * NotificationPreferencesApi - object-oriented interface
 */
export class NotificationPreferencesApi extends BaseAPI implements NotificationPreferencesApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsActionTypeDelete(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsActionTypeDelete(requestParameters.actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsActionTypeGet(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsActionTypeGet(requestParameters.actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsActionTypePut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsActionTypePut(requestParameters.actionType, requestParameters.updateActionPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesDisablePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesEnablePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesGet(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationPreferencesApiApiNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesPut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesPutRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesPut(requestParameters.updateUserNotificationPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesResetPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsActionTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/action-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsDeliveryChannelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/delivery-channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [recipientClientId] 
         * @param {string} [binderId] 
         * @param {NotificationActionType} [actionType] 
         * @param {boolean} [isRead] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet: async (clientId?: string, recipientClientId?: string, binderId?: string, actionType?: NotificationActionType, isRead?: boolean, dateFrom?: string, dateTo?: string, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (recipientClientId !== undefined) {
                localVarQueryParameter['RecipientClientId'] = recipientClientId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['ActionType'] = actionType;
            }

            if (isRead !== undefined) {
                localVarQueryParameter['IsRead'] = isRead;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['DateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['DateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdDismissPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNotificationsIdDismissPost', 'id', id)
            const localVarPath = `/api/notifications/{id}/dismiss`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdReadPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNotificationsIdReadPost', 'id', id)
            const localVarPath = `/api/notifications/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadAllPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/read-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkNotificationsReadDto} [markNotificationsReadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadBatchPost: async (markNotificationsReadDto?: MarkNotificationsReadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/read-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationsReadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsRecentGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsUnreadCountGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsActionTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsActionTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsDeliveryChannelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsDeliveryChannelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [recipientClientId] 
         * @param {string} [binderId] 
         * @param {NotificationActionType} [actionType] 
         * @param {boolean} [isRead] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsGet(clientId?: string, recipientClientId?: string, binderId?: string, actionType?: NotificationActionType, isRead?: boolean, dateFrom?: string, dateTo?: string, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedNotificationDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsGet(clientId, recipientClientId, binderId, actionType, isRead, dateFrom, dateTo, sortBy, sortOrder, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsIdDismissPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsIdDismissPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsIdDismissPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsIdReadPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsIdReadPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsIdReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsReadAllPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsReadAllPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsReadAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkNotificationsReadDto} [markNotificationsReadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsReadBatchPost(markNotificationsReadDto?: MarkNotificationsReadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsReadBatchPost(markNotificationsReadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsReadBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsRecentGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedNotificationDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsRecentGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsRecentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationCountSummaryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsUnreadCountGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsUnreadCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiNotificationsActionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiNotificationsDeliveryChannelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiNotificationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet(requestParameters: NotificationsApiApiNotificationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoPaginatedResponseApiResponse> {
            return localVarFp.apiNotificationsGet(requestParameters.clientId, requestParameters.recipientClientId, requestParameters.binderId, requestParameters.actionType, requestParameters.isRead, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiNotificationsIdDismissPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdDismissPost(requestParameters: NotificationsApiApiNotificationsIdDismissPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsIdDismissPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiNotificationsIdReadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdReadPost(requestParameters: NotificationsApiApiNotificationsIdReadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsIdReadPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadAllPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsReadAllPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiNotificationsReadBatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadBatchPost(requestParameters: NotificationsApiApiNotificationsReadBatchPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsReadBatchPost(requestParameters.markNotificationsReadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiNotificationsRecentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsRecentGet(requestParameters: NotificationsApiApiNotificationsRecentGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoListApiResponse> {
            return localVarFp.apiNotificationsRecentGet(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): AxiosPromise<NotificationCountSummaryDtoApiResponse> {
            return localVarFp.apiNotificationsUnreadCountGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - interface
 */
export interface NotificationsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {NotificationsApiApiNotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsGet(requestParameters?: NotificationsApiApiNotificationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {NotificationsApiApiNotificationsIdDismissPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsIdDismissPost(requestParameters: NotificationsApiApiNotificationsIdDismissPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {NotificationsApiApiNotificationsIdReadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsIdReadPost(requestParameters: NotificationsApiApiNotificationsIdReadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsReadAllPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {NotificationsApiApiNotificationsReadBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsReadBatchPost(requestParameters?: NotificationsApiApiNotificationsReadBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {NotificationsApiApiNotificationsRecentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsRecentGet(requestParameters?: NotificationsApiApiNotificationsRecentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): AxiosPromise<NotificationCountSummaryDtoApiResponse>;

}

/**
 * Request parameters for apiNotificationsGet operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsGetRequest {
    readonly clientId?: string

    readonly recipientClientId?: string

    readonly binderId?: string

    readonly actionType?: NotificationActionType

    readonly isRead?: boolean

    readonly dateFrom?: string

    readonly dateTo?: string

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiNotificationsIdDismissPost operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsIdDismissPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiNotificationsIdReadPost operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsIdReadPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiNotificationsReadBatchPost operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsReadBatchPostRequest {
    readonly markNotificationsReadDto?: MarkNotificationsReadDto
}

/**
 * Request parameters for apiNotificationsRecentGet operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsRecentGetRequest {
    readonly limit?: number
}

/**
 * NotificationsApi - object-oriented interface
 */
export class NotificationsApi extends BaseAPI implements NotificationsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsActionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsDeliveryChannelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiNotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsGet(requestParameters: NotificationsApiApiNotificationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsGet(requestParameters.clientId, requestParameters.recipientClientId, requestParameters.binderId, requestParameters.actionType, requestParameters.isRead, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiNotificationsIdDismissPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsIdDismissPost(requestParameters: NotificationsApiApiNotificationsIdDismissPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsIdDismissPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiNotificationsIdReadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsIdReadPost(requestParameters: NotificationsApiApiNotificationsIdReadPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsIdReadPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsReadAllPost(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsReadAllPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiNotificationsReadBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsReadBatchPost(requestParameters: NotificationsApiApiNotificationsReadBatchPostRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsReadBatchPost(requestParameters.markNotificationsReadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiNotificationsRecentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsRecentGet(requestParameters: NotificationsApiApiNotificationsRecentGetRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsRecentGet(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsUnreadCountGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OptionsApi - axios parameter creator
 */
export const OptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsAnchorPointsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/anchor-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStagesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/binder-stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/binder-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/binder-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientResponseTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-response-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientUserRolesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-user-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsCoordinateSystemsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/coordinate-systems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentDirectionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-directions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestPrioritiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-request-priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-request-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationPrioritiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/notification-priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/notification-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/notification-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsProcessingStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/processing-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/question-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionnaireStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/questionnaire-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureCancellationStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/signature-cancellation-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureFieldTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/signature-field-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/signature-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsTaxTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/tax-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsUserRolesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/user-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsOfficesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OptionsApi - functional programming interface
 */
export const OptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsAnchorPointsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsAnchorPointsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsBinderStagesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsBinderStagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsBinderStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsBinderStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsBinderTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsBinderTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientResponseTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientResponseTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientUserRolesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientUserRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsCoordinateSystemsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsCoordinateSystemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentDirectionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentDirectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentRequestPrioritiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentRequestPrioritiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentRequestStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentRequestStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsNotificationPrioritiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsNotificationPrioritiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsNotificationStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsNotificationStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsNotificationTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsNotificationTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsProcessingStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsProcessingStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsQuestionTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsQuestionTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsQuestionnaireStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsQuestionnaireStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsSignatureCancellationStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsSignatureCancellationStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsSignatureFieldTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsSignatureFieldTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsSignatureStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsSignatureStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsTaxTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsTaxTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsUserRolesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsUserRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsOfficesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsOfficesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsOfficesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OptionsApi - factory interface
 */
export const OptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsAnchorPointsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsBinderStagesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsBinderStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsBinderTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientResponseTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientUserRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsCoordinateSystemsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentDirectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentRequestPrioritiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentRequestStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsNotificationPrioritiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsNotificationStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsNotificationTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsProcessingStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsQuestionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsQuestionnaireStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsSignatureCancellationStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsSignatureFieldTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsSignatureStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsTaxTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsUserRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsOfficesGet(options?: RawAxiosRequestConfig): AxiosPromise<OptionDtoListApiResponse> {
            return localVarFp.apiOptionsOfficesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OptionsApi - interface
 */
export interface OptionsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsOfficesGet(options?: RawAxiosRequestConfig): AxiosPromise<OptionDtoListApiResponse>;

}

/**
 * OptionsApi - object-oriented interface
 */
export class OptionsApi extends BaseAPI implements OptionsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsAnchorPointsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsBinderStagesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsBinderStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsBinderTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientResponseTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientUserRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsCoordinateSystemsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentDirectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentRequestPrioritiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentRequestStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsNotificationPrioritiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsNotificationStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsNotificationTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsProcessingStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsQuestionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsQuestionnaireStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsSignatureCancellationStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsSignatureFieldTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsSignatureStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsTaxTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsUserRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsOfficesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsOfficesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PreparerDashboardApi - axios parameter creator
 */
export const PreparerDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardActivitiesGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardClientsGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardMetricsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [officeId] 
         * @param {string} [preparerId] 
         * @param {number} [taxYear] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [assignedToMe] 
         * @param {BinderStage} [stage] 
         * @param {ClientType} [taxType] 
         * @param {boolean} [isClientSubmitted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardStatsGet: async (officeId?: string, preparerId?: string, taxYear?: number, watchedClientsOnly?: boolean, assignedToMe?: boolean, stage?: BinderStage, taxType?: ClientType, isClientSubmitted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (stage !== undefined) {
                localVarQueryParameter['Stage'] = stage;
            }

            if (taxType !== undefined) {
                localVarQueryParameter['TaxType'] = taxType;
            }

            if (isClientSubmitted !== undefined) {
                localVarQueryParameter['IsClientSubmitted'] = isClientSubmitted;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreparerDashboardApi - functional programming interface
 */
export const PreparerDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreparerDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardActivitiesGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentActivityDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardActivitiesGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardActivitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardClientsGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentClientDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardClientsGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardMetricsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardMetricsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [officeId] 
         * @param {string} [preparerId] 
         * @param {number} [taxYear] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [assignedToMe] 
         * @param {BinderStage} [stage] 
         * @param {ClientType} [taxType] 
         * @param {boolean} [isClientSubmitted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardStatsGet(officeId?: string, preparerId?: string, taxYear?: number, watchedClientsOnly?: boolean, assignedToMe?: boolean, stage?: BinderStage, taxType?: ClientType, isClientSubmitted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardStatsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardStatsGet(officeId, preparerId, taxYear, watchedClientsOnly, assignedToMe, stage, taxType, isClientSubmitted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PreparerDashboardApi - factory interface
 */
export const PreparerDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreparerDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardActivitiesGet(requestParameters: PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RecentActivityDtoListApiResponse> {
            return localVarFp.apiPreparerDashboardActivitiesGet(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PreparerDashboardApiApiPreparerDashboardClientsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardClientsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardClientsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RecentClientDtoListApiResponse> {
            return localVarFp.apiPreparerDashboardClientsGet(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardDtoApiResponse> {
            return localVarFp.apiPreparerDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardMetricsDtoApiResponse> {
            return localVarFp.apiPreparerDashboardMetricsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PreparerDashboardApiApiPreparerDashboardStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardStatsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardStatsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DashboardStatsDtoApiResponse> {
            return localVarFp.apiPreparerDashboardStatsGet(requestParameters.officeId, requestParameters.preparerId, requestParameters.taxYear, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.stage, requestParameters.taxType, requestParameters.isClientSubmitted, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreparerDashboardApi - interface
 */
export interface PreparerDashboardApiInterface {
    /**
     * 
     * @param {PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardActivitiesGet(requestParameters?: PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecentActivityDtoListApiResponse>;

    /**
     * 
     * @param {PreparerDashboardApiApiPreparerDashboardClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardClientsGet(requestParameters?: PreparerDashboardApiApiPreparerDashboardClientsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecentClientDtoListApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardMetricsDtoApiResponse>;

    /**
     * 
     * @param {PreparerDashboardApiApiPreparerDashboardStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardStatsGet(requestParameters?: PreparerDashboardApiApiPreparerDashboardStatsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardStatsDtoApiResponse>;

}

/**
 * Request parameters for apiPreparerDashboardActivitiesGet operation in PreparerDashboardApi.
 */
export interface PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest {
    readonly limit?: number
}

/**
 * Request parameters for apiPreparerDashboardClientsGet operation in PreparerDashboardApi.
 */
export interface PreparerDashboardApiApiPreparerDashboardClientsGetRequest {
    readonly limit?: number
}

/**
 * Request parameters for apiPreparerDashboardStatsGet operation in PreparerDashboardApi.
 */
export interface PreparerDashboardApiApiPreparerDashboardStatsGetRequest {
    readonly officeId?: string

    readonly preparerId?: string

    readonly taxYear?: number

    readonly watchedClientsOnly?: boolean

    readonly assignedToMe?: boolean

    readonly stage?: BinderStage

    readonly taxType?: ClientType

    readonly isClientSubmitted?: boolean
}

/**
 * PreparerDashboardApi - object-oriented interface
 */
export class PreparerDashboardApi extends BaseAPI implements PreparerDashboardApiInterface {
    /**
     * 
     * @param {PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardActivitiesGet(requestParameters: PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardActivitiesGet(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PreparerDashboardApiApiPreparerDashboardClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardClientsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardClientsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardClientsGet(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardGet(options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardMetricsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PreparerDashboardApiApiPreparerDashboardStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardStatsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardStatsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardStatsGet(requestParameters.officeId, requestParameters.preparerId, requestParameters.taxYear, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.stage, requestParameters.taxType, requestParameters.isClientSubmitted, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionnaireApi - axios parameter creator
 */
export const QuestionnaireApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireAnswersGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdQuestionnaireAnswersGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/questionnaire/answers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompleteDelete: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdQuestionnaireCompleteDelete', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/questionnaire/complete`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {CompleteQuestionnaireRequest} [completeQuestionnaireRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompletePut: async (binderId: string, completeQuestionnaireRequest?: CompleteQuestionnaireRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdQuestionnaireCompletePut', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/questionnaire/complete`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeQuestionnaireRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnaireApi - functional programming interface
 */
export const QuestionnaireApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnaireApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdQuestionnaireAnswersGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdQuestionnaireAnswersGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireApi.apiTaxBindersBinderIdQuestionnaireAnswersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdQuestionnaireCompleteDelete(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdQuestionnaireCompleteDelete(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireApi.apiTaxBindersBinderIdQuestionnaireCompleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {CompleteQuestionnaireRequest} [completeQuestionnaireRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdQuestionnaireCompletePut(binderId: string, completeQuestionnaireRequest?: CompleteQuestionnaireRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdQuestionnaireCompletePut(binderId, completeQuestionnaireRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireApi.apiTaxBindersBinderIdQuestionnaireCompletePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionnaireApi - factory interface
 */
export const QuestionnaireApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnaireApiFp(configuration)
    return {
        /**
         * 
         * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters.binderId, requestParameters.completeQuestionnaireRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionnaireApi - interface
 */
export interface QuestionnaireApiInterface {
    /**
     * 
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBinderIdQuestionnaireAnswersGet operation in QuestionnaireApi.
 */
export interface QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdQuestionnaireCompleteDelete operation in QuestionnaireApi.
 */
export interface QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdQuestionnaireCompletePut operation in QuestionnaireApi.
 */
export interface QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest {
    readonly binderId: string

    readonly completeQuestionnaireRequest?: CompleteQuestionnaireRequest
}

/**
 * QuestionnaireApi - object-oriented interface
 */
export class QuestionnaireApi extends BaseAPI implements QuestionnaireApiInterface {
    /**
     * 
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters.binderId, requestParameters.completeQuestionnaireRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionnaireResponsesApi - axios parameter creator
 */
export const QuestionnaireResponsesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [binderId] 
         * @param {QuestionnaireStatus} [status] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesGet: async (page?: number, limit?: number, binderId?: string, status?: QuestionnaireStatus, fromDate?: string, toDate?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaire-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdDelete', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdGet', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuestionnaireResponseDto} [updateQuestionnaireResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdPut: async (id: string, updateQuestionnaireResponseDto?: UpdateQuestionnaireResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdPut', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionnaireResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdSubmitPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdSubmitPost', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuestionnaireResponseDto} [createQuestionnaireResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesPost: async (createQuestionnaireResponseDto?: CreateQuestionnaireResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaire-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionnaireResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnaireResponsesApi - functional programming interface
 */
export const QuestionnaireResponsesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnaireResponsesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [binderId] 
         * @param {QuestionnaireStatus} [status] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesGet(page?: number, limit?: number, binderId?: string, status?: QuestionnaireStatus, fromDate?: string, toDate?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesGet(page, limit, binderId, status, fromDate, toDate, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuestionnaireResponseDto} [updateQuestionnaireResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdPut(id: string, updateQuestionnaireResponseDto?: UpdateQuestionnaireResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdPut(id, updateQuestionnaireResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdSubmitPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdSubmitPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateQuestionnaireResponseDto} [createQuestionnaireResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesPost(createQuestionnaireResponseDto?: CreateQuestionnaireResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesPost(createQuestionnaireResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionnaireResponsesApi - factory interface
 */
export const QuestionnaireResponsesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnaireResponsesApiFp(configuration)
    return {
        /**
         * 
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoPaginatedResponseApiResponse> {
            return localVarFp.apiQuestionnaireResponsesGet(requestParameters.page, requestParameters.limit, requestParameters.binderId, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdDelete(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdPut(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdPut(requestParameters.id, requestParameters.updateQuestionnaireResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdSubmitPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdSubmitPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesPost(requestParameters.createQuestionnaireResponseDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionnaireResponsesApi - interface
 */
export interface QuestionnaireResponsesApiInterface {
    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesGet(requestParameters?: QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdDelete(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdPut(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdSubmitPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesPost(requestParameters?: QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

}

/**
 * Request parameters for apiQuestionnaireResponsesGet operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly binderId?: string

    readonly status?: QuestionnaireStatus

    readonly fromDate?: string

    readonly toDate?: string

    readonly sortBy?: string

    readonly sortOrder?: string
}

/**
 * Request parameters for apiQuestionnaireResponsesIdDelete operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiQuestionnaireResponsesIdGet operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiQuestionnaireResponsesIdPut operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest {
    readonly id: string

    readonly updateQuestionnaireResponseDto?: UpdateQuestionnaireResponseDto
}

/**
 * Request parameters for apiQuestionnaireResponsesIdSubmitPost operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiQuestionnaireResponsesPost operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest {
    readonly createQuestionnaireResponseDto?: CreateQuestionnaireResponseDto
}

/**
 * QuestionnaireResponsesApi - object-oriented interface
 */
export class QuestionnaireResponsesApi extends BaseAPI implements QuestionnaireResponsesApiInterface {
    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesGet(requestParameters.page, requestParameters.limit, requestParameters.binderId, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdDelete(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdPut(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdPut(requestParameters.id, requestParameters.updateQuestionnaireResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdSubmitPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdSubmitPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesPost(requestParameters.createQuestionnaireResponseDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionnairesApi - axios parameter creator
 */
export const QuestionnairesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} taxYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesActiveTaxYearGet: async (taxYear: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taxYear' is not null or undefined
            assertParamExists('apiQuestionnairesActiveTaxYearGet', 'taxYear', taxYear)
            const localVarPath = `/api/questionnaires/active/{taxYear}`
                .replace(`{${"taxYear"}}`, encodeURIComponent(String(taxYear)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [taxYear] 
         * @param {boolean} [isActive] 
         * @param {boolean} [isRequired] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesGet: async (taxYear?: number, isActive?: boolean, isRequired?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaires`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (isRequired !== undefined) {
                localVarQueryParameter['IsRequired'] = isRequired;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdDelete', 'id', id)
            const localVarPath = `/api/questionnaires/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdGet', 'id', id)
            const localVarPath = `/api/questionnaires/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPublishPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdPublishPost', 'id', id)
            const localVarPath = `/api/questionnaires/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuestionnaireDto} [updateQuestionnaireDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPut: async (id: string, updateQuestionnaireDto?: UpdateQuestionnaireDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdPut', 'id', id)
            const localVarPath = `/api/questionnaires/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionnaireDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdStatisticsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdStatisticsGet', 'id', id)
            const localVarPath = `/api/questionnaires/{id}/statistics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuestionnaireDto} [createQuestionnaireDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesPost: async (createQuestionnaireDto?: CreateQuestionnaireDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaires`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionnaireDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnairesApi - functional programming interface
 */
export const QuestionnairesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnairesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} taxYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesActiveTaxYearGet(taxYear: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesActiveTaxYearGet(taxYear, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesActiveTaxYearGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [taxYear] 
         * @param {boolean} [isActive] 
         * @param {boolean} [isRequired] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesGet(taxYear?: number, isActive?: boolean, isRequired?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesGet(taxYear, isActive, isRequired, search, sortBy, sortDirection, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdPublishPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdPublishPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdPublishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuestionnaireDto} [updateQuestionnaireDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdPut(id: string, updateQuestionnaireDto?: UpdateQuestionnaireDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdPut(id, updateQuestionnaireDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdStatisticsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringObjectDictionaryApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdStatisticsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdStatisticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateQuestionnaireDto} [createQuestionnaireDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesPost(createQuestionnaireDto?: CreateQuestionnaireDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesPost(createQuestionnaireDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionnairesApi - factory interface
 */
export const QuestionnairesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnairesApiFp(configuration)
    return {
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesActiveTaxYearGet(requestParameters: QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoListApiResponse> {
            return localVarFp.apiQuestionnairesActiveTaxYearGet(requestParameters.taxYear, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesGet(requestParameters: QuestionnairesApiApiQuestionnairesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoPaginatedResponseApiResponse> {
            return localVarFp.apiQuestionnairesGet(requestParameters.taxYear, requestParameters.isActive, requestParameters.isRequired, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdDelete(requestParameters: QuestionnairesApiApiQuestionnairesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiQuestionnairesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdGet(requestParameters: QuestionnairesApiApiQuestionnairesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesIdPublishPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPublishPost(requestParameters: QuestionnairesApiApiQuestionnairesIdPublishPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesIdPublishPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPut(requestParameters: QuestionnairesApiApiQuestionnairesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesIdPut(requestParameters.id, requestParameters.updateQuestionnaireDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdStatisticsGet(requestParameters: QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringObjectDictionaryApiResponse> {
            return localVarFp.apiQuestionnairesIdStatisticsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnairesApiApiQuestionnairesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesPost(requestParameters: QuestionnairesApiApiQuestionnairesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesPost(requestParameters.createQuestionnaireDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionnairesApi - interface
 */
export interface QuestionnairesApiInterface {
    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesActiveTaxYearGet(requestParameters: QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoListApiResponse>;

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesGet(requestParameters?: QuestionnairesApiApiQuestionnairesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdDelete(requestParameters: QuestionnairesApiApiQuestionnairesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdGet(requestParameters: QuestionnairesApiApiQuestionnairesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdPublishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdPublishPost(requestParameters: QuestionnairesApiApiQuestionnairesIdPublishPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdPut(requestParameters: QuestionnairesApiApiQuestionnairesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdStatisticsGet(requestParameters: QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringObjectDictionaryApiResponse>;

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesPost(requestParameters?: QuestionnairesApiApiQuestionnairesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

}

/**
 * Request parameters for apiQuestionnairesActiveTaxYearGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest {
    readonly taxYear: number
}

/**
 * Request parameters for apiQuestionnairesGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesGetRequest {
    readonly taxYear?: number

    readonly isActive?: boolean

    readonly isRequired?: boolean

    readonly search?: string

    readonly sortBy?: string

    readonly sortDirection?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiQuestionnairesIdDelete operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesIdGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesIdPublishPost operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdPublishPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesIdPut operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdPutRequest {
    readonly id: string

    readonly updateQuestionnaireDto?: UpdateQuestionnaireDto
}

/**
 * Request parameters for apiQuestionnairesIdStatisticsGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesPost operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesPostRequest {
    readonly createQuestionnaireDto?: CreateQuestionnaireDto
}

/**
 * QuestionnairesApi - object-oriented interface
 */
export class QuestionnairesApi extends BaseAPI implements QuestionnairesApiInterface {
    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesActiveTaxYearGet(requestParameters: QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesActiveTaxYearGet(requestParameters.taxYear, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesGet(requestParameters: QuestionnairesApiApiQuestionnairesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesGet(requestParameters.taxYear, requestParameters.isActive, requestParameters.isRequired, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdDelete(requestParameters: QuestionnairesApiApiQuestionnairesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdGet(requestParameters: QuestionnairesApiApiQuestionnairesIdGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdPublishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdPublishPost(requestParameters: QuestionnairesApiApiQuestionnairesIdPublishPostRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdPublishPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdPut(requestParameters: QuestionnairesApiApiQuestionnairesIdPutRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdPut(requestParameters.id, requestParameters.updateQuestionnaireDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdStatisticsGet(requestParameters: QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdStatisticsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionnairesApiApiQuestionnairesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesPost(requestParameters: QuestionnairesApiApiQuestionnairesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesPost(requestParameters.createQuestionnaireDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SignatureTemplatesApi - axios parameter creator
 */
export const SignatureTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateTemplateFromDocumentDto} [createTemplateFromDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesCreateFromDocumentPost: async (createTemplateFromDocumentDto?: CreateTemplateFromDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/create-from-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTemplateFromDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {string} [templateName] 
         * @param {DocumentType} [documentType] 
         * @param {boolean} [requiresSignature] 
         * @param {boolean} [isOneTimeUse] 
         * @param {boolean} [autoGenerateName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesCreateFromPdfPost: async (file?: File, templateName?: string, documentType?: DocumentType, requiresSignature?: boolean, isOneTimeUse?: boolean, autoGenerateName?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/create-from-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (templateName !== undefined) { 
                localVarFormParams.append('templateName', templateName as any);
            }

            if (documentType !== undefined) { 
                localVarFormParams.append('documentType', documentType as any);
            }

            if (requiresSignature !== undefined) { 
                localVarFormParams.append('requiresSignature', String(requiresSignature) as any);
            }

            if (isOneTimeUse !== undefined) { 
                localVarFormParams.append('isOneTimeUse', String(isOneTimeUse) as any);
            }

            if (autoGenerateName !== undefined) { 
                localVarFormParams.append('autoGenerateName', String(autoGenerateName) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDefaultDocumentTypeGet: async (documentType: DocumentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('apiSignaturesTemplatesDefaultDocumentTypeGet', 'documentType', documentType)
            const localVarPath = `/api/signatures/templates/default/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDocumentTypeDocumentTypeGet: async (documentType: DocumentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('apiSignaturesTemplatesDocumentTypeDocumentTypeGet', 'documentType', documentType)
            const localVarPath = `/api/signatures/templates/document-type/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFormBuilderSavePost: async (formBuilderSaveDto?: FormBuilderSaveDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/form-builder-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formBuilderSaveDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFromBuilderPost: async (formBuilderSaveDto?: FormBuilderSaveDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/from-builder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formBuilderSaveDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {DocumentType} [documentType] 
         * @param {boolean} [requiresSignature] 
         * @param {boolean} [isActive] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesGet: async (page?: number, limit?: number, sortBy?: string, sortOrder?: string, search?: string, documentType?: DocumentType, requiresSignature?: boolean, isActive?: boolean, createdAfter?: string, createdBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }

            if (requiresSignature !== undefined) {
                localVarQueryParameter['RequiresSignature'] = requiresSignature;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['CreatedAfter'] = (createdAfter as any instanceof Date) ?
                    (createdAfter as any).toISOString() :
                    createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['CreatedBefore'] = (createdBefore as any instanceof Date) ?
                    (createdBefore as any).toISOString() :
                    createdBefore;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderConfigGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdBuilderConfigGet', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/builder-config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {FormBuilderTokenRequestDto} [formBuilderTokenRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderTokenPost: async (id: string, formBuilderTokenRequestDto?: FormBuilderTokenRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdBuilderTokenPost', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/builder-token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formBuilderTokenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdDelete', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdGet', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdOneTimeCleanupDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdOneTimeCleanupDelete', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/one-time-cleanup`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PreviewRequestDto} [previewRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPreviewPost: async (id: string, previewRequestDto?: PreviewRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdPreviewPost', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSignatureTemplateDto} [updateSignatureTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPut: async (id: string, updateSignatureTemplateDto?: UpdateSignatureTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdPut', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSignatureTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSignatureTemplateDto} [createSignatureTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesPost: async (createSignatureTemplateDto?: CreateSignatureTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [previewMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSigningFormConfigGet: async (previewMode?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/signing-form-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (previewMode !== undefined) {
                localVarQueryParameter['previewMode'] = previewMode;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSigningFormRequestDto} [createSigningFormRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSigningFormPost: async (createSigningFormRequestDto?: CreateSigningFormRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/signing-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSigningFormRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSimpleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/simple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignatureTemplatesApi - functional programming interface
 */
export const SignatureTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignatureTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateTemplateFromDocumentDto} [createTemplateFromDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesCreateFromDocumentPost(createTemplateFromDocumentDto?: CreateTemplateFromDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesCreateFromDocumentPost(createTemplateFromDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesCreateFromDocumentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {string} [templateName] 
         * @param {DocumentType} [documentType] 
         * @param {boolean} [requiresSignature] 
         * @param {boolean} [isOneTimeUse] 
         * @param {boolean} [autoGenerateName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesCreateFromPdfPost(file?: File, templateName?: string, documentType?: DocumentType, requiresSignature?: boolean, isOneTimeUse?: boolean, autoGenerateName?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesCreateFromPdfPost(file, templateName, documentType, requiresSignature, isOneTimeUse, autoGenerateName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesCreateFromPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesDefaultDocumentTypeGet(documentType: DocumentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesDefaultDocumentTypeGet(documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesDefaultDocumentTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesDocumentTypeDocumentTypeGet(documentType: DocumentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesDocumentTypeDocumentTypeGet(documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesDocumentTypeDocumentTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesFormBuilderSavePost(formBuilderSaveDto?: FormBuilderSaveDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesFormBuilderSavePost(formBuilderSaveDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesFormBuilderSavePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesFromBuilderPost(formBuilderSaveDto?: FormBuilderSaveDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesFromBuilderPost(formBuilderSaveDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesFromBuilderPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {DocumentType} [documentType] 
         * @param {boolean} [requiresSignature] 
         * @param {boolean} [isActive] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesGet(page?: number, limit?: number, sortBy?: string, sortOrder?: string, search?: string, documentType?: DocumentType, requiresSignature?: boolean, isActive?: boolean, createdAfter?: string, createdBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesGet(page, limit, sortBy, sortOrder, search, documentType, requiresSignature, isActive, createdAfter, createdBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdBuilderConfigGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormBuilderConfigDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdBuilderConfigGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdBuilderConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {FormBuilderTokenRequestDto} [formBuilderTokenRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdBuilderTokenPost(id: string, formBuilderTokenRequestDto?: FormBuilderTokenRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdBuilderTokenPost(id, formBuilderTokenRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdBuilderTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdOneTimeCleanupDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdOneTimeCleanupDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdOneTimeCleanupDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {PreviewRequestDto} [previewRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdPreviewPost(id: string, previewRequestDto?: PreviewRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdPreviewPost(id, previewRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSignatureTemplateDto} [updateSignatureTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdPut(id: string, updateSignatureTemplateDto?: UpdateSignatureTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdPut(id, updateSignatureTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSignatureTemplateDto} [createSignatureTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesPost(createSignatureTemplateDto?: CreateSignatureTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesPost(createSignatureTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [previewMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesSigningFormConfigGet(previewMode?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigningFormConfigDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesSigningFormConfigGet(previewMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesSigningFormConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSigningFormRequestDto} [createSigningFormRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesSigningFormPost(createSigningFormRequestDto?: CreateSigningFormRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigningFormResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesSigningFormPost(createSigningFormRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesSigningFormPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesSimpleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesSimpleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SignatureTemplatesApi - factory interface
 */
export const SignatureTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignatureTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesCreateFromDocumentPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesCreateFromDocumentPost(requestParameters.createTemplateFromDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesCreateFromPdfPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesCreateFromPdfPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesCreateFromPdfPost(requestParameters.file, requestParameters.templateName, requestParameters.documentType, requestParameters.requiresSignature, requestParameters.isOneTimeUse, requestParameters.autoGenerateName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFormBuilderSavePost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesFormBuilderSavePost(requestParameters.formBuilderSaveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFromBuilderPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesFromBuilderPost(requestParameters.formBuilderSaveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoPaginatedResponseApiResponse> {
            return localVarFp.apiSignaturesTemplatesGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.documentType, requestParameters.requiresSignature, requestParameters.isActive, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormBuilderConfigDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdBuilderConfigGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderTokenPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdBuilderTokenPost(requestParameters.id, requestParameters.formBuilderTokenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPreviewPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSignaturesTemplatesIdPreviewPost(requestParameters.id, requestParameters.previewRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPut(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdPut(requestParameters.id, requestParameters.updateSignatureTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesPost(requestParameters.createSignatureTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSigningFormConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SigningFormConfigDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesSigningFormConfigGet(requestParameters.previewMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSigningFormPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesSigningFormPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SigningFormResponseDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesSigningFormPost(requestParameters.createSigningFormRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoListApiResponse> {
            return localVarFp.apiSignaturesTemplatesSimpleGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignatureTemplatesApi - interface
 */
export interface SignatureTemplatesApiInterface {
    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesCreateFromDocumentPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesCreateFromPdfPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesCreateFromPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesFormBuilderSavePost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesFromBuilderPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesGet(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdBuilderConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormBuilderConfigDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdBuilderTokenPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdPreviewPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdPut(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesSigningFormConfigGet(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigningFormConfigDtoApiResponse>;

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesSigningFormPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesSigningFormPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigningFormResponseDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoListApiResponse>;

}

/**
 * Request parameters for apiSignaturesTemplatesCreateFromDocumentPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest {
    readonly createTemplateFromDocumentDto?: CreateTemplateFromDocumentDto
}

/**
 * Request parameters for apiSignaturesTemplatesCreateFromPdfPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesCreateFromPdfPostRequest {
    readonly file?: File

    readonly templateName?: string

    readonly documentType?: DocumentType

    readonly requiresSignature?: boolean

    readonly isOneTimeUse?: boolean

    readonly autoGenerateName?: boolean
}

/**
 * Request parameters for apiSignaturesTemplatesDefaultDocumentTypeGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest {
    readonly documentType: DocumentType
}

/**
 * Request parameters for apiSignaturesTemplatesDocumentTypeDocumentTypeGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest {
    readonly documentType: DocumentType
}

/**
 * Request parameters for apiSignaturesTemplatesFormBuilderSavePost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest {
    readonly formBuilderSaveDto?: FormBuilderSaveDto
}

/**
 * Request parameters for apiSignaturesTemplatesFromBuilderPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest {
    readonly formBuilderSaveDto?: FormBuilderSaveDto
}

/**
 * Request parameters for apiSignaturesTemplatesGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly search?: string

    readonly documentType?: DocumentType

    readonly requiresSignature?: boolean

    readonly isActive?: boolean

    readonly createdAfter?: string

    readonly createdBefore?: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdBuilderConfigGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdBuilderTokenPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest {
    readonly id: string

    readonly formBuilderTokenRequestDto?: FormBuilderTokenRequestDto
}

/**
 * Request parameters for apiSignaturesTemplatesIdDelete operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdOneTimeCleanupDelete operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdPreviewPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest {
    readonly id: string

    readonly previewRequestDto?: PreviewRequestDto
}

/**
 * Request parameters for apiSignaturesTemplatesIdPut operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest {
    readonly id: string

    readonly updateSignatureTemplateDto?: UpdateSignatureTemplateDto
}

/**
 * Request parameters for apiSignaturesTemplatesPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesPostRequest {
    readonly createSignatureTemplateDto?: CreateSignatureTemplateDto
}

/**
 * Request parameters for apiSignaturesTemplatesSigningFormConfigGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest {
    readonly previewMode?: boolean
}

/**
 * Request parameters for apiSignaturesTemplatesSigningFormPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesSigningFormPostRequest {
    readonly createSigningFormRequestDto?: CreateSigningFormRequestDto
}

/**
 * SignatureTemplatesApi - object-oriented interface
 */
export class SignatureTemplatesApi extends BaseAPI implements SignatureTemplatesApiInterface {
    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesCreateFromDocumentPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesCreateFromDocumentPost(requestParameters.createTemplateFromDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesCreateFromPdfPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesCreateFromPdfPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesCreateFromPdfPost(requestParameters.file, requestParameters.templateName, requestParameters.documentType, requestParameters.requiresSignature, requestParameters.isOneTimeUse, requestParameters.autoGenerateName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesFormBuilderSavePost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesFormBuilderSavePost(requestParameters.formBuilderSaveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesFromBuilderPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesFromBuilderPost(requestParameters.formBuilderSaveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.documentType, requestParameters.requiresSignature, requestParameters.isActive, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdBuilderConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdBuilderConfigGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdBuilderTokenPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdBuilderTokenPost(requestParameters.id, requestParameters.formBuilderTokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdPreviewPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdPreviewPost(requestParameters.id, requestParameters.previewRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdPut(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdPut(requestParameters.id, requestParameters.updateSignatureTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesPost(requestParameters.createSignatureTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesSigningFormConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesSigningFormConfigGet(requestParameters.previewMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesSigningFormPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesSigningFormPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesSigningFormPost(requestParameters.createSigningFormRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesSimpleGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SignaturesApi - axios parameter creator
 */
export const SignaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRefreshStatusPost: async (submissionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRefreshStatusPost', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/refresh-status`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {SendBulkReminderDto} [sendBulkReminderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersBulkPost: async (submissionId: string, sendBulkReminderDto?: SendBulkReminderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRemindersBulkPost', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/reminders/bulk`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendBulkReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {string} signerId 
         * @param {SendSignerReminderDto} [sendSignerReminderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersSignerIdPost: async (submissionId: string, signerId: string, sendSignerReminderDto?: SendSignerReminderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRemindersSignerIdPost', 'submissionId', submissionId)
            // verify required parameter 'signerId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRemindersSignerIdPost', 'signerId', signerId)
            const localVarPath = `/api/Signatures/{submissionId}/reminders/{signerId}`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)))
                .replace(`{${"signerId"}}`, encodeURIComponent(String(signerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSignerReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {AddSignerRequestDto} [addSignerRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersPost: async (submissionId: string, addSignerRequestDto?: AddSignerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdSignersPost', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/signers`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSignerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {string} signerId 
         * @param {ReplaceSignerDto} [replaceSignerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersSignerIdReplacePut: async (submissionId: string, signerId: string, replaceSignerDto?: ReplaceSignerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdSignersSignerIdReplacePut', 'submissionId', submissionId)
            // verify required parameter 'signerId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdSignersSignerIdReplacePut', 'signerId', signerId)
            const localVarPath = `/api/Signatures/{submissionId}/signers/{signerId}/replace`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)))
                .replace(`{${"signerId"}}`, encodeURIComponent(String(signerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceSignerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdStatusGet: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdStatusGet', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/status`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocuSealWebhookDto} [docuSealWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesWebhookPost: async (docuSealWebhookDto?: DocuSealWebhookDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Signatures/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(docuSealWebhookDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignaturesApi - functional programming interface
 */
export const SignaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdRefreshStatusPost(submissionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdRefreshStatusPost(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdRefreshStatusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {SendBulkReminderDto} [sendBulkReminderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdRemindersBulkPost(submissionId: string, sendBulkReminderDto?: SendBulkReminderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendBulkReminderResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdRemindersBulkPost(submissionId, sendBulkReminderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdRemindersBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {string} signerId 
         * @param {SendSignerReminderDto} [sendSignerReminderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdRemindersSignerIdPost(submissionId: string, signerId: string, sendSignerReminderDto?: SendSignerReminderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendReminderResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdRemindersSignerIdPost(submissionId, signerId, sendSignerReminderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdRemindersSignerIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {AddSignerRequestDto} [addSignerRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdSignersPost(submissionId: string, addSignerRequestDto?: AddSignerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddSignerResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdSignersPost(submissionId, addSignerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdSignersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {string} signerId 
         * @param {ReplaceSignerDto} [replaceSignerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdSignersSignerIdReplacePut(submissionId: string, signerId: string, replaceSignerDto?: ReplaceSignerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplaceSignerResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdSignersSignerIdReplacePut(submissionId, signerId, replaceSignerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdSignersSignerIdReplacePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdStatusGet(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdStatusGet(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DocuSealWebhookDto} [docuSealWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesWebhookPost(docuSealWebhookDto?: DocuSealWebhookDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesWebhookPost(docuSealWebhookDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesWebhookPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SignaturesApi - factory interface
 */
export const SignaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignaturesApiFp(configuration)
    return {
        /**
         * 
         * @param {SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRefreshStatusPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureStatusDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdRefreshStatusPost(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersBulkPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendBulkReminderResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdRemindersBulkPost(requestParameters.submissionId, requestParameters.sendBulkReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendReminderResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters.submissionId, requestParameters.signerId, requestParameters.sendSignerReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignaturesApiApiSignaturesSubmissionIdSignersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddSignerResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdSignersPost(requestParameters.submissionId, requestParameters.addSignerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceSignerResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters.submissionId, requestParameters.signerId, requestParameters.replaceSignerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignaturesApiApiSignaturesSubmissionIdStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdStatusGet(requestParameters: SignaturesApiApiSignaturesSubmissionIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdStatusGet(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignaturesApiApiSignaturesWebhookPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesWebhookPost(requestParameters: SignaturesApiApiSignaturesWebhookPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiSignaturesWebhookPost(requestParameters.docuSealWebhookDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignaturesApi - interface
 */
export interface SignaturesApiInterface {
    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdRefreshStatusPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureStatusDtoApiResponse>;

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdRemindersBulkPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendBulkReminderResponseDtoApiResponse>;

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendReminderResponseDtoApiResponse>;

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdSignersPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddSignerResponseDtoApiResponse>;

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceSignerResponseDtoApiResponse>;

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdStatusGet(requestParameters: SignaturesApiApiSignaturesSubmissionIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {SignaturesApiApiSignaturesWebhookPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesWebhookPost(requestParameters?: SignaturesApiApiSignaturesWebhookPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

}

/**
 * Request parameters for apiSignaturesSubmissionIdRefreshStatusPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest {
    readonly submissionId: number
}

/**
 * Request parameters for apiSignaturesSubmissionIdRemindersBulkPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest {
    readonly submissionId: string

    readonly sendBulkReminderDto?: SendBulkReminderDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdRemindersSignerIdPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest {
    readonly submissionId: string

    readonly signerId: string

    readonly sendSignerReminderDto?: SendSignerReminderDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdSignersPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdSignersPostRequest {
    readonly submissionId: string

    readonly addSignerRequestDto?: AddSignerRequestDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdSignersSignerIdReplacePut operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest {
    readonly submissionId: string

    readonly signerId: string

    readonly replaceSignerDto?: ReplaceSignerDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdStatusGet operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdStatusGetRequest {
    readonly submissionId: string
}

/**
 * Request parameters for apiSignaturesWebhookPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesWebhookPostRequest {
    readonly docuSealWebhookDto?: DocuSealWebhookDto
}

/**
 * SignaturesApi - object-oriented interface
 */
export class SignaturesApi extends BaseAPI implements SignaturesApiInterface {
    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdRefreshStatusPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdRefreshStatusPost(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdRemindersBulkPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdRemindersBulkPost(requestParameters.submissionId, requestParameters.sendBulkReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters.submissionId, requestParameters.signerId, requestParameters.sendSignerReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdSignersPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdSignersPost(requestParameters.submissionId, requestParameters.addSignerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters.submissionId, requestParameters.signerId, requestParameters.replaceSignerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignaturesApiApiSignaturesSubmissionIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdStatusGet(requestParameters: SignaturesApiApiSignaturesSubmissionIdStatusGetRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdStatusGet(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignaturesApiApiSignaturesWebhookPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesWebhookPost(requestParameters: SignaturesApiApiSignaturesWebhookPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesWebhookPost(requestParameters.docuSealWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StructuredAuditsApi - axios parameter creator
 */
export const StructuredAuditsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsEntityEntityTypeEntityIdGet: async (entityType: string, entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('apiStructuredAuditsEntityEntityTypeEntityIdGet', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiStructuredAuditsEntityEntityTypeEntityIdGet', 'entityId', entityId)
            const localVarPath = `/api/StructuredAudits/entity/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [entityType] 
         * @param {string} [entityId] 
         * @param {string} [parentEntityType] 
         * @param {string} [parentEntityId] 
         * @param {string} [userId] 
         * @param {string} [action] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsGet: async (entityType?: string, entityId?: string, parentEntityType?: string, parentEntityId?: string, userId?: string, action?: string, fromDate?: string, toDate?: string, search?: string, page?: number, pageSize?: number, sortBy?: string, sortDirection?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StructuredAudits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }

            if (parentEntityType !== undefined) {
                localVarQueryParameter['ParentEntityType'] = parentEntityType;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['ParentEntityId'] = parentEntityId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['UserId'] = userId;
            }

            if (action !== undefined) {
                localVarQueryParameter['Action'] = action;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStructuredAuditsIdGet', 'id', id)
            const localVarPath = `/api/StructuredAudits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} parentEntityType 
         * @param {string} parentEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsParentParentEntityTypeParentEntityIdGet: async (parentEntityType: string, parentEntityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentEntityType' is not null or undefined
            assertParamExists('apiStructuredAuditsParentParentEntityTypeParentEntityIdGet', 'parentEntityType', parentEntityType)
            // verify required parameter 'parentEntityId' is not null or undefined
            assertParamExists('apiStructuredAuditsParentParentEntityTypeParentEntityIdGet', 'parentEntityId', parentEntityId)
            const localVarPath = `/api/StructuredAudits/parent/{parentEntityType}/{parentEntityId}`
                .replace(`{${"parentEntityType"}}`, encodeURIComponent(String(parentEntityType)))
                .replace(`{${"parentEntityId"}}`, encodeURIComponent(String(parentEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StructuredAuditsApi - functional programming interface
 */
export const StructuredAuditsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StructuredAuditsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsEntityEntityTypeEntityIdGet(entityType: string, entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAuditTrailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsEntityEntityTypeEntityIdGet(entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsEntityEntityTypeEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [entityType] 
         * @param {string} [entityId] 
         * @param {string} [parentEntityType] 
         * @param {string} [parentEntityId] 
         * @param {string} [userId] 
         * @param {string} [action] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsGet(entityType?: string, entityId?: string, parentEntityType?: string, parentEntityId?: string, userId?: string, action?: string, fromDate?: string, toDate?: string, search?: string, page?: number, pageSize?: number, sortBy?: string, sortDirection?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructuredAuditDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsGet(entityType, entityId, parentEntityType, parentEntityId, userId, action, fromDate, toDate, search, page, pageSize, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructuredAuditDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} parentEntityType 
         * @param {string} parentEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(parentEntityType: string, parentEntityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructuredAuditDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(parentEntityType, parentEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsParentParentEntityTypeParentEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StructuredAuditsApi - factory interface
 */
export const StructuredAuditsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StructuredAuditsApiFp(configuration)
    return {
        /**
         * 
         * @param {StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityAuditTrailDtoApiResponse> {
            return localVarFp.apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StructuredAuditsApiApiStructuredAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsGet(requestParameters: StructuredAuditsApiApiStructuredAuditsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoPaginatedResponseApiResponse> {
            return localVarFp.apiStructuredAuditsGet(requestParameters.entityType, requestParameters.entityId, requestParameters.parentEntityType, requestParameters.parentEntityId, requestParameters.userId, requestParameters.action, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StructuredAuditsApiApiStructuredAuditsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoApiResponse> {
            return localVarFp.apiStructuredAuditsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoListApiResponse> {
            return localVarFp.apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters.parentEntityType, requestParameters.parentEntityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StructuredAuditsApi - interface
 */
export interface StructuredAuditsApiInterface {
    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityAuditTrailDtoApiResponse>;

    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsGet(requestParameters?: StructuredAuditsApiApiStructuredAuditsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoApiResponse>;

    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoListApiResponse>;

}

/**
 * Request parameters for apiStructuredAuditsEntityEntityTypeEntityIdGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest {
    readonly entityType: string

    readonly entityId: string
}

/**
 * Request parameters for apiStructuredAuditsGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsGetRequest {
    readonly entityType?: string

    readonly entityId?: string

    readonly parentEntityType?: string

    readonly parentEntityId?: string

    readonly userId?: string

    readonly action?: string

    readonly fromDate?: string

    readonly toDate?: string

    readonly search?: string

    readonly page?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortDirection?: string
}

/**
 * Request parameters for apiStructuredAuditsIdGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsIdGetRequest {
    readonly id: number
}

/**
 * Request parameters for apiStructuredAuditsParentParentEntityTypeParentEntityIdGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest {
    readonly parentEntityType: string

    readonly parentEntityId: string
}

/**
 * StructuredAuditsApi - object-oriented interface
 */
export class StructuredAuditsApi extends BaseAPI implements StructuredAuditsApiInterface {
    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsGet(requestParameters: StructuredAuditsApiApiStructuredAuditsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsGet(requestParameters.entityType, requestParameters.entityId, requestParameters.parentEntityType, requestParameters.parentEntityId, requestParameters.userId, requestParameters.action, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsIdGetRequest, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters.parentEntityType, requestParameters.parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaxBindersApi - axios parameter creator
 */
export const TaxBindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdResultsGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiTaxBindersBatchUploadJobIdResultsGet', 'jobId', jobId)
            const localVarPath = `/api/tax-binders/batch-upload/{jobId}/results`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdStatusGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiTaxBindersBatchUploadJobIdStatusGet', 'jobId', jobId)
            const localVarPath = `/api/tax-binders/batch-upload/{jobId}/status`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {boolean} [extractEngagementLetter] 
         * @param {string} [clientOperationId] 
         * @param {File} [organizerPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdAnalyzeOrganizerPost: async (binderId: string, extractEngagementLetter?: boolean, clientOperationId?: string, organizerPdf?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdAnalyzeOrganizerPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/analyze-organizer`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (extractEngagementLetter !== undefined) {
                localVarQueryParameter['extractEngagementLetter'] = extractEngagementLetter;
            }

            if (clientOperationId !== undefined) {
                localVarQueryParameter['clientOperationId'] = clientOperationId;
            }


            if (organizerPdf !== undefined) { 
                localVarFormParams.append('organizerPdf', organizerPdf as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {ArchiveTaxBinderRequest} [archiveTaxBinderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdArchivePatch: async (binderId: string, archiveTaxBinderRequest?: ArchiveTaxBinderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdArchivePatch', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/archive`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveTaxBinderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {boolean} [runAiDetection] 
         * @param {number} [confidenceThreshold] 
         * @param {boolean} [createSeparateDocuments] 
         * @param {boolean} [extractDocumentData] 
         * @param {boolean} [groupMultiPageForms] 
         * @param {DocumentDirection} [direction] 
         * @param {string} [selectedPageNumbers] 
         * @param {boolean} [autoSplitPages] 
         * @param {number} [autoSplitConfidenceThreshold] 
         * @param {boolean} [generateAiDescriptionsForAutoSplit] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdDocumentsBatchUploadPost: async (binderId: string, runAiDetection?: boolean, confidenceThreshold?: number, createSeparateDocuments?: boolean, extractDocumentData?: boolean, groupMultiPageForms?: boolean, direction?: DocumentDirection, selectedPageNumbers?: string, autoSplitPages?: boolean, autoSplitConfidenceThreshold?: number, generateAiDescriptionsForAutoSplit?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdDocumentsBatchUploadPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/documents/batch-upload`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runAiDetection !== undefined) {
                localVarQueryParameter['runAiDetection'] = runAiDetection;
            }

            if (confidenceThreshold !== undefined) {
                localVarQueryParameter['confidenceThreshold'] = confidenceThreshold;
            }

            if (createSeparateDocuments !== undefined) {
                localVarQueryParameter['createSeparateDocuments'] = createSeparateDocuments;
            }

            if (extractDocumentData !== undefined) {
                localVarQueryParameter['extractDocumentData'] = extractDocumentData;
            }

            if (groupMultiPageForms !== undefined) {
                localVarQueryParameter['groupMultiPageForms'] = groupMultiPageForms;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (selectedPageNumbers !== undefined) {
                localVarQueryParameter['selectedPageNumbers'] = selectedPageNumbers;
            }

            if (autoSplitPages !== undefined) {
                localVarQueryParameter['autoSplitPages'] = autoSplitPages;
            }

            if (autoSplitConfidenceThreshold !== undefined) {
                localVarQueryParameter['autoSplitConfidenceThreshold'] = autoSplitConfidenceThreshold;
            }

            if (generateAiDescriptionsForAutoSplit !== undefined) {
                localVarQueryParameter['generateAiDescriptionsForAutoSplit'] = generateAiDescriptionsForAutoSplit;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdEstimatedPaymentsGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdEstimatedPaymentsGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/estimated-payments`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} documentId 
         * @param {UpdatePreprocessedDocumentDto} [updatePreprocessedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingDocumentsDocumentIdPut: async (binderId: string, documentId: string, updatePreprocessedDocumentDto?: UpdatePreprocessedDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingDocumentsDocumentIdPut', 'binderId', binderId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingDocumentsDocumentIdPut', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{binderId}/staging/documents/{documentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePreprocessedDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {FinalizeStagingDto} [finalizeStagingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingFinalizePost: async (binderId: string, finalizeStagingDto?: FinalizeStagingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingFinalizePost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/staging/finalize`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalizeStagingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/staging`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerificationStatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdVerificationStatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/verification-status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {VerifySpouseInfoDto} [verifySpouseInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerifySpouseInfoPost: async (binderId: string, verifySpouseInfoDto?: VerifySpouseInfoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdVerifySpouseInfoPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/verify-spouse-info`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifySpouseInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [taxYear] 
         * @param {string} [clientId] 
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {string} [partnerId] 
         * @param {ClientType} [taxType] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {string} [search] 
         * @param {string} [priority] 
         * @param {boolean} [isOverdue] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [isClientSubmitted] 
         * @param {boolean} [hasUnreviewedDocuments] 
         * @param {boolean} [hasUnreviewedComments] 
         * @param {boolean} [hasLateDocuments] 
         * @param {boolean} [assignedToMe] 
         * @param {BinderStage} [stage] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersGet: async (taxYear?: number, clientId?: string, preparerId?: string, officeId?: string, partnerId?: string, taxType?: ClientType, dueDateFrom?: string, dueDateTo?: string, search?: string, priority?: string, isOverdue?: boolean, watchedClientsOnly?: boolean, isClientSubmitted?: boolean, hasUnreviewedDocuments?: boolean, hasUnreviewedComments?: boolean, hasLateDocuments?: boolean, assignedToMe?: boolean, stage?: BinderStage, page?: number, limit?: number, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tax-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['PartnerId'] = partnerId;
            }

            if (taxType !== undefined) {
                localVarQueryParameter['TaxType'] = taxType;
            }

            if (dueDateFrom !== undefined) {
                localVarQueryParameter['DueDateFrom'] = (dueDateFrom as any instanceof Date) ?
                    (dueDateFrom as any).toISOString() :
                    dueDateFrom;
            }

            if (dueDateTo !== undefined) {
                localVarQueryParameter['DueDateTo'] = (dueDateTo as any instanceof Date) ?
                    (dueDateTo as any).toISOString() :
                    dueDateTo;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (priority !== undefined) {
                localVarQueryParameter['Priority'] = priority;
            }

            if (isOverdue !== undefined) {
                localVarQueryParameter['IsOverdue'] = isOverdue;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (isClientSubmitted !== undefined) {
                localVarQueryParameter['IsClientSubmitted'] = isClientSubmitted;
            }

            if (hasUnreviewedDocuments !== undefined) {
                localVarQueryParameter['HasUnreviewedDocuments'] = hasUnreviewedDocuments;
            }

            if (hasUnreviewedComments !== undefined) {
                localVarQueryParameter['HasUnreviewedComments'] = hasUnreviewedComments;
            }

            if (hasLateDocuments !== undefined) {
                localVarQueryParameter['HasLateDocuments'] = hasLateDocuments;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (stage !== undefined) {
                localVarQueryParameter['Stage'] = stage;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdAuditHistoryGet: async (id: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdAuditHistoryGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/audit-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [className] 
         * @param {string} [subClassName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsGet: async (id: string, className?: string, subClassName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdCchDocumentsGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/cch-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (className !== undefined) {
                localVarQueryParameter['className'] = className;
            }

            if (subClassName !== undefined) {
                localVarQueryParameter['subClassName'] = subClassName;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CchDocumentImportRequest} [cchDocumentImportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsImportPost: async (id: string, cchDocumentImportRequest?: CchDocumentImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdCchDocumentsImportPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/cch-documents/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cchDocumentImportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdClearLateDocumentsPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdClearLateDocumentsPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/clear-late-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdDelete', 'id', id)
            const localVarPath = `/api/tax-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {boolean} [confirmReset] 
         * @param {boolean} [sendNotification] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDocumentsDocumentIdReplacePost: async (id: string, documentId: string, confirmReset?: boolean, sendNotification?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdDocumentsDocumentIdReplacePost', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersIdDocumentsDocumentIdReplacePost', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{id}/documents/{documentId}/replace`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (confirmReset !== undefined) {
                localVarQueryParameter['confirmReset'] = confirmReset;
            }

            if (sendNotification !== undefined) {
                localVarQueryParameter['sendNotification'] = sendNotification;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDownloadSignedGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdDownloadSignedGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/download-signed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignatureAuditGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdESignatureAuditGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/e-signature-audit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignaturesGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdESignaturesGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/e-signatures`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {File} file 
         * @param {boolean} [replaceExisting] 
         * @param {string} [clientName] 
         * @param {string} [clientEmail] 
         * @param {string} [spouseName] 
         * @param {string} [spouseEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterAttachPost: async (id: string, file: File, replaceExisting?: boolean, clientName?: string, clientEmail?: string, spouseName?: string, spouseEmail?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterAttachPost', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterAttachPost', 'file', file)
            const localVarPath = `/api/tax-binders/{id}/engagement-letter/attach`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (replaceExisting !== undefined) { 
                localVarFormParams.append('ReplaceExisting', String(replaceExisting) as any);
            }

            if (clientName !== undefined) { 
                localVarFormParams.append('ClientName', clientName as any);
            }

            if (clientEmail !== undefined) { 
                localVarFormParams.append('ClientEmail', clientEmail as any);
            }

            if (spouseName !== undefined) { 
                localVarFormParams.append('SpouseName', spouseName as any);
            }

            if (spouseEmail !== undefined) { 
                localVarFormParams.append('SpouseEmail', spouseEmail as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterPrepareSignaturePost: async (id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterPrepareSignaturePost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/engagement-letter/prepare-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleDocumentSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {File} file 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterUploadSignedPost: async (id: string, file: File, comment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterUploadSignedPost', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterUploadSignedPost', 'file', file)
            const localVarPath = `/api/tax-binders/{id}/engagement-letter/upload-signed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaxBinderPackageExportDto} [taxBinderPackageExportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPackagePost: async (id: string, taxBinderPackageExportDto?: TaxBinderPackageExportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportPackagePost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export-package`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taxBinderPackageExportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPreviewPost: async (id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportPreviewPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taxBinderExportSelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportSelectedPost: async (id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportSelectedPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export/selected`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taxBinderExportSelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PrepareForSignatureDto} [prepareForSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPrepareForSignaturePost: async (id: string, prepareForSignatureDto?: PrepareForSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdPrepareForSignaturePost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/prepare-for-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prepareForSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaxBinderDto} [updateTaxBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPut: async (id: string, updateTaxBinderDto?: UpdateTaxBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdPut', 'id', id)
            const localVarPath = `/api/tax-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaxBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RecallReturnDto} [recallReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRecallReturnPost: async (id: string, recallReturnDto?: RecallReturnDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdRecallReturnPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/recall-return`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recallReturnDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseStatusGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdReleaseStatusGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/release-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ReleaseToClientDto} [releaseToClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseToClientPost: async (id: string, releaseToClientDto?: ReleaseToClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdReleaseToClientPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/release-to-client`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseToClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RequestChangesDto} [requestChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRequestChangesPost: async (id: string, requestChangesDto?: RequestChangesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdRequestChangesPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/request-changes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdResendWelcomeEmailPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdResendWelcomeEmailPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/resend-welcome-email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SendBackToClientDto} [sendBackToClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSendBackPost: async (id: string, sendBackToClientDto?: SendBackToClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSendBackPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/send-back`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendBackToClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet: async (id: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{id}/signature-documents/{documentId}/signing-session`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsEligibleSignersGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsEligibleSignersGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-documents/eligible-signers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsPost: async (id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureStatusGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureStatusGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaxBinderStageDto} [updateTaxBinderStageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdStagePatch: async (id: string, updateTaxBinderStageDto?: UpdateTaxBinderStageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdStagePatch', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/stage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaxBinderStageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitTaxBinderRequest} [submitTaxBinderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSubmitPost: async (id: string, submitTaxBinderRequest?: SubmitTaxBinderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSubmitPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitTaxBinderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdWithdrawSubmissionPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdWithdrawSubmissionPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/withdraw-submission`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {number} taxYear 
         * @param {string} clientId 
         * @param {string} [preparerId] 
         * @param {string} [dueDate] 
         * @param {number} [notificationDaysPrior] 
         * @param {string} [invoiceLink] 
         * @param {File} [organizerPdf] 
         * @param {File} [engagementLetterPdf] 
         * @param {boolean} [extractEngagementLetter] 
         * @param {boolean} [sendWelcomeEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersPost: async (name: string, taxYear: number, clientId: string, preparerId?: string, dueDate?: string, notificationDaysPrior?: number, invoiceLink?: string, organizerPdf?: File, engagementLetterPdf?: File, extractEngagementLetter?: boolean, sendWelcomeEmail?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiTaxBindersPost', 'name', name)
            // verify required parameter 'taxYear' is not null or undefined
            assertParamExists('apiTaxBindersPost', 'taxYear', taxYear)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiTaxBindersPost', 'clientId', clientId)
            const localVarPath = `/api/tax-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }

            if (taxYear !== undefined) { 
                localVarFormParams.append('TaxYear', taxYear as any);
            }

            if (clientId !== undefined) { 
                localVarFormParams.append('ClientId', clientId as any);
            }

            if (preparerId !== undefined) { 
                localVarFormParams.append('PreparerId', preparerId as any);
            }

            if (dueDate !== undefined) { 
                localVarFormParams.append('DueDate', dueDate as any);
            }

            if (notificationDaysPrior !== undefined) { 
                localVarFormParams.append('NotificationDaysPrior', notificationDaysPrior as any);
            }

            if (invoiceLink !== undefined) { 
                localVarFormParams.append('InvoiceLink', invoiceLink as any);
            }

            if (organizerPdf !== undefined) { 
                localVarFormParams.append('OrganizerPdf', organizerPdf as any);
            }

            if (engagementLetterPdf !== undefined) { 
                localVarFormParams.append('EngagementLetterPdf', engagementLetterPdf as any);
            }

            if (extractEngagementLetter !== undefined) { 
                localVarFormParams.append('ExtractEngagementLetter', String(extractEngagementLetter) as any);
            }

            if (sendWelcomeEmail !== undefined) { 
                localVarFormParams.append('SendWelcomeEmail', String(sendWelcomeEmail) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersTaxTypeOptionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tax-binders/tax-type-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {number} taxYear 
         * @param {string} name 
         * @param {File} clientCopyPdf 
         * @param {File} governmentCopyPdf 
         * @param {string} [dueDate] 
         * @param {string} [invoiceLink] 
         * @param {File} [k1Pdf] 
         * @param {boolean} [engagementLetterAlreadySigned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersWithBundlePost: async (clientId: string, taxYear: number, name: string, clientCopyPdf: File, governmentCopyPdf: File, dueDate?: string, invoiceLink?: string, k1Pdf?: File, engagementLetterAlreadySigned?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'clientId', clientId)
            // verify required parameter 'taxYear' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'taxYear', taxYear)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'name', name)
            // verify required parameter 'clientCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'clientCopyPdf', clientCopyPdf)
            // verify required parameter 'governmentCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'governmentCopyPdf', governmentCopyPdf)
            const localVarPath = `/api/tax-binders/with-bundle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (clientId !== undefined) { 
                localVarFormParams.append('ClientId', clientId as any);
            }

            if (taxYear !== undefined) { 
                localVarFormParams.append('TaxYear', taxYear as any);
            }

            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }

            if (dueDate !== undefined) { 
                localVarFormParams.append('DueDate', dueDate as any);
            }

            if (invoiceLink !== undefined) { 
                localVarFormParams.append('InvoiceLink', invoiceLink as any);
            }

            if (clientCopyPdf !== undefined) { 
                localVarFormParams.append('ClientCopyPdf', clientCopyPdf as any);
            }

            if (governmentCopyPdf !== undefined) { 
                localVarFormParams.append('GovernmentCopyPdf', governmentCopyPdf as any);
            }

            if (k1Pdf !== undefined) { 
                localVarFormParams.append('K1Pdf', k1Pdf as any);
            }

            if (engagementLetterAlreadySigned !== undefined) { 
                localVarFormParams.append('EngagementLetterAlreadySigned', String(engagementLetterAlreadySigned) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxBindersApi - functional programming interface
 */
export const TaxBindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxBindersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBatchUploadJobIdResultsGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUploadResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBatchUploadJobIdResultsGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBatchUploadJobIdResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBatchUploadJobIdStatusGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUploadStatusResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBatchUploadJobIdStatusGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBatchUploadJobIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {boolean} [extractEngagementLetter] 
         * @param {string} [clientOperationId] 
         * @param {File} [organizerPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdAnalyzeOrganizerPost(binderId: string, extractEngagementLetter?: boolean, clientOperationId?: string, organizerPdf?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizerAnalysisResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdAnalyzeOrganizerPost(binderId, extractEngagementLetter, clientOperationId, organizerPdf, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdAnalyzeOrganizerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {ArchiveTaxBinderRequest} [archiveTaxBinderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdArchivePatch(binderId: string, archiveTaxBinderRequest?: ArchiveTaxBinderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdArchivePatch(binderId, archiveTaxBinderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {boolean} [runAiDetection] 
         * @param {number} [confidenceThreshold] 
         * @param {boolean} [createSeparateDocuments] 
         * @param {boolean} [extractDocumentData] 
         * @param {boolean} [groupMultiPageForms] 
         * @param {DocumentDirection} [direction] 
         * @param {string} [selectedPageNumbers] 
         * @param {boolean} [autoSplitPages] 
         * @param {number} [autoSplitConfidenceThreshold] 
         * @param {boolean} [generateAiDescriptionsForAutoSplit] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdDocumentsBatchUploadPost(binderId: string, runAiDetection?: boolean, confidenceThreshold?: number, createSeparateDocuments?: boolean, extractDocumentData?: boolean, groupMultiPageForms?: boolean, direction?: DocumentDirection, selectedPageNumbers?: string, autoSplitPages?: boolean, autoSplitConfidenceThreshold?: number, generateAiDescriptionsForAutoSplit?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUploadJobResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdDocumentsBatchUploadPost(binderId, runAiDetection, confidenceThreshold, createSeparateDocuments, extractDocumentData, groupMultiPageForms, direction, selectedPageNumbers, autoSplitPages, autoSplitConfidenceThreshold, generateAiDescriptionsForAutoSplit, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdDocumentsBatchUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdEstimatedPaymentsGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderEstimatedPaymentsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdEstimatedPaymentsGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdEstimatedPaymentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} documentId 
         * @param {UpdatePreprocessedDocumentDto} [updatePreprocessedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(binderId: string, documentId: string, updatePreprocessedDocumentDto?: UpdatePreprocessedDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreprocessedDocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(binderId, documentId, updatePreprocessedDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdStagingDocumentsDocumentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {FinalizeStagingDto} [finalizeStagingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdStagingFinalizePost(binderId: string, finalizeStagingDto?: FinalizeStagingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinalizeStagingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdStagingFinalizePost(binderId, finalizeStagingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdStagingFinalizePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdStagingGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentStagingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdStagingGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdStagingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdVerificationStatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdVerificationStatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdVerificationStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {VerifySpouseInfoDto} [verifySpouseInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdVerifySpouseInfoPost(binderId: string, verifySpouseInfoDto?: VerifySpouseInfoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdVerifySpouseInfoPost(binderId, verifySpouseInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdVerifySpouseInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [taxYear] 
         * @param {string} [clientId] 
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {string} [partnerId] 
         * @param {ClientType} [taxType] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {string} [search] 
         * @param {string} [priority] 
         * @param {boolean} [isOverdue] 
         * @param {boolean} [watchedClientsOnly] 
         * @param {boolean} [isClientSubmitted] 
         * @param {boolean} [hasUnreviewedDocuments] 
         * @param {boolean} [hasUnreviewedComments] 
         * @param {boolean} [hasLateDocuments] 
         * @param {boolean} [assignedToMe] 
         * @param {BinderStage} [stage] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersGet(taxYear?: number, clientId?: string, preparerId?: string, officeId?: string, partnerId?: string, taxType?: ClientType, dueDateFrom?: string, dueDateTo?: string, search?: string, priority?: string, isOverdue?: boolean, watchedClientsOnly?: boolean, isClientSubmitted?: boolean, hasUnreviewedDocuments?: boolean, hasUnreviewedComments?: boolean, hasLateDocuments?: boolean, assignedToMe?: boolean, stage?: BinderStage, page?: number, limit?: number, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersGet(taxYear, clientId, preparerId, officeId, partnerId, taxType, dueDateFrom, dueDateTo, search, priority, isOverdue, watchedClientsOnly, isClientSubmitted, hasUnreviewedDocuments, hasUnreviewedComments, hasLateDocuments, assignedToMe, stage, page, limit, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdAuditHistoryGet(id: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdAuditHistoryGet(id, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdAuditHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [className] 
         * @param {string} [subClassName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdCchDocumentsGet(id: string, className?: string, subClassName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CchDocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdCchDocumentsGet(id, className, subClassName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdCchDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CchDocumentImportRequest} [cchDocumentImportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdCchDocumentsImportPost(id: string, cchDocumentImportRequest?: CchDocumentImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CchDocumentImportResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdCchDocumentsImportPost(id, cchDocumentImportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdCchDocumentsImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdClearLateDocumentsPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdClearLateDocumentsPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdClearLateDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {boolean} [confirmReset] 
         * @param {boolean} [sendNotification] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdDocumentsDocumentIdReplacePost(id: string, documentId: string, confirmReset?: boolean, sendNotification?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplaceDocumentResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdDocumentsDocumentIdReplacePost(id, documentId, confirmReset, sendNotification, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdDocumentsDocumentIdReplacePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdDownloadSignedGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdDownloadSignedGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdDownloadSignedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdESignatureAuditGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ESignatureAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdESignatureAuditGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdESignatureAuditGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdESignaturesGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ESignatureDocumentListDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdESignaturesGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdESignaturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {File} file 
         * @param {boolean} [replaceExisting] 
         * @param {string} [clientName] 
         * @param {string} [clientEmail] 
         * @param {string} [spouseName] 
         * @param {string} [spouseEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdEngagementLetterAttachPost(id: string, file: File, replaceExisting?: boolean, clientName?: string, clientEmail?: string, spouseName?: string, spouseEmail?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachEngagementLetterResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdEngagementLetterAttachPost(id, file, replaceExisting, clientName, clientEmail, spouseName, spouseEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdEngagementLetterAttachPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdEngagementLetterPrepareSignaturePost(id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSubmissionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdEngagementLetterPrepareSignaturePost(id, singleDocumentSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdEngagementLetterPrepareSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {File} file 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdEngagementLetterUploadSignedPost(id: string, file: File, comment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadSignedEngagementLetterResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdEngagementLetterUploadSignedPost(id, file, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdEngagementLetterUploadSignedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaxBinderPackageExportDto} [taxBinderPackageExportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportPackagePost(id: string, taxBinderPackageExportDto?: TaxBinderPackageExportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportPackagePost(id, taxBinderPackageExportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportPackagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportPreviewPost(id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderExportPreviewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportPreviewPost(id, taxBinderExportSelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportSelectedPost(id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportSelectedPost(id, taxBinderExportSelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportSelectedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {PrepareForSignatureDto} [prepareForSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdPrepareForSignaturePost(id: string, prepareForSignatureDto?: PrepareForSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepareForSignatureResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdPrepareForSignaturePost(id, prepareForSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdPrepareForSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaxBinderDto} [updateTaxBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdPut(id: string, updateTaxBinderDto?: UpdateTaxBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdPut(id, updateTaxBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {RecallReturnDto} [recallReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdRecallReturnPost(id: string, recallReturnDto?: RecallReturnDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecallReturnResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdRecallReturnPost(id, recallReturnDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdRecallReturnPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdReleaseStatusGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdReleaseStatusGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdReleaseStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ReleaseToClientDto} [releaseToClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdReleaseToClientPost(id: string, releaseToClientDto?: ReleaseToClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseToClientResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdReleaseToClientPost(id, releaseToClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdReleaseToClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {RequestChangesDto} [requestChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdRequestChangesPost(id: string, requestChangesDto?: RequestChangesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdRequestChangesPost(id, requestChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdRequestChangesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdResendWelcomeEmailPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdResendWelcomeEmailPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdResendWelcomeEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SendBackToClientDto} [sendBackToClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSendBackPost(id: string, sendBackToClientDto?: SendBackToClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSendBackPost(id, sendBackToClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSendBackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSigningSessionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsEligibleSignersGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibleSignersDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsEligibleSignersGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsEligibleSignersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureDocumentListDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsPost(id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureRequestResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsPost(id, createSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureStatusGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureStatusGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaxBinderStageDto} [updateTaxBinderStageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdStagePatch(id: string, updateTaxBinderStageDto?: UpdateTaxBinderStageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdStagePatch(id, updateTaxBinderStageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdStagePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitTaxBinderRequest} [submitTaxBinderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSubmitPost(id: string, submitTaxBinderRequest?: SubmitTaxBinderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSubmitPost(id, submitTaxBinderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdWithdrawSubmissionPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdWithdrawSubmissionPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdWithdrawSubmissionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {number} taxYear 
         * @param {string} clientId 
         * @param {string} [preparerId] 
         * @param {string} [dueDate] 
         * @param {number} [notificationDaysPrior] 
         * @param {string} [invoiceLink] 
         * @param {File} [organizerPdf] 
         * @param {File} [engagementLetterPdf] 
         * @param {boolean} [extractEngagementLetter] 
         * @param {boolean} [sendWelcomeEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersPost(name: string, taxYear: number, clientId: string, preparerId?: string, dueDate?: string, notificationDaysPrior?: number, invoiceLink?: string, organizerPdf?: File, engagementLetterPdf?: File, extractEngagementLetter?: boolean, sendWelcomeEmail?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersPost(name, taxYear, clientId, preparerId, dueDate, notificationDaysPrior, invoiceLink, organizerPdf, engagementLetterPdf, extractEngagementLetter, sendWelcomeEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxTypeOptionListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersTaxTypeOptionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersTaxTypeOptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {number} taxYear 
         * @param {string} name 
         * @param {File} clientCopyPdf 
         * @param {File} governmentCopyPdf 
         * @param {string} [dueDate] 
         * @param {string} [invoiceLink] 
         * @param {File} [k1Pdf] 
         * @param {boolean} [engagementLetterAlreadySigned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersWithBundlePost(clientId: string, taxYear: number, name: string, clientCopyPdf: File, governmentCopyPdf: File, dueDate?: string, invoiceLink?: string, k1Pdf?: File, engagementLetterAlreadySigned?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBinderWithBundleResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersWithBundlePost(clientId, taxYear, name, clientCopyPdf, governmentCopyPdf, dueDate, invoiceLink, k1Pdf, engagementLetterAlreadySigned, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersWithBundlePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaxBindersApi - factory interface
 */
export const TaxBindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxBindersApiFp(configuration)
    return {
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdResultsGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadResultApiResponse> {
            return localVarFp.apiTaxBindersBatchUploadJobIdResultsGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdStatusGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadStatusResponseApiResponse> {
            return localVarFp.apiTaxBindersBatchUploadJobIdStatusGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizerAnalysisResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters.binderId, requestParameters.extractEngagementLetter, requestParameters.clientOperationId, requestParameters.organizerPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdArchivePatch(requestParameters: TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdArchivePatch(requestParameters.binderId, requestParameters.archiveTaxBinderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadJobResponseApiResponse> {
            return localVarFp.apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters.binderId, requestParameters.runAiDetection, requestParameters.confidenceThreshold, requestParameters.createSeparateDocuments, requestParameters.extractDocumentData, requestParameters.groupMultiPageForms, requestParameters.direction, requestParameters.selectedPageNumbers, requestParameters.autoSplitPages, requestParameters.autoSplitConfidenceThreshold, requestParameters.generateAiDescriptionsForAutoSplit, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderEstimatedPaymentsDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreprocessedDocumentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters.binderId, requestParameters.documentId, requestParameters.updatePreprocessedDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingFinalizePost(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FinalizeStagingResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdStagingFinalizePost(requestParameters.binderId, requestParameters.finalizeStagingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdStagingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStagingDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdStagingGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerificationStatusGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdVerificationStatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters.binderId, requestParameters.verifySpouseInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersGet(requestParameters: TaxBindersApiApiTaxBindersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoPaginatedResponseApiResponse> {
            return localVarFp.apiTaxBindersGet(requestParameters.taxYear, requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.partnerId, requestParameters.taxType, requestParameters.dueDateFrom, requestParameters.dueDateTo, requestParameters.search, requestParameters.priority, requestParameters.isOverdue, requestParameters.watchedClientsOnly, requestParameters.isClientSubmitted, requestParameters.hasUnreviewedDocuments, requestParameters.hasUnreviewedComments, requestParameters.hasLateDocuments, requestParameters.assignedToMe, requestParameters.stage, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdAuditHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderAuditHistoryDtoApiResponse> {
            return localVarFp.apiTaxBindersIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentDtoListApiResponse> {
            return localVarFp.apiTaxBindersIdCchDocumentsGet(requestParameters.id, requestParameters.className, requestParameters.subClassName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsImportPost(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentImportResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdCchDocumentsImportPost(requestParameters.id, requestParameters.cchDocumentImportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdClearLateDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdClearLateDocumentsPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDelete(requestParameters: TaxBindersApiApiTaxBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTaxBindersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters: TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceDocumentResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters.id, requestParameters.documentId, requestParameters.confirmReset, requestParameters.sendNotification, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDownloadSignedGet(requestParameters: TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTaxBindersIdDownloadSignedGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignatureAuditGet(requestParameters: TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureAuditHistoryDtoApiResponse> {
            return localVarFp.apiTaxBindersIdESignatureAuditGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdESignaturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignaturesGet(requestParameters: TaxBindersApiApiTaxBindersIdESignaturesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureDocumentListDtoApiResponse> {
            return localVarFp.apiTaxBindersIdESignaturesGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterAttachPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachEngagementLetterResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersIdEngagementLetterAttachPost(requestParameters.id, requestParameters.file, requestParameters.replaceExisting, requestParameters.clientName, requestParameters.clientEmail, requestParameters.spouseName, requestParameters.spouseEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse> {
            return localVarFp.apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadSignedEngagementLetterResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters.id, requestParameters.file, requestParameters.comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdExportGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportGet(requestParameters: TaxBindersApiApiTaxBindersIdExportGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTaxBindersIdExportGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdExportPackagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPackagePost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackagePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTaxBindersIdExportPackagePost(requestParameters.id, requestParameters.taxBinderPackageExportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdExportPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPreviewPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderExportPreviewDtoApiResponse> {
            return localVarFp.apiTaxBindersIdExportPreviewPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdExportSelectedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportSelectedPost(requestParameters: TaxBindersApiApiTaxBindersIdExportSelectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTaxBindersIdExportSelectedPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdGet(requestParameters: TaxBindersApiApiTaxBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPrepareForSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrepareForSignatureResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdPrepareForSignaturePost(requestParameters.id, requestParameters.prepareForSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPut(requestParameters: TaxBindersApiApiTaxBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdPut(requestParameters.id, requestParameters.updateTaxBinderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdRecallReturnPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRecallReturnPost(requestParameters: TaxBindersApiApiTaxBindersIdRecallReturnPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecallReturnResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdRecallReturnPost(requestParameters.id, requestParameters.recallReturnDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersIdReleaseStatusGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseToClientPost(requestParameters: TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseToClientResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdReleaseToClientPost(requestParameters.id, requestParameters.releaseToClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdRequestChangesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRequestChangesPost(requestParameters: TaxBindersApiApiTaxBindersIdRequestChangesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdRequestChangesPost(requestParameters.id, requestParameters.requestChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdResendWelcomeEmailPost(requestParameters: TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersIdResendWelcomeEmailPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdSendBackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSendBackPost(requestParameters: TaxBindersApiApiTaxBindersIdSendBackPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSendBackPost(requestParameters.id, requestParameters.sendBackToClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureDocumentListDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureStatusGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdStagePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdStagePatch(requestParameters: TaxBindersApiApiTaxBindersIdStagePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdStagePatch(requestParameters.id, requestParameters.updateTaxBinderStageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSubmitPost(requestParameters: TaxBindersApiApiTaxBindersIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSubmitPost(requestParameters.id, requestParameters.submitTaxBinderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdWithdrawSubmissionPost(requestParameters: TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdWithdrawSubmissionPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersPost(requestParameters: TaxBindersApiApiTaxBindersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersPost(requestParameters.name, requestParameters.taxYear, requestParameters.clientId, requestParameters.preparerId, requestParameters.dueDate, requestParameters.notificationDaysPrior, requestParameters.invoiceLink, requestParameters.organizerPdf, requestParameters.engagementLetterPdf, requestParameters.extractEngagementLetter, requestParameters.sendWelcomeEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig): AxiosPromise<TaxTypeOptionListApiResponse> {
            return localVarFp.apiTaxBindersTaxTypeOptionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxBindersApiApiTaxBindersWithBundlePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersWithBundlePost(requestParameters: TaxBindersApiApiTaxBindersWithBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBinderWithBundleResultDtoApiResponse> {
            return localVarFp.apiTaxBindersWithBundlePost(requestParameters.clientId, requestParameters.taxYear, requestParameters.name, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.dueDate, requestParameters.invoiceLink, requestParameters.k1Pdf, requestParameters.engagementLetterAlreadySigned, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxBindersApi - interface
 */
export interface TaxBindersApiInterface {
    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBatchUploadJobIdResultsGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadResultApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBatchUploadJobIdStatusGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadStatusResponseApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizerAnalysisResultDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdArchivePatch(requestParameters: TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadJobResponseApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderEstimatedPaymentsDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreprocessedDocumentDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdStagingFinalizePost(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FinalizeStagingResultDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdStagingGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStagingDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdVerificationStatusGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersGet(requestParameters?: TaxBindersApiApiTaxBindersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdAuditHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderAuditHistoryDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdCchDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentDtoListApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdCchDocumentsImportPost(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentImportResultDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdClearLateDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdDelete(requestParameters: TaxBindersApiApiTaxBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters: TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceDocumentResponseDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdDownloadSignedGet(requestParameters: TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdESignatureAuditGet(requestParameters: TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureAuditHistoryDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdESignaturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdESignaturesGet(requestParameters: TaxBindersApiApiTaxBindersIdESignaturesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureDocumentListDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdEngagementLetterAttachPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachEngagementLetterResponseDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadSignedEngagementLetterResponseDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportGet(requestParameters: TaxBindersApiApiTaxBindersIdExportGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportPackagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportPackagePost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackagePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportPreviewPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderExportPreviewDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportSelectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportSelectedPost(requestParameters: TaxBindersApiApiTaxBindersIdExportSelectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdGet(requestParameters: TaxBindersApiApiTaxBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdPrepareForSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrepareForSignatureResultDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdPut(requestParameters: TaxBindersApiApiTaxBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdRecallReturnPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdRecallReturnPost(requestParameters: TaxBindersApiApiTaxBindersIdRecallReturnPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecallReturnResultDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdReleaseStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseStatusDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdReleaseToClientPost(requestParameters: TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseToClientResultDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdRequestChangesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdRequestChangesPost(requestParameters: TaxBindersApiApiTaxBindersIdRequestChangesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdResendWelcomeEmailPost(requestParameters: TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSendBackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSendBackPost(requestParameters: TaxBindersApiApiTaxBindersIdSendBackPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureDocumentListDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdStagePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdStagePatch(requestParameters: TaxBindersApiApiTaxBindersIdStagePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSubmitPost(requestParameters: TaxBindersApiApiTaxBindersIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdWithdrawSubmissionPost(requestParameters: TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersPost(requestParameters: TaxBindersApiApiTaxBindersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig): AxiosPromise<TaxTypeOptionListApiResponse>;

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersWithBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersWithBundlePost(requestParameters: TaxBindersApiApiTaxBindersWithBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBinderWithBundleResultDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBatchUploadJobIdResultsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest {
    readonly jobId: string
}

/**
 * Request parameters for apiTaxBindersBatchUploadJobIdStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest {
    readonly jobId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdAnalyzeOrganizerPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest {
    readonly binderId: string

    readonly extractEngagementLetter?: boolean

    readonly clientOperationId?: string

    readonly organizerPdf?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdArchivePatch operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest {
    readonly binderId: string

    readonly archiveTaxBinderRequest?: ArchiveTaxBinderRequest
}

/**
 * Request parameters for apiTaxBindersBinderIdDocumentsBatchUploadPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest {
    readonly binderId: string

    readonly runAiDetection?: boolean

    readonly confidenceThreshold?: number

    readonly createSeparateDocuments?: boolean

    readonly extractDocumentData?: boolean

    readonly groupMultiPageForms?: boolean

    readonly direction?: DocumentDirection

    readonly selectedPageNumbers?: string

    readonly autoSplitPages?: boolean

    readonly autoSplitConfidenceThreshold?: number

    readonly generateAiDescriptionsForAutoSplit?: boolean

    readonly file?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdEstimatedPaymentsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdStagingDocumentsDocumentIdPut operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest {
    readonly binderId: string

    readonly documentId: string

    readonly updatePreprocessedDocumentDto?: UpdatePreprocessedDocumentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdStagingFinalizePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest {
    readonly binderId: string

    readonly finalizeStagingDto?: FinalizeStagingDto
}

/**
 * Request parameters for apiTaxBindersBinderIdStagingGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdStagingGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdVerificationStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdVerifySpouseInfoPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest {
    readonly binderId: string

    readonly verifySpouseInfoDto?: VerifySpouseInfoDto
}

/**
 * Request parameters for apiTaxBindersGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersGetRequest {
    readonly taxYear?: number

    readonly clientId?: string

    readonly preparerId?: string

    readonly officeId?: string

    readonly partnerId?: string

    readonly taxType?: ClientType

    readonly dueDateFrom?: string

    readonly dueDateTo?: string

    readonly search?: string

    readonly priority?: string

    readonly isOverdue?: boolean

    readonly watchedClientsOnly?: boolean

    readonly isClientSubmitted?: boolean

    readonly hasUnreviewedDocuments?: boolean

    readonly hasUnreviewedComments?: boolean

    readonly hasLateDocuments?: boolean

    readonly assignedToMe?: boolean

    readonly stage?: BinderStage

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string
}

/**
 * Request parameters for apiTaxBindersIdAuditHistoryGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest {
    readonly id: string

    readonly startDate?: string

    readonly endDate?: string
}

/**
 * Request parameters for apiTaxBindersIdCchDocumentsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest {
    readonly id: string

    readonly className?: string

    readonly subClassName?: string
}

/**
 * Request parameters for apiTaxBindersIdCchDocumentsImportPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest {
    readonly id: string

    readonly cchDocumentImportRequest?: CchDocumentImportRequest
}

/**
 * Request parameters for apiTaxBindersIdClearLateDocumentsPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdDelete operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdDocumentsDocumentIdReplacePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest {
    readonly id: string

    readonly documentId: string

    readonly confirmReset?: boolean

    readonly sendNotification?: boolean

    readonly file?: File
}

/**
 * Request parameters for apiTaxBindersIdDownloadSignedGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdESignatureAuditGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdESignaturesGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdESignaturesGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdEngagementLetterAttachPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest {
    readonly id: string

    readonly file: File

    readonly replaceExisting?: boolean

    readonly clientName?: string

    readonly clientEmail?: string

    readonly spouseName?: string

    readonly spouseEmail?: string
}

/**
 * Request parameters for apiTaxBindersIdEngagementLetterPrepareSignaturePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest {
    readonly id: string

    readonly singleDocumentSignatureDto?: SingleDocumentSignatureDto
}

/**
 * Request parameters for apiTaxBindersIdEngagementLetterUploadSignedPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest {
    readonly id: string

    readonly file: File

    readonly comment?: string
}

/**
 * Request parameters for apiTaxBindersIdExportGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdExportPackagePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportPackagePostRequest {
    readonly id: string

    readonly taxBinderPackageExportDto?: TaxBinderPackageExportDto
}

/**
 * Request parameters for apiTaxBindersIdExportPreviewPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportPreviewPostRequest {
    readonly id: string

    readonly taxBinderExportSelectionDto?: TaxBinderExportSelectionDto
}

/**
 * Request parameters for apiTaxBindersIdExportSelectedPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportSelectedPostRequest {
    readonly id: string

    readonly taxBinderExportSelectionDto?: TaxBinderExportSelectionDto
}

/**
 * Request parameters for apiTaxBindersIdGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdPrepareForSignaturePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest {
    readonly id: string

    readonly prepareForSignatureDto?: PrepareForSignatureDto
}

/**
 * Request parameters for apiTaxBindersIdPut operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdPutRequest {
    readonly id: string

    readonly updateTaxBinderDto?: UpdateTaxBinderDto
}

/**
 * Request parameters for apiTaxBindersIdRecallReturnPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdRecallReturnPostRequest {
    readonly id: string

    readonly recallReturnDto?: RecallReturnDto
}

/**
 * Request parameters for apiTaxBindersIdReleaseStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdReleaseToClientPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest {
    readonly id: string

    readonly releaseToClientDto?: ReleaseToClientDto
}

/**
 * Request parameters for apiTaxBindersIdRequestChangesPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdRequestChangesPostRequest {
    readonly id: string

    readonly requestChangesDto?: RequestChangesDto
}

/**
 * Request parameters for apiTaxBindersIdResendWelcomeEmailPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdSendBackPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSendBackPostRequest {
    readonly id: string

    readonly sendBackToClientDto?: SendBackToClientDto
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest {
    readonly id: string

    readonly documentId: string
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsEligibleSignersGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest {
    readonly id: string

    readonly createSignatureRequestDto?: CreateSignatureRequestDto
}

/**
 * Request parameters for apiTaxBindersIdSignatureStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdStagePatch operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdStagePatchRequest {
    readonly id: string

    readonly updateTaxBinderStageDto?: UpdateTaxBinderStageDto
}

/**
 * Request parameters for apiTaxBindersIdSubmitPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSubmitPostRequest {
    readonly id: string

    readonly submitTaxBinderRequest?: SubmitTaxBinderRequest
}

/**
 * Request parameters for apiTaxBindersIdWithdrawSubmissionPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersPostRequest {
    readonly name: string

    readonly taxYear: number

    readonly clientId: string

    readonly preparerId?: string

    readonly dueDate?: string

    readonly notificationDaysPrior?: number

    readonly invoiceLink?: string

    readonly organizerPdf?: File

    readonly engagementLetterPdf?: File

    readonly extractEngagementLetter?: boolean

    readonly sendWelcomeEmail?: boolean
}

/**
 * Request parameters for apiTaxBindersWithBundlePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersWithBundlePostRequest {
    readonly clientId: string

    readonly taxYear: number

    readonly name: string

    readonly clientCopyPdf: File

    readonly governmentCopyPdf: File

    readonly dueDate?: string

    readonly invoiceLink?: string

    readonly k1Pdf?: File

    readonly engagementLetterAlreadySigned?: boolean
}

/**
 * TaxBindersApi - object-oriented interface
 */
export class TaxBindersApi extends BaseAPI implements TaxBindersApiInterface {
    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBatchUploadJobIdResultsGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBatchUploadJobIdResultsGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBatchUploadJobIdStatusGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBatchUploadJobIdStatusGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters.binderId, requestParameters.extractEngagementLetter, requestParameters.clientOperationId, requestParameters.organizerPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdArchivePatch(requestParameters: TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdArchivePatch(requestParameters.binderId, requestParameters.archiveTaxBinderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters.binderId, requestParameters.runAiDetection, requestParameters.confidenceThreshold, requestParameters.createSeparateDocuments, requestParameters.extractDocumentData, requestParameters.groupMultiPageForms, requestParameters.direction, requestParameters.selectedPageNumbers, requestParameters.autoSplitPages, requestParameters.autoSplitConfidenceThreshold, requestParameters.generateAiDescriptionsForAutoSplit, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters.binderId, requestParameters.documentId, requestParameters.updatePreprocessedDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdStagingFinalizePost(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdStagingFinalizePost(requestParameters.binderId, requestParameters.finalizeStagingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdStagingGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdStagingGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdVerificationStatusGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdVerificationStatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters.binderId, requestParameters.verifySpouseInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersGet(requestParameters: TaxBindersApiApiTaxBindersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersGet(requestParameters.taxYear, requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.partnerId, requestParameters.taxType, requestParameters.dueDateFrom, requestParameters.dueDateTo, requestParameters.search, requestParameters.priority, requestParameters.isOverdue, requestParameters.watchedClientsOnly, requestParameters.isClientSubmitted, requestParameters.hasUnreviewedDocuments, requestParameters.hasUnreviewedComments, requestParameters.hasLateDocuments, requestParameters.assignedToMe, requestParameters.stage, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdAuditHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdCchDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdCchDocumentsGet(requestParameters.id, requestParameters.className, requestParameters.subClassName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdCchDocumentsImportPost(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdCchDocumentsImportPost(requestParameters.id, requestParameters.cchDocumentImportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdClearLateDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdClearLateDocumentsPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdDelete(requestParameters: TaxBindersApiApiTaxBindersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters: TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters.id, requestParameters.documentId, requestParameters.confirmReset, requestParameters.sendNotification, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdDownloadSignedGet(requestParameters: TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdDownloadSignedGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdESignatureAuditGet(requestParameters: TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdESignatureAuditGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdESignaturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdESignaturesGet(requestParameters: TaxBindersApiApiTaxBindersIdESignaturesGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdESignaturesGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdEngagementLetterAttachPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdEngagementLetterAttachPost(requestParameters.id, requestParameters.file, requestParameters.replaceExisting, requestParameters.clientName, requestParameters.clientEmail, requestParameters.spouseName, requestParameters.spouseEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters.id, requestParameters.file, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportGet(requestParameters: TaxBindersApiApiTaxBindersIdExportGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportPackagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportPackagePost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackagePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportPackagePost(requestParameters.id, requestParameters.taxBinderPackageExportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportPreviewPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportPreviewPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdExportSelectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportSelectedPost(requestParameters: TaxBindersApiApiTaxBindersIdExportSelectedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportSelectedPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdGet(requestParameters: TaxBindersApiApiTaxBindersIdGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdPrepareForSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdPrepareForSignaturePost(requestParameters.id, requestParameters.prepareForSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdPut(requestParameters: TaxBindersApiApiTaxBindersIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdPut(requestParameters.id, requestParameters.updateTaxBinderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdRecallReturnPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdRecallReturnPost(requestParameters: TaxBindersApiApiTaxBindersIdRecallReturnPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdRecallReturnPost(requestParameters.id, requestParameters.recallReturnDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdReleaseStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdReleaseStatusGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdReleaseToClientPost(requestParameters: TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdReleaseToClientPost(requestParameters.id, requestParameters.releaseToClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdRequestChangesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdRequestChangesPost(requestParameters: TaxBindersApiApiTaxBindersIdRequestChangesPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdRequestChangesPost(requestParameters.id, requestParameters.requestChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdResendWelcomeEmailPost(requestParameters: TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdResendWelcomeEmailPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSendBackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSendBackPost(requestParameters: TaxBindersApiApiTaxBindersIdSendBackPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSendBackPost(requestParameters.id, requestParameters.sendBackToClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureStatusGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdStagePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdStagePatch(requestParameters: TaxBindersApiApiTaxBindersIdStagePatchRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdStagePatch(requestParameters.id, requestParameters.updateTaxBinderStageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSubmitPost(requestParameters: TaxBindersApiApiTaxBindersIdSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSubmitPost(requestParameters.id, requestParameters.submitTaxBinderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdWithdrawSubmissionPost(requestParameters: TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdWithdrawSubmissionPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersPost(requestParameters: TaxBindersApiApiTaxBindersPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersPost(requestParameters.name, requestParameters.taxYear, requestParameters.clientId, requestParameters.preparerId, requestParameters.dueDate, requestParameters.notificationDaysPrior, requestParameters.invoiceLink, requestParameters.organizerPdf, requestParameters.engagementLetterPdf, requestParameters.extractEngagementLetter, requestParameters.sendWelcomeEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersTaxTypeOptionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxBindersApiApiTaxBindersWithBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersWithBundlePost(requestParameters: TaxBindersApiApiTaxBindersWithBundlePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersWithBundlePost(requestParameters.clientId, requestParameters.taxYear, requestParameters.name, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.dueDate, requestParameters.invoiceLink, requestParameters.k1Pdf, requestParameters.engagementLetterAlreadySigned, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaxReturnBundleApi - axios parameter creator
 */
export const TaxReturnBundleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete: async (binderId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete', 'binderId', binderId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete', 'id', id)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents/{id}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} id 
         * @param {UpdatePreparerDocumentDto} [updatePreparerDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdPut: async (binderId: string, id: string, updatePreparerDocumentDto?: UpdatePreparerDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdPut', 'binderId', binderId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdPut', 'id', id)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents/{id}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePreparerDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} displayName 
         * @param {BundleDocumentCategory} category 
         * @param {File} file 
         * @param {string} [jurisdictionId] 
         * @param {boolean} [requiresSignature] 
         * @param {string} [signatureFieldPlacementsJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsPost: async (binderId: string, displayName: string, category: BundleDocumentCategory, file: File, jurisdictionId?: string, requiresSignature?: boolean, signatureFieldPlacementsJson?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'binderId', binderId)
            // verify required parameter 'displayName' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'displayName', displayName)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'category', category)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'file', file)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (displayName !== undefined) { 
                localVarFormParams.append('DisplayName', displayName as any);
            }

            if (category !== undefined) { 
                localVarFormParams.append('Category', category as any);
            }

            if (jurisdictionId !== undefined) { 
                localVarFormParams.append('JurisdictionId', jurisdictionId as any);
            }

            if (requiresSignature !== undefined) { 
                localVarFormParams.append('RequiresSignature', String(requiresSignature) as any);
            }

            if (signatureFieldPlacementsJson !== undefined) { 
                localVarFormParams.append('SignatureFieldPlacementsJson', signatureFieldPlacementsJson as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleSignatureStatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleSignatureStatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-signature-status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsProcessingStatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsProcessingStatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/processing-status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReprocessPost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReprocessPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/reprocess`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {RequestBundleSignatureDto} [requestBundleSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost: async (binderId: string, requestBundleSignatureDto?: RequestBundleSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/request-document-signatures`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBundleSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {ConvertToPaperDto} [convertToPaperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost: async (binderId: string, returnId: string, convertToPaperDto?: ConvertToPaperDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/convert-to-paper`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(convertToPaperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {DeleteReturnDto} [deleteReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdDelete: async (binderId: string, returnId: string, deleteReturnDto?: DeleteReturnDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdDelete', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdDelete', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteReturnDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet: async (binderId: string, returnId: string, instructionType?: FilingInstructionType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/filing-instructions`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instructionType !== undefined) {
                localVarQueryParameter['instructionType'] = instructionType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {UpdateFilingInstructionDto} [updateFilingInstructionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch: async (binderId: string, returnId: string, instructionType?: FilingInstructionType, updateFilingInstructionDto?: UpdateFilingInstructionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/filing-instructions`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instructionType !== undefined) {
                localVarQueryParameter['instructionType'] = instructionType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFilingInstructionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdGet: async (binderId: string, returnId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdGet', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdGet', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost: async (binderId: string, returnId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-accepted`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {MarkTaxReturnFiledDto} [markTaxReturnFiledDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost: async (binderId: string, returnId: string, markTaxReturnFiledDto?: MarkTaxReturnFiledDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-filed`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markTaxReturnFiledDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} signedAt 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost: async (binderId: string, returnId: string, signedAt: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost', 'returnId', returnId)
            // verify required parameter 'signedAt' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost', 'signedAt', signedAt)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-paper-signed`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (signedAt !== undefined) { 
                localVarFormParams.append('SignedAt', signedAt as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {MarkTaxReturnRejectedDto} [markTaxReturnRejectedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost: async (binderId: string, returnId: string, markTaxReturnRejectedDto?: MarkTaxReturnRejectedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-rejected`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markTaxReturnRejectedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {UpdateJurisdictionDto} [updateJurisdictionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdPatch: async (binderId: string, returnId: string, updateJurisdictionDto?: UpdateJurisdictionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdPatch', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdPatch', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJurisdictionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} requirementId 
         * @param {UpdateBundleSignatureRequirementDto} [updateBundleSignatureRequirementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut: async (binderId: string, returnId: string, requirementId: string, updateBundleSignatureRequirementDto?: UpdateBundleSignatureRequirementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut', 'returnId', returnId)
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut', 'requirementId', requirementId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/signature-requirements/{requirementId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"requirementId"}}`, encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBundleSignatureRequirementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersGet: async (binderId: string, returnId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersGet', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersGet', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {CreatePaymentVoucherDto} [createPaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersPost: async (binderId: string, returnId: string, createPaymentVoucherDto?: CreatePaymentVoucherDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentVoucherDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete: async (binderId: string, returnId: string, voucherId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {MarkPaymentVoucherPaidDto} [markPaymentVoucherPaidDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost: async (binderId: string, returnId: string, voucherId: string, markPaymentVoucherPaidDto?: MarkPaymentVoucherPaidDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}/mark-paid`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markPaymentVoucherPaidDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {PaymentVoucherReminderOptInDto} [paymentVoucherReminderOptInDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost: async (binderId: string, returnId: string, voucherId: string, paymentVoucherReminderOptInDto?: PaymentVoucherReminderOptInDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}/opt-in`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentVoucherReminderOptInDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {UpdatePaymentVoucherDto} [updatePaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch: async (binderId: string, returnId: string, voucherId: string, updatePaymentVoucherDto?: UpdatePaymentVoucherDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentVoucherDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} binderId 
         * @param {File} clientCopyPdf 
         * @param {File} governmentCopyPdf 
         * @param {File} [k1Pdf] 
         * @param {string} [invoiceLink] 
         * @param {boolean} [forceReprocess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsUploadBundlePost: async (binderId: string, clientCopyPdf: File, governmentCopyPdf: File, k1Pdf?: File, invoiceLink?: string, forceReprocess?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsUploadBundlePost', 'binderId', binderId)
            // verify required parameter 'clientCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsUploadBundlePost', 'clientCopyPdf', clientCopyPdf)
            // verify required parameter 'governmentCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsUploadBundlePost', 'governmentCopyPdf', governmentCopyPdf)
            const localVarPath = `/api/tax-binders/{binderId}/returns/upload-bundle`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (clientCopyPdf !== undefined) { 
                localVarFormParams.append('ClientCopyPdf', clientCopyPdf as any);
            }

            if (governmentCopyPdf !== undefined) { 
                localVarFormParams.append('GovernmentCopyPdf', governmentCopyPdf as any);
            }

            if (k1Pdf !== undefined) { 
                localVarFormParams.append('K1Pdf', k1Pdf as any);
            }

            if (invoiceLink !== undefined) { 
                localVarFormParams.append('InvoiceLink', invoiceLink as any);
            }

            if (forceReprocess !== undefined) { 
                localVarFormParams.append('ForceReprocess', String(forceReprocess) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxReturnBundleApi - functional programming interface
 */
export const TaxReturnBundleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxReturnBundleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(binderId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(binderId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} id 
         * @param {UpdatePreparerDocumentDto} [updatePreparerDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(binderId: string, id: string, updatePreparerDocumentDto?: UpdatePreparerDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(binderId, id, updatePreparerDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} displayName 
         * @param {BundleDocumentCategory} category 
         * @param {File} file 
         * @param {string} [jurisdictionId] 
         * @param {boolean} [requiresSignature] 
         * @param {string} [signatureFieldPlacementsJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsPost(binderId: string, displayName: string, category: BundleDocumentCategory, file: File, jurisdictionId?: string, requiresSignature?: boolean, signatureFieldPlacementsJson?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsPost(binderId, displayName, category, file, jurisdictionId, requiresSignature, signatureFieldPlacementsJson, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleSignatureStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleSignatureStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsProcessingStatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleProcessingStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsProcessingStatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsProcessingStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReprocessPost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleProcessingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReprocessPost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReprocessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {RequestBundleSignatureDto} [requestBundleSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(binderId: string, requestBundleSignatureDto?: RequestBundleSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentSignatureResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(binderId, requestBundleSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {ConvertToPaperDto} [convertToPaperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(binderId: string, returnId: string, convertToPaperDto?: ConvertToPaperDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(binderId, returnId, convertToPaperDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {DeleteReturnDto} [deleteReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdDelete(binderId: string, returnId: string, deleteReturnDto?: DeleteReturnDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdDelete(binderId, returnId, deleteReturnDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(binderId: string, returnId: string, instructionType?: FilingInstructionType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(binderId, returnId, instructionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {UpdateFilingInstructionDto} [updateFilingInstructionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(binderId: string, returnId: string, instructionType?: FilingInstructionType, updateFilingInstructionDto?: UpdateFilingInstructionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(binderId, returnId, instructionType, updateFilingInstructionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdGet(binderId: string, returnId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdGet(binderId, returnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(binderId: string, returnId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(binderId, returnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {MarkTaxReturnFiledDto} [markTaxReturnFiledDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(binderId: string, returnId: string, markTaxReturnFiledDto?: MarkTaxReturnFiledDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(binderId, returnId, markTaxReturnFiledDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} signedAt 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(binderId: string, returnId: string, signedAt: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(binderId, returnId, signedAt, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {MarkTaxReturnRejectedDto} [markTaxReturnRejectedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(binderId: string, returnId: string, markTaxReturnRejectedDto?: MarkTaxReturnRejectedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(binderId, returnId, markTaxReturnRejectedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {UpdateJurisdictionDto} [updateJurisdictionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdPatch(binderId: string, returnId: string, updateJurisdictionDto?: UpdateJurisdictionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdPatch(binderId, returnId, updateJurisdictionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} requirementId 
         * @param {UpdateBundleSignatureRequirementDto} [updateBundleSignatureRequirementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(binderId: string, returnId: string, requirementId: string, updateBundleSignatureRequirementDto?: UpdateBundleSignatureRequirementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleSignatureRequirementDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(binderId, returnId, requirementId, updateBundleSignatureRequirementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersGet(binderId: string, returnId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersGet(binderId, returnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {CreatePaymentVoucherDto} [createPaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersPost(binderId: string, returnId: string, createPaymentVoucherDto?: CreatePaymentVoucherDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersPost(binderId, returnId, createPaymentVoucherDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(binderId: string, returnId: string, voucherId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(binderId, returnId, voucherId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {MarkPaymentVoucherPaidDto} [markPaymentVoucherPaidDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(binderId: string, returnId: string, voucherId: string, markPaymentVoucherPaidDto?: MarkPaymentVoucherPaidDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(binderId, returnId, voucherId, markPaymentVoucherPaidDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {PaymentVoucherReminderOptInDto} [paymentVoucherReminderOptInDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(binderId: string, returnId: string, voucherId: string, paymentVoucherReminderOptInDto?: PaymentVoucherReminderOptInDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(binderId, returnId, voucherId, paymentVoucherReminderOptInDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {UpdatePaymentVoucherDto} [updatePaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(binderId: string, returnId: string, voucherId: string, updatePaymentVoucherDto?: UpdatePaymentVoucherDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(binderId, returnId, voucherId, updatePaymentVoucherDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} binderId 
         * @param {File} clientCopyPdf 
         * @param {File} governmentCopyPdf 
         * @param {File} [k1Pdf] 
         * @param {string} [invoiceLink] 
         * @param {boolean} [forceReprocess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsUploadBundlePost(binderId: string, clientCopyPdf: File, governmentCopyPdf: File, k1Pdf?: File, invoiceLink?: string, forceReprocess?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleProcessingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsUploadBundlePost(binderId, clientCopyPdf, governmentCopyPdf, k1Pdf, invoiceLink, forceReprocess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsUploadBundlePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaxReturnBundleApi - factory interface
 */
export const TaxReturnBundleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxReturnBundleApiFp(configuration)
    return {
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters.binderId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters.binderId, requestParameters.id, requestParameters.updatePreparerDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters.binderId, requestParameters.displayName, requestParameters.category, requestParameters.file, requestParameters.jurisdictionId, requestParameters.requiresSignature, requestParameters.signatureFieldPlacementsJson, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReprocessPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReprocessPost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentSignatureResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters.binderId, requestParameters.requestBundleSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters.binderId, requestParameters.returnId, requestParameters.convertToPaperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.deleteReturnDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, requestParameters.updateFilingInstructionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnFiledDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.signedAt, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnRejectedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.updateJurisdictionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureRequirementDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters.binderId, requestParameters.returnId, requestParameters.requirementId, requestParameters.updateBundleSignatureRequirementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters.binderId, requestParameters.returnId, requestParameters.createPaymentVoucherDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.markPaymentVoucherPaidDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.paymentVoucherReminderOptInDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.updatePaymentVoucherDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters.binderId, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.k1Pdf, requestParameters.invoiceLink, requestParameters.forceReprocess, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxReturnBundleApi - interface
 */
export interface TaxReturnBundleApiInterface {
    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoListApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureStatusDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoListApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingStatusDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReprocessPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentSignatureResponseDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureRequirementDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoListApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest {
    readonly binderId: string

    readonly id: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsIdPut operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest {
    readonly binderId: string

    readonly id: string

    readonly updatePreparerDocumentDto?: UpdatePreparerDocumentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest {
    readonly binderId: string

    readonly displayName: string

    readonly category: BundleDocumentCategory

    readonly file: File

    readonly jurisdictionId?: string

    readonly requiresSignature?: boolean

    readonly signatureFieldPlacementsJson?: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleSignatureStatusGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsProcessingStatusGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReprocessPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest {
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest {
    readonly binderId: string

    readonly requestBundleSignatureDto?: RequestBundleSignatureDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest {
    readonly binderId: string

    readonly returnId: string

    readonly convertToPaperDto?: ConvertToPaperDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdDelete operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest {
    readonly binderId: string

    readonly returnId: string

    readonly deleteReturnDto?: DeleteReturnDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest {
    readonly binderId: string

    readonly returnId: string

    readonly instructionType?: FilingInstructionType
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest {
    readonly binderId: string

    readonly returnId: string

    readonly instructionType?: FilingInstructionType

    readonly updateFilingInstructionDto?: UpdateFilingInstructionDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest {
    readonly binderId: string

    readonly returnId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest {
    readonly binderId: string

    readonly returnId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest {
    readonly binderId: string

    readonly returnId: string

    readonly markTaxReturnFiledDto?: MarkTaxReturnFiledDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest {
    readonly binderId: string

    readonly returnId: string

    readonly signedAt: string

    readonly file?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest {
    readonly binderId: string

    readonly returnId: string

    readonly markTaxReturnRejectedDto?: MarkTaxReturnRejectedDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdPatch operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest {
    readonly binderId: string

    readonly returnId: string

    readonly updateJurisdictionDto?: UpdateJurisdictionDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest {
    readonly binderId: string

    readonly returnId: string

    readonly requirementId: string

    readonly updateBundleSignatureRequirementDto?: UpdateBundleSignatureRequirementDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest {
    readonly binderId: string

    readonly returnId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest {
    readonly binderId: string

    readonly returnId: string

    readonly createPaymentVoucherDto?: CreatePaymentVoucherDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest {
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest {
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string

    readonly markPaymentVoucherPaidDto?: MarkPaymentVoucherPaidDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest {
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string

    readonly paymentVoucherReminderOptInDto?: PaymentVoucherReminderOptInDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest {
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string

    readonly updatePaymentVoucherDto?: UpdatePaymentVoucherDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsUploadBundlePost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest {
    readonly binderId: string

    readonly clientCopyPdf: File

    readonly governmentCopyPdf: File

    readonly k1Pdf?: File

    readonly invoiceLink?: string

    readonly forceReprocess?: boolean
}

/**
 * TaxReturnBundleApi - object-oriented interface
 */
export class TaxReturnBundleApi extends BaseAPI implements TaxReturnBundleApiInterface {
    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters.binderId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters.binderId, requestParameters.id, requestParameters.updatePreparerDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters.binderId, requestParameters.displayName, requestParameters.category, requestParameters.file, requestParameters.jurisdictionId, requestParameters.requiresSignature, requestParameters.signatureFieldPlacementsJson, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReprocessPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReprocessPost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters.binderId, requestParameters.requestBundleSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters.binderId, requestParameters.returnId, requestParameters.convertToPaperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.deleteReturnDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, requestParameters.updateFilingInstructionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnFiledDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.signedAt, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnRejectedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.updateJurisdictionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters.binderId, requestParameters.returnId, requestParameters.requirementId, requestParameters.updateBundleSignatureRequirementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters.binderId, requestParameters.returnId, requestParameters.createPaymentVoucherDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.markPaymentVoucherPaidDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.paymentVoucherReminderOptInDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.updatePaymentVoucherDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters.binderId, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.k1Pdf, requestParameters.invoiceLink, requestParameters.forceReprocess, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserSettingsApi - axios parameter creator
 */
export const UserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserSettingDto} [updateUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsPut: async (updateUserSettingDto?: UpdateUserSettingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetUserSettingDto} [resetUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsResetPost: async (resetUserSettingDto?: ResetUserSettingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetUserSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSettingsApi - functional programming interface
 */
export const UserSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiUserSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateUserSettingDto} [updateUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingsPut(updateUserSettingDto?: UpdateUserSettingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingsPut(updateUserSettingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiUserSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetUserSettingDto} [resetUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingsResetPost(resetUserSettingDto?: ResetUserSettingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingsResetPost(resetUserSettingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiUserSettingsResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserSettingsApi - factory interface
 */
export const UserSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsGet(options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse> {
            return localVarFp.apiUserSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserSettingsApiApiUserSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsPut(requestParameters: UserSettingsApiApiUserSettingsPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse> {
            return localVarFp.apiUserSettingsPut(requestParameters.updateUserSettingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserSettingsApiApiUserSettingsResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsResetPost(requestParameters: UserSettingsApiApiUserSettingsResetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse> {
            return localVarFp.apiUserSettingsResetPost(requestParameters.resetUserSettingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSettingsApi - interface
 */
export interface UserSettingsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserSettingsGet(options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse>;

    /**
     * 
     * @param {UserSettingsApiApiUserSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserSettingsPut(requestParameters?: UserSettingsApiApiUserSettingsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse>;

    /**
     * 
     * @param {UserSettingsApiApiUserSettingsResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserSettingsResetPost(requestParameters?: UserSettingsApiApiUserSettingsResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse>;

}

/**
 * Request parameters for apiUserSettingsPut operation in UserSettingsApi.
 */
export interface UserSettingsApiApiUserSettingsPutRequest {
    readonly updateUserSettingDto?: UpdateUserSettingDto
}

/**
 * Request parameters for apiUserSettingsResetPost operation in UserSettingsApi.
 */
export interface UserSettingsApiApiUserSettingsResetPostRequest {
    readonly resetUserSettingDto?: ResetUserSettingDto
}

/**
 * UserSettingsApi - object-oriented interface
 */
export class UserSettingsApi extends BaseAPI implements UserSettingsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserSettingsGet(options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserSettingsApiApiUserSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserSettingsPut(requestParameters: UserSettingsApiApiUserSettingsPutRequest = {}, options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingsPut(requestParameters.updateUserSettingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserSettingsApiApiUserSettingsResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserSettingsResetPost(requestParameters: UserSettingsApiApiUserSettingsResetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingsResetPost(requestParameters.resetUserSettingDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssignUserToClientDto} [assignUserToClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAssignToClientPost: async (assignUserToClientDto?: AssignUserToClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/assign-to-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignUserToClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientClientIdGet: async (clientId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiUsersClientClientIdGet', 'clientId', clientId)
            const localVarPath = `/api/Users/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateClientUserRoleDto} [updateClientUserRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientRolePatch: async (updateClientUserRoleDto?: UpdateClientUserRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/client-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientUserRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserWithClientDto} [createUserWithClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCreateWithClientPost: async (createUserWithClientDto?: CreateUserWithClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/create-with-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserWithClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {UserRole} [role] 
         * @param {boolean} [isActive] 
         * @param {string} [clientId] 
         * @param {boolean} [isPartner] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDescending] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet: async (search?: string, role?: UserRole, isActive?: boolean, clientId?: string, isPartner?: boolean, sortBy?: string, sortDescending?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (role !== undefined) {
                localVarQueryParameter['Role'] = role;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (isPartner !== undefined) {
                localVarQueryParameter['IsPartner'] = isPartner;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDescending !== undefined) {
                localVarQueryParameter['SortDescending'] = sortDescending;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdActivatePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdActivatePost', 'id', id)
            const localVarPath = `/api/Users/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContactInfoDto} [updateContactInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdContactInfoPatch: async (id: string, updateContactInfoDto?: UpdateContactInfoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdContactInfoPatch', 'id', id)
            const localVarPath = `/api/Users/{id}/contact-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContactInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDeactivatePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdDeactivatePost', 'id', id)
            const localVarPath = `/api/Users/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdDelete', 'id', id)
            const localVarPath = `/api/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdGet', 'id', id)
            const localVarPath = `/api/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPossibleDuplicatesGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPossibleDuplicatesGet', 'id', id)
            const localVarPath = `/api/Users/{id}/possible-duplicates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} [updateUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut: async (id: string, updateUserDto?: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPut', 'id', id)
            const localVarPath = `/api/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdResendInvitationPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdResendInvitationPost', 'id', id)
            const localVarPath = `/api/Users/{id}/resend-invitation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InviteUserDto} [inviteUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitePost: async (inviteUserDto?: InviteUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MergeUsersDto} [mergeUsersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePost: async (mergeUsersDto?: MergeUsersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeUsersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MergeUsersDto} [mergeUsersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePreviewPost: async (mergeUsersDto?: MergeUsersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/merge/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeUsersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserDto} [createUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost: async (createUserDto?: CreateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserAdminSearchQueryDto} [userAdminSearchQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchAdminPost: async (userAdminSearchQueryDto?: UserAdminSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/search/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAdminSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchQuery] 
         * @param {string} [excludeClientId] 
         * @param {UserRole} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchGet: async (searchQuery?: string, excludeClientId?: string, role?: UserRole, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (excludeClientId !== undefined) {
                localVarQueryParameter['excludeClientId'] = excludeClientId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendEmailVerificationDto} [sendEmailVerificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendEmailVerificationPost: async (sendEmailVerificationDto?: SendEmailVerificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/send-email-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendPhoneVerificationDto} [sendPhoneVerificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendPhoneVerificationPost: async (sendPhoneVerificationDto?: SendPhoneVerificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/send-phone-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RevokeSmsConsentDto} [revokeSmsConsentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentDelete: async (revokeSmsConsentDto?: RevokeSmsConsentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/sms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeSmsConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/sms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GrantSmsConsentDto} [grantSmsConsentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentPost: async (grantSmsConsentDto?: GrantSmsConsentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/sms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantSmsConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUserIdClientClientIdDelete: async (userId: string, clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiUsersUserIdClientClientIdDelete', 'userId', userId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiUsersUserIdClientClientIdDelete', 'clientId', clientId)
            const localVarPath = `/api/Users/{userId}/client/{clientId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [phoneNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersValidatePhoneGet: async (phoneNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/validate-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyEmailDto} [verifyEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyEmailPost: async (verifyEmailDto?: VerifyEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/verify-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyPhoneDto} [verifyPhoneDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyPhonePost: async (verifyPhoneDto?: VerifyPhoneDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/verify-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPhoneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssignUserToClientDto} [assignUserToClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersAssignToClientPost(assignUserToClientDto?: AssignUserToClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersAssignToClientPost(assignUserToClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersAssignToClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersClientClientIdGet(clientId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientUserDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersClientClientIdGet(clientId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersClientClientIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateClientUserRoleDto} [updateClientUserRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersClientRolePatch(updateClientUserRoleDto?: UpdateClientUserRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersClientRolePatch(updateClientUserRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersClientRolePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUserWithClientDto} [createUserWithClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersCreateWithClientPost(createUserWithClientDto?: CreateUserWithClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithClientsSearchResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersCreateWithClientPost(createUserWithClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersCreateWithClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {UserRole} [role] 
         * @param {boolean} [isActive] 
         * @param {string} [clientId] 
         * @param {boolean} [isPartner] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDescending] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersGet(search?: string, role?: UserRole, isActive?: boolean, clientId?: string, isPartner?: boolean, sortBy?: string, sortDescending?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersGet(search, role, isActive, clientId, isPartner, sortBy, sortDescending, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdActivatePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdActivatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContactInfoDto} [updateContactInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdContactInfoPatch(id: string, updateContactInfoDto?: UpdateContactInfoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdContactInfoPatch(id, updateContactInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdContactInfoPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdDeactivatePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdDeactivatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPossibleDuplicatesGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PossibleDuplicateDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPossibleDuplicatesGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdPossibleDuplicatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} [updateUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPut(id: string, updateUserDto?: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPut(id, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdResendInvitationPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdResendInvitationPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdResendInvitationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InviteUserDto} [inviteUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersInvitePost(inviteUserDto?: InviteUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersInvitePost(inviteUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MergeUsersDto} [mergeUsersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersMergePost(mergeUsersDto?: MergeUsersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MergeResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersMergePost(mergeUsersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersMergePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MergeUsersDto} [mergeUsersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersMergePreviewPost(mergeUsersDto?: MergeUsersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MergePreviewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersMergePreviewPost(mergeUsersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersMergePreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUserDto} [createUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersPost(createUserDto?: CreateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersPost(createUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfileGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfileGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserAdminSearchQueryDto} [userAdminSearchQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSearchAdminPost(userAdminSearchQueryDto?: UserAdminSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminSearchResultDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSearchAdminPost(userAdminSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSearchAdminPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchQuery] 
         * @param {string} [excludeClientId] 
         * @param {UserRole} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSearchGet(searchQuery?: string, excludeClientId?: string, role?: UserRole, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithClientsSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSearchGet(searchQuery, excludeClientId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendEmailVerificationDto} [sendEmailVerificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSendEmailVerificationPost(sendEmailVerificationDto?: SendEmailVerificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSendEmailVerificationPost(sendEmailVerificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSendEmailVerificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendPhoneVerificationDto} [sendPhoneVerificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSendPhoneVerificationPost(sendPhoneVerificationDto?: SendPhoneVerificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSendPhoneVerificationPost(sendPhoneVerificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSendPhoneVerificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RevokeSmsConsentDto} [revokeSmsConsentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSmsConsentDelete(revokeSmsConsentDto?: RevokeSmsConsentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsConsentStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSmsConsentDelete(revokeSmsConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSmsConsentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSmsConsentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsConsentStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSmsConsentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSmsConsentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GrantSmsConsentDto} [grantSmsConsentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSmsConsentPost(grantSmsConsentDto?: GrantSmsConsentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsConsentStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSmsConsentPost(grantSmsConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSmsConsentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersUserIdClientClientIdDelete(userId: string, clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersUserIdClientClientIdDelete(userId, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersUserIdClientClientIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [phoneNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersValidatePhoneGet(phoneNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneLookupResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersValidatePhoneGet(phoneNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersValidatePhoneGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyEmailDto} [verifyEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersVerifyEmailPost(verifyEmailDto?: VerifyEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersVerifyEmailPost(verifyEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersVerifyEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyPhoneDto} [verifyPhoneDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersVerifyPhonePost(verifyPhoneDto?: VerifyPhoneDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersVerifyPhonePost(verifyPhoneDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersVerifyPhonePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {UsersApiApiUsersAssignToClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAssignToClientPost(requestParameters: UsersApiApiUsersAssignToClientPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersAssignToClientPost(requestParameters.assignUserToClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersClientClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientClientIdGet(requestParameters: UsersApiApiUsersClientClientIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDtoPaginatedResponseApiResponse> {
            return localVarFp.apiUsersClientClientIdGet(requestParameters.clientId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersClientRolePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientRolePatch(requestParameters: UsersApiApiUsersClientRolePatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersClientRolePatch(requestParameters.updateClientUserRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersCreateWithClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCreateWithClientPost(requestParameters: UsersApiApiUsersCreateWithClientPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse> {
            return localVarFp.apiUsersCreateWithClientPost(requestParameters.createUserWithClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet(requestParameters: UsersApiApiUsersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserListDtoPaginatedResponseApiResponse> {
            return localVarFp.apiUsersGet(requestParameters.search, requestParameters.role, requestParameters.isActive, requestParameters.clientId, requestParameters.isPartner, requestParameters.sortBy, requestParameters.sortDescending, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdActivatePost(requestParameters: UsersApiApiUsersIdActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersIdActivatePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdContactInfoPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdContactInfoPatch(requestParameters: UsersApiApiUsersIdContactInfoPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersIdContactInfoPatch(requestParameters.id, requestParameters.updateContactInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdDeactivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDeactivatePost(requestParameters: UsersApiApiUsersIdDeactivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersIdDeactivatePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete(requestParameters: UsersApiApiUsersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet(requestParameters: UsersApiApiUsersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdPossibleDuplicatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPossibleDuplicatesGet(requestParameters: UsersApiApiUsersIdPossibleDuplicatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PossibleDuplicateDtoListApiResponse> {
            return localVarFp.apiUsersIdPossibleDuplicatesGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(requestParameters: UsersApiApiUsersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersIdPut(requestParameters.id, requestParameters.updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersIdResendInvitationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdResendInvitationPost(requestParameters: UsersApiApiUsersIdResendInvitationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersIdResendInvitationPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersInvitePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitePost(requestParameters: UsersApiApiUsersInvitePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersInvitePost(requestParameters.inviteUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersMergePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePost(requestParameters: UsersApiApiUsersMergePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MergeResultDtoApiResponse> {
            return localVarFp.apiUsersMergePost(requestParameters.mergeUsersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersMergePreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePreviewPost(requestParameters: UsersApiApiUsersMergePreviewPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MergePreviewDtoApiResponse> {
            return localVarFp.apiUsersMergePreviewPost(requestParameters.mergeUsersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost(requestParameters: UsersApiApiUsersPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersPost(requestParameters.createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileGet(options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersSearchAdminPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchAdminPost(requestParameters: UsersApiApiUsersSearchAdminPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSearchResultDtoPaginatedResponseApiResponse> {
            return localVarFp.apiUsersSearchAdminPost(requestParameters.userAdminSearchQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchGet(requestParameters: UsersApiApiUsersSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoListApiResponse> {
            return localVarFp.apiUsersSearchGet(requestParameters.searchQuery, requestParameters.excludeClientId, requestParameters.role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersSendEmailVerificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendEmailVerificationPost(requestParameters: UsersApiApiUsersSendEmailVerificationPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersSendEmailVerificationPost(requestParameters.sendEmailVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersSendPhoneVerificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendPhoneVerificationPost(requestParameters: UsersApiApiUsersSendPhoneVerificationPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersSendPhoneVerificationPost(requestParameters.sendPhoneVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersSmsConsentDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentDelete(requestParameters: UsersApiApiUsersSmsConsentDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse> {
            return localVarFp.apiUsersSmsConsentDelete(requestParameters.revokeSmsConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentGet(options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse> {
            return localVarFp.apiUsersSmsConsentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersSmsConsentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentPost(requestParameters: UsersApiApiUsersSmsConsentPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse> {
            return localVarFp.apiUsersSmsConsentPost(requestParameters.grantSmsConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersUserIdClientClientIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUserIdClientClientIdDelete(requestParameters: UsersApiApiUsersUserIdClientClientIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersUserIdClientClientIdDelete(requestParameters.userId, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersValidatePhoneGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersValidatePhoneGet(requestParameters: UsersApiApiUsersValidatePhoneGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PhoneLookupResultApiResponse> {
            return localVarFp.apiUsersValidatePhoneGet(requestParameters.phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersVerifyEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyEmailPost(requestParameters: UsersApiApiUsersVerifyEmailPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersVerifyEmailPost(requestParameters.verifyEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiUsersVerifyPhonePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyPhonePost(requestParameters: UsersApiApiUsersVerifyPhonePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersVerifyPhonePost(requestParameters.verifyPhoneDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - interface
 */
export interface UsersApiInterface {
    /**
     * 
     * @param {UsersApiApiUsersAssignToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersAssignToClientPost(requestParameters?: UsersApiApiUsersAssignToClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersClientClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersClientClientIdGet(requestParameters: UsersApiApiUsersClientClientIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersClientRolePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersClientRolePatch(requestParameters?: UsersApiApiUsersClientRolePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersCreateWithClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersCreateWithClientPost(requestParameters?: UsersApiApiUsersCreateWithClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersGet(requestParameters?: UsersApiApiUsersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserListDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdActivatePost(requestParameters: UsersApiApiUsersIdActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdContactInfoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdContactInfoPatch(requestParameters: UsersApiApiUsersIdContactInfoPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdDeactivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdDeactivatePost(requestParameters: UsersApiApiUsersIdDeactivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdDelete(requestParameters: UsersApiApiUsersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdGet(requestParameters: UsersApiApiUsersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdPossibleDuplicatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdPossibleDuplicatesGet(requestParameters: UsersApiApiUsersIdPossibleDuplicatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PossibleDuplicateDtoListApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdPut(requestParameters: UsersApiApiUsersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersIdResendInvitationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdResendInvitationPost(requestParameters: UsersApiApiUsersIdResendInvitationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersInvitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersInvitePost(requestParameters?: UsersApiApiUsersInvitePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersMergePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersMergePost(requestParameters?: UsersApiApiUsersMergePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MergeResultDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersMergePreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersMergePreviewPost(requestParameters?: UsersApiApiUsersMergePreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MergePreviewDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersPost(requestParameters?: UsersApiApiUsersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersProfileGet(options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersSearchAdminPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSearchAdminPost(requestParameters?: UsersApiApiUsersSearchAdminPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSearchResultDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSearchGet(requestParameters?: UsersApiApiUsersSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoListApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersSendEmailVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSendEmailVerificationPost(requestParameters?: UsersApiApiUsersSendEmailVerificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersSendPhoneVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSendPhoneVerificationPost(requestParameters?: UsersApiApiUsersSendPhoneVerificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersSmsConsentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSmsConsentDelete(requestParameters?: UsersApiApiUsersSmsConsentDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSmsConsentGet(options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersSmsConsentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSmsConsentPost(requestParameters?: UsersApiApiUsersSmsConsentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersUserIdClientClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersUserIdClientClientIdDelete(requestParameters: UsersApiApiUsersUserIdClientClientIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersValidatePhoneGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersValidatePhoneGet(requestParameters?: UsersApiApiUsersValidatePhoneGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PhoneLookupResultApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersVerifyEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersVerifyEmailPost(requestParameters?: UsersApiApiUsersVerifyEmailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse>;

    /**
     * 
     * @param {UsersApiApiUsersVerifyPhonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersVerifyPhonePost(requestParameters?: UsersApiApiUsersVerifyPhonePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse>;

}

/**
 * Request parameters for apiUsersAssignToClientPost operation in UsersApi.
 */
export interface UsersApiApiUsersAssignToClientPostRequest {
    readonly assignUserToClientDto?: AssignUserToClientDto
}

/**
 * Request parameters for apiUsersClientClientIdGet operation in UsersApi.
 */
export interface UsersApiApiUsersClientClientIdGetRequest {
    readonly clientId: string

    readonly page?: number

    readonly limit?: number
}

/**
 * Request parameters for apiUsersClientRolePatch operation in UsersApi.
 */
export interface UsersApiApiUsersClientRolePatchRequest {
    readonly updateClientUserRoleDto?: UpdateClientUserRoleDto
}

/**
 * Request parameters for apiUsersCreateWithClientPost operation in UsersApi.
 */
export interface UsersApiApiUsersCreateWithClientPostRequest {
    readonly createUserWithClientDto?: CreateUserWithClientDto
}

/**
 * Request parameters for apiUsersGet operation in UsersApi.
 */
export interface UsersApiApiUsersGetRequest {
    readonly search?: string

    readonly role?: UserRole

    readonly isActive?: boolean

    readonly clientId?: string

    readonly isPartner?: boolean

    readonly sortBy?: string

    readonly sortDescending?: boolean

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiUsersIdActivatePost operation in UsersApi.
 */
export interface UsersApiApiUsersIdActivatePostRequest {
    readonly id: string
}

/**
 * Request parameters for apiUsersIdContactInfoPatch operation in UsersApi.
 */
export interface UsersApiApiUsersIdContactInfoPatchRequest {
    readonly id: string

    readonly updateContactInfoDto?: UpdateContactInfoDto
}

/**
 * Request parameters for apiUsersIdDeactivatePost operation in UsersApi.
 */
export interface UsersApiApiUsersIdDeactivatePostRequest {
    readonly id: string
}

/**
 * Request parameters for apiUsersIdDelete operation in UsersApi.
 */
export interface UsersApiApiUsersIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiUsersIdGet operation in UsersApi.
 */
export interface UsersApiApiUsersIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiUsersIdPossibleDuplicatesGet operation in UsersApi.
 */
export interface UsersApiApiUsersIdPossibleDuplicatesGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiUsersIdPut operation in UsersApi.
 */
export interface UsersApiApiUsersIdPutRequest {
    readonly id: string

    readonly updateUserDto?: UpdateUserDto
}

/**
 * Request parameters for apiUsersIdResendInvitationPost operation in UsersApi.
 */
export interface UsersApiApiUsersIdResendInvitationPostRequest {
    readonly id: string
}

/**
 * Request parameters for apiUsersInvitePost operation in UsersApi.
 */
export interface UsersApiApiUsersInvitePostRequest {
    readonly inviteUserDto?: InviteUserDto
}

/**
 * Request parameters for apiUsersMergePost operation in UsersApi.
 */
export interface UsersApiApiUsersMergePostRequest {
    readonly mergeUsersDto?: MergeUsersDto
}

/**
 * Request parameters for apiUsersMergePreviewPost operation in UsersApi.
 */
export interface UsersApiApiUsersMergePreviewPostRequest {
    readonly mergeUsersDto?: MergeUsersDto
}

/**
 * Request parameters for apiUsersPost operation in UsersApi.
 */
export interface UsersApiApiUsersPostRequest {
    readonly createUserDto?: CreateUserDto
}

/**
 * Request parameters for apiUsersSearchAdminPost operation in UsersApi.
 */
export interface UsersApiApiUsersSearchAdminPostRequest {
    readonly userAdminSearchQueryDto?: UserAdminSearchQueryDto
}

/**
 * Request parameters for apiUsersSearchGet operation in UsersApi.
 */
export interface UsersApiApiUsersSearchGetRequest {
    readonly searchQuery?: string

    readonly excludeClientId?: string

    readonly role?: UserRole
}

/**
 * Request parameters for apiUsersSendEmailVerificationPost operation in UsersApi.
 */
export interface UsersApiApiUsersSendEmailVerificationPostRequest {
    readonly sendEmailVerificationDto?: SendEmailVerificationDto
}

/**
 * Request parameters for apiUsersSendPhoneVerificationPost operation in UsersApi.
 */
export interface UsersApiApiUsersSendPhoneVerificationPostRequest {
    readonly sendPhoneVerificationDto?: SendPhoneVerificationDto
}

/**
 * Request parameters for apiUsersSmsConsentDelete operation in UsersApi.
 */
export interface UsersApiApiUsersSmsConsentDeleteRequest {
    readonly revokeSmsConsentDto?: RevokeSmsConsentDto
}

/**
 * Request parameters for apiUsersSmsConsentPost operation in UsersApi.
 */
export interface UsersApiApiUsersSmsConsentPostRequest {
    readonly grantSmsConsentDto?: GrantSmsConsentDto
}

/**
 * Request parameters for apiUsersUserIdClientClientIdDelete operation in UsersApi.
 */
export interface UsersApiApiUsersUserIdClientClientIdDeleteRequest {
    readonly userId: string

    readonly clientId: string
}

/**
 * Request parameters for apiUsersValidatePhoneGet operation in UsersApi.
 */
export interface UsersApiApiUsersValidatePhoneGetRequest {
    readonly phoneNumber?: string
}

/**
 * Request parameters for apiUsersVerifyEmailPost operation in UsersApi.
 */
export interface UsersApiApiUsersVerifyEmailPostRequest {
    readonly verifyEmailDto?: VerifyEmailDto
}

/**
 * Request parameters for apiUsersVerifyPhonePost operation in UsersApi.
 */
export interface UsersApiApiUsersVerifyPhonePostRequest {
    readonly verifyPhoneDto?: VerifyPhoneDto
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
    /**
     * 
     * @param {UsersApiApiUsersAssignToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersAssignToClientPost(requestParameters: UsersApiApiUsersAssignToClientPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersAssignToClientPost(requestParameters.assignUserToClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersClientClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersClientClientIdGet(requestParameters: UsersApiApiUsersClientClientIdGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersClientClientIdGet(requestParameters.clientId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersClientRolePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersClientRolePatch(requestParameters: UsersApiApiUsersClientRolePatchRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersClientRolePatch(requestParameters.updateClientUserRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersCreateWithClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersCreateWithClientPost(requestParameters: UsersApiApiUsersCreateWithClientPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersCreateWithClientPost(requestParameters.createUserWithClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersGet(requestParameters: UsersApiApiUsersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersGet(requestParameters.search, requestParameters.role, requestParameters.isActive, requestParameters.clientId, requestParameters.isPartner, requestParameters.sortBy, requestParameters.sortDescending, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdActivatePost(requestParameters: UsersApiApiUsersIdActivatePostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdActivatePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdContactInfoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdContactInfoPatch(requestParameters: UsersApiApiUsersIdContactInfoPatchRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdContactInfoPatch(requestParameters.id, requestParameters.updateContactInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdDeactivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdDeactivatePost(requestParameters: UsersApiApiUsersIdDeactivatePostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdDeactivatePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdDelete(requestParameters: UsersApiApiUsersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdGet(requestParameters: UsersApiApiUsersIdGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdPossibleDuplicatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdPossibleDuplicatesGet(requestParameters: UsersApiApiUsersIdPossibleDuplicatesGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdPossibleDuplicatesGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdPut(requestParameters: UsersApiApiUsersIdPutRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdPut(requestParameters.id, requestParameters.updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersIdResendInvitationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdResendInvitationPost(requestParameters: UsersApiApiUsersIdResendInvitationPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdResendInvitationPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersInvitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersInvitePost(requestParameters: UsersApiApiUsersInvitePostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersInvitePost(requestParameters.inviteUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersMergePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersMergePost(requestParameters: UsersApiApiUsersMergePostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersMergePost(requestParameters.mergeUsersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersMergePreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersMergePreviewPost(requestParameters: UsersApiApiUsersMergePreviewPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersMergePreviewPost(requestParameters.mergeUsersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersPost(requestParameters: UsersApiApiUsersPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersPost(requestParameters.createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersProfileGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersSearchAdminPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSearchAdminPost(requestParameters: UsersApiApiUsersSearchAdminPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSearchAdminPost(requestParameters.userAdminSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSearchGet(requestParameters: UsersApiApiUsersSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSearchGet(requestParameters.searchQuery, requestParameters.excludeClientId, requestParameters.role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersSendEmailVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSendEmailVerificationPost(requestParameters: UsersApiApiUsersSendEmailVerificationPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSendEmailVerificationPost(requestParameters.sendEmailVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersSendPhoneVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSendPhoneVerificationPost(requestParameters: UsersApiApiUsersSendPhoneVerificationPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSendPhoneVerificationPost(requestParameters.sendPhoneVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersSmsConsentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSmsConsentDelete(requestParameters: UsersApiApiUsersSmsConsentDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSmsConsentDelete(requestParameters.revokeSmsConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSmsConsentGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSmsConsentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersSmsConsentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSmsConsentPost(requestParameters: UsersApiApiUsersSmsConsentPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSmsConsentPost(requestParameters.grantSmsConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersUserIdClientClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersUserIdClientClientIdDelete(requestParameters: UsersApiApiUsersUserIdClientClientIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersUserIdClientClientIdDelete(requestParameters.userId, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersValidatePhoneGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersValidatePhoneGet(requestParameters: UsersApiApiUsersValidatePhoneGetRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersValidatePhoneGet(requestParameters.phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersVerifyEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersVerifyEmailPost(requestParameters: UsersApiApiUsersVerifyEmailPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersVerifyEmailPost(requestParameters.verifyEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiUsersVerifyPhonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersVerifyPhonePost(requestParameters: UsersApiApiUsersVerifyPhonePostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersVerifyPhonePost(requestParameters.verifyPhoneDto, options).then((request) => request(this.axios, this.basePath));
    }
}



